(function () {
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1496"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1496"] = parcelRequire;
}
parcelRequire.register("c0NVP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bec37880ac74127$var$ReactIs, $8bec37880ac74127$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eb1SH"))();

});
parcelRequire.register("eb1SH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bGfkf = parcelRequire("bGfkf");
function $a5238d524461d311$var$emptyFunction() {}
function $a5238d524461d311$var$emptyFunctionWithReset() {}
$a5238d524461d311$var$emptyFunctionWithReset.resetWarningCache = $a5238d524461d311$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bGfkf) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a5238d524461d311$var$emptyFunctionWithReset,
        resetWarningCache: $a5238d524461d311$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("bGfkf", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $880f8150843eceb2$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $880f8150843eceb2$var$ReactPropTypesSecret;

});



parcelRequire.register("lTb4y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PureComponent", function () { return $fef752cad57d0747$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $fef752cad57d0747$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $fef752cad57d0747$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $fef752cad57d0747$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $fef752cad57d0747$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $fef752cad57d0747$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $fef752cad57d0747$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $fef752cad57d0747$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $fef752cad57d0747$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $fef752cad57d0747$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fef752cad57d0747$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $fef752cad57d0747$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $fef752cad57d0747$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $fef752cad57d0747$export$a8257692ac88316c; });
$parcel$export(module.exports, "cloneElement", function () { return $fef752cad57d0747$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fef752cad57d0747$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $fef752cad57d0747$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fef752cad57d0747$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $fef752cad57d0747$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "StrictMode", function () { return $fef752cad57d0747$export$5f8d39834fd61797; });
$parcel$export(module.exports, "startTransition", function () { return $fef752cad57d0747$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $fef752cad57d0747$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $fef752cad57d0747$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $fef752cad57d0747$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $fef752cad57d0747$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "default", function () { return $fef752cad57d0747$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("ep79K")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("ep79K")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("ep79K")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("ep79K")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("ep79K")).createRef; });

var $ep79K = parcelRequire("ep79K");

var $9Raem = parcelRequire("9Raem");
function $fef752cad57d0747$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $fef752cad57d0747$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $fef752cad57d0747$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $fef752cad57d0747$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $fef752cad57d0747$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $fef752cad57d0747$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $ep79K.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($fef752cad57d0747$export$221d75b3f55bb0bd.prototype = new (0, $ep79K.Component)).isPureReactComponent = !0, $fef752cad57d0747$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $fef752cad57d0747$var$C(this.props, n) || $fef752cad57d0747$var$C(this.state, t);
};
var $fef752cad57d0747$var$R = (0, $ep79K.options).__b;
(0, $ep79K.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $fef752cad57d0747$var$R && $fef752cad57d0747$var$R(n);
};
var $fef752cad57d0747$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $fef752cad57d0747$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $fef752cad57d0747$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $fef752cad57d0747$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $fef752cad57d0747$var$A = function(n, t) {
    return null == n ? null : (0, $ep79K.toChildArray)((0, $ep79K.toChildArray)(n).map(t));
}, $fef752cad57d0747$export$dca3b0875bd9a954 = {
    map: $fef752cad57d0747$var$A,
    forEach: $fef752cad57d0747$var$A,
    count: function(n) {
        return n ? (0, $ep79K.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $ep79K.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $ep79K.toChildArray)
}, $fef752cad57d0747$var$T = (0, $ep79K.options).__e;
(0, $ep79K.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $fef752cad57d0747$var$T(n, t, e, r);
};
var $fef752cad57d0747$var$I = (0, $ep79K.options).unmount;
function $fef752cad57d0747$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $fef752cad57d0747$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $fef752cad57d0747$var$L(n, t, e);
    })), n;
}
function $fef752cad57d0747$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $fef752cad57d0747$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $fef752cad57d0747$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $fef752cad57d0747$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $fef752cad57d0747$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $ep79K.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $fef752cad57d0747$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $ep79K.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $fef752cad57d0747$var$I && $fef752cad57d0747$var$I(n);
}, ($fef752cad57d0747$export$74bf444e3cd11ea5.prototype = new (0, $ep79K.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $fef752cad57d0747$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $fef752cad57d0747$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $fef752cad57d0747$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $fef752cad57d0747$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $fef752cad57d0747$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $ep79K.createElement)((0, $ep79K.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $ep79K.createElement)((0, $ep79K.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $fef752cad57d0747$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $fef752cad57d0747$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $fef752cad57d0747$var$j(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $ep79K.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $ep79K.render)((0, $ep79K.createElement)($fef752cad57d0747$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $fef752cad57d0747$export$d39a5bbd09211389(n, e) {
    var r = (0, $ep79K.createElement)($fef752cad57d0747$var$j, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($fef752cad57d0747$export$998bcd577473dd93.prototype = new (0, $ep79K.Component)).__a = function(n) {
    var t = this, e = $fef752cad57d0747$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $fef752cad57d0747$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $fef752cad57d0747$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $ep79K.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $fef752cad57d0747$export$998bcd577473dd93.prototype.componentDidUpdate = $fef752cad57d0747$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $fef752cad57d0747$var$W(n, e, t);
    });
};
var $fef752cad57d0747$var$B = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $fef752cad57d0747$var$H = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $fef752cad57d0747$var$Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $fef752cad57d0747$var$Y = /[A-Z0-9]/g, $fef752cad57d0747$var$$ = "undefined" != typeof document, $fef752cad57d0747$var$q = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $fef752cad57d0747$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $ep79K.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $fef752cad57d0747$export$fa8d919ba61d84db(n, t, e) {
    return (0, $ep79K.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $ep79K.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $ep79K.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $fef752cad57d0747$var$K = (0, $ep79K.options).event;
function $fef752cad57d0747$var$Q() {}
function $fef752cad57d0747$var$X() {
    return this.cancelBubble;
}
function $fef752cad57d0747$var$nn() {
    return this.defaultPrevented;
}
(0, $ep79K.options).event = function(n) {
    return $fef752cad57d0747$var$K && (n = $fef752cad57d0747$var$K(n)), n.persist = $fef752cad57d0747$var$Q, n.isPropagationStopped = $fef752cad57d0747$var$X, n.isDefaultPrevented = $fef752cad57d0747$var$nn, n.nativeEvent = n;
};
var $fef752cad57d0747$var$tn, $fef752cad57d0747$var$en = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $fef752cad57d0747$var$rn = (0, $ep79K.options).vnode;
(0, $ep79K.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $fef752cad57d0747$var$$ && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var l = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "ondoubleclick" === l ? o = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $fef752cad57d0747$var$q(t.type) ? "onfocus" === l ? o = "onfocusin" : "onblur" === l ? o = "onfocusout" : $fef752cad57d0747$var$Z.test(o) ? o = l : -1 === e.indexOf("-") && $fef752cad57d0747$var$H.test(o) ? o = o.replace($fef752cad57d0747$var$Y, "-$&").toLowerCase() : null === i && (i = void 0) : l = o = "oninput", "oninput" === l && u[o = l] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $ep79K.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $ep79K.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $fef752cad57d0747$var$en)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $fef752cad57d0747$var$B, $fef752cad57d0747$var$rn && $fef752cad57d0747$var$rn(n);
};
var $fef752cad57d0747$var$un = (0, $ep79K.options).__r;
(0, $ep79K.options).__r = function(n) {
    $fef752cad57d0747$var$un && $fef752cad57d0747$var$un(n), $fef752cad57d0747$var$tn = n.__c;
};
var $fef752cad57d0747$var$on = (0, $ep79K.options).diffed;
(0, $ep79K.options).diffed = function(n) {
    $fef752cad57d0747$var$on && $fef752cad57d0747$var$on(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $fef752cad57d0747$var$tn = null;
};
var $fef752cad57d0747$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $fef752cad57d0747$var$tn.__n[n.__c].props.value;
            }
        }
    }
}, $fef752cad57d0747$export$83d89fbfd8236492 = "17.0.2";
function $fef752cad57d0747$export$d38cd72104c1f0e9(n) {
    return (0, $ep79K.createElement).bind(null, n);
}
function $fef752cad57d0747$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $fef752cad57d0747$var$B;
}
function $fef752cad57d0747$export$e530037191fcd5d7(n) {
    return $fef752cad57d0747$export$a8257692ac88316c(n) ? (0, $ep79K.cloneElement).apply(null, arguments) : n;
}
function $fef752cad57d0747$export$502457920280e6be(n) {
    return !!n.__k && ((0, $ep79K.render)(null, n), !0);
}
function $fef752cad57d0747$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $fef752cad57d0747$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $fef752cad57d0747$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $fef752cad57d0747$export$5f8d39834fd61797 = (0, $ep79K.Fragment);
function $fef752cad57d0747$export$7568632d0d33d16d(n) {
    n();
}
function $fef752cad57d0747$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $fef752cad57d0747$export$7b286972b8d8ccbf() {
    return [
        !1,
        $fef752cad57d0747$export$7568632d0d33d16d
    ];
}
var $fef752cad57d0747$export$aaabe4eda9ed9969 = (0, $9Raem.useLayoutEffect);
function $fef752cad57d0747$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $9Raem.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $9Raem.useLayoutEffect)(function() {
        u.__ = e, u.v = t, $fef752cad57d0747$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $9Raem.useEffect)(function() {
        return $fef752cad57d0747$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $fef752cad57d0747$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $fef752cad57d0747$export$2e2bcd8739ae039 = {
    useState: (0, $9Raem.useState),
    useId: (0, $9Raem.useId),
    useReducer: (0, $9Raem.useReducer),
    useEffect: (0, $9Raem.useEffect),
    useLayoutEffect: (0, $9Raem.useLayoutEffect),
    useInsertionEffect: $fef752cad57d0747$export$aaabe4eda9ed9969,
    useTransition: $fef752cad57d0747$export$7b286972b8d8ccbf,
    useDeferredValue: $fef752cad57d0747$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $fef752cad57d0747$export$306c0aa65ff9ec16,
    startTransition: $fef752cad57d0747$export$7568632d0d33d16d,
    useRef: (0, $9Raem.useRef),
    useImperativeHandle: (0, $9Raem.useImperativeHandle),
    useMemo: (0, $9Raem.useMemo),
    useCallback: (0, $9Raem.useCallback),
    useContext: (0, $9Raem.useContext),
    useDebugValue: (0, $9Raem.useDebugValue),
    version: "17.0.2",
    Children: $fef752cad57d0747$export$dca3b0875bd9a954,
    render: $fef752cad57d0747$export$b3890eb0ae9dca99,
    hydrate: $fef752cad57d0747$export$fa8d919ba61d84db,
    unmountComponentAtNode: $fef752cad57d0747$export$502457920280e6be,
    createPortal: $fef752cad57d0747$export$d39a5bbd09211389,
    createElement: (0, $ep79K.createElement),
    createContext: (0, $ep79K.createContext),
    createFactory: $fef752cad57d0747$export$d38cd72104c1f0e9,
    cloneElement: $fef752cad57d0747$export$e530037191fcd5d7,
    createRef: (0, $ep79K.createRef),
    Fragment: (0, $ep79K.Fragment),
    isValidElement: $fef752cad57d0747$export$a8257692ac88316c,
    findDOMNode: $fef752cad57d0747$export$466bfc07425424d5,
    Component: (0, $ep79K.Component),
    PureComponent: $fef752cad57d0747$export$221d75b3f55bb0bd,
    memo: $fef752cad57d0747$export$7c73462e0d25e514,
    forwardRef: $fef752cad57d0747$export$257a8862b851cb5b,
    flushSync: $fef752cad57d0747$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $fef752cad57d0747$export$c78a37762a8d58e1,
    StrictMode: $fef752cad57d0747$export$5f8d39834fd61797,
    Suspense: $fef752cad57d0747$export$74bf444e3cd11ea5,
    SuspenseList: $fef752cad57d0747$export$998bcd577473dd93,
    lazy: $fef752cad57d0747$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $fef752cad57d0747$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $9Raem);

});
parcelRequire.register("ep79K", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $a7c8f38afd854ee4$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $a7c8f38afd854ee4$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $a7c8f38afd854ee4$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $a7c8f38afd854ee4$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $a7c8f38afd854ee4$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $a7c8f38afd854ee4$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $a7c8f38afd854ee4$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $a7c8f38afd854ee4$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $a7c8f38afd854ee4$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $a7c8f38afd854ee4$export$fd42f52fd3ae1109; });
var $a7c8f38afd854ee4$var$n, $a7c8f38afd854ee4$export$41c562ebe57d11e2, $a7c8f38afd854ee4$var$u, $a7c8f38afd854ee4$export$a8257692ac88316c, $a7c8f38afd854ee4$var$t, $a7c8f38afd854ee4$var$o, $a7c8f38afd854ee4$var$r, $a7c8f38afd854ee4$var$f, $a7c8f38afd854ee4$var$e, $a7c8f38afd854ee4$var$c = {}, $a7c8f38afd854ee4$var$s = [], $a7c8f38afd854ee4$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $a7c8f38afd854ee4$var$v = Array.isArray;
function $a7c8f38afd854ee4$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $a7c8f38afd854ee4$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $a7c8f38afd854ee4$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $a7c8f38afd854ee4$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $a7c8f38afd854ee4$var$d(l, f, t, o, null);
}
function $a7c8f38afd854ee4$var$d(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$a7c8f38afd854ee4$var$u : r
    };
    return null == r && null != $a7c8f38afd854ee4$export$41c562ebe57d11e2.vnode && $a7c8f38afd854ee4$export$41c562ebe57d11e2.vnode(f), f;
}
function $a7c8f38afd854ee4$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $a7c8f38afd854ee4$export$ffb0004e005737fa(n) {
    return n.children;
}
function $a7c8f38afd854ee4$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $a7c8f38afd854ee4$var$g(n, l) {
    if (null == l) return n.__ ? $a7c8f38afd854ee4$var$g(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $a7c8f38afd854ee4$var$g(n) : null;
}
function $a7c8f38afd854ee4$var$m(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $a7c8f38afd854ee4$var$m(n);
    }
}
function $a7c8f38afd854ee4$var$w(n) {
    (!n.__d && (n.__d = !0) && $a7c8f38afd854ee4$var$t.push(n) && !$a7c8f38afd854ee4$var$x.__r++ || $a7c8f38afd854ee4$var$o !== $a7c8f38afd854ee4$export$41c562ebe57d11e2.debounceRendering) && (($a7c8f38afd854ee4$var$o = $a7c8f38afd854ee4$export$41c562ebe57d11e2.debounceRendering) || $a7c8f38afd854ee4$var$r)($a7c8f38afd854ee4$var$x);
}
function $a7c8f38afd854ee4$var$x() {
    var n, l, u, i, o, r, e, c;
    for($a7c8f38afd854ee4$var$t.sort($a7c8f38afd854ee4$var$f); n = $a7c8f38afd854ee4$var$t.shift();)n.__d && (l = $a7c8f38afd854ee4$var$t.length, i = void 0, o = void 0, e = (r = (u = n).__v).__e, (c = u.__P) && (i = [], (o = $a7c8f38afd854ee4$var$h({}, r)).__v = r.__v + 1, $a7c8f38afd854ee4$var$L(c, r, o, u.__n, void 0 !== c.ownerSVGElement, null != r.__h ? [
        e
    ] : null, i, null == e ? $a7c8f38afd854ee4$var$g(r) : e, r.__h), $a7c8f38afd854ee4$var$M(i, r), r.__e != e && $a7c8f38afd854ee4$var$m(r)), $a7c8f38afd854ee4$var$t.length > l && $a7c8f38afd854ee4$var$t.sort($a7c8f38afd854ee4$var$f));
    $a7c8f38afd854ee4$var$x.__r = 0;
}
function $a7c8f38afd854ee4$var$P(n, l, u, i, t, o, r, f, e, a) {
    var h, p, y, _, b, m, w, x = i && i.__k || $a7c8f38afd854ee4$var$s, P = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ || "function" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $a7c8f38afd854ee4$var$d(null, _, null, null, _) : $a7c8f38afd854ee4$var$v(_) ? $a7c8f38afd854ee4$var$d($a7c8f38afd854ee4$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $a7c8f38afd854ee4$var$d(_.type, _.props, _.key, _.ref ? _.ref : null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (y = x[h]) || y && _.key == y.key && _.type === y.type) x[h] = void 0;
        else for(p = 0; p < P; p++){
            if ((y = x[p]) && _.key == y.key && _.type === y.type) {
                x[p] = void 0;
                break;
            }
            y = null;
        }
        $a7c8f38afd854ee4$var$L(n, _, y = y || $a7c8f38afd854ee4$var$c, t, o, r, f, e, a), b = _.__e, (p = _.ref) && y.ref != p && (w || (w = []), y.ref && w.push(y.ref, null, _), w.push(p, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === y.__k ? _.__d = e = $a7c8f38afd854ee4$var$C(_, e, n) : e = $a7c8f38afd854ee4$var$$(n, _, y, x, b, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $a7c8f38afd854ee4$var$g(y));
    }
    for(u.__e = m, h = P; h--;)null != x[h] && ("function" == typeof u.type && null != x[h].__e && x[h].__e == u.__d && (u.__d = $a7c8f38afd854ee4$var$A(i).nextSibling), $a7c8f38afd854ee4$var$q(x[h], x[h]));
    if (w) for(h = 0; h < w.length; h++)$a7c8f38afd854ee4$var$O(w[h], w[++h], w[++h]);
}
function $a7c8f38afd854ee4$var$C(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $a7c8f38afd854ee4$var$C(i, l, u) : $a7c8f38afd854ee4$var$$(u, i, i, t, i.__e, l));
    return l;
}
function $a7c8f38afd854ee4$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($a7c8f38afd854ee4$var$v(n) ? n.some(function(n) {
        $a7c8f38afd854ee4$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $a7c8f38afd854ee4$var$$(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $a7c8f38afd854ee4$var$A(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $a7c8f38afd854ee4$var$A(u))) return i;
    }
    return null;
}
function $a7c8f38afd854ee4$var$H(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $a7c8f38afd854ee4$var$T(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $a7c8f38afd854ee4$var$T(n, o, l[o], u[o], i);
}
function $a7c8f38afd854ee4$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $a7c8f38afd854ee4$var$a.test(l) ? u : u + "px";
}
function $a7c8f38afd854ee4$var$T(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $a7c8f38afd854ee4$var$I(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $a7c8f38afd854ee4$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $a7c8f38afd854ee4$var$z : $a7c8f38afd854ee4$var$j, o) : n.removeEventListener(l, o ? $a7c8f38afd854ee4$var$z : $a7c8f38afd854ee4$var$j, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $a7c8f38afd854ee4$var$j(n) {
    return this.l[n.type + !1]($a7c8f38afd854ee4$export$41c562ebe57d11e2.event ? $a7c8f38afd854ee4$export$41c562ebe57d11e2.event(n) : n);
}
function $a7c8f38afd854ee4$var$z(n) {
    return this.l[n.type + !0]($a7c8f38afd854ee4$export$41c562ebe57d11e2.event ? $a7c8f38afd854ee4$export$41c562ebe57d11e2.event(n) : n);
}
function $a7c8f38afd854ee4$var$L(n, u, i, t, o, r, f, e, c) {
    var s, a, p, y, d, _, g, m, w, x, C, S, $, A, H, I = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (s = $a7c8f38afd854ee4$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof I) {
            if (m = u.props, w = (s = I.contextType) && t[s.__c], x = s ? w ? w.props.value : s.__ : t, i.__c ? g = (a = u.__c = i.__c).__ = a.__E : ("prototype" in I && I.prototype.render ? u.__c = a = new I(m, x) : (u.__c = a = new $a7c8f38afd854ee4$export$16fa2f45be04daa8(m, x), a.constructor = I, a.render = $a7c8f38afd854ee4$var$B), w && w.sub(a), a.props = m, a.state || (a.state = {}), a.context = x, a.__n = t, p = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != I.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $a7c8f38afd854ee4$var$h({}, a.__s)), $a7c8f38afd854ee4$var$h(a.__s, I.getDerivedStateFromProps(m, a.__s))), y = a.props, d = a.state, a.__v = u, p) null == I.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == I.getDerivedStateFromProps && m !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(m, x), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(m, a.__s, x) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = m, a.state = a.__s, a.__d = !1), a.__e = !1, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(m, a.__s, x), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, d, _);
                });
            }
            if (a.context = x, a.props = m, a.__P = n, S = $a7c8f38afd854ee4$export$41c562ebe57d11e2.__r, $ = 0, "prototype" in I && I.prototype.render) {
                for(a.state = a.__s, a.__d = !1, S && S(u), s = a.render(a.props, a.state, a.context), A = 0; A < a._sb.length; A++)a.__h.push(a._sb[A]);
                a._sb = [];
            } else do a.__d = !1, S && S(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++$ < 25);
            a.state = a.__s, null != a.getChildContext && (t = $a7c8f38afd854ee4$var$h($a7c8f38afd854ee4$var$h({}, t), a.getChildContext())), p || null == a.getSnapshotBeforeUpdate || (_ = a.getSnapshotBeforeUpdate(y, d)), $a7c8f38afd854ee4$var$P(n, $a7c8f38afd854ee4$var$v(H = null != s && s.type === $a7c8f38afd854ee4$export$ffb0004e005737fa && null == s.key ? s.props.children : s) ? H : [
                H
            ], u, i, t, o, r, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), g && (a.__E = a.__ = null), a.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $a7c8f38afd854ee4$var$N(i.__e, u, i, t, o, r, f, c);
        (s = $a7c8f38afd854ee4$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $a7c8f38afd854ee4$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $a7c8f38afd854ee4$var$M(n, u) {
    $a7c8f38afd854ee4$export$41c562ebe57d11e2.__c && $a7c8f38afd854ee4$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $a7c8f38afd854ee4$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $a7c8f38afd854ee4$var$N(l, u, i, t, o, r, f, e) {
    var s, a, h, y = i.props, d = u.props, _ = u.type, k = 0;
    if ("svg" === _ && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!_ && (_ ? s.localName === _ : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === _) return document.createTextNode(d);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, d.is && d), r = null, e = !1;
    }
    if (null === _) y === d || e && l.data === d || (l.data = d);
    else {
        if (r = r && $a7c8f38afd854ee4$var$n.call(l.childNodes), a = (y = i.props || $a7c8f38afd854ee4$var$c).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !e) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($a7c8f38afd854ee4$var$H(l, d, y, o, e), h) u.__k = [];
        else if ($a7c8f38afd854ee4$var$P(l, $a7c8f38afd854ee4$var$v(k = u.props.children) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== _, r, f, r ? r[0] : i.__k && $a7c8f38afd854ee4$var$g(i, 0), e), null != r) for(k = r.length; k--;)null != r[k] && $a7c8f38afd854ee4$var$p(r[k]);
        e || ("value" in d && void 0 !== (k = d.value) && (k !== l.value || "progress" === _ && !k || "option" === _ && k !== y.value) && $a7c8f38afd854ee4$var$T(l, "value", k, y.value, !1), "checked" in d && void 0 !== (k = d.checked) && k !== l.checked && $a7c8f38afd854ee4$var$T(l, "checked", k, y.checked, !1));
    }
    return l;
}
function $a7c8f38afd854ee4$var$O(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $a7c8f38afd854ee4$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $a7c8f38afd854ee4$var$q(n, u, i) {
    var t, o;
    if ($a7c8f38afd854ee4$export$41c562ebe57d11e2.unmount && $a7c8f38afd854ee4$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $a7c8f38afd854ee4$var$O(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $a7c8f38afd854ee4$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $a7c8f38afd854ee4$var$q(t[o], u, i || "function" != typeof n.type);
    i || null == n.__e || $a7c8f38afd854ee4$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $a7c8f38afd854ee4$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $a7c8f38afd854ee4$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, f;
    $a7c8f38afd854ee4$export$41c562ebe57d11e2.__ && $a7c8f38afd854ee4$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $a7c8f38afd854ee4$var$L(i, u = (!o && t || i).__k = $a7c8f38afd854ee4$export$c8a8987d4410bf2d($a7c8f38afd854ee4$export$ffb0004e005737fa, null, [
        u
    ]), r || $a7c8f38afd854ee4$var$c, $a7c8f38afd854ee4$var$c, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $a7c8f38afd854ee4$var$n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), $a7c8f38afd854ee4$var$M(f, u);
}
function $a7c8f38afd854ee4$export$fa8d919ba61d84db(n, l) {
    $a7c8f38afd854ee4$export$b3890eb0ae9dca99(n, l, $a7c8f38afd854ee4$export$fa8d919ba61d84db);
}
function $a7c8f38afd854ee4$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f, e = $a7c8f38afd854ee4$var$h({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $a7c8f38afd854ee4$var$n.call(arguments, 2) : i), $a7c8f38afd854ee4$var$d(l.type, e, t || l.key, o || l.ref, null);
}
function $a7c8f38afd854ee4$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $a7c8f38afd854ee4$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $a7c8f38afd854ee4$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$a7c8f38afd854ee4$var$n = $a7c8f38afd854ee4$var$s.slice, $a7c8f38afd854ee4$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $a7c8f38afd854ee4$var$u = 0, $a7c8f38afd854ee4$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $a7c8f38afd854ee4$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $a7c8f38afd854ee4$var$h({}, this.state), "function" == typeof n && (n = n($a7c8f38afd854ee4$var$h({}, u), this.props)), n && $a7c8f38afd854ee4$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $a7c8f38afd854ee4$var$w(this));
}, $a7c8f38afd854ee4$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $a7c8f38afd854ee4$var$w(this));
}, $a7c8f38afd854ee4$export$16fa2f45be04daa8.prototype.render = $a7c8f38afd854ee4$export$ffb0004e005737fa, $a7c8f38afd854ee4$var$t = [], $a7c8f38afd854ee4$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $a7c8f38afd854ee4$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $a7c8f38afd854ee4$var$x.__r = 0, $a7c8f38afd854ee4$var$e = 0;

});

parcelRequire.register("9Raem", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $72d0ffddd99857fb$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $72d0ffddd99857fb$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $72d0ffddd99857fb$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $72d0ffddd99857fb$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $72d0ffddd99857fb$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $72d0ffddd99857fb$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $72d0ffddd99857fb$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $72d0ffddd99857fb$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $72d0ffddd99857fb$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $72d0ffddd99857fb$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $72d0ffddd99857fb$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $72d0ffddd99857fb$export$f680877a34711e37; });

var $ep79K = parcelRequire("ep79K");
var $72d0ffddd99857fb$var$t, $72d0ffddd99857fb$var$r, $72d0ffddd99857fb$var$u, $72d0ffddd99857fb$var$i, $72d0ffddd99857fb$var$o = 0, $72d0ffddd99857fb$var$f = [], $72d0ffddd99857fb$var$c = [], $72d0ffddd99857fb$var$e = (0, $ep79K.options).__b, $72d0ffddd99857fb$var$a = (0, $ep79K.options).__r, $72d0ffddd99857fb$var$v = (0, $ep79K.options).diffed, $72d0ffddd99857fb$var$l = (0, $ep79K.options).__c, $72d0ffddd99857fb$var$m = (0, $ep79K.options).unmount;
function $72d0ffddd99857fb$var$d(t, u) {
    (0, $ep79K.options).__h && (0, $ep79K.options).__h($72d0ffddd99857fb$var$r, t, $72d0ffddd99857fb$var$o || u), $72d0ffddd99857fb$var$o = 0;
    var i = $72d0ffddd99857fb$var$r.__H || ($72d0ffddd99857fb$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $72d0ffddd99857fb$var$c
    }), i.__[t];
}
function $72d0ffddd99857fb$export$60241385465d0a34(n) {
    return $72d0ffddd99857fb$var$o = 1, $72d0ffddd99857fb$export$13e3392192263954($72d0ffddd99857fb$var$B, n);
}
function $72d0ffddd99857fb$export$13e3392192263954(n, u, i) {
    var o = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $72d0ffddd99857fb$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $72d0ffddd99857fb$var$r, !$72d0ffddd99857fb$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $72d0ffddd99857fb$var$r.u = !0;
        var c = $72d0ffddd99857fb$var$r.shouldComponentUpdate, e = $72d0ffddd99857fb$var$r.componentWillUpdate;
        $72d0ffddd99857fb$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $72d0ffddd99857fb$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $72d0ffddd99857fb$export$6d9c69b0de29b591(u, i) {
    var o = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 3);
    !(0, $ep79K.options).__s && $72d0ffddd99857fb$var$z(o.__H, i) && (o.__ = u, o.i = i, $72d0ffddd99857fb$var$r.__H.__h.push(o));
}
function $72d0ffddd99857fb$export$e5c5a5f917a5871c(u, i) {
    var o = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 4);
    !(0, $ep79K.options).__s && $72d0ffddd99857fb$var$z(o.__H, i) && (o.__ = u, o.i = i, $72d0ffddd99857fb$var$r.__h.push(o));
}
function $72d0ffddd99857fb$export$b8f5890fc79d6aca(n) {
    return $72d0ffddd99857fb$var$o = 5, $72d0ffddd99857fb$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $72d0ffddd99857fb$export$d5a552a76deda3c2(n, t, r) {
    $72d0ffddd99857fb$var$o = 6, $72d0ffddd99857fb$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $72d0ffddd99857fb$export$1538c33de8887b59(n, r) {
    var u = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 7);
    return $72d0ffddd99857fb$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $72d0ffddd99857fb$export$35808ee640e87ca7(n, t) {
    return $72d0ffddd99857fb$var$o = 8, $72d0ffddd99857fb$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $72d0ffddd99857fb$export$fae74005e78b1a27(n) {
    var u = $72d0ffddd99857fb$var$r.context[n.__c], i = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($72d0ffddd99857fb$var$r)), u.props.value) : n.__;
}
function $72d0ffddd99857fb$export$dc8fbce3eb94dc1e(t, r) {
    (0, $ep79K.options).useDebugValue && (0, $ep79K.options).useDebugValue(r ? r(t) : t);
}
function $72d0ffddd99857fb$export$c052f6604b7d51fe(n) {
    var u = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 10), i = $72d0ffddd99857fb$export$60241385465d0a34();
    return u.__ = n, $72d0ffddd99857fb$var$r.componentDidCatch || ($72d0ffddd99857fb$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $72d0ffddd99857fb$export$f680877a34711e37() {
    var n = $72d0ffddd99857fb$var$d($72d0ffddd99857fb$var$t++, 11);
    if (!n.__) {
        for(var u = $72d0ffddd99857fb$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $72d0ffddd99857fb$var$b() {
    for(var t; t = $72d0ffddd99857fb$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($72d0ffddd99857fb$var$k), t.__H.__h.forEach($72d0ffddd99857fb$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $ep79K.options).__e(r, t.__v);
    }
}
(0, $ep79K.options).__b = function(n) {
    $72d0ffddd99857fb$var$r = null, $72d0ffddd99857fb$var$e && $72d0ffddd99857fb$var$e(n);
}, (0, $ep79K.options).__r = function(n) {
    $72d0ffddd99857fb$var$a && $72d0ffddd99857fb$var$a(n), $72d0ffddd99857fb$var$t = 0;
    var i = ($72d0ffddd99857fb$var$r = n.__c).__H;
    i && ($72d0ffddd99857fb$var$u === $72d0ffddd99857fb$var$r ? (i.__h = [], $72d0ffddd99857fb$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $72d0ffddd99857fb$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($72d0ffddd99857fb$var$k), i.__h.forEach($72d0ffddd99857fb$var$w), i.__h = [], $72d0ffddd99857fb$var$t = 0)), $72d0ffddd99857fb$var$u = $72d0ffddd99857fb$var$r;
}, (0, $ep79K.options).diffed = function(t) {
    $72d0ffddd99857fb$var$v && $72d0ffddd99857fb$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $72d0ffddd99857fb$var$f.push(o) && $72d0ffddd99857fb$var$i === (0, $ep79K.options).requestAnimationFrame || (($72d0ffddd99857fb$var$i = (0, $ep79K.options).requestAnimationFrame) || $72d0ffddd99857fb$var$j)($72d0ffddd99857fb$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $72d0ffddd99857fb$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $72d0ffddd99857fb$var$c;
    })), $72d0ffddd99857fb$var$u = $72d0ffddd99857fb$var$r = null;
}, (0, $ep79K.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($72d0ffddd99857fb$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $72d0ffddd99857fb$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $ep79K.options).__e(u, t.__v);
        }
    }), $72d0ffddd99857fb$var$l && $72d0ffddd99857fb$var$l(t, r);
}, (0, $ep79K.options).unmount = function(t) {
    $72d0ffddd99857fb$var$m && $72d0ffddd99857fb$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $72d0ffddd99857fb$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $ep79K.options).__e(r, u.__v));
};
var $72d0ffddd99857fb$var$g = "function" == typeof requestAnimationFrame;
function $72d0ffddd99857fb$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $72d0ffddd99857fb$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $72d0ffddd99857fb$var$g && (t = requestAnimationFrame(r));
}
function $72d0ffddd99857fb$var$k(n) {
    var t = $72d0ffddd99857fb$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $72d0ffddd99857fb$var$r = t;
}
function $72d0ffddd99857fb$var$w(n) {
    var t = $72d0ffddd99857fb$var$r;
    n.__c = n.__(), $72d0ffddd99857fb$var$r = t;
}
function $72d0ffddd99857fb$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $72d0ffddd99857fb$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


parcelRequire.register("bPlKw", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $89c5541f7a28cb15$export$2b8d127b894957b9; }, function (v) { return $89c5541f7a28cb15$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $89c5541f7a28cb15$export$cea3a54a6425200c; }, function (v) { return $89c5541f7a28cb15$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $89c5541f7a28cb15$export$a7c73072b1a182ae; }, function (v) { return $89c5541f7a28cb15$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $89c5541f7a28cb15$export$9f27bc3417b4524d; }, function (v) { return $89c5541f7a28cb15$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $89c5541f7a28cb15$export$db77ccec0bb4ccac; }, function (v) { return $89c5541f7a28cb15$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $89c5541f7a28cb15$export$8392c0c9d3dcbd35; }, function (v) { return $89c5541f7a28cb15$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $89c5541f7a28cb15$export$ffb0004e005737fa; }, function (v) { return $89c5541f7a28cb15$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $89c5541f7a28cb15$export$b624eff549462981; }, function (v) { return $89c5541f7a28cb15$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $89c5541f7a28cb15$export$7897aa7841a5380c; }, function (v) { return $89c5541f7a28cb15$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $89c5541f7a28cb15$export$602eac185826482c; }, function (v) { return $89c5541f7a28cb15$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $89c5541f7a28cb15$export$e2c29f18771995cb; }, function (v) { return $89c5541f7a28cb15$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $89c5541f7a28cb15$export$5f8d39834fd61797; }, function (v) { return $89c5541f7a28cb15$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $89c5541f7a28cb15$export$74bf444e3cd11ea5; }, function (v) { return $89c5541f7a28cb15$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $89c5541f7a28cb15$export$92387174baf9b227; }, function (v) { return $89c5541f7a28cb15$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $89c5541f7a28cb15$export$ec112efeb987d9c6; }, function (v) { return $89c5541f7a28cb15$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $89c5541f7a28cb15$export$b706b080d889d2c9; }, function (v) { return $89c5541f7a28cb15$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $89c5541f7a28cb15$export$5be5a87408f70ddc; }, function (v) { return $89c5541f7a28cb15$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $89c5541f7a28cb15$export$45a5e7f76e0caa8d; }, function (v) { return $89c5541f7a28cb15$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $89c5541f7a28cb15$export$455c2e768291efa6; }, function (v) { return $89c5541f7a28cb15$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $89c5541f7a28cb15$export$9522e17588c12572; }, function (v) { return $89c5541f7a28cb15$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $89c5541f7a28cb15$export$2110ac352bb060b9; }, function (v) { return $89c5541f7a28cb15$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $89c5541f7a28cb15$export$56885ab8b9c456ab; }, function (v) { return $89c5541f7a28cb15$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $89c5541f7a28cb15$export$d927fcb6adf8f9de; }, function (v) { return $89c5541f7a28cb15$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $89c5541f7a28cb15$export$b82d16f27459e05a; }, function (v) { return $89c5541f7a28cb15$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $89c5541f7a28cb15$export$522c17b4f5e123e8; }, function (v) { return $89c5541f7a28cb15$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $89c5541f7a28cb15$export$1aabd8a0274ecfd6; }, function (v) { return $89c5541f7a28cb15$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $89c5541f7a28cb15$export$9b621391a187a31a; }, function (v) { return $89c5541f7a28cb15$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $89c5541f7a28cb15$export$f5bbd400c2f4426f; }, function (v) { return $89c5541f7a28cb15$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89c5541f7a28cb15$export$2b8d127b894957b9;
var $89c5541f7a28cb15$export$cea3a54a6425200c;
var $89c5541f7a28cb15$export$a7c73072b1a182ae;
var $89c5541f7a28cb15$export$9f27bc3417b4524d;
var $89c5541f7a28cb15$export$db77ccec0bb4ccac;
var $89c5541f7a28cb15$export$8392c0c9d3dcbd35;
var $89c5541f7a28cb15$export$ffb0004e005737fa;
var $89c5541f7a28cb15$export$b624eff549462981;
var $89c5541f7a28cb15$export$7897aa7841a5380c;
var $89c5541f7a28cb15$export$602eac185826482c;
var $89c5541f7a28cb15$export$e2c29f18771995cb;
var $89c5541f7a28cb15$export$5f8d39834fd61797;
var $89c5541f7a28cb15$export$74bf444e3cd11ea5;
var $89c5541f7a28cb15$export$92387174baf9b227;
var $89c5541f7a28cb15$export$ec112efeb987d9c6;
var $89c5541f7a28cb15$export$b706b080d889d2c9;
var $89c5541f7a28cb15$export$5be5a87408f70ddc;
var $89c5541f7a28cb15$export$45a5e7f76e0caa8d;
var $89c5541f7a28cb15$export$455c2e768291efa6;
var $89c5541f7a28cb15$export$9522e17588c12572;
var $89c5541f7a28cb15$export$2110ac352bb060b9;
var $89c5541f7a28cb15$export$56885ab8b9c456ab;
var $89c5541f7a28cb15$export$d927fcb6adf8f9de;
var $89c5541f7a28cb15$export$b82d16f27459e05a;
var $89c5541f7a28cb15$export$522c17b4f5e123e8;
var $89c5541f7a28cb15$export$1aabd8a0274ecfd6;
var $89c5541f7a28cb15$export$9b621391a187a31a;
var $89c5541f7a28cb15$export$f5bbd400c2f4426f;
"use strict";
var $89c5541f7a28cb15$var$b = "function" === typeof Symbol && Symbol.for, $89c5541f7a28cb15$var$c = $89c5541f7a28cb15$var$b ? Symbol.for("react.element") : 60103, $89c5541f7a28cb15$var$d = $89c5541f7a28cb15$var$b ? Symbol.for("react.portal") : 60106, $89c5541f7a28cb15$var$e = $89c5541f7a28cb15$var$b ? Symbol.for("react.fragment") : 60107, $89c5541f7a28cb15$var$f = $89c5541f7a28cb15$var$b ? Symbol.for("react.strict_mode") : 60108, $89c5541f7a28cb15$var$g = $89c5541f7a28cb15$var$b ? Symbol.for("react.profiler") : 60114, $89c5541f7a28cb15$var$h = $89c5541f7a28cb15$var$b ? Symbol.for("react.provider") : 60109, $89c5541f7a28cb15$var$k = $89c5541f7a28cb15$var$b ? Symbol.for("react.context") : 60110, $89c5541f7a28cb15$var$l = $89c5541f7a28cb15$var$b ? Symbol.for("react.async_mode") : 60111, $89c5541f7a28cb15$var$m = $89c5541f7a28cb15$var$b ? Symbol.for("react.concurrent_mode") : 60111, $89c5541f7a28cb15$var$n = $89c5541f7a28cb15$var$b ? Symbol.for("react.forward_ref") : 60112, $89c5541f7a28cb15$var$p = $89c5541f7a28cb15$var$b ? Symbol.for("react.suspense") : 60113, $89c5541f7a28cb15$var$q = $89c5541f7a28cb15$var$b ? Symbol.for("react.suspense_list") : 60120, $89c5541f7a28cb15$var$r = $89c5541f7a28cb15$var$b ? Symbol.for("react.memo") : 60115, $89c5541f7a28cb15$var$t = $89c5541f7a28cb15$var$b ? Symbol.for("react.lazy") : 60116, $89c5541f7a28cb15$var$v = $89c5541f7a28cb15$var$b ? Symbol.for("react.block") : 60121, $89c5541f7a28cb15$var$w = $89c5541f7a28cb15$var$b ? Symbol.for("react.fundamental") : 60117, $89c5541f7a28cb15$var$x = $89c5541f7a28cb15$var$b ? Symbol.for("react.responder") : 60118, $89c5541f7a28cb15$var$y = $89c5541f7a28cb15$var$b ? Symbol.for("react.scope") : 60119;
function $89c5541f7a28cb15$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $89c5541f7a28cb15$var$c:
                switch(a = a.type, a){
                    case $89c5541f7a28cb15$var$l:
                    case $89c5541f7a28cb15$var$m:
                    case $89c5541f7a28cb15$var$e:
                    case $89c5541f7a28cb15$var$g:
                    case $89c5541f7a28cb15$var$f:
                    case $89c5541f7a28cb15$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $89c5541f7a28cb15$var$k:
                            case $89c5541f7a28cb15$var$n:
                            case $89c5541f7a28cb15$var$t:
                            case $89c5541f7a28cb15$var$r:
                            case $89c5541f7a28cb15$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $89c5541f7a28cb15$var$d:
                return u;
        }
    }
}
function $89c5541f7a28cb15$var$A(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$m;
}
$89c5541f7a28cb15$export$2b8d127b894957b9 = $89c5541f7a28cb15$var$l;
$89c5541f7a28cb15$export$cea3a54a6425200c = $89c5541f7a28cb15$var$m;
$89c5541f7a28cb15$export$a7c73072b1a182ae = $89c5541f7a28cb15$var$k;
$89c5541f7a28cb15$export$9f27bc3417b4524d = $89c5541f7a28cb15$var$h;
$89c5541f7a28cb15$export$db77ccec0bb4ccac = $89c5541f7a28cb15$var$c;
$89c5541f7a28cb15$export$8392c0c9d3dcbd35 = $89c5541f7a28cb15$var$n;
$89c5541f7a28cb15$export$ffb0004e005737fa = $89c5541f7a28cb15$var$e;
$89c5541f7a28cb15$export$b624eff549462981 = $89c5541f7a28cb15$var$t;
$89c5541f7a28cb15$export$7897aa7841a5380c = $89c5541f7a28cb15$var$r;
$89c5541f7a28cb15$export$602eac185826482c = $89c5541f7a28cb15$var$d;
$89c5541f7a28cb15$export$e2c29f18771995cb = $89c5541f7a28cb15$var$g;
$89c5541f7a28cb15$export$5f8d39834fd61797 = $89c5541f7a28cb15$var$f;
$89c5541f7a28cb15$export$74bf444e3cd11ea5 = $89c5541f7a28cb15$var$p;
$89c5541f7a28cb15$export$92387174baf9b227 = function(a) {
    return $89c5541f7a28cb15$var$A(a) || $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$l;
};
$89c5541f7a28cb15$export$ec112efeb987d9c6 = $89c5541f7a28cb15$var$A;
$89c5541f7a28cb15$export$b706b080d889d2c9 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$k;
};
$89c5541f7a28cb15$export$5be5a87408f70ddc = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$h;
};
$89c5541f7a28cb15$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $89c5541f7a28cb15$var$c;
};
$89c5541f7a28cb15$export$455c2e768291efa6 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$n;
};
$89c5541f7a28cb15$export$9522e17588c12572 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$e;
};
$89c5541f7a28cb15$export$2110ac352bb060b9 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$t;
};
$89c5541f7a28cb15$export$56885ab8b9c456ab = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$r;
};
$89c5541f7a28cb15$export$d927fcb6adf8f9de = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$d;
};
$89c5541f7a28cb15$export$b82d16f27459e05a = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$g;
};
$89c5541f7a28cb15$export$522c17b4f5e123e8 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$f;
};
$89c5541f7a28cb15$export$1aabd8a0274ecfd6 = function(a) {
    return $89c5541f7a28cb15$var$z(a) === $89c5541f7a28cb15$var$p;
};
$89c5541f7a28cb15$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $89c5541f7a28cb15$var$e || a === $89c5541f7a28cb15$var$m || a === $89c5541f7a28cb15$var$g || a === $89c5541f7a28cb15$var$f || a === $89c5541f7a28cb15$var$p || a === $89c5541f7a28cb15$var$q || "object" === typeof a && null !== a && (a.$$typeof === $89c5541f7a28cb15$var$t || a.$$typeof === $89c5541f7a28cb15$var$r || a.$$typeof === $89c5541f7a28cb15$var$h || a.$$typeof === $89c5541f7a28cb15$var$k || a.$$typeof === $89c5541f7a28cb15$var$n || a.$$typeof === $89c5541f7a28cb15$var$w || a.$$typeof === $89c5541f7a28cb15$var$x || a.$$typeof === $89c5541f7a28cb15$var$y || a.$$typeof === $89c5541f7a28cb15$var$v);
};
$89c5541f7a28cb15$export$f5bbd400c2f4426f = $89c5541f7a28cb15$var$z;

});

parcelRequire.register("hkaDl", function(module, exports) {
"use strict";

var $j4Kfh = parcelRequire("j4Kfh");

var $c2EI1 = parcelRequire("c2EI1");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDomTreeShapes = $c9cc8d8e6114c29b$var$getDomTreeShapes;
module.exports.findNativeHandler = $c9cc8d8e6114c29b$var$findNativeHandler;
module.exports.default = module.exports.SwipeableViewsContext = void 0;

var $c9cc8d8e6114c29b$var$_extends2 = $c2EI1((parcelRequire("c2dZ0")));

var $c9cc8d8e6114c29b$var$_objectWithoutProperties2 = $c2EI1((parcelRequire("2LVuF")));

var $c9cc8d8e6114c29b$var$_classCallCheck2 = $c2EI1((parcelRequire("4TC9g")));

var $c9cc8d8e6114c29b$var$_createClass2 = $c2EI1((parcelRequire("5JIpT")));

var $c9cc8d8e6114c29b$var$_possibleConstructorReturn2 = $c2EI1((parcelRequire("1qGqe")));

var $c9cc8d8e6114c29b$var$_getPrototypeOf2 = $c2EI1((parcelRequire("cGqyA")));

var $c9cc8d8e6114c29b$var$_inherits2 = $c2EI1((parcelRequire("i1aL6")));

var $c9cc8d8e6114c29b$var$React = $j4Kfh((parcelRequire("lTb4y")));

var $c9cc8d8e6114c29b$var$_propTypes = $c2EI1((parcelRequire("c0NVP")));

var $c9cc8d8e6114c29b$var$_warning = $c2EI1((parcelRequire("fiGG7")));

var $8iRar = parcelRequire("8iRar");
function $c9cc8d8e6114c29b$var$addEventListener(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return {
        remove: function remove() {
            node.removeEventListener(event, handler, options);
        }
    };
}
var $c9cc8d8e6114c29b$var$styles = {
    container: {
        direction: "ltr",
        display: "flex",
        willChange: "transform"
    },
    slide: {
        width: "100%",
        WebkitFlexShrink: 0,
        flexShrink: 0,
        overflow: "auto"
    }
};
var $c9cc8d8e6114c29b$var$axisProperties = {
    root: {
        x: {
            overflowX: "hidden"
        },
        "x-reverse": {
            overflowX: "hidden"
        },
        y: {
            overflowY: "hidden"
        },
        "y-reverse": {
            overflowY: "hidden"
        }
    },
    flexDirection: {
        x: "row",
        "x-reverse": "row-reverse",
        y: "column",
        "y-reverse": "column-reverse"
    },
    transform: {
        x: function x(translate) {
            return "translate(".concat(-translate, "%, 0)");
        },
        "x-reverse": function xReverse(translate) {
            return "translate(".concat(translate, "%, 0)");
        },
        y: function y(translate) {
            return "translate(0, ".concat(-translate, "%)");
        },
        "y-reverse": function yReverse(translate) {
            return "translate(0, ".concat(translate, "%)");
        }
    },
    length: {
        x: "width",
        "x-reverse": "width",
        y: "height",
        "y-reverse": "height"
    },
    rotationMatrix: {
        x: {
            x: [
                1,
                0
            ],
            y: [
                0,
                1
            ]
        },
        "x-reverse": {
            x: [
                -1,
                0
            ],
            y: [
                0,
                1
            ]
        },
        y: {
            x: [
                0,
                1
            ],
            y: [
                1,
                0
            ]
        },
        "y-reverse": {
            x: [
                0,
                -1
            ],
            y: [
                1,
                0
            ]
        }
    },
    scrollPosition: {
        x: "scrollLeft",
        "x-reverse": "scrollLeft",
        y: "scrollTop",
        "y-reverse": "scrollTop"
    },
    scrollLength: {
        x: "scrollWidth",
        "x-reverse": "scrollWidth",
        y: "scrollHeight",
        "y-reverse": "scrollHeight"
    },
    clientLength: {
        x: "clientWidth",
        "x-reverse": "clientWidth",
        y: "clientHeight",
        "y-reverse": "clientHeight"
    }
};
function $c9cc8d8e6114c29b$var$createTransition(property, options) {
    var duration = options.duration, easeFunction = options.easeFunction, delay = options.delay;
    return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.
function $c9cc8d8e6114c29b$var$applyRotationMatrix(touch, axis) {
    var rotationMatrix = $c9cc8d8e6114c29b$var$axisProperties.rotationMatrix[axis];
    return {
        pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
        pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
    };
}
function $c9cc8d8e6114c29b$var$adaptMouse(event) {
    event.touches = [
        {
            pageX: event.pageX,
            pageY: event.pageY
        }
    ];
    return event;
}
function $c9cc8d8e6114c29b$var$getDomTreeShapes(element, rootNode) {
    var domTreeShapes = [];
    while(element && element !== rootNode && element !== document.body){
        // We reach a Swipeable View, no need to look higher in the dom tree.
        if (element.hasAttribute("data-swipeable")) break;
        var style = window.getComputedStyle(element);
        if (style.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue("overflow-x") === "hidden") domTreeShapes = [];
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push({
            element: element,
            scrollWidth: element.scrollWidth,
            scrollHeight: element.scrollHeight,
            clientWidth: element.clientWidth,
            clientHeight: element.clientHeight,
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        });
        element = element.parentNode;
    }
    return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
var $c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll = null;
function $c9cc8d8e6114c29b$var$findNativeHandler(params) {
    var domTreeShapes = params.domTreeShapes, pageX = params.pageX, startX = params.startX, axis = params.axis;
    return domTreeShapes.some(function(shape) {
        // Determine if we are going backward or forward.
        var goingForward = pageX >= startX;
        if (axis === "x" || axis === "y") goingForward = !goingForward;
         // scrollTop is not always be an integer.
        // https://github.com/jquery/api.jquery.com/issues/608
        var scrollPosition = Math.round(shape[$c9cc8d8e6114c29b$var$axisProperties.scrollPosition[axis]]);
        var areNotAtStart = scrollPosition > 0;
        var areNotAtEnd = scrollPosition + shape[$c9cc8d8e6114c29b$var$axisProperties.clientLength[axis]] < shape[$c9cc8d8e6114c29b$var$axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
            $c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll = shape.element;
            return true;
        }
        return false;
    });
}
var $c9cc8d8e6114c29b$var$SwipeableViewsContext = $c9cc8d8e6114c29b$var$React.createContext();
module.exports.SwipeableViewsContext = $c9cc8d8e6114c29b$var$SwipeableViewsContext;
var $c9cc8d8e6114c29b$var$SwipeableViews = /*#__PURE__*/ function(_React$Component) {
    (0, $c9cc8d8e6114c29b$var$_inherits2.default)(SwipeableViews, _React$Component);
    function SwipeableViews(props) {
        var _this;
        (0, $c9cc8d8e6114c29b$var$_classCallCheck2.default)(this, SwipeableViews);
        _this = (0, $c9cc8d8e6114c29b$var$_possibleConstructorReturn2.default)(this, (0, $c9cc8d8e6114c29b$var$_getPrototypeOf2.default)(SwipeableViews).call(this, props));
        _this.rootNode = null;
        _this.containerNode = null;
        _this.ignoreNextScrollEvents = false;
        _this.viewLength = 0;
        _this.startX = 0;
        _this.lastX = 0;
        _this.vx = 0;
        _this.startY = 0;
        _this.isSwiping = undefined;
        _this.started = false;
        _this.startIndex = 0;
        _this.transitionListener = null;
        _this.touchMoveListener = null;
        _this.activeSlide = null;
        _this.indexCurrent = null;
        _this.firstRenderTimeout = null;
        _this.setRootNode = function(node) {
            _this.rootNode = node;
        };
        _this.setContainerNode = function(node) {
            _this.containerNode = node;
        };
        _this.setActiveSlide = function(node) {
            _this.activeSlide = node;
            _this.updateHeight();
        };
        _this.handleSwipeStart = function(event) {
            var axis = _this.props.axis;
            var touch = $c9cc8d8e6114c29b$var$applyRotationMatrix(event.touches[0], axis);
            _this.viewLength = _this.rootNode.getBoundingClientRect()[$c9cc8d8e6114c29b$var$axisProperties.length[axis]];
            _this.startX = touch.pageX;
            _this.lastX = touch.pageX;
            _this.vx = 0;
            _this.startY = touch.pageY;
            _this.isSwiping = undefined;
            _this.started = true;
            var computedStyle = window.getComputedStyle(_this.containerNode);
            var transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
            if (transform && transform !== "none") {
                var transformValues = transform.split("(")[1].split(")")[0].split(",");
                var rootStyle = window.getComputedStyle(_this.rootNode);
                var tranformNormalized = $c9cc8d8e6114c29b$var$applyRotationMatrix({
                    pageX: parseInt(transformValues[4], 10),
                    pageY: parseInt(transformValues[5], 10)
                }, axis);
                _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
            }
        };
        _this.handleSwipeMove = function(event) {
            // The touch start event can be cancel.
            // Makes sure we set a starting point.
            if (!_this.started) {
                _this.handleTouchStart(event);
                return;
            } // We are not supposed to hanlde this touch move.
            if ($c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll !== null && $c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll !== _this.rootNode) return;
            var _this$props = _this.props, axis = _this$props.axis, children = _this$props.children, ignoreNativeScroll = _this$props.ignoreNativeScroll, onSwitching = _this$props.onSwitching, resistance = _this$props.resistance;
            var touch = $c9cc8d8e6114c29b$var$applyRotationMatrix(event.touches[0], axis); // We don't know yet.
            if (_this.isSwiping === undefined) {
                var dx = Math.abs(touch.pageX - _this.startX);
                var dy = Math.abs(touch.pageY - _this.startY);
                var isSwiping = dx > dy && dx > $8iRar.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.
                if (!resistance && (axis === "y" || axis === "y-reverse") && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === $c9cc8d8e6114c29b$var$React.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
                    _this.isSwiping = false;
                    return;
                } // We are likely to be swiping, let's prevent the scroll event.
                if (dx > dy) event.preventDefault();
                if (isSwiping === true || dy > $8iRar.constant.UNCERTAINTY_THRESHOLD) {
                    _this.isSwiping = isSwiping;
                    _this.startX = touch.pageX; // Shift the starting point.
                    return; // Let's wait the next touch event to move something.
                }
            }
            if (_this.isSwiping !== true) return;
             // We are swiping, let's prevent the scroll event.
            event.preventDefault(); // Low Pass filter.
            _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
            _this.lastX = touch.pageX;
            var _computeIndex = (0, $8iRar.computeIndex)({
                children: children,
                resistance: resistance,
                pageX: touch.pageX,
                startIndex: _this.startIndex,
                startX: _this.startX,
                viewLength: _this.viewLength
            }), index = _computeIndex.index, startX = _computeIndex.startX; // Add support for native scroll elements.
            if ($c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
                var domTreeShapes = $c9cc8d8e6114c29b$var$getDomTreeShapes(event.target, _this.rootNode);
                var hasFoundNativeHandler = $c9cc8d8e6114c29b$var$findNativeHandler({
                    domTreeShapes: domTreeShapes,
                    startX: _this.startX,
                    pageX: touch.pageX,
                    axis: axis
                }); // We abort the touch move handler.
                if (hasFoundNativeHandler) return;
            } // We are moving toward the edges.
            if (startX) _this.startX = startX;
            else if ($c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll === null) $c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll = _this.rootNode;
            _this.setIndexCurrent(index);
            var callback = function callback() {
                if (onSwitching) onSwitching(index, "move");
            };
            if (_this.state.displaySameSlide || !_this.state.isDragging) _this.setState({
                displaySameSlide: false,
                isDragging: true
            }, callback);
            callback();
        };
        _this.handleSwipeEnd = function() {
            $c9cc8d8e6114c29b$var$nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
            // Makes sure that a starting point is set.
            if (!_this.started) return;
            _this.started = false;
            if (_this.isSwiping !== true) return;
            var indexLatest = _this.state.indexLatest;
            var indexCurrent = _this.indexCurrent;
            var delta = indexLatest - indexCurrent;
            var indexNew; // Quick movement
            if (Math.abs(_this.vx) > _this.props.threshold) {
                if (_this.vx > 0) indexNew = Math.floor(indexCurrent);
                else indexNew = Math.ceil(indexCurrent);
            } else if (Math.abs(delta) > _this.props.hysteresis) // Some hysteresis with indexLatest.
            indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
            else indexNew = indexLatest;
            var indexMax = $c9cc8d8e6114c29b$var$React.Children.count(_this.props.children) - 1;
            if (indexNew < 0) indexNew = 0;
            else if (indexNew > indexMax) indexNew = indexMax;
            _this.setIndexCurrent(indexNew);
            _this.setState({
                indexLatest: indexNew,
                isDragging: false
            }, function() {
                if (_this.props.onSwitching) _this.props.onSwitching(indexNew, "end");
                if (_this.props.onChangeIndex && indexNew !== indexLatest) _this.props.onChangeIndex(indexNew, indexLatest, {
                    reason: "swipe"
                });
                 // Manually calling handleTransitionEnd in that case as isn't otherwise.
                if (indexCurrent === indexLatest) _this.handleTransitionEnd();
            });
        };
        _this.handleTouchStart = function(event) {
            if (_this.props.onTouchStart) _this.props.onTouchStart(event);
            _this.handleSwipeStart(event);
        };
        _this.handleTouchEnd = function(event) {
            if (_this.props.onTouchEnd) _this.props.onTouchEnd(event);
            _this.handleSwipeEnd(event);
        };
        _this.handleMouseDown = function(event) {
            if (_this.props.onMouseDown) _this.props.onMouseDown(event);
            event.persist();
            _this.handleSwipeStart($c9cc8d8e6114c29b$var$adaptMouse(event));
        };
        _this.handleMouseUp = function(event) {
            if (_this.props.onMouseUp) _this.props.onMouseUp(event);
            _this.handleSwipeEnd($c9cc8d8e6114c29b$var$adaptMouse(event));
        };
        _this.handleMouseLeave = function(event) {
            if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
             // Filter out events
            if (_this.started) _this.handleSwipeEnd($c9cc8d8e6114c29b$var$adaptMouse(event));
        };
        _this.handleMouseMove = function(event) {
            if (_this.props.onMouseMove) _this.props.onMouseMove(event);
             // Filter out events
            if (_this.started) _this.handleSwipeMove($c9cc8d8e6114c29b$var$adaptMouse(event));
        };
        _this.handleScroll = function(event) {
            if (_this.props.onScroll) _this.props.onScroll(event);
             // Ignore events bubbling up.
            if (event.target !== _this.rootNode) return;
            if (_this.ignoreNextScrollEvents) {
                _this.ignoreNextScrollEvents = false;
                return;
            }
            var indexLatest = _this.state.indexLatest;
            var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
            _this.ignoreNextScrollEvents = true; // Reset the scroll position.
            event.target.scrollLeft = 0;
            if (_this.props.onChangeIndex && indexNew !== indexLatest) _this.props.onChangeIndex(indexNew, indexLatest, {
                reason: "focus"
            });
        };
        _this.updateHeight = function() {
            if (_this.activeSlide !== null) {
                var child = _this.activeSlide.children[0];
                if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) _this.setState({
                    heightLatest: child.offsetHeight
                });
            }
        };
        _this.state = {
            indexLatest: props.index,
            // Set to true as soon as the component is swiping.
            // It's the state counter part of this.isSwiping.
            isDragging: false,
            // Help with SSR logic and lazy loading logic.
            renderOnlyActive: !props.disableLazyLoading,
            heightLatest: 0,
            // Let the render method that we are going to display the same slide than previously.
            displaySameSlide: true
        };
        _this.setIndexCurrent(props.index);
        return _this;
    }
    (0, $c9cc8d8e6114c29b$var$_createClass2.default)(SwipeableViews, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // Subscribe to transition end events.
                this.transitionListener = $c9cc8d8e6114c29b$var$addEventListener(this.containerNode, "transitionend", function(event) {
                    if (event.target !== _this2.containerNode) return;
                    _this2.handleTransitionEnd();
                }); // Block the thread to handle that event.
                this.touchMoveListener = $c9cc8d8e6114c29b$var$addEventListener(this.rootNode, "touchmove", function(event) {
                    // Handling touch events is disabled.
                    if (_this2.props.disabled) return;
                    _this2.handleSwipeMove(event);
                }, {
                    passive: false
                });
                if (!this.props.disableLazyLoading) this.firstRenderTimeout = setTimeout(function() {
                    _this2.setState({
                        renderOnlyActive: false
                    });
                }, 0);
                 // Send all functions in an object if action param is set.
                if (this.props.action) this.props.action({
                    updateHeight: this.updateHeight
                });
            } // eslint-disable-next-line camelcase,react/sort-comp
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var index = nextProps.index;
                if (typeof index === "number" && index !== this.props.index) {
                    this.setIndexCurrent(index);
                    this.setState({
                        // If true, we are going to change the children. We shoudn't animate it.
                        displaySameSlide: (0, $8iRar.getDisplaySameSlide)(this.props, nextProps),
                        indexLatest: index
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.transitionListener.remove();
                this.touchMoveListener.remove();
                clearTimeout(this.firstRenderTimeout);
            }
        },
        {
            key: "getSwipeableViewsContext",
            value: function getSwipeableViewsContext() {
                var _this3 = this;
                return {
                    slideUpdateHeight: function slideUpdateHeight() {
                        _this3.updateHeight();
                    }
                };
            }
        },
        {
            key: "setIndexCurrent",
            value: function setIndexCurrent(indexCurrent) {
                if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) this.handleTransitionEnd();
                this.indexCurrent = indexCurrent;
                if (this.containerNode) {
                    var axis = this.props.axis;
                    var transform = $c9cc8d8e6114c29b$var$axisProperties.transform[axis](indexCurrent * 100);
                    this.containerNode.style.WebkitTransform = transform;
                    this.containerNode.style.transform = transform;
                }
            }
        },
        {
            key: "handleTransitionEnd",
            value: function handleTransitionEnd() {
                if (!this.props.onTransitionEnd) return;
                 // Filters out when changing the children
                if (this.state.displaySameSlide) return;
                 // The rest callback is triggered when swiping. It's just noise.
                // We filter it out.
                if (!this.state.isDragging) this.props.onTransitionEnd();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$props2 = this.props, action = _this$props2.action, animateHeight = _this$props2.animateHeight, animateTransitions = _this$props2.animateTransitions, axis = _this$props2.axis, children = _this$props2.children, containerStyleProp = _this$props2.containerStyle, disabled = _this$props2.disabled, disableLazyLoading = _this$props2.disableLazyLoading, enableMouseEvents = _this$props2.enableMouseEvents, hysteresis = _this$props2.hysteresis, ignoreNativeScroll = _this$props2.ignoreNativeScroll, index = _this$props2.index, onChangeIndex = _this$props2.onChangeIndex, onSwitching = _this$props2.onSwitching, onTransitionEnd = _this$props2.onTransitionEnd, resistance = _this$props2.resistance, slideStyleProp = _this$props2.slideStyle, slideClassName = _this$props2.slideClassName, springConfig = _this$props2.springConfig, style = _this$props2.style, threshold = _this$props2.threshold, other = (0, $c9cc8d8e6114c29b$var$_objectWithoutProperties2.default)(_this$props2, [
                    "action",
                    "animateHeight",
                    "animateTransitions",
                    "axis",
                    "children",
                    "containerStyle",
                    "disabled",
                    "disableLazyLoading",
                    "enableMouseEvents",
                    "hysteresis",
                    "ignoreNativeScroll",
                    "index",
                    "onChangeIndex",
                    "onSwitching",
                    "onTransitionEnd",
                    "resistance",
                    "slideStyle",
                    "slideClassName",
                    "springConfig",
                    "style",
                    "threshold"
                ]);
                var _this$state = this.state, displaySameSlide = _this$state.displaySameSlide, heightLatest = _this$state.heightLatest, indexLatest = _this$state.indexLatest, isDragging = _this$state.isDragging, renderOnlyActive = _this$state.renderOnlyActive;
                var touchEvents = !disabled ? {
                    onTouchStart: this.handleTouchStart,
                    onTouchEnd: this.handleTouchEnd
                } : {};
                var mouseEvents = !disabled && enableMouseEvents ? {
                    onMouseDown: this.handleMouseDown,
                    onMouseUp: this.handleMouseUp,
                    onMouseLeave: this.handleMouseLeave,
                    onMouseMove: this.handleMouseMove
                } : {}; // There is no point to animate if we are already providing a height.
                var slideStyle = (0, $c9cc8d8e6114c29b$var$_extends2.default)({}, $c9cc8d8e6114c29b$var$styles.slide, slideStyleProp);
                var transition;
                var WebkitTransition;
                if (isDragging || !animateTransitions || displaySameSlide) {
                    transition = "all 0s ease 0s";
                    WebkitTransition = "all 0s ease 0s";
                } else {
                    transition = $c9cc8d8e6114c29b$var$createTransition("transform", springConfig);
                    WebkitTransition = $c9cc8d8e6114c29b$var$createTransition("-webkit-transform", springConfig);
                    if (heightLatest !== 0) {
                        var additionalTranstion = ", ".concat($c9cc8d8e6114c29b$var$createTransition("height", springConfig));
                        transition += additionalTranstion;
                        WebkitTransition += additionalTranstion;
                    }
                }
                var containerStyle = {
                    height: null,
                    WebkitFlexDirection: $c9cc8d8e6114c29b$var$axisProperties.flexDirection[axis],
                    flexDirection: $c9cc8d8e6114c29b$var$axisProperties.flexDirection[axis],
                    WebkitTransition: WebkitTransition,
                    transition: transition
                }; // Apply the styles for SSR considerations
                if (!renderOnlyActive) {
                    var transform = $c9cc8d8e6114c29b$var$axisProperties.transform[axis](this.indexCurrent * 100);
                    containerStyle.WebkitTransform = transform;
                    containerStyle.transform = transform;
                }
                if (animateHeight) containerStyle.height = heightLatest;
                return $c9cc8d8e6114c29b$var$React.createElement($c9cc8d8e6114c29b$var$SwipeableViewsContext.Provider, {
                    value: this.getSwipeableViewsContext()
                }, $c9cc8d8e6114c29b$var$React.createElement("div", (0, $c9cc8d8e6114c29b$var$_extends2.default)({
                    ref: this.setRootNode,
                    style: (0, $c9cc8d8e6114c29b$var$_extends2.default)({}, $c9cc8d8e6114c29b$var$axisProperties.root[axis], style)
                }, other, touchEvents, mouseEvents, {
                    onScroll: this.handleScroll
                }), $c9cc8d8e6114c29b$var$React.createElement("div", {
                    ref: this.setContainerNode,
                    style: (0, $c9cc8d8e6114c29b$var$_extends2.default)({}, containerStyle, $c9cc8d8e6114c29b$var$styles.container, containerStyleProp),
                    className: "react-swipeable-view-container"
                }, $c9cc8d8e6114c29b$var$React.Children.map(children, function(child, indexChild) {
                    if (renderOnlyActive && indexChild !== indexLatest) return null;
                    var ref;
                    var hidden = true;
                    if (indexChild === indexLatest) {
                        hidden = false;
                        if (animateHeight) {
                            ref = _this4.setActiveSlide;
                            slideStyle.overflowY = "hidden";
                        }
                    }
                    return $c9cc8d8e6114c29b$var$React.createElement("div", {
                        ref: ref,
                        style: slideStyle,
                        className: slideClassName,
                        "aria-hidden": hidden,
                        "data-swipeable": "true"
                    }, child);
                }))));
            }
        }
    ]);
    return SwipeableViews;
}($c9cc8d8e6114c29b$var$React.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.
$c9cc8d8e6114c29b$var$SwipeableViews.displayName = "ReactSwipableView";
$c9cc8d8e6114c29b$var$SwipeableViews.propTypes = {};
$c9cc8d8e6114c29b$var$SwipeableViews.defaultProps = {
    animateHeight: false,
    animateTransitions: true,
    axis: "x",
    disabled: false,
    disableLazyLoading: false,
    enableMouseEvents: false,
    hysteresis: 0.6,
    ignoreNativeScroll: false,
    index: 0,
    threshold: 5,
    springConfig: {
        duration: "0.35s",
        easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
        delay: "0s"
    },
    resistance: false
};
var $c9cc8d8e6114c29b$var$_default = $c9cc8d8e6114c29b$var$SwipeableViews;
module.exports.default = $c9cc8d8e6114c29b$var$_default;

});
parcelRequire.register("j4Kfh", function(module, exports) {
function $de32436692a48f6e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
module.exports = $de32436692a48f6e$var$_interopRequireWildcard;

});

parcelRequire.register("c2EI1", function(module, exports) {
function $8c453fe9b7d0d5e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $8c453fe9b7d0d5e8$var$_interopRequireDefault;

});

parcelRequire.register("c2dZ0", function(module, exports) {
function $8c3084ae542e8fa9$var$_extends() {
    module.exports = $8c3084ae542e8fa9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3084ae542e8fa9$var$_extends.apply(this, arguments);
}
module.exports = $8c3084ae542e8fa9$var$_extends;

});

parcelRequire.register("2LVuF", function(module, exports) {

var $6s9RN = parcelRequire("6s9RN");
function $204c9195a019cffe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6s9RN(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $204c9195a019cffe$var$_objectWithoutProperties;

});
parcelRequire.register("6s9RN", function(module, exports) {
function $4b2d02ed2ea88b23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $4b2d02ed2ea88b23$var$_objectWithoutPropertiesLoose;

});


parcelRequire.register("4TC9g", function(module, exports) {
function $3909e3fa0a5ed9a2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $3909e3fa0a5ed9a2$var$_classCallCheck;

});

parcelRequire.register("5JIpT", function(module, exports) {
function $42d39bf4c5101728$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $42d39bf4c5101728$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $42d39bf4c5101728$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $42d39bf4c5101728$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $42d39bf4c5101728$var$_createClass;

});

parcelRequire.register("1qGqe", function(module, exports) {

var $ipmAx = parcelRequire("ipmAx");

var $jy0Jk = parcelRequire("jy0Jk");
function $10a9204ca353cb22$var$_possibleConstructorReturn(self, call) {
    if (call && ($ipmAx(call) === "object" || typeof call === "function")) return call;
    return $jy0Jk(self);
}
module.exports = $10a9204ca353cb22$var$_possibleConstructorReturn;

});
parcelRequire.register("ipmAx", function(module, exports) {
function $d66c15581ca4f333$var$_typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d66c15581ca4f333$var$_typeof2 = function _typeof2(obj) {
        return typeof obj;
    };
    else $d66c15581ca4f333$var$_typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d66c15581ca4f333$var$_typeof2(obj);
}
function $d66c15581ca4f333$var$_typeof(obj) {
    if (typeof Symbol === "function" && $d66c15581ca4f333$var$_typeof2(Symbol.iterator) === "symbol") module.exports = $d66c15581ca4f333$var$_typeof = function _typeof(obj) {
        return $d66c15581ca4f333$var$_typeof2(obj);
    };
    else module.exports = $d66c15581ca4f333$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : $d66c15581ca4f333$var$_typeof2(obj);
    };
    return $d66c15581ca4f333$var$_typeof(obj);
}
module.exports = $d66c15581ca4f333$var$_typeof;

});

parcelRequire.register("jy0Jk", function(module, exports) {
function $e3b1c246b794ae63$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $e3b1c246b794ae63$var$_assertThisInitialized;

});


parcelRequire.register("cGqyA", function(module, exports) {
function $93be01e75cfce582$var$_getPrototypeOf(o) {
    module.exports = $93be01e75cfce582$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $93be01e75cfce582$var$_getPrototypeOf(o);
}
module.exports = $93be01e75cfce582$var$_getPrototypeOf;

});

parcelRequire.register("i1aL6", function(module, exports) {

var $6Xzf6 = parcelRequire("6Xzf6");
function $d1e0aa723197a9c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6Xzf6(subClass, superClass);
}
module.exports = $d1e0aa723197a9c9$var$_inherits;

});
parcelRequire.register("6Xzf6", function(module, exports) {
function $51139735c1e7292b$var$_setPrototypeOf(o, p) {
    module.exports = $51139735c1e7292b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $51139735c1e7292b$var$_setPrototypeOf(o, p);
}
module.exports = $51139735c1e7292b$var$_setPrototypeOf;

});


parcelRequire.register("fiGG7", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b239a478f73df72a$var$__DEV__ = false;
var $b239a478f73df72a$var$warning = function() {};
if ($b239a478f73df72a$var$__DEV__) {
    var $b239a478f73df72a$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $b239a478f73df72a$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $b239a478f73df72a$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $b239a478f73df72a$var$warning;

});

parcelRequire.register("8iRar", function(module, exports) {
"use strict";

var $8DZPR = parcelRequire("8DZPR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "checkIndexBounds", {
    enumerable: true,
    get: function get() {
        return $60b93f215f84deb3$var$_checkIndexBounds.default;
    }
});
Object.defineProperty(module.exports, "computeIndex", {
    enumerable: true,
    get: function get() {
        return $60b93f215f84deb3$var$_computeIndex.default;
    }
});
Object.defineProperty(module.exports, "constant", {
    enumerable: true,
    get: function get() {
        return $60b93f215f84deb3$var$_constant.default;
    }
});
Object.defineProperty(module.exports, "getDisplaySameSlide", {
    enumerable: true,
    get: function get() {
        return $60b93f215f84deb3$var$_getDisplaySameSlide.default;
    }
});
Object.defineProperty(module.exports, "mod", {
    enumerable: true,
    get: function get() {
        return $60b93f215f84deb3$var$_mod.default;
    }
});

var $60b93f215f84deb3$var$_checkIndexBounds = $8DZPR((parcelRequire("4vDVV")));

var $60b93f215f84deb3$var$_computeIndex = $8DZPR((parcelRequire("9T6I9")));

var $60b93f215f84deb3$var$_constant = $8DZPR((parcelRequire("dujpt")));

var $60b93f215f84deb3$var$_getDisplaySameSlide = $8DZPR((parcelRequire("8XqB8")));

var $60b93f215f84deb3$var$_mod = $8DZPR((parcelRequire("fUlu4")));

});
parcelRequire.register("8DZPR", function(module, exports) {
function $64b1ee778630183b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $64b1ee778630183b$var$_interopRequireDefault;

});

parcelRequire.register("4vDVV", function(module, exports) {
"use strict";

var $8DZPR = parcelRequire("8DZPR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $348908985fcca922$var$_react = $8DZPR((parcelRequire("lTb4y")));

var $348908985fcca922$var$_warning = $8DZPR((parcelRequire("fiGG7")));
var $348908985fcca922$var$checkIndexBounds = function checkIndexBounds(props) {
    var index = props.index, children = props.children;
    var childrenCount = $348908985fcca922$var$_react.default.Children.count(children);
};
var $348908985fcca922$var$_default = $348908985fcca922$var$checkIndexBounds;
module.exports.default = $348908985fcca922$var$_default;

});

parcelRequire.register("9T6I9", function(module, exports) {
"use strict";

var $8DZPR = parcelRequire("8DZPR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $732e74d12ec2a8cb$var$computeIndex;

var $732e74d12ec2a8cb$var$_react = $8DZPR((parcelRequire("lTb4y")));

var $732e74d12ec2a8cb$var$_constant = $8DZPR((parcelRequire("dujpt")));
function $732e74d12ec2a8cb$var$computeIndex(params) {
    var children = params.children, startIndex = params.startIndex, startX = params.startX, pageX = params.pageX, viewLength = params.viewLength, resistance = params.resistance;
    var indexMax = $732e74d12ec2a8cb$var$_react.default.Children.count(children) - 1;
    var index = startIndex + (startX - pageX) / viewLength;
    var newStartX;
    if (!resistance) {
        // Reset the starting point
        if (index < 0) {
            index = 0;
            newStartX = (index - startIndex) * viewLength + pageX;
        } else if (index > indexMax) {
            index = indexMax;
            newStartX = (index - startIndex) * viewLength + pageX;
        }
    } else if (index < 0) index = Math.exp(index * $732e74d12ec2a8cb$var$_constant.default.RESISTANCE_COEF) - 1;
    else if (index > indexMax) index = indexMax + 1 - Math.exp((indexMax - index) * $732e74d12ec2a8cb$var$_constant.default.RESISTANCE_COEF);
    return {
        index: index,
        startX: newStartX
    };
}

});
parcelRequire.register("dujpt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9d1d221ac70e52a4$var$_default = {
    RESISTANCE_COEF: 0.6,
    // This value is closed to what browsers are using internally to
    // trigger a native scroll.
    UNCERTAINTY_THRESHOLD: 3 // px
};
module.exports.default = $9d1d221ac70e52a4$var$_default;

});


parcelRequire.register("8XqB8", function(module, exports) {
"use strict";

var $8DZPR = parcelRequire("8DZPR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $685877343fbd5f49$var$_react = $8DZPR((parcelRequire("lTb4y")));
var $685877343fbd5f49$var$getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
    var displaySameSlide = false;
    var getChildrenKey = function getChildrenKey(child) {
        return child ? child.key : "empty";
    };
    if (props.children.length && nextProps.children.length) {
        var oldKeys = $685877343fbd5f49$var$_react.default.Children.map(props.children, getChildrenKey);
        var oldKey = oldKeys[props.index];
        if (oldKey !== null && oldKey !== undefined) {
            var newKeys = $685877343fbd5f49$var$_react.default.Children.map(nextProps.children, getChildrenKey);
            var newKey = newKeys[nextProps.index];
            if (oldKey === newKey) displaySameSlide = true;
        }
    }
    return displaySameSlide;
};
var $685877343fbd5f49$var$_default = $685877343fbd5f49$var$getDisplaySameSlide;
module.exports.default = $685877343fbd5f49$var$_default;

});

parcelRequire.register("fUlu4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// Extended version of % with negative integer support.
function $b94cc03c49b7e127$var$mod(n, m) {
    var q = n % m;
    return q < 0 ? q + m : q;
}
var $b94cc03c49b7e127$var$_default = $b94cc03c49b7e127$var$mod;
module.exports.default = $b94cc03c49b7e127$var$_default;

});



parcelRequire.register("c8qBC", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8d5adec116dabe92$export$bdfd709ae4826697; }, function (v) { return $8d5adec116dabe92$export$bdfd709ae4826697 = v; });
var $8d5adec116dabe92$export$bdfd709ae4826697;
var $8d5adec116dabe92$export$c9e73fbda7da57b6;
var $8d5adec116dabe92$export$5a759dc7a1cfb72a;
"use strict";
var $8d5adec116dabe92$var$bundleURL = {};
function $8d5adec116dabe92$var$getBundleURLCached(id) {
    var value = $8d5adec116dabe92$var$bundleURL[id];
    if (!value) {
        value = $8d5adec116dabe92$var$getBundleURL();
        $8d5adec116dabe92$var$bundleURL[id] = value;
    }
    return value;
}
function $8d5adec116dabe92$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8d5adec116dabe92$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $8d5adec116dabe92$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8d5adec116dabe92$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$8d5adec116dabe92$export$bdfd709ae4826697 = $8d5adec116dabe92$var$getBundleURLCached;
$8d5adec116dabe92$export$c9e73fbda7da57b6 = $8d5adec116dabe92$var$getBaseURL;
$8d5adec116dabe92$export$5a759dc7a1cfb72a = $8d5adec116dabe92$var$getOrigin;

});

parcelRequire.register("ihlVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3Beyx.default;
    }
});

var $3Beyx = parcelRequire("3Beyx");

});
parcelRequire.register("3Beyx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29f01e57548f7fa0$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");

var $1aLFM = parcelRequire("1aLFM");

var $4fnJY = parcelRequire("4fnJY");
function $29f01e57548f7fa0$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $1aLFM.default), (0, $alwoF.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $1aLFM.default).muiName;
    return /*#__PURE__*/ $lTb4y.memo(/*#__PURE__*/ $lTb4y.forwardRef(Component));
}

});
parcelRequire.register("alwoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7884fee6dcbaa6d1$export$2e2bcd8739ae039; });
function $7884fee6dcbaa6d1$export$2e2bcd8739ae039() {
    $7884fee6dcbaa6d1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7884fee6dcbaa6d1$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("1aLFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dabb4729184a392$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $eIYVv = parcelRequire("eIYVv");

var $lEU9Q = parcelRequire("lEU9Q");

var $l7HUa = parcelRequire("l7HUa");

var $b7Jfo = parcelRequire("b7Jfo");

var $4fnJY = parcelRequire("4fnJY");
const $0dabb4729184a392$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $0dabb4729184a392$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $eIYVv.default)(color)}`,
            `fontSize${(0, $eIYVv.default)(fontSize)}`
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $b7Jfo.getSvgIconUtilityClass), classes);
};
const $0dabb4729184a392$var$SvgIconRoot = (0, $l7HUa.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $eIYVv.default)(ownerState.color)}`],
            styles[`fontSize${(0, $eIYVv.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $0dabb4729184a392$var$SvgIcon = /*#__PURE__*/ $lTb4y.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $bjnlX.default)(props, $0dabb4729184a392$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $lTb4y.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $alwoF.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $0dabb4729184a392$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($0dabb4729184a392$var$SvgIconRoot, (0, $alwoF.default)({
        as: component,
        className: (0, $bIObK.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $4fnJY.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$0dabb4729184a392$var$SvgIcon.muiName = "SvgIcon";
var $0dabb4729184a392$export$2e2bcd8739ae039 = $0dabb4729184a392$var$SvgIcon;

});
parcelRequire.register("bjnlX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c395856d516c0a$export$2e2bcd8739ae039; });
function $83c395856d516c0a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("bIObK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $888abc2a384dfc2f$export$2e2bcd8739ae039; });
function $888abc2a384dfc2f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $888abc2a384dfc2f$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $888abc2a384dfc2f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $888abc2a384dfc2f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $888abc2a384dfc2f$export$2e2bcd8739ae039 = $888abc2a384dfc2f$export$4f5d2d50c9deca37;

});

parcelRequire.register("7ED3r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $592a903bf9806e50$export$2e2bcd8739ae039; });
function $592a903bf9806e50$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("eIYVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab846f7a56d8f828$export$2e2bcd8739ae039; });

var $13hoV = parcelRequire("13hoV");
var $ab846f7a56d8f828$export$2e2bcd8739ae039 = (0, $13hoV.default);

});
parcelRequire.register("13hoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c4391b64761528c$export$2e2bcd8739ae039; });

var $3uxq4 = parcelRequire("3uxq4");
function $0c4391b64761528c$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $3uxq4.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("3uxq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ae18d7b49856bb$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $28ae18d7b49856bb$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("lEU9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc48e52d92f373cd$export$2e2bcd8739ae039; });

var $iQwnU = parcelRequire("iQwnU");

var $fBkQg = parcelRequire("fBkQg");

var $5gJQF = parcelRequire("5gJQF");
function $fc48e52d92f373cd$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $iQwnU.default)({
        props: props,
        name: name,
        defaultTheme: $fBkQg.default,
        themeId: (0, $5gJQF.default)
    });
}

});
parcelRequire.register("iQwnU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db863441c139f2f3$export$2e2bcd8739ae039; });

var $chM7U = parcelRequire("chM7U");

var $8HH67 = parcelRequire("8HH67");
function $db863441c139f2f3$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $8HH67.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $chM7U.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("chM7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f1c67860ba570c3$export$2e2bcd8739ae039; });

var $8fdUL = parcelRequire("8fdUL");
function $8f1c67860ba570c3$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8fdUL.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("8fdUL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600a849756973f75$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");
function $600a849756973f75$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $alwoF.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $alwoF.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $alwoF.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $600a849756973f75$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("8HH67", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6563c5350092b8b0$export$2e2bcd8739ae039; });

var $aiTSV = parcelRequire("aiTSV");

var $6SBoQ = parcelRequire("6SBoQ");
const $6563c5350092b8b0$export$35e57303dbd8a66 = (0, $aiTSV.default)();
function $6563c5350092b8b0$var$useTheme(defaultTheme = $6563c5350092b8b0$export$35e57303dbd8a66) {
    return (0, $6SBoQ.default)(defaultTheme);
}
var $6563c5350092b8b0$export$2e2bcd8739ae039 = $6563c5350092b8b0$var$useTheme;

});
parcelRequire.register("aiTSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7806ef5fc8272c77$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $3P2ac = parcelRequire("3P2ac");

var $kvH1Q = parcelRequire("kvH1Q");

var $eXf2G = parcelRequire("eXf2G");

var $dhkSL = parcelRequire("dhkSL");

var $6tAkp = parcelRequire("6tAkp");

var $1yxXw = parcelRequire("1yxXw");
const $7806ef5fc8272c77$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $7806ef5fc8272c77$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $bjnlX.default)(options, $7806ef5fc8272c77$var$_excluded);
    const breakpoints = (0, $kvH1Q.default)(breakpointsInput);
    const spacing = (0, $dhkSL.default)(spacingInput);
    let muiTheme = (0, $3P2ac.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $alwoF.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $alwoF.default)({}, (0, $eXf2G.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3P2ac.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $alwoF.default)({}, (0, $1yxXw.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6tAkp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $7806ef5fc8272c77$export$2e2bcd8739ae039 = $7806ef5fc8272c77$var$createTheme;

});
parcelRequire.register("3P2ac", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $2c87d02ae7f1ff6e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $2c87d02ae7f1ff6e$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");
function $2c87d02ae7f1ff6e$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $2c87d02ae7f1ff6e$var$deepClone(source) {
    if (!$2c87d02ae7f1ff6e$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2c87d02ae7f1ff6e$var$deepClone(source[key]);
    });
    return output;
}
function $2c87d02ae7f1ff6e$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $alwoF.default)({}, target) : target;
    if ($2c87d02ae7f1ff6e$export$53b83ca8eaab0383(target) && $2c87d02ae7f1ff6e$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($2c87d02ae7f1ff6e$export$53b83ca8eaab0383(source[key]) && key in target && $2c87d02ae7f1ff6e$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2c87d02ae7f1ff6e$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2c87d02ae7f1ff6e$export$53b83ca8eaab0383(source[key]) ? $2c87d02ae7f1ff6e$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("kvH1Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eee814853fc60d2e$export$2e2bcd8739ae039; });

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");
const $eee814853fc60d2e$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $eee814853fc60d2e$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $eee814853fc60d2e$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $alwoF.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $eee814853fc60d2e$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $bjnlX.default)(breakpoints, $eee814853fc60d2e$var$_excluded);
    const sortedValues = $eee814853fc60d2e$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $alwoF.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("eXf2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae323e71cac27043$export$2e2bcd8739ae039; });
const $ae323e71cac27043$var$shape = {
    borderRadius: 4
};
var $ae323e71cac27043$export$2e2bcd8739ae039 = $ae323e71cac27043$var$shape;

});

parcelRequire.register("dhkSL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aad0fab20aae105$export$2e2bcd8739ae039; });

var $6y3Kg = parcelRequire("6y3Kg");
function $9aad0fab20aae105$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $6y3Kg.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("6y3Kg", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $4c48d2c727997c06$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $4c48d2c727997c06$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $4c48d2c727997c06$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $4c48d2c727997c06$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $4c48d2c727997c06$export$6f98e8eaf0be1996; });


var $4C9sh = parcelRequire("4C9sh");

var $4PWi6 = parcelRequire("4PWi6");

var $aa4eh = parcelRequire("aa4eh");

var $6600W = parcelRequire("6600W");
const $4c48d2c727997c06$var$properties = {
    m: "margin",
    p: "padding"
};
const $4c48d2c727997c06$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $4c48d2c727997c06$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $4c48d2c727997c06$var$getCssProperties = (0, $6600W.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($4c48d2c727997c06$var$aliases[prop]) prop = $4c48d2c727997c06$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $4c48d2c727997c06$var$properties[a];
    const direction = $4c48d2c727997c06$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $4c48d2c727997c06$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $4c48d2c727997c06$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $4c48d2c727997c06$var$spacingKeys = [
    ...$4c48d2c727997c06$export$aab52a0dde05ad8a,
    ...$4c48d2c727997c06$export$f8397d44f03ab6ad
];
function $4c48d2c727997c06$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $4PWi6.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $4c48d2c727997c06$export$1def6f833384e3d1(theme) {
    return $4c48d2c727997c06$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $4c48d2c727997c06$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $4c48d2c727997c06$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $4c48d2c727997c06$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $4c48d2c727997c06$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $4c48d2c727997c06$var$getCssProperties(prop);
    const styleFromPropValue = $4c48d2c727997c06$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $4C9sh.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $4c48d2c727997c06$var$style(props, keys) {
    const transformer = $4c48d2c727997c06$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$4c48d2c727997c06$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aa4eh.default), {});
}
function $4c48d2c727997c06$export$7ede87f9b603dd3c(props) {
    return $4c48d2c727997c06$var$style(props, $4c48d2c727997c06$export$aab52a0dde05ad8a);
}
$4c48d2c727997c06$export$7ede87f9b603dd3c.propTypes = {};
$4c48d2c727997c06$export$7ede87f9b603dd3c.filterProps = $4c48d2c727997c06$export$aab52a0dde05ad8a;
function $4c48d2c727997c06$export$6f98e8eaf0be1996(props) {
    return $4c48d2c727997c06$var$style(props, $4c48d2c727997c06$export$f8397d44f03ab6ad);
}
$4c48d2c727997c06$export$6f98e8eaf0be1996.propTypes = {};
$4c48d2c727997c06$export$6f98e8eaf0be1996.filterProps = $4c48d2c727997c06$export$f8397d44f03ab6ad;
function $4c48d2c727997c06$var$spacing(props) {
    return $4c48d2c727997c06$var$style(props, $4c48d2c727997c06$var$spacingKeys);
}
$4c48d2c727997c06$var$spacing.propTypes = {};
$4c48d2c727997c06$var$spacing.filterProps = $4c48d2c727997c06$var$spacingKeys;
var $4c48d2c727997c06$export$2e2bcd8739ae039 = $4c48d2c727997c06$var$spacing;

});
parcelRequire.register("4C9sh", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $35c20ba230e4de66$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $35c20ba230e4de66$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $35c20ba230e4de66$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $35c20ba230e4de66$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $35c20ba230e4de66$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $35c20ba230e4de66$export$980e6a259d807490; });

var $alwoF = parcelRequire("alwoF");


var $3P2ac = parcelRequire("3P2ac");

var $aa4eh = parcelRequire("aa4eh");
const $35c20ba230e4de66$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $35c20ba230e4de66$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$35c20ba230e4de66$export$68c286be0e7e55b7[key]}px)`
};
function $35c20ba230e4de66$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $35c20ba230e4de66$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $35c20ba230e4de66$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $35c20ba230e4de66$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $35c20ba230e4de66$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $35c20ba230e4de66$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $alwoF.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aa4eh.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $35c20ba230e4de66$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $35c20ba230e4de66$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $35c20ba230e4de66$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $35c20ba230e4de66$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3P2ac.default)(prev, next), {});
    return $35c20ba230e4de66$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $35c20ba230e4de66$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $35c20ba230e4de66$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $35c20ba230e4de66$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $35c20ba230e4de66$export$2e2bcd8739ae039 = $35c20ba230e4de66$var$breakpoints;

});
parcelRequire.register("aa4eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $765e1e6a1ed0a9e5$export$2e2bcd8739ae039; });

var $3P2ac = parcelRequire("3P2ac");
function $765e1e6a1ed0a9e5$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3P2ac.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $765e1e6a1ed0a9e5$export$2e2bcd8739ae039 = $765e1e6a1ed0a9e5$var$merge;

});


parcelRequire.register("4PWi6", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $3859243632086cb4$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $3859243632086cb4$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $3859243632086cb4$export$2e2bcd8739ae039; });

var $13hoV = parcelRequire("13hoV");


var $4C9sh = parcelRequire("4C9sh");
function $3859243632086cb4$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $3859243632086cb4$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $3859243632086cb4$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $3859243632086cb4$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $3859243632086cb4$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $3859243632086cb4$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $3859243632086cb4$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $13hoV.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4C9sh.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $3859243632086cb4$export$2e2bcd8739ae039 = $3859243632086cb4$var$style;

});

parcelRequire.register("6600W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47035068ab58d41d$export$2e2bcd8739ae039; });
function $47035068ab58d41d$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("6tAkp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b71a1815bc76e37$export$2e2bcd8739ae039; });

var $13hoV = parcelRequire("13hoV");

var $aa4eh = parcelRequire("aa4eh");

var $4PWi6 = parcelRequire("4PWi6");

var $4C9sh = parcelRequire("4C9sh");

var $1yxXw = parcelRequire("1yxXw");
function $4b71a1815bc76e37$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $4b71a1815bc76e37$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $4b71a1815bc76e37$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $4PWi6.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4PWi6.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $4PWi6.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $13hoV.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4C9sh.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $1yxXw.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $4C9sh.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $4b71a1815bc76e37$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $aa4eh.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $4C9sh.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($4b71a1815bc76e37$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aa4eh.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aa4eh.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $4C9sh.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $4b71a1815bc76e37$var$styleFunctionSx = $4b71a1815bc76e37$export$7d53d8bf2911e013();
$4b71a1815bc76e37$var$styleFunctionSx.filterProps = [
    "sx"
];
var $4b71a1815bc76e37$export$2e2bcd8739ae039 = $4b71a1815bc76e37$var$styleFunctionSx;

});
parcelRequire.register("1yxXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12234ef60247ad83$export$2e2bcd8739ae039; });

var $6y3Kg = parcelRequire("6y3Kg");

var $v1iug = parcelRequire("v1iug");

var $dFvbj = parcelRequire("dFvbj");

var $2Qjgr = parcelRequire("2Qjgr");

var $4eUIM = parcelRequire("4eUIM");
const $12234ef60247ad83$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $v1iug.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $v1iug.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $v1iug.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $v1iug.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $v1iug.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $v1iug.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $2Qjgr.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $2Qjgr.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $2Qjgr.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $6y3Kg.padding)
    },
    pt: {
        style: (0, $6y3Kg.padding)
    },
    pr: {
        style: (0, $6y3Kg.padding)
    },
    pb: {
        style: (0, $6y3Kg.padding)
    },
    pl: {
        style: (0, $6y3Kg.padding)
    },
    px: {
        style: (0, $6y3Kg.padding)
    },
    py: {
        style: (0, $6y3Kg.padding)
    },
    padding: {
        style: (0, $6y3Kg.padding)
    },
    paddingTop: {
        style: (0, $6y3Kg.padding)
    },
    paddingRight: {
        style: (0, $6y3Kg.padding)
    },
    paddingBottom: {
        style: (0, $6y3Kg.padding)
    },
    paddingLeft: {
        style: (0, $6y3Kg.padding)
    },
    paddingX: {
        style: (0, $6y3Kg.padding)
    },
    paddingY: {
        style: (0, $6y3Kg.padding)
    },
    paddingInline: {
        style: (0, $6y3Kg.padding)
    },
    paddingInlineStart: {
        style: (0, $6y3Kg.padding)
    },
    paddingInlineEnd: {
        style: (0, $6y3Kg.padding)
    },
    paddingBlock: {
        style: (0, $6y3Kg.padding)
    },
    paddingBlockStart: {
        style: (0, $6y3Kg.padding)
    },
    paddingBlockEnd: {
        style: (0, $6y3Kg.padding)
    },
    m: {
        style: (0, $6y3Kg.margin)
    },
    mt: {
        style: (0, $6y3Kg.margin)
    },
    mr: {
        style: (0, $6y3Kg.margin)
    },
    mb: {
        style: (0, $6y3Kg.margin)
    },
    ml: {
        style: (0, $6y3Kg.margin)
    },
    mx: {
        style: (0, $6y3Kg.margin)
    },
    my: {
        style: (0, $6y3Kg.margin)
    },
    margin: {
        style: (0, $6y3Kg.margin)
    },
    marginTop: {
        style: (0, $6y3Kg.margin)
    },
    marginRight: {
        style: (0, $6y3Kg.margin)
    },
    marginBottom: {
        style: (0, $6y3Kg.margin)
    },
    marginLeft: {
        style: (0, $6y3Kg.margin)
    },
    marginX: {
        style: (0, $6y3Kg.margin)
    },
    marginY: {
        style: (0, $6y3Kg.margin)
    },
    marginInline: {
        style: (0, $6y3Kg.margin)
    },
    marginInlineStart: {
        style: (0, $6y3Kg.margin)
    },
    marginInlineEnd: {
        style: (0, $6y3Kg.margin)
    },
    marginBlock: {
        style: (0, $6y3Kg.margin)
    },
    marginBlockStart: {
        style: (0, $6y3Kg.margin)
    },
    marginBlockEnd: {
        style: (0, $6y3Kg.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $dFvbj.gap)
    },
    rowGap: {
        style: (0, $dFvbj.rowGap)
    },
    columnGap: {
        style: (0, $dFvbj.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $4eUIM.sizingTransform)
    },
    maxWidth: {
        style: (0, $4eUIM.maxWidth)
    },
    minWidth: {
        transform: (0, $4eUIM.sizingTransform)
    },
    height: {
        transform: (0, $4eUIM.sizingTransform)
    },
    maxHeight: {
        transform: (0, $4eUIM.sizingTransform)
    },
    minHeight: {
        transform: (0, $4eUIM.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $12234ef60247ad83$export$2e2bcd8739ae039 = $12234ef60247ad83$var$defaultSxConfig;

});
parcelRequire.register("v1iug", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $05d3e6f527951968$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $05d3e6f527951968$export$7a57f79000377ca2; });


var $4PWi6 = parcelRequire("4PWi6");

var $g9pCi = parcelRequire("g9pCi");

var $6y3Kg = parcelRequire("6y3Kg");

var $4C9sh = parcelRequire("4C9sh");
function $05d3e6f527951968$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $05d3e6f527951968$export$1edee58a52776cd9 = (0, $4PWi6.default)({
    prop: "border",
    themeKey: "borders",
    transform: $05d3e6f527951968$export$34e2febe53ae29cc
});
const $05d3e6f527951968$export$f9a7b6bd24892946 = (0, $4PWi6.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $05d3e6f527951968$export$34e2febe53ae29cc
});
const $05d3e6f527951968$export$5abca33e6be905d2 = (0, $4PWi6.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $05d3e6f527951968$export$34e2febe53ae29cc
});
const $05d3e6f527951968$export$e2ce9f12a980a822 = (0, $4PWi6.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $05d3e6f527951968$export$34e2febe53ae29cc
});
const $05d3e6f527951968$export$47658cca1a909427 = (0, $4PWi6.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $05d3e6f527951968$export$34e2febe53ae29cc
});
const $05d3e6f527951968$export$e7fb0694ba2404fc = (0, $4PWi6.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $05d3e6f527951968$export$126a92c968acdb85 = (0, $4PWi6.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $05d3e6f527951968$export$85cc51cb8fbb8c0e = (0, $4PWi6.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $05d3e6f527951968$export$340b0327727f6d1a = (0, $4PWi6.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $05d3e6f527951968$export$60beef91a985b4bf = (0, $4PWi6.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $05d3e6f527951968$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $6y3Kg.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $6y3Kg.getValue)(transformer, propValue)
            });
        return (0, $4C9sh.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$05d3e6f527951968$export$7a57f79000377ca2.propTypes = {};
$05d3e6f527951968$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $05d3e6f527951968$var$borders = (0, $g9pCi.default)($05d3e6f527951968$export$1edee58a52776cd9, $05d3e6f527951968$export$f9a7b6bd24892946, $05d3e6f527951968$export$5abca33e6be905d2, $05d3e6f527951968$export$e2ce9f12a980a822, $05d3e6f527951968$export$47658cca1a909427, $05d3e6f527951968$export$e7fb0694ba2404fc, $05d3e6f527951968$export$126a92c968acdb85, $05d3e6f527951968$export$85cc51cb8fbb8c0e, $05d3e6f527951968$export$340b0327727f6d1a, $05d3e6f527951968$export$60beef91a985b4bf, $05d3e6f527951968$export$7a57f79000377ca2);
var $05d3e6f527951968$export$2e2bcd8739ae039 = $05d3e6f527951968$var$borders;

});
parcelRequire.register("g9pCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc215b8cde6c516e$export$2e2bcd8739ae039; });

var $aa4eh = parcelRequire("aa4eh");
function $bc215b8cde6c516e$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aa4eh.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $bc215b8cde6c516e$export$2e2bcd8739ae039 = $bc215b8cde6c516e$var$compose;

});


parcelRequire.register("dFvbj", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $9f374aaa614db593$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $9f374aaa614db593$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $9f374aaa614db593$export$8a833ffa5f5dbeda; });

var $4PWi6 = parcelRequire("4PWi6");

var $g9pCi = parcelRequire("g9pCi");

var $6y3Kg = parcelRequire("6y3Kg");

var $4C9sh = parcelRequire("4C9sh");

const $9f374aaa614db593$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $6y3Kg.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $6y3Kg.getValue)(transformer, propValue)
            });
        return (0, $4C9sh.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$9f374aaa614db593$export$5df9adcb0db95e1e.propTypes = {};
$9f374aaa614db593$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $9f374aaa614db593$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $6y3Kg.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $6y3Kg.getValue)(transformer, propValue)
            });
        return (0, $4C9sh.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$9f374aaa614db593$export$ec60d70ff941a580.propTypes = {};
$9f374aaa614db593$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $9f374aaa614db593$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $6y3Kg.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $6y3Kg.getValue)(transformer, propValue)
            });
        return (0, $4C9sh.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$9f374aaa614db593$export$8a833ffa5f5dbeda.propTypes = {};
$9f374aaa614db593$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $9f374aaa614db593$export$baf44164ca3a34e8 = (0, $4PWi6.default)({
    prop: "gridColumn"
});
const $9f374aaa614db593$export$8f7213a1cd01e832 = (0, $4PWi6.default)({
    prop: "gridRow"
});
const $9f374aaa614db593$export$b0e0abbc49ba668 = (0, $4PWi6.default)({
    prop: "gridAutoFlow"
});
const $9f374aaa614db593$export$bcd8b929d4b4142 = (0, $4PWi6.default)({
    prop: "gridAutoColumns"
});
const $9f374aaa614db593$export$e5039a674e14c828 = (0, $4PWi6.default)({
    prop: "gridAutoRows"
});
const $9f374aaa614db593$export$42bd9088661ffb03 = (0, $4PWi6.default)({
    prop: "gridTemplateColumns"
});
const $9f374aaa614db593$export$920682ae05b999bc = (0, $4PWi6.default)({
    prop: "gridTemplateRows"
});
const $9f374aaa614db593$export$1b88fbdd482fd33a = (0, $4PWi6.default)({
    prop: "gridTemplateAreas"
});
const $9f374aaa614db593$export$bdb486e40d52d26f = (0, $4PWi6.default)({
    prop: "gridArea"
});
const $9f374aaa614db593$var$grid = (0, $g9pCi.default)($9f374aaa614db593$export$5df9adcb0db95e1e, $9f374aaa614db593$export$ec60d70ff941a580, $9f374aaa614db593$export$8a833ffa5f5dbeda, $9f374aaa614db593$export$baf44164ca3a34e8, $9f374aaa614db593$export$8f7213a1cd01e832, $9f374aaa614db593$export$b0e0abbc49ba668, $9f374aaa614db593$export$bcd8b929d4b4142, $9f374aaa614db593$export$e5039a674e14c828, $9f374aaa614db593$export$42bd9088661ffb03, $9f374aaa614db593$export$920682ae05b999bc, $9f374aaa614db593$export$1b88fbdd482fd33a, $9f374aaa614db593$export$bdb486e40d52d26f);
var $9f374aaa614db593$export$2e2bcd8739ae039 = $9f374aaa614db593$var$grid;

});

parcelRequire.register("2Qjgr", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $211f619588df7bba$export$dbaffd4420ea0ac6; });

var $4PWi6 = parcelRequire("4PWi6");

var $g9pCi = parcelRequire("g9pCi");
function $211f619588df7bba$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $211f619588df7bba$export$35e9368ef982300f = (0, $4PWi6.default)({
    prop: "color",
    themeKey: "palette",
    transform: $211f619588df7bba$export$dbaffd4420ea0ac6
});
const $211f619588df7bba$export$2506f56c10355b33 = (0, $4PWi6.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $211f619588df7bba$export$dbaffd4420ea0ac6
});
const $211f619588df7bba$export$8c5a050822fd698c = (0, $4PWi6.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $211f619588df7bba$export$dbaffd4420ea0ac6
});
const $211f619588df7bba$var$palette = (0, $g9pCi.default)($211f619588df7bba$export$35e9368ef982300f, $211f619588df7bba$export$2506f56c10355b33, $211f619588df7bba$export$8c5a050822fd698c);
var $211f619588df7bba$export$2e2bcd8739ae039 = $211f619588df7bba$var$palette;

});

parcelRequire.register("4eUIM", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $316477e94f28c5b8$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $316477e94f28c5b8$export$488fda99655ff65a; });

var $4PWi6 = parcelRequire("4PWi6");

var $g9pCi = parcelRequire("g9pCi");

var $4C9sh = parcelRequire("4C9sh");
function $316477e94f28c5b8$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $316477e94f28c5b8$export$7e3df82ee760448c = (0, $4PWi6.default)({
    prop: "width",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $4C9sh.values)[propValue];
            return {
                maxWidth: breakpoint || $316477e94f28c5b8$export$8afece71750ec241(propValue)
            };
        };
        return (0, $4C9sh.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$316477e94f28c5b8$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $316477e94f28c5b8$export$ee148fbbe8357dd2 = (0, $4PWi6.default)({
    prop: "minWidth",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$ac607276a8fe9f0a = (0, $4PWi6.default)({
    prop: "height",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$dc0d8bd0b94f8570 = (0, $4PWi6.default)({
    prop: "maxHeight",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$a43cf604e12f3b17 = (0, $4PWi6.default)({
    prop: "minHeight",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$ffed9f14fb65e276 = (0, $4PWi6.default)({
    prop: "size",
    cssProperty: "width",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$905076ed6620e671 = (0, $4PWi6.default)({
    prop: "size",
    cssProperty: "height",
    transform: $316477e94f28c5b8$export$8afece71750ec241
});
const $316477e94f28c5b8$export$6ccc93f785106a58 = (0, $4PWi6.default)({
    prop: "boxSizing"
});
const $316477e94f28c5b8$var$sizing = (0, $g9pCi.default)($316477e94f28c5b8$export$7e3df82ee760448c, $316477e94f28c5b8$export$488fda99655ff65a, $316477e94f28c5b8$export$ee148fbbe8357dd2, $316477e94f28c5b8$export$ac607276a8fe9f0a, $316477e94f28c5b8$export$dc0d8bd0b94f8570, $316477e94f28c5b8$export$a43cf604e12f3b17, $316477e94f28c5b8$export$6ccc93f785106a58);
var $316477e94f28c5b8$export$2e2bcd8739ae039 = $316477e94f28c5b8$var$sizing;

});




parcelRequire.register("6SBoQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5024cc074b8598be$export$2e2bcd8739ae039; });
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
parcelRequire("6fozl");
var $9eXW2 = parcelRequire("9eXW2");
function $5024cc074b8598be$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5024cc074b8598be$var$useTheme(defaultTheme = null) {
    const contextTheme = $9Raem.useContext((0, $9eXW2.T));
    return !contextTheme || $5024cc074b8598be$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5024cc074b8598be$export$2e2bcd8739ae039 = $5024cc074b8598be$var$useTheme;

});
parcelRequire.register("6fozl", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $48c733b1c3757309$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $48c733b1c3757309$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $48c733b1c3757309$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("9eXW2")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("9eXW2")).w; });

var $9eXW2 = parcelRequire("9eXW2");
parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");
var $9Raem = parcelRequire("9Raem");

var $lUTXa = parcelRequire("lUTXa");

var $aT4Jc = parcelRequire("aT4Jc");

var $bvink = parcelRequire("bvink");
parcelRequire("emI5i");
parcelRequire("7GtyH");
parcelRequire("2CEqM");

parcelRequire("ex3t8");
var $48c733b1c3757309$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $48c733b1c3757309$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $9eXW2.h).call(props, "css")) // $FlowFixMe
    return $ep79K.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $9eXW2.E);
    createElementArgArray[1] = (0, $9eXW2.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $ep79K.createElement.apply(null, createElementArgArray);
};
var $48c733b1c3757309$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $48c733b1c3757309$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $9eXW2.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bvink.serializeStyles)([
        styles
    ], undefined, $9Raem.useContext((0, $9eXW2.T)));
    if (!(0, $9eXW2.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $ep79K.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $9Raem.useRef();
    (0, $aT4Jc.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $aT4Jc.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $lUTXa.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $48c733b1c3757309$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bvink.serializeStyles)(args);
}
var $48c733b1c3757309$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $48c733b1c3757309$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $48c733b1c3757309$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $48c733b1c3757309$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $lUTXa.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $48c733b1c3757309$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $aT4Jc.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $lUTXa.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $48c733b1c3757309$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $9eXW2.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bvink.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $lUTXa.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $48c733b1c3757309$var$merge(cache.registered, css, $48c733b1c3757309$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $9Raem.useContext((0, $9eXW2.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $ep79K.createElement($ep79K.Fragment, null, /*#__PURE__*/ $ep79K.createElement($48c733b1c3757309$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $48c733b1c3757309$var$isBrowser, $48c733b1c3757309$var$isTestEnv, $48c733b1c3757309$var$globalContext, $48c733b1c3757309$var$globalKey;

});
parcelRequire.register("9eXW2", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $6ba3e9b4e36aa197$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $6ba3e9b4e36aa197$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $6ba3e9b4e36aa197$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $6ba3e9b4e36aa197$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $6ba3e9b4e36aa197$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $6ba3e9b4e36aa197$export$a9c23c6ac3fc3eca; });
parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");
var $9Raem = parcelRequire("9Raem");
var $lTb4y = parcelRequire("lTb4y");

var $emI5i = parcelRequire("emI5i");

var $alwoF = parcelRequire("alwoF");

var $2CEqM = parcelRequire("2CEqM");

var $6Z2xb = parcelRequire("6Z2xb");

var $lUTXa = parcelRequire("lUTXa");

var $bvink = parcelRequire("bvink");

var $aT4Jc = parcelRequire("aT4Jc");
var $6ba3e9b4e36aa197$export$23f2a1d2818174ef = true;
var $6ba3e9b4e36aa197$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $6ba3e9b4e36aa197$var$EmotionCacheContext = /* #__PURE__ */ $ep79K.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $emI5i.default)({
    key: "css"
}) : null);
var $6ba3e9b4e36aa197$export$e7094788287c5e9b = $6ba3e9b4e36aa197$var$EmotionCacheContext.Provider;
var $6ba3e9b4e36aa197$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $9Raem.useContext)($6ba3e9b4e36aa197$var$EmotionCacheContext);
};
var $6ba3e9b4e36aa197$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $lTb4y.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $9Raem.useContext)($6ba3e9b4e36aa197$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$6ba3e9b4e36aa197$export$23f2a1d2818174ef) $6ba3e9b4e36aa197$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $9Raem.useContext)($6ba3e9b4e36aa197$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $emI5i.default)({
                key: "css"
            });
            return /*#__PURE__*/ $ep79K.createElement($6ba3e9b4e36aa197$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $6ba3e9b4e36aa197$export$971d5caa766a69d7 = /* #__PURE__ */ $ep79K.createContext({});
var $6ba3e9b4e36aa197$export$3b14a55fb2447963 = function useTheme() {
    return $9Raem.useContext($6ba3e9b4e36aa197$export$971d5caa766a69d7);
};
var $6ba3e9b4e36aa197$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $alwoF.default)({}, outerTheme, theme);
};
var $6ba3e9b4e36aa197$var$createCacheWithTheme = /* #__PURE__ */ (0, $2CEqM.default)(function(outerTheme) {
    return (0, $2CEqM.default)(function(theme) {
        return $6ba3e9b4e36aa197$var$getTheme(outerTheme, theme);
    });
});
var $6ba3e9b4e36aa197$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $9Raem.useContext($6ba3e9b4e36aa197$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $6ba3e9b4e36aa197$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $ep79K.createElement($6ba3e9b4e36aa197$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $6ba3e9b4e36aa197$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $9Raem.useContext($6ba3e9b4e36aa197$export$971d5caa766a69d7);
        return /*#__PURE__*/ $ep79K.createElement(Component, (0, $alwoF.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $lTb4y.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $6Z2xb.default)(WithTheme, Component);
}
var $6ba3e9b4e36aa197$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $6ba3e9b4e36aa197$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $6ba3e9b4e36aa197$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $6ba3e9b4e36aa197$var$getLastPart(match[1]);
    return undefined;
};
var $6ba3e9b4e36aa197$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $6ba3e9b4e36aa197$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $6ba3e9b4e36aa197$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $6ba3e9b4e36aa197$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($6ba3e9b4e36aa197$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $6ba3e9b4e36aa197$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $6ba3e9b4e36aa197$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $6ba3e9b4e36aa197$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $6ba3e9b4e36aa197$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($6ba3e9b4e36aa197$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$6ba3e9b4e36aa197$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $6ba3e9b4e36aa197$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lUTXa.registerStyles)(cache, serialized, isStringTag);
    (0, $aT4Jc.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lUTXa.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $6ba3e9b4e36aa197$var$Emotion = /* #__PURE__ */ $6ba3e9b4e36aa197$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$6ba3e9b4e36aa197$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $lUTXa.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bvink.serializeStyles)(registeredStyles, undefined, $9Raem.useContext($6ba3e9b4e36aa197$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($6ba3e9b4e36aa197$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $6ba3e9b4e36aa197$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $ep79K.createElement($ep79K.Fragment, null, /*#__PURE__*/ $ep79K.createElement($6ba3e9b4e36aa197$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $ep79K.createElement(WrappedComponent, newProps));
});
var $6ba3e9b4e36aa197$export$a9c23c6ac3fc3eca = $6ba3e9b4e36aa197$var$Emotion;

});
parcelRequire.register("emI5i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7555108ff906326$export$2e2bcd8739ae039; });

var $fjNj2 = parcelRequire("fjNj2");

var $9pPLr = parcelRequire("9pPLr");
parcelRequire("2CEqM");
parcelRequire("365jb");
var $a7555108ff906326$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $9pPLr.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $9pPLr.token)(character)) break;
        (0, $9pPLr.next)();
    }
    return (0, $9pPLr.slice)(begin, (0, $9pPLr.position));
};
var $a7555108ff906326$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $9pPLr.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $9pPLr.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a7555108ff906326$var$identifierWithPointTracking((0, $9pPLr.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $9pPLr.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $9pPLr.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9pPLr.from)(character);
    }
    while (character = (0, $9pPLr.next)());
    return parsed;
};
var $a7555108ff906326$var$getRules = function getRules(value, points) {
    return (0, $9pPLr.dealloc)($a7555108ff906326$var$toRules((0, $9pPLr.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a7555108ff906326$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a7555108ff906326$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a7555108ff906326$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a7555108ff906326$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a7555108ff906326$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a7555108ff906326$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $a7555108ff906326$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $a7555108ff906326$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($a7555108ff906326$var$ignoreFlag) > -1;
};
var $a7555108ff906326$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($a7555108ff906326$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $a7555108ff906326$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $a7555108ff906326$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$a7555108ff906326$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $a7555108ff906326$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $a7555108ff906326$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$a7555108ff906326$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $a7555108ff906326$var$nullifyElement(element);
    } else if ($a7555108ff906326$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $a7555108ff906326$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $a7555108ff906326$var$prefix(value, length) {
    switch((0, $9pPLr.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $9pPLr.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $9pPLr.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MOZ) + value + (0, $9pPLr.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + value + value;
        // order
        case 6165:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.replace)(value, /(\w+).+(:[^]+)/, (0, $9pPLr.WEBKIT) + "box-$1$2" + (0, $9pPLr.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + "flex-item-" + (0, $9pPLr.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + "flex-line-pack" + (0, $9pPLr.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $9pPLr.WEBKIT) + "box-" + (0, $9pPLr.replace)(value, "-grow", "") + (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $9pPLr.WEBKIT) + (0, $9pPLr.replace)(value, /([^-])(transform)/g, "$1" + (0, $9pPLr.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $9pPLr.replace)((0, $9pPLr.replace)((0, $9pPLr.replace)(value, /(zoom-|grab)/, (0, $9pPLr.WEBKIT) + "$1"), /(image-set)/, (0, $9pPLr.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9pPLr.replace)(value, /(image-set\([^]*)/, (0, $9pPLr.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $9pPLr.replace)((0, $9pPLr.replace)(value, /(.+:)(flex-)?(.*)/, (0, $9pPLr.WEBKIT) + "box-pack:$3" + (0, $9pPLr.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $9pPLr.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9pPLr.replace)(value, /(.+)-inline(.+)/, (0, $9pPLr.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9pPLr.strlen)(value) - 1 - length > 6) switch((0, $9pPLr.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9pPLr.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9pPLr.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $9pPLr.WEBKIT) + "$2-$3" + "$1" + (0, $9pPLr.MOZ) + ((0, $9pPLr.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9pPLr.indexof)(value, "stretch") ? $a7555108ff906326$var$prefix((0, $9pPLr.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9pPLr.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9pPLr.charat)(value, (0, $9pPLr.strlen)(value) - 3 - (~(0, $9pPLr.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $9pPLr.replace)(value, ":", ":" + (0, $9pPLr.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9pPLr.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $9pPLr.WEBKIT) + ((0, $9pPLr.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $9pPLr.WEBKIT) + "$2$3" + "$1" + (0, $9pPLr.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9pPLr.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + (0, $9pPLr.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $9pPLr.WEBKIT) + value + (0, $9pPLr.MS) + value + value;
    }
    return value;
}
var $a7555108ff906326$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $9pPLr.DECLARATION:
                element["return"] = $a7555108ff906326$var$prefix(element.value, element.length);
                break;
            case 0, $9pPLr.KEYFRAMES:
                return (0, $9pPLr.serialize)([
                    (0, $9pPLr.copy)(element, {
                        value: (0, $9pPLr.replace)(element.value, "@", "@" + (0, $9pPLr.WEBKIT))
                    })
                ], callback);
            case 0, $9pPLr.RULESET:
                if (element.length) return (0, $9pPLr.combine)(element.props, function(value) {
                    switch((0, $9pPLr.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $9pPLr.serialize)([
                                (0, $9pPLr.copy)(element, {
                                    props: [
                                        (0, $9pPLr.replace)(value, /:(read-\w+)/, ":" + (0, $9pPLr.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $9pPLr.serialize)([
                                (0, $9pPLr.copy)(element, {
                                    props: [
                                        (0, $9pPLr.replace)(value, /:(plac\w+)/, ":" + (0, $9pPLr.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $9pPLr.copy)(element, {
                                    props: [
                                        (0, $9pPLr.replace)(value, /:(plac\w+)/, ":" + (0, $9pPLr.MOZ) + "$1")
                                    ]
                                }),
                                (0, $9pPLr.copy)(element, {
                                    props: [
                                        (0, $9pPLr.replace)(value, /:(plac\w+)/, (0, $9pPLr.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $a7555108ff906326$var$defaultStylisPlugins = [
    $a7555108ff906326$var$prefixer
];
var $a7555108ff906326$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $a7555108ff906326$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $a7555108ff906326$var$compat,
        $a7555108ff906326$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $9pPLr.stringify),
        (0, $9pPLr.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9pPLr.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $9pPLr.serialize)((0, $9pPLr.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $fjNj2.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("fjNj2", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $b26ee08642700229$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $b26ee08642700229$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $b26ee08642700229$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $b26ee08642700229$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($b26ee08642700229$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $b26ee08642700229$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("9pPLr", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c92c033438678757$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c92c033438678757$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c92c033438678757$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c92c033438678757$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c92c033438678757$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c92c033438678757$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c92c033438678757$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c92c033438678757$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c92c033438678757$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c92c033438678757$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c92c033438678757$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c92c033438678757$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c92c033438678757$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c92c033438678757$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c92c033438678757$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c92c033438678757$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c92c033438678757$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c92c033438678757$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c92c033438678757$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c92c033438678757$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c92c033438678757$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c92c033438678757$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c92c033438678757$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c92c033438678757$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c92c033438678757$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c92c033438678757$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c92c033438678757$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c92c033438678757$export$38bcb760f1d4871c; });
var $c92c033438678757$export$71ad59f2e432cfe8 = "-ms-";
var $c92c033438678757$export$2c0f367103c8d01c = "-moz-";
var $c92c033438678757$export$39dfd62a25e0fe93 = "-webkit-";
var $c92c033438678757$export$a29989082612d0d9 = "comm";
var $c92c033438678757$export$aa3a2e812ca8570d = "rule";
var $c92c033438678757$export$527d108ccf083c2b = "decl";
var $c92c033438678757$export$d3d35020fa5b54f0 = "@page";
var $c92c033438678757$export$500415a86c544f73 = "@media";
var $c92c033438678757$export$a763edbf796b780a = "@import";
var $c92c033438678757$export$2790aeb8b4e5c826 = "@charset";
var $c92c033438678757$export$1cc683e23b84b133 = "@viewport";
var $c92c033438678757$export$9447a5efea57e862 = "@supports";
var $c92c033438678757$export$ef011b4e114b1fba = "@document";
var $c92c033438678757$export$6aad947bda0f3f46 = "@namespace";
var $c92c033438678757$export$b44a8529a35fcb60 = "@keyframes";
var $c92c033438678757$export$2c16de31893252e6 = "@font-face";
var $c92c033438678757$export$3d846dd52e150c6f = "@counter-style";
var $c92c033438678757$export$22314bfbb57653fe = "@font-feature-values";
var $c92c033438678757$export$d773506282b3cfe6 = "@layer";
var $c92c033438678757$export$2335f513bbd82c6d = Math.abs;
var $c92c033438678757$export$6788812c4e6611e6 = String.fromCharCode;
var $c92c033438678757$export$e6e34fd1f2686227 = Object.assign;
function $c92c033438678757$export$d6af199866bfb566(e, r) {
    return $c92c033438678757$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c92c033438678757$export$a9db5e087081082d(e, 0)) << 2 ^ $c92c033438678757$export$a9db5e087081082d(e, 1)) << 2 ^ $c92c033438678757$export$a9db5e087081082d(e, 2)) << 2 ^ $c92c033438678757$export$a9db5e087081082d(e, 3) : 0;
}
function $c92c033438678757$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c92c033438678757$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c92c033438678757$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c92c033438678757$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c92c033438678757$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c92c033438678757$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c92c033438678757$export$36776f635604f274(e) {
    return e.length;
}
function $c92c033438678757$export$f9084667e487ed46(e) {
    return e.length;
}
function $c92c033438678757$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c92c033438678757$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c92c033438678757$export$53f1d5ea8de3d7c = 1;
var $c92c033438678757$export$4e0c71f277ca26b3 = 1;
var $c92c033438678757$export$f24224f1c91d8156 = 0;
var $c92c033438678757$export$5880b8b5730aff45 = 0;
var $c92c033438678757$export$c0306caf338ac095 = 0;
var $c92c033438678757$export$30a86d91af8ff6e6 = "";
function $c92c033438678757$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c92c033438678757$export$53f1d5ea8de3d7c,
        column: $c92c033438678757$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c92c033438678757$export$784d13d8ee351f07(e, r) {
    return $c92c033438678757$export$e6e34fd1f2686227($c92c033438678757$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c92c033438678757$export$eba6f6f03b0a92e7() {
    return $c92c033438678757$export$c0306caf338ac095;
}
function $c92c033438678757$export$232faf9add678146() {
    $c92c033438678757$export$c0306caf338ac095 = $c92c033438678757$export$5880b8b5730aff45 > 0 ? $c92c033438678757$export$a9db5e087081082d($c92c033438678757$export$30a86d91af8ff6e6, --$c92c033438678757$export$5880b8b5730aff45) : 0;
    if ($c92c033438678757$export$4e0c71f277ca26b3--, $c92c033438678757$export$c0306caf338ac095 === 10) $c92c033438678757$export$4e0c71f277ca26b3 = 1, $c92c033438678757$export$53f1d5ea8de3d7c--;
    return $c92c033438678757$export$c0306caf338ac095;
}
function $c92c033438678757$export$48cfd1e771a65c4f() {
    $c92c033438678757$export$c0306caf338ac095 = $c92c033438678757$export$5880b8b5730aff45 < $c92c033438678757$export$f24224f1c91d8156 ? $c92c033438678757$export$a9db5e087081082d($c92c033438678757$export$30a86d91af8ff6e6, $c92c033438678757$export$5880b8b5730aff45++) : 0;
    if ($c92c033438678757$export$4e0c71f277ca26b3++, $c92c033438678757$export$c0306caf338ac095 === 10) $c92c033438678757$export$4e0c71f277ca26b3 = 1, $c92c033438678757$export$53f1d5ea8de3d7c++;
    return $c92c033438678757$export$c0306caf338ac095;
}
function $c92c033438678757$export$4d3fb11e950abb9e() {
    return $c92c033438678757$export$a9db5e087081082d($c92c033438678757$export$30a86d91af8ff6e6, $c92c033438678757$export$5880b8b5730aff45);
}
function $c92c033438678757$export$e88cb2efb12ae807() {
    return $c92c033438678757$export$5880b8b5730aff45;
}
function $c92c033438678757$export$58adb3bec8346d0f(e, r) {
    return $c92c033438678757$export$2f35ab04d2335697($c92c033438678757$export$30a86d91af8ff6e6, e, r);
}
function $c92c033438678757$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c92c033438678757$export$2de70f21292aac9e(e) {
    return $c92c033438678757$export$53f1d5ea8de3d7c = $c92c033438678757$export$4e0c71f277ca26b3 = 1, $c92c033438678757$export$f24224f1c91d8156 = $c92c033438678757$export$36776f635604f274($c92c033438678757$export$30a86d91af8ff6e6 = e), $c92c033438678757$export$5880b8b5730aff45 = 0, [];
}
function $c92c033438678757$export$45918ac1574455b1(e) {
    return $c92c033438678757$export$30a86d91af8ff6e6 = "", e;
}
function $c92c033438678757$export$410ac95b9ec204b8(e) {
    return $c92c033438678757$export$87c2784dc9fc4ab($c92c033438678757$export$58adb3bec8346d0f($c92c033438678757$export$5880b8b5730aff45 - 1, $c92c033438678757$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c92c033438678757$export$660b2ee2d4fb4eff(e) {
    return $c92c033438678757$export$45918ac1574455b1($c92c033438678757$export$5f8c09e3ae6f64e1($c92c033438678757$export$2de70f21292aac9e(e)));
}
function $c92c033438678757$export$7af1228ff777d175(e) {
    while($c92c033438678757$export$c0306caf338ac095 = $c92c033438678757$export$4d3fb11e950abb9e())if ($c92c033438678757$export$c0306caf338ac095 < 33) $c92c033438678757$export$48cfd1e771a65c4f();
    else break;
    return $c92c033438678757$export$9e1725a4cfeada27(e) > 2 || $c92c033438678757$export$9e1725a4cfeada27($c92c033438678757$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c92c033438678757$export$5f8c09e3ae6f64e1(e) {
    while($c92c033438678757$export$48cfd1e771a65c4f())switch($c92c033438678757$export$9e1725a4cfeada27($c92c033438678757$export$c0306caf338ac095)){
        case 0:
            $c92c033438678757$export$10d8903dec122b9d($c92c033438678757$export$c2ab62c7bf24634($c92c033438678757$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c92c033438678757$export$10d8903dec122b9d($c92c033438678757$export$410ac95b9ec204b8($c92c033438678757$export$c0306caf338ac095), e);
            break;
        default:
            $c92c033438678757$export$10d8903dec122b9d($c92c033438678757$export$6788812c4e6611e6($c92c033438678757$export$c0306caf338ac095), e);
    }
    return e;
}
function $c92c033438678757$export$955ba06d119e085e(e, r) {
    while(--r && $c92c033438678757$export$48cfd1e771a65c4f())if ($c92c033438678757$export$c0306caf338ac095 < 48 || $c92c033438678757$export$c0306caf338ac095 > 102 || $c92c033438678757$export$c0306caf338ac095 > 57 && $c92c033438678757$export$c0306caf338ac095 < 65 || $c92c033438678757$export$c0306caf338ac095 > 70 && $c92c033438678757$export$c0306caf338ac095 < 97) break;
    return $c92c033438678757$export$58adb3bec8346d0f(e, $c92c033438678757$export$e88cb2efb12ae807() + (r < 6 && $c92c033438678757$export$4d3fb11e950abb9e() == 32 && $c92c033438678757$export$48cfd1e771a65c4f() == 32));
}
function $c92c033438678757$export$c889f2fcc19dbf12(e) {
    while($c92c033438678757$export$48cfd1e771a65c4f())switch($c92c033438678757$export$c0306caf338ac095){
        case e:
            return $c92c033438678757$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c92c033438678757$export$c889f2fcc19dbf12($c92c033438678757$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c92c033438678757$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c92c033438678757$export$48cfd1e771a65c4f();
            break;
    }
    return $c92c033438678757$export$5880b8b5730aff45;
}
function $c92c033438678757$export$4254d4e2b3745c4c(e, r) {
    while($c92c033438678757$export$48cfd1e771a65c4f())if (e + $c92c033438678757$export$c0306caf338ac095 === 57) break;
    else if (e + $c92c033438678757$export$c0306caf338ac095 === 84 && $c92c033438678757$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c92c033438678757$export$58adb3bec8346d0f(r, $c92c033438678757$export$5880b8b5730aff45 - 1) + "*" + $c92c033438678757$export$6788812c4e6611e6(e === 47 ? e : $c92c033438678757$export$48cfd1e771a65c4f());
}
function $c92c033438678757$export$c2ab62c7bf24634(e) {
    while(!$c92c033438678757$export$9e1725a4cfeada27($c92c033438678757$export$4d3fb11e950abb9e()))$c92c033438678757$export$48cfd1e771a65c4f();
    return $c92c033438678757$export$58adb3bec8346d0f(e, $c92c033438678757$export$5880b8b5730aff45);
}
function $c92c033438678757$export$ef7acd7185315e22(e) {
    return $c92c033438678757$export$45918ac1574455b1($c92c033438678757$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c92c033438678757$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c92c033438678757$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c92c033438678757$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c92c033438678757$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c92c033438678757$export$f8e21b1e77979a08(j += $c92c033438678757$export$77ad94ebf1c2b9ed($c92c033438678757$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c92c033438678757$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c92c033438678757$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c92c033438678757$export$955ba06d119e085e($c92c033438678757$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c92c033438678757$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c92c033438678757$export$10d8903dec122b9d($c92c033438678757$export$4a34f930e789283c($c92c033438678757$export$4254d4e2b3745c4c($c92c033438678757$export$48cfd1e771a65c4f(), $c92c033438678757$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c92c033438678757$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c92c033438678757$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c92c033438678757$export$36776f635604f274(j) - l) $c92c033438678757$export$10d8903dec122b9d(p > 32 ? $c92c033438678757$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c92c033438678757$export$f8483753829ec8f3($c92c033438678757$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c92c033438678757$export$10d8903dec122b9d(y = $c92c033438678757$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c92c033438678757$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c92c033438678757$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c92c033438678757$export$98e6a39c04603d36(e, y, y, n && $c92c033438678757$export$10d8903dec122b9d($c92c033438678757$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c92c033438678757$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c92c033438678757$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c92c033438678757$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c92c033438678757$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c92c033438678757$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c92c033438678757$export$4d3fb11e950abb9e() === 45) j += $c92c033438678757$export$410ac95b9ec204b8($c92c033438678757$export$48cfd1e771a65c4f());
                    v = $c92c033438678757$export$4d3fb11e950abb9e(), o = l = $c92c033438678757$export$36776f635604f274(g = j += $c92c033438678757$export$c2ab62c7bf24634($c92c033438678757$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c92c033438678757$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c92c033438678757$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c92c033438678757$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c92c033438678757$export$2f35ab04d2335697(e, v + 1, v = $c92c033438678757$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c92c033438678757$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c92c033438678757$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c92c033438678757$export$35059013cd4a06db(e, r, a, s === 0 ? $c92c033438678757$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c92c033438678757$export$4a34f930e789283c(e, r, a) {
    return $c92c033438678757$export$35059013cd4a06db(e, r, a, $c92c033438678757$export$a29989082612d0d9, $c92c033438678757$export$6788812c4e6611e6($c92c033438678757$export$eba6f6f03b0a92e7()), $c92c033438678757$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c92c033438678757$export$f8483753829ec8f3(e, r, a, n) {
    return $c92c033438678757$export$35059013cd4a06db(e, r, a, $c92c033438678757$export$527d108ccf083c2b, $c92c033438678757$export$2f35ab04d2335697(e, 0, n), $c92c033438678757$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c92c033438678757$export$82e9f45cca5ba907(n, c, s) {
    switch($c92c033438678757$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c92c033438678757$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c92c033438678757$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$2c0f367103c8d01c + n + $c92c033438678757$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c92c033438678757$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c92c033438678757$export$39dfd62a25e0fe93 + "box-$1$2" + $c92c033438678757$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + "flex-item-" + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c92c033438678757$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c92c033438678757$export$71ad59f2e432cfe8 + "grid-row-" + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + "flex-line-pack" + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c92c033438678757$export$39dfd62a25e0fe93 + "box-" + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c92c033438678757$export$39dfd62a25e0fe93 + n + $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c92c033438678757$export$39dfd62a25e0fe93 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c92c033438678757$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c92c033438678757$export$77ad94ebf1c2b9ed($c92c033438678757$export$77ad94ebf1c2b9ed($c92c033438678757$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c92c033438678757$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c92c033438678757$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c92c033438678757$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c92c033438678757$export$77ad94ebf1c2b9ed($c92c033438678757$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c92c033438678757$export$39dfd62a25e0fe93 + "box-pack:$3" + $c92c033438678757$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c92c033438678757$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c92c033438678757$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c92c033438678757$export$71ad59f2e432cfe8 + "grid-column-align" + $c92c033438678757$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c92c033438678757$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c92c033438678757$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c92c033438678757$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c92c033438678757$export$f8e21b1e77979a08(s, "span") ? $c92c033438678757$export$4659b591c19bdf3d(s, /\d+/) : +$c92c033438678757$export$4659b591c19bdf3d(s, /\d+/) - +$c92c033438678757$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c92c033438678757$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c92c033438678757$export$71ad59f2e432cfe8 + $c92c033438678757$export$77ad94ebf1c2b9ed($c92c033438678757$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c92c033438678757$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c92c033438678757$export$36776f635604f274(n) - 1 - c > 6) switch($c92c033438678757$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c92c033438678757$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c92c033438678757$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c92c033438678757$export$2c0f367103c8d01c + ($c92c033438678757$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c92c033438678757$export$f8e21b1e77979a08(n, "stretch") ? $c92c033438678757$export$82e9f45cca5ba907($c92c033438678757$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c92c033438678757$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c92c033438678757$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c92c033438678757$export$a9db5e087081082d(n, c + 6) === 121) return $c92c033438678757$export$77ad94ebf1c2b9ed(n, ":", ":" + $c92c033438678757$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c92c033438678757$export$a9db5e087081082d(n, $c92c033438678757$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c92c033438678757$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c92c033438678757$export$39dfd62a25e0fe93 + ($c92c033438678757$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c92c033438678757$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c92c033438678757$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c92c033438678757$export$77ad94ebf1c2b9ed(n, ":", ":" + $c92c033438678757$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c92c033438678757$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c92c033438678757$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c92c033438678757$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c92c033438678757$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c92c033438678757$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c92c033438678757$export$a763edbf796b780a:
        case $c92c033438678757$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c92c033438678757$export$a29989082612d0d9:
            return "";
        case $c92c033438678757$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c92c033438678757$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c92c033438678757$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c92c033438678757$export$36776f635604f274(a = $c92c033438678757$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c92c033438678757$export$5a7767152ae0305f(e) {
    var r = $c92c033438678757$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c92c033438678757$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c92c033438678757$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c92c033438678757$export$527d108ccf083c2b:
                n.return = $c92c033438678757$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c92c033438678757$export$b44a8529a35fcb60:
                return $c92c033438678757$export$dfdc1655ccc5b9cb([
                    $c92c033438678757$export$784d13d8ee351f07(n, {
                        value: $c92c033438678757$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c92c033438678757$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c92c033438678757$export$aa3a2e812ca8570d:
                if (n.length) return $c92c033438678757$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c92c033438678757$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c92c033438678757$export$dfdc1655ccc5b9cb([
                                $c92c033438678757$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c92c033438678757$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c92c033438678757$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c92c033438678757$export$dfdc1655ccc5b9cb([
                                $c92c033438678757$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c92c033438678757$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c92c033438678757$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c92c033438678757$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c92c033438678757$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c92c033438678757$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c92c033438678757$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c92c033438678757$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c92c033438678757$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c92c033438678757$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c92c033438678757$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c92c033438678757$export$1be1fc439b849fdf($c92c033438678757$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c92c033438678757$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c92c033438678757$export$2f35ab04d2335697(r, 1, $c92c033438678757$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c92c033438678757$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c92c033438678757$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c92c033438678757$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("2CEqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e8e7e1d6cca5fbf$export$2e2bcd8739ae039; });
var $1e8e7e1d6cca5fbf$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("365jb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24160cc2df0c54d0$export$2e2bcd8739ae039; });
function $24160cc2df0c54d0$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("6Z2xb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $515a67d7b0ee4c12$export$2e2bcd8739ae039; });

var $ex3t8 = parcelRequire("ex3t8");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $515a67d7b0ee4c12$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ex3t8)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("ex3t8", function(module, exports) {
"use strict";

var $8ykJa = parcelRequire("8ykJa");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a946d6a2b1e60ac3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a946d6a2b1e60ac3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a946d6a2b1e60ac3$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $a946d6a2b1e60ac3$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $a946d6a2b1e60ac3$var$TYPE_STATICS = {};
$a946d6a2b1e60ac3$var$TYPE_STATICS[$8ykJa.ForwardRef] = $a946d6a2b1e60ac3$var$FORWARD_REF_STATICS;
$a946d6a2b1e60ac3$var$TYPE_STATICS[$8ykJa.Memo] = $a946d6a2b1e60ac3$var$MEMO_STATICS;
function $a946d6a2b1e60ac3$var$getStatics(component) {
    // React v16.11 and below
    if ($8ykJa.isMemo(component)) return $a946d6a2b1e60ac3$var$MEMO_STATICS;
     // React v16.12 and above
    return $a946d6a2b1e60ac3$var$TYPE_STATICS[component["$$typeof"]] || $a946d6a2b1e60ac3$var$REACT_STATICS;
}
var $a946d6a2b1e60ac3$var$defineProperty = Object.defineProperty;
var $a946d6a2b1e60ac3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a946d6a2b1e60ac3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a946d6a2b1e60ac3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a946d6a2b1e60ac3$var$getPrototypeOf = Object.getPrototypeOf;
var $a946d6a2b1e60ac3$var$objectPrototype = Object.prototype;
function $a946d6a2b1e60ac3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($a946d6a2b1e60ac3$var$objectPrototype) {
            var inheritedComponent = $a946d6a2b1e60ac3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a946d6a2b1e60ac3$var$objectPrototype) $a946d6a2b1e60ac3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a946d6a2b1e60ac3$var$getOwnPropertyNames(sourceComponent);
        if ($a946d6a2b1e60ac3$var$getOwnPropertySymbols) keys = keys.concat($a946d6a2b1e60ac3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $a946d6a2b1e60ac3$var$getStatics(targetComponent);
        var sourceStatics = $a946d6a2b1e60ac3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a946d6a2b1e60ac3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $a946d6a2b1e60ac3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $a946d6a2b1e60ac3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $a946d6a2b1e60ac3$var$hoistNonReactStatics;

});
parcelRequire.register("8ykJa", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bPlKw"));

});



parcelRequire.register("lUTXa", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $ff4a3b194e51b668$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $ff4a3b194e51b668$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $ff4a3b194e51b668$export$6f077d94b33a01aa; });
var $ff4a3b194e51b668$var$isBrowser = true;
function $ff4a3b194e51b668$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $ff4a3b194e51b668$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ff4a3b194e51b668$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ff4a3b194e51b668$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ff4a3b194e51b668$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("bvink", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $8600d7eadd7d6a92$export$6321afa313b251b5; });

var $1LM22 = parcelRequire("1LM22");

var $7qcaw = parcelRequire("7qcaw");

var $365jb = parcelRequire("365jb");
var $8600d7eadd7d6a92$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8600d7eadd7d6a92$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8600d7eadd7d6a92$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8600d7eadd7d6a92$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8600d7eadd7d6a92$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8600d7eadd7d6a92$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $8600d7eadd7d6a92$var$processStyleName = /* #__PURE__ */ (0, $365jb.default)(function(styleName) {
    return $8600d7eadd7d6a92$var$isCustomProperty(styleName) ? styleName : styleName.replace($8600d7eadd7d6a92$var$hyphenateRegex, "-$&").toLowerCase();
});
var $8600d7eadd7d6a92$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($8600d7eadd7d6a92$var$animationRegex, function(match, p1, p2) {
                $8600d7eadd7d6a92$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8600d7eadd7d6a92$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7qcaw.default)[key] !== 1 && !$8600d7eadd7d6a92$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $8600d7eadd7d6a92$var$contentValuePattern, $8600d7eadd7d6a92$var$contentValues, $8600d7eadd7d6a92$var$oldProcessStyleValue, $8600d7eadd7d6a92$var$msPattern, $8600d7eadd7d6a92$var$hyphenPattern, $8600d7eadd7d6a92$var$hyphenatedCache;
var $8600d7eadd7d6a92$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $8600d7eadd7d6a92$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8600d7eadd7d6a92$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8600d7eadd7d6a92$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8600d7eadd7d6a92$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8600d7eadd7d6a92$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $8600d7eadd7d6a92$var$cursor;
                var result = interpolation(mergedProps);
                $8600d7eadd7d6a92$var$cursor = previousCursor;
                return $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $8600d7eadd7d6a92$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8600d7eadd7d6a92$var$isProcessableValue(value)) string += $8600d7eadd7d6a92$var$processStyleName(_key) + ":" + $8600d7eadd7d6a92$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($8600d7eadd7d6a92$var$isProcessableValue(value[_i])) string += $8600d7eadd7d6a92$var$processStyleName(_key) + ":" + $8600d7eadd7d6a92$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $8600d7eadd7d6a92$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $8600d7eadd7d6a92$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $8600d7eadd7d6a92$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8600d7eadd7d6a92$var$cursor;
var $8600d7eadd7d6a92$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $8600d7eadd7d6a92$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8600d7eadd7d6a92$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8600d7eadd7d6a92$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8600d7eadd7d6a92$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1LM22.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8600d7eadd7d6a92$var$cursor
    };
};

});
parcelRequire.register("1LM22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $149f7060101658e9$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $149f7060101658e9$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("7qcaw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $567466914be2e96d$export$2e2bcd8739ae039; });
var $567466914be2e96d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("aT4Jc", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $7ed2b5563e66c294$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $7ed2b5563e66c294$export$811a713a7276cb9d; });

var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $7ed2b5563e66c294$var$syncFallback = function syncFallback(create) {
    return create();
};
var $7ed2b5563e66c294$var$useInsertionEffect = $lTb4y.useInsertionEffect ? $lTb4y.useInsertionEffect : false;
var $7ed2b5563e66c294$export$db21c7ffa21794e7 = $7ed2b5563e66c294$var$useInsertionEffect || $7ed2b5563e66c294$var$syncFallback;
var $7ed2b5563e66c294$export$811a713a7276cb9d = $7ed2b5563e66c294$var$useInsertionEffect || $9Raem.useLayoutEffect;

});


parcelRequire.register("7GtyH", function(module, exports) {
function $59836267815b4bd6$var$_extends() {
    module.exports = $59836267815b4bd6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $59836267815b4bd6$var$_extends.apply(this, arguments);
}
module.exports = $59836267815b4bd6$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("fBkQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ba7a8503fd2406$export$2e2bcd8739ae039; });

var $5jbOF = parcelRequire("5jbOF");
const $b5ba7a8503fd2406$var$defaultTheme = (0, $5jbOF.default)();
var $b5ba7a8503fd2406$export$2e2bcd8739ae039 = $b5ba7a8503fd2406$var$defaultTheme;

});
parcelRequire.register("5jbOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd7e492fa9e558f$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $3P2ac = parcelRequire("3P2ac");
var $3uxq4 = parcelRequire("3uxq4");

var $aiTSV = parcelRequire("aiTSV");
var $1yxXw = parcelRequire("1yxXw");
var $6tAkp = parcelRequire("6tAkp");


var $hYrss = parcelRequire("hYrss");

var $cX7wH = parcelRequire("cX7wH");

var $5E6ql = parcelRequire("5E6ql");

var $hLdBC = parcelRequire("hLdBC");

var $dQ5nE = parcelRequire("dQ5nE");

var $l2pf5 = parcelRequire("l2pf5");
const $3dd7e492fa9e558f$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $3dd7e492fa9e558f$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $bjnlX.default)(options, $3dd7e492fa9e558f$var$_excluded);
    if (options.vars) throw new Error((0, $3uxq4.default)(18));
    const palette = (0, $cX7wH.default)(paletteInput);
    const systemTheme = (0, $aiTSV.default)(options);
    let muiTheme = (0, $3P2ac.default)(systemTheme, {
        mixins: (0, $hYrss.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $hLdBC.default).slice(),
        typography: (0, $5E6ql.default)(palette, typographyInput),
        transitions: (0, $dQ5nE.default)(transitionsInput),
        zIndex: (0, $alwoF.default)({}, (0, $l2pf5.default))
    });
    muiTheme = (0, $3P2ac.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3P2ac.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $alwoF.default)({}, (0, $1yxXw.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6tAkp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $3dd7e492fa9e558f$var$warnedOnce = false;
function $3dd7e492fa9e558f$export$c469355549431d9b(...args) {
    return $3dd7e492fa9e558f$var$createTheme(...args);
}
var $3dd7e492fa9e558f$export$2e2bcd8739ae039 = $3dd7e492fa9e558f$var$createTheme;

});
parcelRequire.register("hYrss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d15d56da4c8dbe14$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");
function $d15d56da4c8dbe14$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $alwoF.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("cX7wH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96e0d5532b82d423$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $3P2ac = parcelRequire("3P2ac");
var $3uxq4 = parcelRequire("3uxq4");

var $ea7uD = parcelRequire("ea7uD");

var $3NP4v = parcelRequire("3NP4v");

var $2mK8W = parcelRequire("2mK8W");

var $fhQNK = parcelRequire("fhQNK");

var $kLMXp = parcelRequire("kLMXp");

var $kJnFg = parcelRequire("kJnFg");

var $d4g1P = parcelRequire("d4g1P");

var $dmxga = parcelRequire("dmxga");

var $kffzh = parcelRequire("kffzh");
const $96e0d5532b82d423$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $96e0d5532b82d423$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $3NP4v.default).white,
        default: (0, $3NP4v.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $96e0d5532b82d423$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $3NP4v.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $3NP4v.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $96e0d5532b82d423$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $ea7uD.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $ea7uD.darken)(intent.main, tonalOffsetDark);
    }
}
function $96e0d5532b82d423$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $d4g1P.default)[200],
        light: (0, $d4g1P.default)[50],
        dark: (0, $d4g1P.default)[400]
    };
    return {
        main: (0, $d4g1P.default)[700],
        light: (0, $d4g1P.default)[400],
        dark: (0, $d4g1P.default)[800]
    };
}
function $96e0d5532b82d423$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $fhQNK.default)[200],
        light: (0, $fhQNK.default)[50],
        dark: (0, $fhQNK.default)[400]
    };
    return {
        main: (0, $fhQNK.default)[500],
        light: (0, $fhQNK.default)[300],
        dark: (0, $fhQNK.default)[700]
    };
}
function $96e0d5532b82d423$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kLMXp.default)[500],
        light: (0, $kLMXp.default)[300],
        dark: (0, $kLMXp.default)[700]
    };
    return {
        main: (0, $kLMXp.default)[700],
        light: (0, $kLMXp.default)[400],
        dark: (0, $kLMXp.default)[800]
    };
}
function $96e0d5532b82d423$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dmxga.default)[400],
        light: (0, $dmxga.default)[300],
        dark: (0, $dmxga.default)[700]
    };
    return {
        main: (0, $dmxga.default)[700],
        light: (0, $dmxga.default)[500],
        dark: (0, $dmxga.default)[900]
    };
}
function $96e0d5532b82d423$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kffzh.default)[400],
        light: (0, $kffzh.default)[300],
        dark: (0, $kffzh.default)[700]
    };
    return {
        main: (0, $kffzh.default)[800],
        light: (0, $kffzh.default)[500],
        dark: (0, $kffzh.default)[900]
    };
}
function $96e0d5532b82d423$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kJnFg.default)[400],
        light: (0, $kJnFg.default)[300],
        dark: (0, $kJnFg.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $kJnFg.default)[500],
        dark: (0, $kJnFg.default)[900]
    };
}
function $96e0d5532b82d423$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $bjnlX.default)(palette, $96e0d5532b82d423$var$_excluded);
    const primary = palette.primary || $96e0d5532b82d423$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $96e0d5532b82d423$var$getDefaultSecondary(mode);
    const error = palette.error || $96e0d5532b82d423$var$getDefaultError(mode);
    const info = palette.info || $96e0d5532b82d423$var$getDefaultInfo(mode);
    const success = palette.success || $96e0d5532b82d423$var$getDefaultSuccess(mode);
    const warning = palette.warning || $96e0d5532b82d423$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $ea7uD.getContrastRatio)(background, $96e0d5532b82d423$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $96e0d5532b82d423$export$55ce6f3a06c59543.text.primary : $96e0d5532b82d423$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $alwoF.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $3uxq4.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $3uxq4.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $96e0d5532b82d423$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $96e0d5532b82d423$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $96e0d5532b82d423$export$55ce6f3a06c59543,
        light: $96e0d5532b82d423$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3P2ac.default)((0, $alwoF.default)({
        // A collection of common colors.
        common: (0, $alwoF.default)({}, (0, $3NP4v.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2mK8W.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("ea7uD", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $a4f7cfd7668212ce$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $a4f7cfd7668212ce$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $a4f7cfd7668212ce$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $a4f7cfd7668212ce$export$c0816ed86df316af; });

var $3uxq4 = parcelRequire("3uxq4");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $a4f7cfd7668212ce$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $a4f7cfd7668212ce$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $a4f7cfd7668212ce$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $a4f7cfd7668212ce$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $a4f7cfd7668212ce$export$677b39864803984e($a4f7cfd7668212ce$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $3uxq4.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $3uxq4.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $a4f7cfd7668212ce$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $a4f7cfd7668212ce$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $a4f7cfd7668212ce$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $a4f7cfd7668212ce$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $a4f7cfd7668212ce$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $a4f7cfd7668212ce$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $a4f7cfd7668212ce$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$a4f7cfd7668212ce$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $a4f7cfd7668212ce$export$29fb7152bd3f781a(color) {
    color = $a4f7cfd7668212ce$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $a4f7cfd7668212ce$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $a4f7cfd7668212ce$export$c852d90bf7403b62(color) {
    color = $a4f7cfd7668212ce$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $a4f7cfd7668212ce$export$677b39864803984e($a4f7cfd7668212ce$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $a4f7cfd7668212ce$export$d061e26956a60b0a(foreground, background) {
    const lumA = $a4f7cfd7668212ce$export$c852d90bf7403b62(foreground);
    const lumB = $a4f7cfd7668212ce$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $a4f7cfd7668212ce$export$58f0f39f63f3cf42(color, value) {
    color = $a4f7cfd7668212ce$export$677b39864803984e(color);
    value = $a4f7cfd7668212ce$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $a4f7cfd7668212ce$export$211a73f2b8c10ce4(color);
}
function $a4f7cfd7668212ce$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $a4f7cfd7668212ce$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $a4f7cfd7668212ce$export$4b073707ff63303(color, coefficient) {
    color = $a4f7cfd7668212ce$export$677b39864803984e(color);
    coefficient = $a4f7cfd7668212ce$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $a4f7cfd7668212ce$export$211a73f2b8c10ce4(color);
}
function $a4f7cfd7668212ce$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $a4f7cfd7668212ce$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $a4f7cfd7668212ce$export$c0816ed86df316af(color, coefficient) {
    color = $a4f7cfd7668212ce$export$677b39864803984e(color);
    coefficient = $a4f7cfd7668212ce$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $a4f7cfd7668212ce$export$211a73f2b8c10ce4(color);
}
function $a4f7cfd7668212ce$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $a4f7cfd7668212ce$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $a4f7cfd7668212ce$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $a4f7cfd7668212ce$export$c852d90bf7403b62(color) > 0.5 ? $a4f7cfd7668212ce$export$4b073707ff63303(color, coefficient) : $a4f7cfd7668212ce$export$c0816ed86df316af(color, coefficient);
}
function $a4f7cfd7668212ce$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $a4f7cfd7668212ce$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("3NP4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c4d907610c93d56$export$2e2bcd8739ae039; });
const $2c4d907610c93d56$var$common = {
    black: "#000",
    white: "#fff"
};
var $2c4d907610c93d56$export$2e2bcd8739ae039 = $2c4d907610c93d56$var$common;

});

parcelRequire.register("2mK8W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b916de841208467$export$2e2bcd8739ae039; });
const $1b916de841208467$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1b916de841208467$export$2e2bcd8739ae039 = $1b916de841208467$var$grey;

});

parcelRequire.register("fhQNK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b21166c795a3a369$export$2e2bcd8739ae039; });
const $b21166c795a3a369$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $b21166c795a3a369$export$2e2bcd8739ae039 = $b21166c795a3a369$var$purple;

});

parcelRequire.register("kLMXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03e6f032c1d131c5$export$2e2bcd8739ae039; });
const $03e6f032c1d131c5$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $03e6f032c1d131c5$export$2e2bcd8739ae039 = $03e6f032c1d131c5$var$red;

});

parcelRequire.register("kJnFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f17a5de440af533f$export$2e2bcd8739ae039; });
const $f17a5de440af533f$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $f17a5de440af533f$export$2e2bcd8739ae039 = $f17a5de440af533f$var$orange;

});

parcelRequire.register("d4g1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983814fff78d4464$export$2e2bcd8739ae039; });
const $983814fff78d4464$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $983814fff78d4464$export$2e2bcd8739ae039 = $983814fff78d4464$var$blue;

});

parcelRequire.register("dmxga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ba7211eca078ffb$export$2e2bcd8739ae039; });
const $9ba7211eca078ffb$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $9ba7211eca078ffb$export$2e2bcd8739ae039 = $9ba7211eca078ffb$var$lightBlue;

});

parcelRequire.register("kffzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd148d37054db24$export$2e2bcd8739ae039; });
const $ebd148d37054db24$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ebd148d37054db24$export$2e2bcd8739ae039 = $ebd148d37054db24$var$green;

});


parcelRequire.register("5E6ql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41c5abd3df4d1d28$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $3P2ac = parcelRequire("3P2ac");
const $41c5abd3df4d1d28$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $41c5abd3df4d1d28$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $41c5abd3df4d1d28$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $41c5abd3df4d1d28$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $41c5abd3df4d1d28$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $41c5abd3df4d1d28$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $bjnlX.default)(_ref, $41c5abd3df4d1d28$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $alwoF.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $41c5abd3df4d1d28$var$defaultFontFamily ? {
            letterSpacing: `${$41c5abd3df4d1d28$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $41c5abd3df4d1d28$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $41c5abd3df4d1d28$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $3P2ac.default)((0, $alwoF.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("hLdBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cee16149f1db6d4d$export$2e2bcd8739ae039; });
const $cee16149f1db6d4d$var$shadowKeyUmbraOpacity = 0.2;
const $cee16149f1db6d4d$var$shadowKeyPenumbraOpacity = 0.14;
const $cee16149f1db6d4d$var$shadowAmbientShadowOpacity = 0.12;
function $cee16149f1db6d4d$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$cee16149f1db6d4d$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$cee16149f1db6d4d$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$cee16149f1db6d4d$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $cee16149f1db6d4d$var$shadows = [
    "none",
    $cee16149f1db6d4d$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $cee16149f1db6d4d$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $cee16149f1db6d4d$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $cee16149f1db6d4d$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $cee16149f1db6d4d$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $cee16149f1db6d4d$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $cee16149f1db6d4d$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $cee16149f1db6d4d$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $cee16149f1db6d4d$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $cee16149f1db6d4d$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $cee16149f1db6d4d$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $cee16149f1db6d4d$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $cee16149f1db6d4d$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $cee16149f1db6d4d$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $cee16149f1db6d4d$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $cee16149f1db6d4d$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $cee16149f1db6d4d$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $cee16149f1db6d4d$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $cee16149f1db6d4d$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $cee16149f1db6d4d$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $cee16149f1db6d4d$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $cee16149f1db6d4d$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $cee16149f1db6d4d$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $cee16149f1db6d4d$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $cee16149f1db6d4d$export$2e2bcd8739ae039 = $cee16149f1db6d4d$var$shadows;

});

parcelRequire.register("dQ5nE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1344e2569cbb539$export$2e2bcd8739ae039; });

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");
const $a1344e2569cbb539$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $a1344e2569cbb539$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $a1344e2569cbb539$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a1344e2569cbb539$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $a1344e2569cbb539$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $a1344e2569cbb539$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $alwoF.default)({}, $a1344e2569cbb539$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $alwoF.default)({}, $a1344e2569cbb539$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $bjnlX.default)(options, $a1344e2569cbb539$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $a1344e2569cbb539$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $a1344e2569cbb539$var$formatMs(delay)}`).join(",");
    };
    return (0, $alwoF.default)({
        getAutoHeightDuration: $a1344e2569cbb539$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("l2pf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f50d5d769372feb5$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f50d5d769372feb5$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f50d5d769372feb5$export$2e2bcd8739ae039 = $f50d5d769372feb5$var$zIndex;

});



parcelRequire.register("5gJQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d6202ed2034e848$export$2e2bcd8739ae039; });
var $3d6202ed2034e848$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("l7HUa", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $f60c4f08b0ab27fc$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $f60c4f08b0ab27fc$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $f60c4f08b0ab27fc$export$2e2bcd8739ae039; });

var $1jIrR = parcelRequire("1jIrR");

var $fBkQg = parcelRequire("fBkQg");

var $5gJQF = parcelRequire("5gJQF");
const $f60c4f08b0ab27fc$export$effb20ecdbf4d6aa = (prop)=>(0, $1jIrR.shouldForwardProp)(prop) && prop !== "classes";
const $f60c4f08b0ab27fc$export$f10c5a10d27438e5 = (0, $1jIrR.shouldForwardProp);
const $f60c4f08b0ab27fc$var$styled = (0, $1jIrR.default)({
    themeId: (0, $5gJQF.default),
    defaultTheme: $fBkQg.default,
    rootShouldForwardProp: $f60c4f08b0ab27fc$export$effb20ecdbf4d6aa
});
var $f60c4f08b0ab27fc$export$2e2bcd8739ae039 = $f60c4f08b0ab27fc$var$styled;

});
parcelRequire.register("1jIrR", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $0f5a0b4d74abb83f$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $0f5a0b4d74abb83f$export$2e2bcd8739ae039; });

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $dxKlZ = parcelRequire("dxKlZ");


var $aiTSV = parcelRequire("aiTSV");

var $2v0nI = parcelRequire("2v0nI");

var $6tAkp = parcelRequire("6tAkp");
const $0f5a0b4d74abb83f$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0f5a0b4d74abb83f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0f5a0b4d74abb83f$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $0f5a0b4d74abb83f$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $0f5a0b4d74abb83f$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $2v0nI.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $0f5a0b4d74abb83f$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $2v0nI.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $0f5a0b4d74abb83f$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0f5a0b4d74abb83f$export$35e57303dbd8a66 = (0, $aiTSV.default)();
const $0f5a0b4d74abb83f$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0f5a0b4d74abb83f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0f5a0b4d74abb83f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0f5a0b4d74abb83f$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0f5a0b4d74abb83f$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0f5a0b4d74abb83f$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0f5a0b4d74abb83f$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $6tAkp.default)((0, $alwoF.default)({}, props, {
            theme: $0f5a0b4d74abb83f$var$resolveTheme((0, $alwoF.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $dxKlZ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $bjnlX.default)(inputOptions, $0f5a0b4d74abb83f$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0f5a0b4d74abb83f$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0f5a0b4d74abb83f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $dxKlZ.default)(tag, (0, $alwoF.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $alwoF.default)({}, props, {
                        theme: $0f5a0b4d74abb83f$var$resolveTheme((0, $alwoF.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0f5a0b4d74abb83f$var$resolveTheme((0, $alwoF.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $0f5a0b4d74abb83f$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $alwoF.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0f5a0b4d74abb83f$var$resolveTheme((0, $alwoF.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $0f5a0b4d74abb83f$var$variantsResolver(props, $0f5a0b4d74abb83f$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $alwoF.default)({}, props, {
                    theme: $0f5a0b4d74abb83f$var$resolveTheme((0, $alwoF.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("dxKlZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dc250533cfe0ef5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $9dc250533cfe0ef5$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $8BYxD = parcelRequire("8BYxD");
parcelRequire("6fozl");
var $9eXW2 = parcelRequire("9eXW2");
var $6fozl = parcelRequire("6fozl");


var $blNfd = parcelRequire("blNfd");
function $9dc250533cfe0ef5$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8BYxD.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $9dc250533cfe0ef5$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("8BYxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6450bdb67117a941$export$2e2bcd8739ae039; });

var $aahvG = parcelRequire("aahvG");
parcelRequire("7GtyH");
parcelRequire("lTb4y");
parcelRequire("euRCH");

parcelRequire("lUTXa");
parcelRequire("bvink");
parcelRequire("aT4Jc");
var $6450bdb67117a941$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $6450bdb67117a941$export$2e2bcd8739ae039 = (0, $aahvG.default).bind();
$6450bdb67117a941$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $6450bdb67117a941$export$2e2bcd8739ae039[tagName] = $6450bdb67117a941$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("aahvG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76686ba9c72cbb25$export$2e2bcd8739ae039; });

var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $ep79K = parcelRequire("ep79K");

var $euRCH = parcelRequire("euRCH");
parcelRequire("6fozl");
var $9eXW2 = parcelRequire("9eXW2");

var $lUTXa = parcelRequire("lUTXa");

var $bvink = parcelRequire("bvink");

var $aT4Jc = parcelRequire("aT4Jc");
var $76686ba9c72cbb25$var$testOmitPropsOnStringTag = (0, $euRCH.default);
var $76686ba9c72cbb25$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $76686ba9c72cbb25$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $76686ba9c72cbb25$var$testOmitPropsOnStringTag : $76686ba9c72cbb25$var$testOmitPropsOnComponent;
};
var $76686ba9c72cbb25$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $76686ba9c72cbb25$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $76686ba9c72cbb25$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lUTXa.registerStyles)(cache, serialized, isStringTag);
    (0, $aT4Jc.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lUTXa.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $76686ba9c72cbb25$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $76686ba9c72cbb25$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $76686ba9c72cbb25$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $9eXW2.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $9Raem.useContext((0, $9eXW2.T));
            }
            if (typeof props.className === "string") className = (0, $lUTXa.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $bvink.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $76686ba9c72cbb25$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $ep79K.createElement($ep79K.Fragment, null, /*#__PURE__*/ $ep79K.createElement($76686ba9c72cbb25$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $ep79K.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $alwoF.default)({}, options, nextOptions, {
                shouldForwardProp: $76686ba9c72cbb25$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("euRCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8dd767ad34695cd$export$2e2bcd8739ae039; });

var $365jb = parcelRequire("365jb");
var $a8dd767ad34695cd$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a8dd767ad34695cd$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $365jb.default)(function(prop) {
    return $a8dd767ad34695cd$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("blNfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8437dac7daebb6ea$export$2e2bcd8739ae039; });
parcelRequire("lTb4y");


var $6fozl = parcelRequire("6fozl");

var $4fnJY = parcelRequire("4fnJY");
function $8437dac7daebb6ea$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $8437dac7daebb6ea$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($8437dac7daebb6ea$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $6fozl.Global), {
        styles: globalStyles
    });
}

});
parcelRequire.register("4fnJY", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $317afa8792244611$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $317afa8792244611$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("ep79K")).Fragment; });

var $ep79K = parcelRequire("ep79K");
var $317afa8792244611$var$_ = 0;
function $317afa8792244611$export$34b9dba7ce09269b(o, e, n, t, f, l) {
    var s, u, a = {};
    for(u in e)"ref" == u ? s = e[u] : a[u] = e[u];
    var i = {
        type: o,
        props: a,
        key: n,
        ref: s,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$317afa8792244611$var$_,
        __source: f,
        __self: l
    };
    if ("function" == typeof o && (s = o.defaultProps)) for(u in s)void 0 === a[u] && (a[u] = s[u]);
    return (0, $ep79K.options).vnode && (0, $ep79K.options).vnode(i), i;
}

});



parcelRequire.register("2v0nI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1ec5c8f30254c1$export$2e2bcd8739ae039; });

var $bjnlX = parcelRequire("bjnlX");

var $13hoV = parcelRequire("13hoV");
const $1d1ec5c8f30254c1$var$_excluded = [
    "variant"
];
function $1d1ec5c8f30254c1$var$isEmpty(string) {
    return string.length === 0;
}
function $1d1ec5c8f30254c1$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $bjnlX.default)(props, $1d1ec5c8f30254c1$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $1d1ec5c8f30254c1$var$isEmpty(classKey) ? props[key] : (0, $13hoV.default)(props[key]);
        else classKey += `${$1d1ec5c8f30254c1$var$isEmpty(classKey) ? key : (0, $13hoV.default)(key)}${(0, $13hoV.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("b7Jfo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $8193724cd9f13c2c$export$c7c50641356bdfa5; });

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $8193724cd9f13c2c$export$c7c50641356bdfa5(slot) {
    return (0, $io057.default)("MuiSvgIcon", slot);
}
const $8193724cd9f13c2c$var$svgIconClasses = (0, $6w46Z.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $8193724cd9f13c2c$export$2e2bcd8739ae039 = $8193724cd9f13c2c$var$svgIconClasses;

});
parcelRequire.register("6w46Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be8ebb86633ccdb$export$2e2bcd8739ae039; });

var $io057 = parcelRequire("io057");
function $4be8ebb86633ccdb$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $io057.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("io057", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62a8814ca0885cc$export$2e2bcd8739ae039; });

var $gPRSi = parcelRequire("gPRSi");
const $d62a8814ca0885cc$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $d62a8814ca0885cc$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $d62a8814ca0885cc$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $gPRSi.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("gPRSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c41b332cdf5fa833$export$2e2bcd8739ae039; });
const $c41b332cdf5fa833$var$defaultGenerator = (componentName)=>componentName;
const $c41b332cdf5fa833$var$createClassNameGenerator = ()=>{
    let generate = $c41b332cdf5fa833$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c41b332cdf5fa833$var$defaultGenerator;
        }
    };
};
const $c41b332cdf5fa833$var$ClassNameGenerator = $c41b332cdf5fa833$var$createClassNameGenerator();
var $c41b332cdf5fa833$export$2e2bcd8739ae039 = $c41b332cdf5fa833$var$ClassNameGenerator;

});







parcelRequire.register("kpNCR", function(module, exports) {



module.exports = (parcelRequire("b0RxU"))((parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("gOIvr")).then(()=>parcelRequire("dokB4"));

});
parcelRequire.register("b0RxU", function(module, exports) {
"use strict";

var $dmMsj = parcelRequire("dmMsj");
module.exports = $dmMsj(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("dmMsj", function(module, exports) {
"use strict";
var $9bb2eab95e8b4b09$var$cachedBundles = {};
var $9bb2eab95e8b4b09$var$cachedPreloads = {};
var $9bb2eab95e8b4b09$var$cachedPrefetches = {};
function $9bb2eab95e8b4b09$var$getCache(type) {
    switch(type){
        case "preload":
            return $9bb2eab95e8b4b09$var$cachedPreloads;
        case "prefetch":
            return $9bb2eab95e8b4b09$var$cachedPrefetches;
        default:
            return $9bb2eab95e8b4b09$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9bb2eab95e8b4b09$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $4fnJY = parcelRequire("4fnJY");

var $ep79K = parcelRequire("ep79K");





var $4fnJY = parcelRequire("4fnJY");

var $5jbOF = parcelRequire("5jbOF");
var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");


var $lEU9Q = parcelRequire("lEU9Q");

var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");

parcelRequire("lTb4y");


var $blNfd = parcelRequire("blNfd");

var $8HH67 = parcelRequire("8HH67");

var $4fnJY = parcelRequire("4fnJY");
function $d9c6fadd12bd9f81$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $8HH67.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $blNfd.default), {
        styles: globalStyles
    });
}
var $d9c6fadd12bd9f81$export$2e2bcd8739ae039 = $d9c6fadd12bd9f81$var$GlobalStyles;



var $fBkQg = parcelRequire("fBkQg");

var $5gJQF = parcelRequire("5gJQF");

var $4fnJY = parcelRequire("4fnJY");
function $d1be5670b4609678$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $d9c6fadd12bd9f81$export$2e2bcd8739ae039), (0, $alwoF.default)({}, props, {
        defaultTheme: (0, $fBkQg.default),
        themeId: (0, $5gJQF.default)
    }));
}
var $d1be5670b4609678$export$2e2bcd8739ae039 = $d1be5670b4609678$var$GlobalStyles;



var $4fnJY = parcelRequire("4fnJY");
const $a614898a78dba1e0$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $alwoF.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $a614898a78dba1e0$export$32180ef41b15b513 = (theme)=>(0, $alwoF.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $a614898a78dba1e0$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $alwoF.default)({
        html: $a614898a78dba1e0$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $alwoF.default)({
            margin: 0
        }, $a614898a78dba1e0$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $a614898a78dba1e0$var$CssBaseline(inProps) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($ep79K.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $d1be5670b4609678$export$2e2bcd8739ae039), {
                styles: (theme)=>$a614898a78dba1e0$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $a614898a78dba1e0$export$2e2bcd8739ae039 = $a614898a78dba1e0$var$CssBaseline;


var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");
parcelRequire("lTb4y");


var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");
const $364f0cb3cbc532a9$var$ThemeContext = /*#__PURE__*/ $ep79K.createContext(null);
var $364f0cb3cbc532a9$export$2e2bcd8739ae039 = $364f0cb3cbc532a9$var$ThemeContext;


parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");

function $e5bf0645fc0392ca$export$2e2bcd8739ae039() {
    const theme = $9Raem.useContext((0, $364f0cb3cbc532a9$export$2e2bcd8739ae039));
    return theme;
}


const $3356b6a7c5698067$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $3356b6a7c5698067$export$2e2bcd8739ae039 = $3356b6a7c5698067$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $4fnJY = parcelRequire("4fnJY");
function $54a5923cc4e4e38d$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $alwoF.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $54a5923cc4e4e38d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $e5bf0645fc0392ca$export$2e2bcd8739ae039)();
    const theme = $9Raem.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $54a5923cc4e4e38d$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $3356b6a7c5698067$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $364f0cb3cbc532a9$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $54a5923cc4e4e38d$export$2e2bcd8739ae039 = $54a5923cc4e4e38d$var$ThemeProvider;



parcelRequire("6fozl");
var $9eXW2 = parcelRequire("9eXW2");

var $6SBoQ = parcelRequire("6SBoQ");

var $4fnJY = parcelRequire("4fnJY");
const $2e59aa948a8b66a9$var$EMPTY_THEME = {};
function $2e59aa948a8b66a9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $9Raem.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $alwoF.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $alwoF.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $alwoF.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2e59aa948a8b66a9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $6SBoQ.default)($2e59aa948a8b66a9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $e5bf0645fc0392ca$export$2e2bcd8739ae039)() || $2e59aa948a8b66a9$var$EMPTY_THEME;
    const engineTheme = $2e59aa948a8b66a9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2e59aa948a8b66a9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $54a5923cc4e4e38d$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $9eXW2.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $2e59aa948a8b66a9$export$2e2bcd8739ae039 = $2e59aa948a8b66a9$var$ThemeProvider;



var $5gJQF = parcelRequire("5gJQF");

var $4fnJY = parcelRequire("4fnJY");
const $c1a37b6588154f63$var$_excluded = [
    "theme"
];
function $c1a37b6588154f63$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $bjnlX.default)(_ref, $c1a37b6588154f63$var$_excluded);
    const scopedTheme = themeInput[0, $5gJQF.default];
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $2e59aa948a8b66a9$export$2e2bcd8739ae039), (0, $alwoF.default)({}, props, {
        themeId: scopedTheme ? (0, $5gJQF.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $lTb4y = parcelRequire("lTb4y");

var $chM7U = parcelRequire("chM7U");
var $6SBoQ = parcelRequire("6SBoQ");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
const $6dbce25e56dc11fc$var$useEnhancedEffect = typeof window !== "undefined" ? $9Raem.useLayoutEffect : $9Raem.useEffect;
var $6dbce25e56dc11fc$export$2e2bcd8739ae039 = $6dbce25e56dc11fc$var$useEnhancedEffect;


var $8c0d08c5d41d7156$export$2e2bcd8739ae039 = (0, $6dbce25e56dc11fc$export$2e2bcd8739ae039);


/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $5cf6bcb342c36297$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $9Raem.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $8c0d08c5d41d7156$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $5cf6bcb342c36297$var$maybeReactUseSyncExternalStore = $lTb4y.useSyncExternalStore;
function $5cf6bcb342c36297$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $9Raem.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $9Raem.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $9Raem.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $5cf6bcb342c36297$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $5cf6bcb342c36297$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $6SBoQ.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $chM7U.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $5cf6bcb342c36297$var$maybeReactUseSyncExternalStore !== undefined ? $5cf6bcb342c36297$var$useMediaQueryNew : $5cf6bcb342c36297$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


const $8acf7da070400ff3$var$getDesignTokens = (mode)=>({
        palette: {
            mode: mode,
            ...mode === "light" ? {
                primary: {
                    main: "#505050"
                },
                secondary: {
                    main: "#dc143c"
                }
            } : {
                // palette values for dark mode
                primary: {
                    main: "#dc143c"
                },
                secondary: {
                    main: "#dc143c"
                },
                background: {
                    default: "#1a1a1a"
                }
            }
        }
    });
function $8acf7da070400ff3$export$2e2bcd8739ae039(props) {
    const prefersDarkMode = (0, $5cf6bcb342c36297$export$2e2bcd8739ae039)("(prefers-color-scheme: dark)");
    const theme = (0, $5jbOF.default)($8acf7da070400ff3$var$getDesignTokens(prefersDarkMode ? "dark" : "light"));
    return /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $c1a37b6588154f63$export$2e2bcd8739ae039), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $a614898a78dba1e0$export$2e2bcd8739ae039), {}),
            props.children
        ]
    });
}



var $4fnJY = parcelRequire("4fnJY");
var $ep79K = parcelRequire("ep79K");

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");

var $bIObK = parcelRequire("bIObK");

var $dxKlZ = parcelRequire("dxKlZ");

var $6tAkp = parcelRequire("6tAkp");
var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $3P2ac = parcelRequire("3P2ac");

var $1yxXw = parcelRequire("1yxXw");
const $3e1fa5e5288a4cf1$var$_excluded = [
    "sx"
];
const $3e1fa5e5288a4cf1$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $1yxXw.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $3e1fa5e5288a4cf1$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $bjnlX.default)(props, $3e1fa5e5288a4cf1$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $3e1fa5e5288a4cf1$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3P2ac.isPlainObject)(result)) return systemProps;
        return (0, $alwoF.default)({}, systemProps, result);
    };
    else finalSx = (0, $alwoF.default)({}, systemProps, inSx);
    return (0, $alwoF.default)({}, otherProps, {
        sx: finalSx
    });
}



var $8HH67 = parcelRequire("8HH67");

var $4fnJY = parcelRequire("4fnJY");
const $8c5fbc26fd53662a$var$_excluded = [
    "className",
    "component"
];
function $8c5fbc26fd53662a$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $dxKlZ.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $6tAkp.default));
    const Box = /*#__PURE__*/ $lTb4y.forwardRef(function Box(inProps, ref) {
        const theme = (0, $8HH67.default)(defaultTheme);
        const _extendSxProp = (0, $3e1fa5e5288a4cf1$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $bjnlX.default)(_extendSxProp, $8c5fbc26fd53662a$var$_excluded);
        return /*#__PURE__*/ (0, $4fnJY.jsx)(BoxRoot, (0, $alwoF.default)({
            as: component,
            ref: ref,
            className: (0, $bIObK.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $gPRSi = parcelRequire("gPRSi");

var $5jbOF = parcelRequire("5jbOF");

var $5gJQF = parcelRequire("5gJQF");
const $84458b2b8e5ee862$var$defaultTheme = (0, $5jbOF.default)();
const $84458b2b8e5ee862$var$Box = (0, $8c5fbc26fd53662a$export$2e2bcd8739ae039)({
    themeId: (0, $5gJQF.default),
    defaultTheme: $84458b2b8e5ee862$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $gPRSi.default).generate
});
var $84458b2b8e5ee862$export$2e2bcd8739ae039 = $84458b2b8e5ee862$var$Box;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bIObK = parcelRequire("bIObK");

var $8fdUL = parcelRequire("8fdUL");

var $7ED3r = parcelRequire("7ED3r");

var $ea7uD = parcelRequire("ea7uD");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $d3544c8c4bebf455$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $153e762309c7ad05$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $9Raem.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $d3544c8c4bebf455$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $e8bb5a753da187fb$export$2e2bcd8739ae039 = (0, $153e762309c7ad05$export$2e2bcd8739ae039);


parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");

function $53a3e18e8559a998$export$2e2bcd8739ae039(fn) {
    const ref = $9Raem.useRef(fn);
    (0, $6dbce25e56dc11fc$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $9Raem.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $cda969162f9e5154$export$2e2bcd8739ae039 = (0, $53a3e18e8559a998$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
let $71e47694e6b473c4$var$hadKeyboardEvent = true;
let $71e47694e6b473c4$var$hadFocusVisibleRecently = false;
let $71e47694e6b473c4$var$hadFocusVisibleRecentlyTimeout;
const $71e47694e6b473c4$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $71e47694e6b473c4$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $71e47694e6b473c4$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $71e47694e6b473c4$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $71e47694e6b473c4$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $71e47694e6b473c4$var$handlePointerDown() {
    $71e47694e6b473c4$var$hadKeyboardEvent = false;
}
function $71e47694e6b473c4$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($71e47694e6b473c4$var$hadFocusVisibleRecently) $71e47694e6b473c4$var$hadKeyboardEvent = true;
    }
}
function $71e47694e6b473c4$var$prepare(doc) {
    doc.addEventListener("keydown", $71e47694e6b473c4$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $71e47694e6b473c4$var$handleVisibilityChange, true);
}
function $71e47694e6b473c4$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $71e47694e6b473c4$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $71e47694e6b473c4$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $71e47694e6b473c4$var$handleVisibilityChange, true);
}
function $71e47694e6b473c4$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $71e47694e6b473c4$var$hadKeyboardEvent || $71e47694e6b473c4$var$focusTriggersKeyboardModality(target);
}
function $71e47694e6b473c4$export$2e2bcd8739ae039() {
    const ref = $9Raem.useCallback((node)=>{
        if (node != null) $71e47694e6b473c4$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $9Raem.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $71e47694e6b473c4$var$hadFocusVisibleRecently = true;
            window.clearTimeout($71e47694e6b473c4$var$hadFocusVisibleRecentlyTimeout);
            $71e47694e6b473c4$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $71e47694e6b473c4$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($71e47694e6b473c4$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $352e4df798dd7536$export$2e2bcd8739ae039 = (0, $71e47694e6b473c4$export$2e2bcd8739ae039);



var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");
function $06f6bd826cf267b1$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $3c80f3424d93f907$export$2e2bcd8739ae039(o, p) {
    $3c80f3424d93f907$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c80f3424d93f907$export$2e2bcd8739ae039(o, p);
}


function $f0b1d6a9489972cf$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $3c80f3424d93f907$export$2e2bcd8739ae039)(subClass, superClass);
}




var $lTb4y = parcelRequire("lTb4y");

var $lTb4y = parcelRequire("lTb4y");
var $cbe612beb4820fb7$export$2e2bcd8739ae039 = (0, $lTb4y.default).createContext(null);



var $lTb4y = parcelRequire("lTb4y");
function $95e5f287a9d74d3b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $lTb4y.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $lTb4y.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $95e5f287a9d74d3b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $95e5f287a9d74d3b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $95e5f287a9d74d3b$export$fa71e2345c31d7a2(props, onExited) {
    return $95e5f287a9d74d3b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $lTb4y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $95e5f287a9d74d3b$var$getProp(child, "appear", props),
            enter: $95e5f287a9d74d3b$var$getProp(child, "enter", props),
            exit: $95e5f287a9d74d3b$var$getProp(child, "exit", props)
        });
    });
}
function $95e5f287a9d74d3b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $95e5f287a9d74d3b$export$bbc8a025727ea824(nextProps.children);
    var children = $95e5f287a9d74d3b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $lTb4y.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $lTb4y.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $lTb4y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $95e5f287a9d74d3b$var$getProp(child, "exit", nextProps),
            enter: $95e5f287a9d74d3b$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $lTb4y.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $lTb4y.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $lTb4y.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $95e5f287a9d74d3b$var$getProp(child, "exit", nextProps),
            enter: $95e5f287a9d74d3b$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $2114d63c02e6f361$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $2114d63c02e6f361$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $2114d63c02e6f361$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $f0b1d6a9489972cf$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $06f6bd826cf267b1$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $95e5f287a9d74d3b$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $95e5f287a9d74d3b$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $95e5f287a9d74d3b$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $alwoF.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $bjnlX.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $2114d63c02e6f361$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, $lTb4y.default).createElement((0, $cbe612beb4820fb7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, $lTb4y.default).createElement((0, $cbe612beb4820fb7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, $lTb4y.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, $lTb4y.default).Component);
$2114d63c02e6f361$var$TransitionGroup.propTypes = {};
$2114d63c02e6f361$var$TransitionGroup.defaultProps = $2114d63c02e6f361$var$defaultProps;
var $2114d63c02e6f361$export$2e2bcd8739ae039 = $2114d63c02e6f361$var$TransitionGroup;



var $bIObK = parcelRequire("bIObK");

var $6fozl = parcelRequire("6fozl");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bIObK = parcelRequire("bIObK");

var $4fnJY = parcelRequire("4fnJY");
function $df565b2fbc94df26$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $9Raem.useState(false);
    const rippleClassName = (0, $bIObK.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $bIObK.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $9Raem.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $4fnJY.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $4fnJY.jsx)("span", {
            className: childClassName
        })
    });
}
var $df565b2fbc94df26$export$2e2bcd8739ae039 = $df565b2fbc94df26$var$Ripple;



var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $b1bbdc7bf306c054$export$b464606f735ab902(slot) {
    return (0, $io057.default)("MuiTouchRipple", slot);
}
const $b1bbdc7bf306c054$var$touchRippleClasses = (0, $6w46Z.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $b1bbdc7bf306c054$export$2e2bcd8739ae039 = $b1bbdc7bf306c054$var$touchRippleClasses;



var $4fnJY = parcelRequire("4fnJY");
const $71b5db1a9bf61898$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $71b5db1a9bf61898$var$_ = (t)=>t, $71b5db1a9bf61898$var$_t, $71b5db1a9bf61898$var$_t2, $71b5db1a9bf61898$var$_t3, $71b5db1a9bf61898$var$_t4;
const $71b5db1a9bf61898$var$DURATION = 550;
const $71b5db1a9bf61898$export$95d0c9356b2231a3 = 80;
const $71b5db1a9bf61898$var$enterKeyframe = (0, $6fozl.keyframes)($71b5db1a9bf61898$var$_t || ($71b5db1a9bf61898$var$_t = $71b5db1a9bf61898$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $71b5db1a9bf61898$var$exitKeyframe = (0, $6fozl.keyframes)($71b5db1a9bf61898$var$_t2 || ($71b5db1a9bf61898$var$_t2 = $71b5db1a9bf61898$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $71b5db1a9bf61898$var$pulsateKeyframe = (0, $6fozl.keyframes)($71b5db1a9bf61898$var$_t3 || ($71b5db1a9bf61898$var$_t3 = $71b5db1a9bf61898$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $71b5db1a9bf61898$export$f6b7418508c72c25 = (0, $l7HUa.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $71b5db1a9bf61898$export$676cfe7b12693c4b = (0, $l7HUa.default)((0, $df565b2fbc94df26$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($71b5db1a9bf61898$var$_t4 || ($71b5db1a9bf61898$var$_t4 = $71b5db1a9bf61898$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).rippleVisible, $71b5db1a9bf61898$var$enterKeyframe, $71b5db1a9bf61898$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).child, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).childLeaving, $71b5db1a9bf61898$var$exitKeyframe, $71b5db1a9bf61898$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).childPulsate, $71b5db1a9bf61898$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $71b5db1a9bf61898$var$TouchRipple = /*#__PURE__*/ $lTb4y.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $bjnlX.default)(props, $71b5db1a9bf61898$var$_excluded);
    const [ripples, setRipples] = $9Raem.useState([]);
    const nextKey = $9Raem.useRef(0);
    const rippleCallback = $9Raem.useRef(null);
    $9Raem.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $9Raem.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $9Raem.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $9Raem.useRef(null);
    const container = $9Raem.useRef(null);
    $9Raem.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $9Raem.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $4fnJY.jsx)($71b5db1a9bf61898$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $bIObK.default)(classes.ripple, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $bIObK.default)(classes.rippleVisible, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $bIObK.default)(classes.ripplePulsate, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $bIObK.default)(classes.child, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $bIObK.default)(classes.childLeaving, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $bIObK.default)(classes.childPulsate, (0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $71b5db1a9bf61898$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $9Raem.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $71b5db1a9bf61898$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $9Raem.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $9Raem.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $9Raem.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($71b5db1a9bf61898$export$f6b7418508c72c25, (0, $alwoF.default)({
        className: (0, $bIObK.default)((0, $b1bbdc7bf306c054$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $2114d63c02e6f361$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $71b5db1a9bf61898$export$2e2bcd8739ae039 = $71b5db1a9bf61898$var$TouchRipple;



var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $b2006522825f21db$export$fccb0498dcd99783(slot) {
    return (0, $io057.default)("MuiButtonBase", slot);
}
const $b2006522825f21db$var$buttonBaseClasses = (0, $6w46Z.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $b2006522825f21db$export$2e2bcd8739ae039 = $b2006522825f21db$var$buttonBaseClasses;



var $4fnJY = parcelRequire("4fnJY");
const $44c8142a1d2b5a55$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $44c8142a1d2b5a55$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $7ED3r.default)(slots, (0, $b2006522825f21db$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $44c8142a1d2b5a55$export$7ec0dcc5e3cdcd36 = (0, $l7HUa.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $b2006522825f21db$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $44c8142a1d2b5a55$var$ButtonBase = /*#__PURE__*/ $lTb4y.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $bjnlX.default)(props, $44c8142a1d2b5a55$var$_excluded);
    const buttonRef = $9Raem.useRef(null);
    const rippleRef = $9Raem.useRef(null);
    const handleRippleRef = (0, $e8bb5a753da187fb$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $352e4df798dd7536$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $9Raem.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $9Raem.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $9Raem.useState(false);
    $9Raem.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $9Raem.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $cda969162f9e5154$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $cda969162f9e5154$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $9Raem.useRef(false);
    const handleKeyDown = (0, $cda969162f9e5154$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $cda969162f9e5154$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $e8bb5a753da187fb$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $alwoF.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $44c8142a1d2b5a55$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($44c8142a1d2b5a55$export$7ec0dcc5e3cdcd36, (0, $alwoF.default)({
        as: ComponentProp,
        className: (0, $bIObK.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $4fnJY.jsx)((0, $71b5db1a9bf61898$export$2e2bcd8739ae039), (0, $alwoF.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $44c8142a1d2b5a55$export$2e2bcd8739ae039 = $44c8142a1d2b5a55$var$ButtonBase;



var $eIYVv = parcelRequire("eIYVv");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $26918fbffd8ec1cd$export$5a6f9035944c8119(slot) {
    return (0, $io057.default)("MuiButton", slot);
}
const $26918fbffd8ec1cd$var$buttonClasses = (0, $6w46Z.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $26918fbffd8ec1cd$export$2e2bcd8739ae039 = $26918fbffd8ec1cd$var$buttonClasses;


parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");
/**
 * @ignore - internal component.
 */ const $601c370efcbde48e$var$ButtonGroupContext = /*#__PURE__*/ $ep79K.createContext({});
var $601c370efcbde48e$export$2e2bcd8739ae039 = $601c370efcbde48e$var$ButtonGroupContext;



var $4fnJY = parcelRequire("4fnJY");
const $2641fe421c31af2c$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $2641fe421c31af2c$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $eIYVv.default)(color)}`,
            `size${(0, $eIYVv.default)(size)}`,
            `${variant}Size${(0, $eIYVv.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $eIYVv.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $eIYVv.default)(size)}`
        ]
    };
    const composedClasses = (0, $7ED3r.default)(slots, (0, $26918fbffd8ec1cd$export$5a6f9035944c8119), classes);
    return (0, $alwoF.default)({}, classes, composedClasses);
};
const $2641fe421c31af2c$var$commonIconStyles = (ownerState)=>(0, $alwoF.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $2641fe421c31af2c$var$ButtonRoot = (0, $l7HUa.default)((0, $44c8142a1d2b5a55$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $l7HUa.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $eIYVv.default)(ownerState.color)}`],
            styles[`size${(0, $eIYVv.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $eIYVv.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $alwoF.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $alwoF.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ea7uD.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ea7uD.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ea7uD.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $alwoF.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $26918fbffd8ec1cd$export$2e2bcd8739ae039).focusVisible}`]: (0, $alwoF.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $26918fbffd8ec1cd$export$2e2bcd8739ae039).disabled}`]: (0, $alwoF.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $ea7uD.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $26918fbffd8ec1cd$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $26918fbffd8ec1cd$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $2641fe421c31af2c$var$ButtonStartIcon = (0, $l7HUa.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $eIYVv.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $alwoF.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $2641fe421c31af2c$var$commonIconStyles(ownerState)));
const $2641fe421c31af2c$var$ButtonEndIcon = (0, $l7HUa.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $eIYVv.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $alwoF.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $2641fe421c31af2c$var$commonIconStyles(ownerState)));
const $2641fe421c31af2c$var$Button = /*#__PURE__*/ $lTb4y.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $9Raem.useContext((0, $601c370efcbde48e$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8fdUL.default)(contextProps, inProps);
    const props = (0, $lEU9Q.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $bjnlX.default)(props, $2641fe421c31af2c$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $2641fe421c31af2c$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $4fnJY.jsx)($2641fe421c31af2c$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $4fnJY.jsx)($2641fe421c31af2c$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($2641fe421c31af2c$var$ButtonRoot, (0, $alwoF.default)({
        ownerState: ownerState,
        className: (0, $bIObK.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $bIObK.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $2641fe421c31af2c$export$2e2bcd8739ae039 = $2641fe421c31af2c$var$Button;


var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $ea7uD = parcelRequire("ea7uD");

var $l7HUa = parcelRequire("l7HUa");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $1628bf9827e14590$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $1628bf9827e14590$export$2e2bcd8739ae039 = $1628bf9827e14590$var$getOverlayAlpha;



var $lEU9Q = parcelRequire("lEU9Q");


var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $09cff635ccfbb32f$export$29cdb466b9b6f20b(slot) {
    return (0, $io057.default)("MuiPaper", slot);
}
const $09cff635ccfbb32f$var$paperClasses = (0, $6w46Z.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $09cff635ccfbb32f$export$2e2bcd8739ae039 = $09cff635ccfbb32f$var$paperClasses;



var $4fnJY = parcelRequire("4fnJY");
const $73b4fe006c27f90b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $73b4fe006c27f90b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $09cff635ccfbb32f$export$29cdb466b9b6f20b), classes);
};
const $73b4fe006c27f90b$var$PaperRoot = (0, $l7HUa.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $alwoF.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $alwoF.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $ea7uD.alpha)("#fff", (0, $1628bf9827e14590$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $ea7uD.alpha)("#fff", (0, $1628bf9827e14590$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $73b4fe006c27f90b$var$Paper = /*#__PURE__*/ $lTb4y.forwardRef(function Paper(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $bjnlX.default)(props, $73b4fe006c27f90b$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $73b4fe006c27f90b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($73b4fe006c27f90b$var$PaperRoot, (0, $alwoF.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $bIObK.default)(classes.root, className),
        ref: ref
    }, other));
});
var $73b4fe006c27f90b$export$2e2bcd8739ae039 = $73b4fe006c27f90b$var$Paper;



var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $4abaebc35a0467f8$export$f3b76d2cce458caa(slot) {
    return (0, $io057.default)("MuiCard", slot);
}
const $4abaebc35a0467f8$var$cardClasses = (0, $6w46Z.default)("MuiCard", [
    "root"
]);
var $4abaebc35a0467f8$export$2e2bcd8739ae039 = $4abaebc35a0467f8$var$cardClasses;



var $4fnJY = parcelRequire("4fnJY");
const $1741921cbd2cd28b$var$_excluded = [
    "className",
    "raised"
];
const $1741921cbd2cd28b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $4abaebc35a0467f8$export$f3b76d2cce458caa), classes);
};
const $1741921cbd2cd28b$var$CardRoot = (0, $l7HUa.default)((0, $73b4fe006c27f90b$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $1741921cbd2cd28b$var$Card = /*#__PURE__*/ $lTb4y.forwardRef(function Card(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $bjnlX.default)(props, $1741921cbd2cd28b$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        raised: raised
    });
    const classes = $1741921cbd2cd28b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($1741921cbd2cd28b$var$CardRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1741921cbd2cd28b$export$2e2bcd8739ae039 = $1741921cbd2cd28b$var$Card;


var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $lEU9Q = parcelRequire("lEU9Q");

var $l7HUa = parcelRequire("l7HUa");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $93171e216d6a6644$export$ee5828fb8c43a48e(slot) {
    return (0, $io057.default)("MuiCardActionArea", slot);
}
const $93171e216d6a6644$var$cardActionAreaClasses = (0, $6w46Z.default)("MuiCardActionArea", [
    "root",
    "focusVisible",
    "focusHighlight"
]);
var $93171e216d6a6644$export$2e2bcd8739ae039 = $93171e216d6a6644$var$cardActionAreaClasses;




var $4fnJY = parcelRequire("4fnJY");
const $e49dec6e8930a45c$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $e49dec6e8930a45c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        focusHighlight: [
            "focusHighlight"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $93171e216d6a6644$export$ee5828fb8c43a48e), classes);
};
const $e49dec6e8930a45c$var$CardActionAreaRoot = (0, $l7HUa.default)((0, $44c8142a1d2b5a55$export$2e2bcd8739ae039), {
    name: "MuiCardActionArea",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        textAlign: "inherit",
        borderRadius: "inherit",
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: "100%",
        [`&:hover .${(0, $93171e216d6a6644$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            "@media (hover: none)": {
                opacity: 0
            }
        },
        [`&.${(0, $93171e216d6a6644$export$2e2bcd8739ae039).focusVisible} .${(0, $93171e216d6a6644$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $e49dec6e8930a45c$var$CardActionAreaFocusHighlight = (0, $l7HUa.default)("span", {
    name: "MuiCardActionArea",
    slot: "FocusHighlight",
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: "inherit",
        opacity: 0,
        backgroundColor: "currentcolor",
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.short
        })
    }));
const $e49dec6e8930a45c$var$CardActionArea = /*#__PURE__*/ $lTb4y.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCardActionArea"
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $bjnlX.default)(props, $e49dec6e8930a45c$var$_excluded);
    const ownerState = props;
    const classes = $e49dec6e8930a45c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($e49dec6e8930a45c$var$CardActionAreaRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        focusVisibleClassName: (0, $bIObK.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $4fnJY.jsx)($e49dec6e8930a45c$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $e49dec6e8930a45c$export$2e2bcd8739ae039 = $e49dec6e8930a45c$var$CardActionArea;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $94bf554ededcda9c$export$2a5c27c211442e3c(slot) {
    return (0, $io057.default)("MuiCardActions", slot);
}
const $94bf554ededcda9c$var$cardActionsClasses = (0, $6w46Z.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $94bf554ededcda9c$export$2e2bcd8739ae039 = $94bf554ededcda9c$var$cardActionsClasses;



var $4fnJY = parcelRequire("4fnJY");
const $370174308974e07b$var$_excluded = [
    "disableSpacing",
    "className"
];
const $370174308974e07b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $94bf554ededcda9c$export$2a5c27c211442e3c), classes);
};
const $370174308974e07b$var$CardActionsRoot = (0, $l7HUa.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $alwoF.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $370174308974e07b$var$CardActions = /*#__PURE__*/ $lTb4y.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $bjnlX.default)(props, $370174308974e07b$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $370174308974e07b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($370174308974e07b$var$CardActionsRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $370174308974e07b$export$2e2bcd8739ae039 = $370174308974e07b$var$CardActions;


var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $dda955a0f05e5dce$export$964336739a8c7119(slot) {
    return (0, $io057.default)("MuiCardContent", slot);
}
const $dda955a0f05e5dce$var$cardContentClasses = (0, $6w46Z.default)("MuiCardContent", [
    "root"
]);
var $dda955a0f05e5dce$export$2e2bcd8739ae039 = $dda955a0f05e5dce$var$cardContentClasses;



var $4fnJY = parcelRequire("4fnJY");
const $c7d802f19fc1c5c9$var$_excluded = [
    "className",
    "component"
];
const $c7d802f19fc1c5c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $dda955a0f05e5dce$export$964336739a8c7119), classes);
};
const $c7d802f19fc1c5c9$var$CardContentRoot = (0, $l7HUa.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $c7d802f19fc1c5c9$var$CardContent = /*#__PURE__*/ $lTb4y.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $bjnlX.default)(props, $c7d802f19fc1c5c9$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        component: component
    });
    const classes = $c7d802f19fc1c5c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($c7d802f19fc1c5c9$var$CardContentRoot, (0, $alwoF.default)({
        as: component,
        className: (0, $bIObK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $c7d802f19fc1c5c9$export$2e2bcd8739ae039 = $c7d802f19fc1c5c9$var$CardContent;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $eIYVv = parcelRequire("eIYVv");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $68e15e8e9ef06afe$export$24c1f8f60cbac79e(slot) {
    return (0, $io057.default)("MuiTypography", slot);
}
const $68e15e8e9ef06afe$var$typographyClasses = (0, $6w46Z.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $68e15e8e9ef06afe$export$2e2bcd8739ae039 = $68e15e8e9ef06afe$var$typographyClasses;



var $4fnJY = parcelRequire("4fnJY");
const $347a21fd4cb79caa$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $347a21fd4cb79caa$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $eIYVv.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $68e15e8e9ef06afe$export$24c1f8f60cbac79e), classes);
};
const $347a21fd4cb79caa$export$140e2f5526d3cad8 = (0, $l7HUa.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $eIYVv.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $alwoF.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $347a21fd4cb79caa$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $347a21fd4cb79caa$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $347a21fd4cb79caa$var$transformDeprecatedColors = (color)=>{
    return $347a21fd4cb79caa$var$colorTransformations[color] || color;
};
const $347a21fd4cb79caa$var$Typography = /*#__PURE__*/ $lTb4y.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $347a21fd4cb79caa$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $3e1fa5e5288a4cf1$export$2e2bcd8739ae039)((0, $alwoF.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $347a21fd4cb79caa$var$defaultVariantMapping } = props, other = (0, $bjnlX.default)(props, $347a21fd4cb79caa$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $347a21fd4cb79caa$var$defaultVariantMapping[variant]) || "span";
    const classes = $347a21fd4cb79caa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($347a21fd4cb79caa$export$140e2f5526d3cad8, (0, $alwoF.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $bIObK.default)(classes.root, className)
    }, other));
});
var $347a21fd4cb79caa$export$2e2bcd8739ae039 = $347a21fd4cb79caa$var$Typography;



var $lEU9Q = parcelRequire("lEU9Q");

var $l7HUa = parcelRequire("l7HUa");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $63b2b3758c07194c$export$f54c8b0d04b67946(slot) {
    return (0, $io057.default)("MuiCardHeader", slot);
}
const $63b2b3758c07194c$var$cardHeaderClasses = (0, $6w46Z.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $63b2b3758c07194c$export$2e2bcd8739ae039 = $63b2b3758c07194c$var$cardHeaderClasses;



var $4fnJY = parcelRequire("4fnJY");
const $51e4c83e24778ef8$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $51e4c83e24778ef8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $63b2b3758c07194c$export$f54c8b0d04b67946), classes);
};
const $51e4c83e24778ef8$var$CardHeaderRoot = (0, $l7HUa.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $alwoF.default)({
            [`& .${(0, $63b2b3758c07194c$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $63b2b3758c07194c$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $51e4c83e24778ef8$var$CardHeaderAvatar = (0, $l7HUa.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $51e4c83e24778ef8$var$CardHeaderAction = (0, $l7HUa.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $51e4c83e24778ef8$var$CardHeaderContent = (0, $l7HUa.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $51e4c83e24778ef8$var$CardHeader = /*#__PURE__*/ $lTb4y.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $bjnlX.default)(props, $51e4c83e24778ef8$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $51e4c83e24778ef8$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $347a21fd4cb79caa$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), (0, $alwoF.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $347a21fd4cb79caa$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), (0, $alwoF.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($51e4c83e24778ef8$var$CardHeaderRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $4fnJY.jsx)($51e4c83e24778ef8$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $4fnJY.jsxs)($51e4c83e24778ef8$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $4fnJY.jsx)($51e4c83e24778ef8$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $51e4c83e24778ef8$export$2e2bcd8739ae039 = $51e4c83e24778ef8$var$CardHeader;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $eIYVv = parcelRequire("eIYVv");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");




var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $d1afb0d204994c0e$export$d6efab9620b78fec(slot) {
    return (0, $io057.default)("MuiLink", slot);
}
const $d1afb0d204994c0e$var$linkClasses = (0, $6w46Z.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $d1afb0d204994c0e$export$2e2bcd8739ae039 = $d1afb0d204994c0e$var$linkClasses;



var $ea7uD = parcelRequire("ea7uD");
var $4PWi6 = parcelRequire("4PWi6");
const $b27796373576c7be$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $b27796373576c7be$var$transformDeprecatedColors = (color)=>{
    return $b27796373576c7be$export$c4e140d5d351182b[color] || color;
};
const $b27796373576c7be$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $b27796373576c7be$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $4PWi6.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $4PWi6.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $ea7uD.alpha)(color, 0.4);
};
var $b27796373576c7be$export$2e2bcd8739ae039 = $b27796373576c7be$var$getTextDecoration;



var $4fnJY = parcelRequire("4fnJY");
const $897e691b868dc2cd$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $897e691b868dc2cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $eIYVv.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $d1afb0d204994c0e$export$d6efab9620b78fec), classes);
};
const $897e691b868dc2cd$var$LinkRoot = (0, $l7HUa.default)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $eIYVv.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $alwoF.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $alwoF.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $b27796373576c7be$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $d1afb0d204994c0e$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $897e691b868dc2cd$var$Link = /*#__PURE__*/ $lTb4y.forwardRef(function Link(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $bjnlX.default)(props, $897e691b868dc2cd$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $352e4df798dd7536$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $9Raem.useState(false);
    const handlerRef = (0, $e8bb5a753da187fb$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $alwoF.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $897e691b868dc2cd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($897e691b868dc2cd$var$LinkRoot, (0, $alwoF.default)({
        color: color,
        className: (0, $bIObK.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $b27796373576c7be$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $897e691b868dc2cd$export$2e2bcd8739ae039 = $897e691b868dc2cd$var$Link;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");


var $eIYVv = parcelRequire("eIYVv");

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $6fozl = parcelRequire("6fozl");
var $ea7uD = parcelRequire("ea7uD");

var $eIYVv = parcelRequire("eIYVv");
parcelRequire("lTb4y");

var $8HH67 = parcelRequire("8HH67");

var $fBkQg = parcelRequire("fBkQg");

var $5gJQF = parcelRequire("5gJQF");
function $c9a3950c5281cf13$export$2e2bcd8739ae039() {
    const theme = (0, $8HH67.default)((0, $fBkQg.default));
    return theme[0, $5gJQF.default] || theme;
}



var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $367a6c6ed2471aa4$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $io057.default)("MuiLinearProgress", slot);
}
const $367a6c6ed2471aa4$var$linearProgressClasses = (0, $6w46Z.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $367a6c6ed2471aa4$export$2e2bcd8739ae039 = $367a6c6ed2471aa4$var$linearProgressClasses;



var $4fnJY = parcelRequire("4fnJY");
const $a3516503d7688977$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $a3516503d7688977$var$_ = (t)=>t, $a3516503d7688977$var$_t, $a3516503d7688977$var$_t2, $a3516503d7688977$var$_t3, $a3516503d7688977$var$_t4, $a3516503d7688977$var$_t5, $a3516503d7688977$var$_t6;
const $a3516503d7688977$var$TRANSITION_DURATION = 4; // seconds
const $a3516503d7688977$var$indeterminate1Keyframe = (0, $6fozl.keyframes)($a3516503d7688977$var$_t || ($a3516503d7688977$var$_t = $a3516503d7688977$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $a3516503d7688977$var$indeterminate2Keyframe = (0, $6fozl.keyframes)($a3516503d7688977$var$_t2 || ($a3516503d7688977$var$_t2 = $a3516503d7688977$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $a3516503d7688977$var$bufferKeyframe = (0, $6fozl.keyframes)($a3516503d7688977$var$_t3 || ($a3516503d7688977$var$_t3 = $a3516503d7688977$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $a3516503d7688977$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $eIYVv.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $eIYVv.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $eIYVv.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $eIYVv.default)(color)}`,
            variant === "buffer" && `color${(0, $eIYVv.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $367a6c6ed2471aa4$export$bc8a6ea1eb17d7c6), classes);
};
const $a3516503d7688977$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $ea7uD.lighten)(theme.palette[color].main, 0.62) : (0, $ea7uD.darken)(theme.palette[color].main, 0.5);
};
const $a3516503d7688977$var$LinearProgressRoot = (0, $l7HUa.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $eIYVv.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $alwoF.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $a3516503d7688977$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $a3516503d7688977$var$LinearProgressDashed = (0, $l7HUa.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $eIYVv.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $a3516503d7688977$var$getColorShade(theme, ownerState.color);
    return (0, $alwoF.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $6fozl.css)($a3516503d7688977$var$_t4 || ($a3516503d7688977$var$_t4 = $a3516503d7688977$var$_`
    animation: ${0} 3s infinite linear;
  `), $a3516503d7688977$var$bufferKeyframe));
const $a3516503d7688977$var$LinearProgressBar1 = (0, $l7HUa.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $eIYVv.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $alwoF.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$a3516503d7688977$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$a3516503d7688977$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $6fozl.css)($a3516503d7688977$var$_t5 || ($a3516503d7688977$var$_t5 = $a3516503d7688977$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $a3516503d7688977$var$indeterminate1Keyframe));
const $a3516503d7688977$var$LinearProgressBar2 = (0, $l7HUa.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $eIYVv.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $alwoF.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $a3516503d7688977$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$a3516503d7688977$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $6fozl.css)($a3516503d7688977$var$_t6 || ($a3516503d7688977$var$_t6 = $a3516503d7688977$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $a3516503d7688977$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $a3516503d7688977$var$LinearProgress = /*#__PURE__*/ $lTb4y.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $bjnlX.default)(props, $a3516503d7688977$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $a3516503d7688977$var$useUtilityClasses(ownerState);
    const theme = (0, $c9a3950c5281cf13$export$2e2bcd8739ae039)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($a3516503d7688977$var$LinearProgressRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $4fnJY.jsx)($a3516503d7688977$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $4fnJY.jsx)($a3516503d7688977$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $4fnJY.jsx)($a3516503d7688977$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $a3516503d7688977$export$2e2bcd8739ae039 = $a3516503d7688977$var$LinearProgress;



var $lEU9Q = parcelRequire("lEU9Q");

var $l7HUa = parcelRequire("l7HUa");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $bbbb5c1e2e4fe03d$export$af7da6d60955385e(slot) {
    return (0, $io057.default)("MuiMobileStepper", slot);
}
const $bbbb5c1e2e4fe03d$var$mobileStepperClasses = (0, $6w46Z.default)("MuiMobileStepper", [
    "root",
    "positionBottom",
    "positionTop",
    "positionStatic",
    "dots",
    "dot",
    "dotActive",
    "progress"
]);
var $bbbb5c1e2e4fe03d$export$2e2bcd8739ae039 = $bbbb5c1e2e4fe03d$var$mobileStepperClasses;



var $4fnJY = parcelRequire("4fnJY");
const $08071c572e0b8d94$var$_excluded = [
    "activeStep",
    "backButton",
    "className",
    "LinearProgressProps",
    "nextButton",
    "position",
    "steps",
    "variant"
];
const $08071c572e0b8d94$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            "root",
            `position${(0, $eIYVv.default)(position)}`
        ],
        dots: [
            "dots"
        ],
        dot: [
            "dot"
        ],
        dotActive: [
            "dotActive"
        ],
        progress: [
            "progress"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $bbbb5c1e2e4fe03d$export$af7da6d60955385e), classes);
};
const $08071c572e0b8d94$var$MobileStepperRoot = (0, $l7HUa.default)((0, $73b4fe006c27f90b$export$2e2bcd8739ae039), {
    name: "MuiMobileStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $eIYVv.default)(ownerState.position)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $alwoF.default)({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        background: (theme.vars || theme).palette.background.default,
        padding: 8
    }, ownerState.position === "bottom" && {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }, ownerState.position === "top" && {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }));
const $08071c572e0b8d94$var$MobileStepperDots = (0, $l7HUa.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dots",
    overridesResolver: (props, styles)=>styles.dots
})(({ ownerState: ownerState })=>(0, $alwoF.default)({}, ownerState.variant === "dots" && {
        display: "flex",
        flexDirection: "row"
    }));
const $08071c572e0b8d94$var$MobileStepperDot = (0, $l7HUa.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dot",
    shouldForwardProp: (prop)=>(0, $l7HUa.slotShouldForwardProp)(prop) && prop !== "dotActive",
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})(({ theme: theme, ownerState: ownerState, dotActive: dotActive })=>(0, $alwoF.default)({}, ownerState.variant === "dots" && (0, $alwoF.default)({
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.action.disabled,
        borderRadius: "50%",
        width: 8,
        height: 8,
        margin: "0 2px"
    }, dotActive && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    })));
const $08071c572e0b8d94$var$MobileStepperProgress = (0, $l7HUa.default)((0, $a3516503d7688977$export$2e2bcd8739ae039), {
    name: "MuiMobileStepper",
    slot: "Progress",
    overridesResolver: (props, styles)=>styles.progress
})(({ ownerState: ownerState })=>(0, $alwoF.default)({}, ownerState.variant === "progress" && {
        width: "50%"
    }));
const $08071c572e0b8d94$var$MobileStepper = /*#__PURE__*/ $lTb4y.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiMobileStepper"
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = "bottom", steps: steps, variant: variant = "dots" } = props, other = (0, $bjnlX.default)(props, $08071c572e0b8d94$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        activeStep: activeStep,
        position: position,
        variant: variant
    });
    let value;
    if (variant === "progress") {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = $08071c572e0b8d94$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($08071c572e0b8d94$var$MobileStepperRoot, (0, $alwoF.default)({
        square: true,
        elevation: 0,
        className: (0, $bIObK.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            backButton,
            variant === "text" && /*#__PURE__*/ (0, $4fnJY.jsxs)($ep79K.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === "dots" && /*#__PURE__*/ (0, $4fnJY.jsx)($08071c572e0b8d94$var$MobileStepperDots, {
                ownerState: ownerState,
                className: classes.dots,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $4fnJY.jsx)($08071c572e0b8d94$var$MobileStepperDot, {
                        className: (0, $bIObK.default)(classes.dot, index === activeStep && classes.dotActive),
                        ownerState: ownerState,
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === "progress" && /*#__PURE__*/ (0, $4fnJY.jsx)($08071c572e0b8d94$var$MobileStepperProgress, (0, $alwoF.default)({
                ownerState: ownerState,
                className: classes.progress,
                variant: "determinate",
                value: value
            }, LinearProgressProps)),
            nextButton
        ]
    }));
});
var $08071c572e0b8d94$export$2e2bcd8739ae039 = $08071c572e0b8d94$var$MobileStepper;


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");

var $bIObK = parcelRequire("bIObK");


var $6fozl = parcelRequire("6fozl");

var $7ED3r = parcelRequire("7ED3r");

var $ea7uD = parcelRequire("ea7uD");function $8a4309ef02229fb6$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $8a4309ef02229fb6$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $8a4309ef02229fb6$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $8a4309ef02229fb6$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $8a4309ef02229fb6$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $8a4309ef02229fb6$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $8a4309ef02229fb6$export$8af1d214c6c2f0f1(length) * $8a4309ef02229fb6$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $8a4309ef02229fb6$export$8af1d214c6c2f0f1(length) * $8a4309ef02229fb6$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $8a4309ef02229fb6$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $8a4309ef02229fb6$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $8a4309ef02229fb6$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $8a4309ef02229fb6$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $8a4309ef02229fb6$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $ee979554825c4a7d$export$c987db9fc844f86(slot) {
    return (0, $io057.default)("MuiSkeleton", slot);
}
const $ee979554825c4a7d$var$skeletonClasses = (0, $6w46Z.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $ee979554825c4a7d$export$2e2bcd8739ae039 = $ee979554825c4a7d$var$skeletonClasses;



var $4fnJY = parcelRequire("4fnJY");
const $df06f0ead90319e2$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $df06f0ead90319e2$var$_ = (t)=>t, $df06f0ead90319e2$var$_t, $df06f0ead90319e2$var$_t2, $df06f0ead90319e2$var$_t3, $df06f0ead90319e2$var$_t4;
const $df06f0ead90319e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $ee979554825c4a7d$export$c987db9fc844f86), classes);
};
const $df06f0ead90319e2$var$pulseKeyframe = (0, $6fozl.keyframes)($df06f0ead90319e2$var$_t || ($df06f0ead90319e2$var$_t = $df06f0ead90319e2$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $df06f0ead90319e2$var$waveKeyframe = (0, $6fozl.keyframes)($df06f0ead90319e2$var$_t2 || ($df06f0ead90319e2$var$_t2 = $df06f0ead90319e2$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $df06f0ead90319e2$var$SkeletonRoot = (0, $l7HUa.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $8a4309ef02229fb6$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $8a4309ef02229fb6$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $alwoF.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $ea7uD.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $6fozl.css)($df06f0ead90319e2$var$_t3 || ($df06f0ead90319e2$var$_t3 = $df06f0ead90319e2$var$_`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), $df06f0ead90319e2$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $6fozl.css)($df06f0ead90319e2$var$_t4 || ($df06f0ead90319e2$var$_t4 = $df06f0ead90319e2$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $df06f0ead90319e2$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $df06f0ead90319e2$var$Skeleton = /*#__PURE__*/ $lTb4y.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $bjnlX.default)(props, $df06f0ead90319e2$var$_excluded);
    const ownerState = (0, $alwoF.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $df06f0ead90319e2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($df06f0ead90319e2$var$SkeletonRoot, (0, $alwoF.default)({
        as: component,
        ref: ref,
        className: (0, $bIObK.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $alwoF.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $df06f0ead90319e2$export$2e2bcd8739ae039 = $df06f0ead90319e2$var$Skeleton;



var $alwoF = parcelRequire("alwoF");

var $bjnlX = parcelRequire("bjnlX");
parcelRequire("lTb4y");
var $ep79K = parcelRequire("ep79K");
var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");
var $io057 = parcelRequire("io057");
var $lTb4y = parcelRequire("lTb4y");
function $f9f5ffa6b7840a80$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $lTb4y.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}



var $1jIrR = parcelRequire("1jIrR");
const $746fe359b0f0950f$var$styled = (0, $1jIrR.default)();
var $746fe359b0f0950f$export$2e2bcd8739ae039 = $746fe359b0f0950f$var$styled;



var $iQwnU = parcelRequire("iQwnU");

var $8HH67 = parcelRequire("8HH67");


var $aiTSV = parcelRequire("aiTSV");

var $alwoF = parcelRequire("alwoF");
const $f786cd1034fbf3f1$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $f786cd1034fbf3f1$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === "object") {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $f786cd1034fbf3f1$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.indexOf(key) !== -1) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === "number" || typeof responsive === "string") iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $2ca5e7e0fef065ec$var$appendLevel(level) {
    if (!level) return "";
    return `Level${level}`;
}
function $2ca5e7e0fef065ec$var$isNestedContainer(ownerState) {
    return ownerState.unstable_level > 0 && ownerState.container;
}
function $2ca5e7e0fef065ec$var$createGetSelfSpacing(ownerState) {
    return function getSelfSpacing(axis) {
        return `var(--Grid-${axis}Spacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)})`;
    };
}
function $2ca5e7e0fef065ec$var$createGetParentSpacing(ownerState) {
    return function getParentSpacing(axis) {
        if (ownerState.unstable_level === 0) return `var(--Grid-${axis}Spacing)`;
        return `var(--Grid-${axis}Spacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level - 1)})`;
    };
}
function $2ca5e7e0fef065ec$var$getParentColumns(ownerState) {
    if (ownerState.unstable_level === 0) return `var(--Grid-columns)`;
    return `var(--Grid-columns${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level - 1)})`;
}
const $2ca5e7e0fef065ec$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const getSelfSpacing = $2ca5e7e0fef065ec$var$createGetSelfSpacing(ownerState);
    const styles = {};
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridSize, (appendStyle, value)=>{
        let style = {};
        if (value === true) style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        if (value === "auto") style = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        if (typeof value === "number") style = {
            flexGrow: 0,
            flexBasis: "auto",
            width: `calc(100% * ${value} / ${$2ca5e7e0fef065ec$var$getParentColumns(ownerState)}${$2ca5e7e0fef065ec$var$isNestedContainer(ownerState) ? ` + ${getSelfSpacing("column")}` : ""})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridOffset, (appendStyle, value)=>{
        let style = {};
        if (value === "auto") style = {
            marginLeft: "auto"
        };
        if (typeof value === "number") style = {
            marginLeft: value === 0 ? "0px" : `calc(100% * ${value} / ${$2ca5e7e0fef065ec$var$getParentColumns(ownerState)})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = $2ca5e7e0fef065ec$var$isNestedContainer(ownerState) ? {
        [`--Grid-columns${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: $2ca5e7e0fef065ec$var$getParentColumns(ownerState)
    } : {
        "--Grid-columns": 12
    };
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columns${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: value
        });
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $2ca5e7e0fef065ec$var$createGetParentSpacing(ownerState);
    const styles = $2ca5e7e0fef065ec$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-rowSpacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("row")
    } : {};
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        var _theme$spacing;
        appendStyle(styles, {
            [`--Grid-rowSpacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing = theme.spacing) == null ? void 0 : _theme$spacing.call(theme, value)
        });
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $2ca5e7e0fef065ec$var$createGetParentSpacing(ownerState);
    const styles = $2ca5e7e0fef065ec$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-columnSpacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("column")
    } : {};
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        var _theme$spacing2;
        appendStyle(styles, {
            [`--Grid-columnSpacing${$2ca5e7e0fef065ec$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing2 = theme.spacing) == null ? void 0 : _theme$spacing2.call(theme, value)
        });
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $f786cd1034fbf3f1$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $2ca5e7e0fef065ec$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    const getSelfSpacing = $2ca5e7e0fef065ec$var$createGetSelfSpacing(ownerState);
    const getParentSpacing = $2ca5e7e0fef065ec$var$createGetParentSpacing(ownerState);
    return (0, $alwoF.default)({
        minWidth: 0,
        boxSizing: "border-box"
    }, ownerState.container && (0, $alwoF.default)({
        display: "flex",
        flexWrap: "wrap"
    }, ownerState.wrap && ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }, {
        margin: `calc(${getSelfSpacing("row")} / -2) calc(${getSelfSpacing("column")} / -2)`
    }, ownerState.disableEqualOverflow && {
        margin: `calc(${getSelfSpacing("row")} * -1) 0px 0px calc(${getSelfSpacing("column")} * -1)`
    }), (!ownerState.container || $2ca5e7e0fef065ec$var$isNestedContainer(ownerState)) && (0, $alwoF.default)({
        padding: `calc(${getParentSpacing("row")} / 2) calc(${getParentSpacing("column")} / 2)`
    }, (ownerState.disableEqualOverflow || ownerState.parentDisableEqualOverflow) && {
        padding: `${getParentSpacing("row")} 0px 0px ${getParentSpacing("column")}`
    }));
};
const $2ca5e7e0fef065ec$export$e2d1175061442d38 = (gridSize)=>{
    const classNames = [];
    Object.entries(gridSize).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $2ca5e7e0fef065ec$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = "xs")=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === "string" && !Number.isNaN(Number(val)) || typeof val === "number" && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === "object" && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $2ca5e7e0fef065ec$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === "object") return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $4fnJY = parcelRequire("4fnJY");
const $a141786af572ab0d$var$_excluded = [
    "className",
    "children",
    "columns",
    "container",
    "component",
    "direction",
    "wrap",
    "spacing",
    "rowSpacing",
    "columnSpacing",
    "disableEqualOverflow",
    "unstable_level"
];
const $a141786af572ab0d$var$defaultTheme = (0, $aiTSV.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $a141786af572ab0d$var$defaultCreateStyledComponent = (0, $746fe359b0f0950f$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $a141786af572ab0d$var$useThemePropsDefault(props) {
    return (0, $iQwnU.default)({
        props: props,
        name: "MuiGrid",
        defaultTheme: $a141786af572ab0d$var$defaultTheme
    });
}
function $a141786af572ab0d$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $a141786af572ab0d$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $a141786af572ab0d$var$useThemePropsDefault, componentName: componentName = "MuiGrid" } = options;
    const OverflowContext = /*#__PURE__*/ $ep79K.createContext(undefined);
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, gridSize: gridSize } = ownerState;
        const slots = {
            root: [
                "root",
                container && "container",
                wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
                ...(0, $2ca5e7e0fef065ec$export$a7c8efbe2b138a60)(direction),
                ...(0, $2ca5e7e0fef065ec$export$e2d1175061442d38)(gridSize),
                ...container ? (0, $2ca5e7e0fef065ec$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $7ED3r.default)(slots, (slot)=>(0, $io057.default)(componentName, slot), {});
    };
    const GridRoot = createStyledComponent((0, $2ca5e7e0fef065ec$export$ccc4d4a4923f1b06), (0, $2ca5e7e0fef065ec$export$a89c28919b8e3bb5), (0, $2ca5e7e0fef065ec$export$68c4dad72dd49c74), (0, $2ca5e7e0fef065ec$export$84053369756c53db), (0, $2ca5e7e0fef065ec$export$2a0a3c01032b3f4), (0, $2ca5e7e0fef065ec$export$810b8c3ab5d46bf), (0, $2ca5e7e0fef065ec$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $lTb4y.forwardRef(function Grid(inProps, ref) {
        var _inProps$columns, _inProps$spacing, _ref, _inProps$rowSpacing, _ref2, _inProps$columnSpacin, _ref3, _disableEqualOverflow;
        const theme = (0, $8HH67.default)();
        const themeProps = useThemeProps(inProps);
        const props = (0, $3e1fa5e5288a4cf1$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const overflow = $9Raem.useContext(OverflowContext);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = "div", direction: direction = "row", wrap: wrap = "wrap", spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, disableEqualOverflow: themeDisableEqualOverflow, unstable_level: level = 0 } = props, rest = (0, $bjnlX.default)(props, $a141786af572ab0d$var$_excluded);
        // Because `disableEqualOverflow` can be set from the theme's defaultProps, the **nested** grid should look at the instance props instead.
        let disableEqualOverflow = themeDisableEqualOverflow;
        if (level && themeDisableEqualOverflow !== undefined) disableEqualOverflow = inProps.disableEqualOverflow;
        // collect breakpoints related props because they can be customized from the theme.
        const gridSize = {};
        const gridOffset = {};
        const other = {};
        Object.entries(rest).forEach(([key, val])=>{
            if (theme.breakpoints.values[key] !== undefined) gridSize[key] = val;
            else if (theme.breakpoints.values[key.replace("Offset", "")] !== undefined) gridOffset[key.replace("Offset", "")] = val;
            else other[key] = val;
        });
        const columns = (_inProps$columns = inProps.columns) != null ? _inProps$columns : level ? undefined : columnsProp;
        const spacing = (_inProps$spacing = inProps.spacing) != null ? _inProps$spacing : level ? undefined : spacingProp;
        const rowSpacing = (_ref = (_inProps$rowSpacing = inProps.rowSpacing) != null ? _inProps$rowSpacing : inProps.spacing) != null ? _ref : level ? undefined : rowSpacingProp;
        const columnSpacing = (_ref2 = (_inProps$columnSpacin = inProps.columnSpacing) != null ? _inProps$columnSpacin : inProps.spacing) != null ? _ref2 : level ? undefined : columnSpacingProp;
        const ownerState = (0, $alwoF.default)({}, props, {
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            gridSize: gridSize,
            gridOffset: gridOffset,
            disableEqualOverflow: (_ref3 = (_disableEqualOverflow = disableEqualOverflow) != null ? _disableEqualOverflow : overflow) != null ? _ref3 : false,
            // use context value if exists.
            parentDisableEqualOverflow: overflow // for nested grid
        });
        const classes = useUtilityClasses(ownerState, theme);
        let result = /*#__PURE__*/ (0, $4fnJY.jsx)(GridRoot, (0, $alwoF.default)({
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $bIObK.default)(classes.root, className)
        }, other, {
            children: $lTb4y.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $lTb4y.isValidElement(child) && (0, $f9f5ffa6b7840a80$export$2e2bcd8739ae039)(child, [
                    "Grid"
                ])) {
                    var _child$props$unstable;
                    return /*#__PURE__*/ $lTb4y.cloneElement(child, {
                        unstable_level: (_child$props$unstable = child.props.unstable_level) != null ? _child$props$unstable : level + 1
                    });
                }
                return child;
            })
        }));
        if (disableEqualOverflow !== undefined && disableEqualOverflow !== (overflow != null ? overflow : false)) // There are 2 possibilities that should wrap with the OverflowContext to communicate with the nested grids:
        // 1. It is the root grid with `disableEqualOverflow`.
        // 2. It is a nested grid with different `disableEqualOverflow` from the context.
        result = /*#__PURE__*/ (0, $4fnJY.jsx)(OverflowContext.Provider, {
            value: disableEqualOverflow,
            children: result
        });
        return result;
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = "Grid";
    return Grid;
}



var $l7HUa = parcelRequire("l7HUa");
var $lEU9Q = parcelRequire("lEU9Q");
const $16326809e0b0b92a$var$Grid2 = (0, $a141786af572ab0d$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $l7HUa.default)("div", {
        name: "MuiGrid2",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    componentName: "MuiGrid2",
    useThemeProps: (inProps)=>(0, $lEU9Q.default)({
            props: inProps,
            name: "MuiGrid2"
        })
});
var $16326809e0b0b92a$export$2e2bcd8739ae039 = $16326809e0b0b92a$var$Grid2;


var $30681c66bd9b43df$exports = {};
"use strict";

var $j4Kfh = parcelRequire("j4Kfh");
Object.defineProperty($30681c66bd9b43df$exports, "__esModule", {
    value: true
});
Object.defineProperty($30681c66bd9b43df$exports, "default", {
    enumerable: true,
    get: function get() {
        return $30681c66bd9b43df$var$_SwipeableViews.default;
    }
});
Object.defineProperty($30681c66bd9b43df$exports, "SwipeableViewsContext", {
    enumerable: true,
    get: function get() {
        return $30681c66bd9b43df$var$_SwipeableViews.SwipeableViewsContext;
    }
});

var $30681c66bd9b43df$var$_SwipeableViews = $j4Kfh((parcelRequire("hkaDl")));



var $lTb4y = parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $181cd6f47a9a1c1a$export$975b30855231130c;
(function(MemberRoles) {
    MemberRoles[MemberRoles["Member"] = 0] = "Member";
    MemberRoles[MemberRoles["Admin"] = 1] = "Admin";
    MemberRoles[MemberRoles["Owner"] = 2] = "Owner";
    MemberRoles[MemberRoles["WebsiteManager"] = 3] = "WebsiteManager";
})($181cd6f47a9a1c1a$export$975b30855231130c || ($181cd6f47a9a1c1a$export$975b30855231130c = {}));
var $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c;
(function(LinkSite) {
    LinkSite[LinkSite["Twitch"] = 0] = "Twitch";
    LinkSite[LinkSite["Discord"] = 1] = "Discord";
    LinkSite[LinkSite["YouTube"] = 2] = "YouTube";
    LinkSite[LinkSite["Instagram"] = 3] = "Instagram";
    LinkSite[LinkSite["Twitter"] = 4] = "Twitter";
    LinkSite[LinkSite["Website"] = 5] = "Website";
    LinkSite[LinkSite["Other"] = 6] = "Other";
})($181cd6f47a9a1c1a$export$a0e36ca1c1f6124c || ($181cd6f47a9a1c1a$export$a0e36ca1c1f6124c = {}));
function $181cd6f47a9a1c1a$export$6ac9c143745f8feb(link) {
    switch(link.linkSite){
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch:
            return `https://twitch.tv/${link.handle}`;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Discord:
            return link.url;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube:
            return `https://youtube.com/${link.handle}`;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Instagram:
            return `https://instagram.com/${link.handle}`;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitter:
            return `https://twitter.com/${link.handle}`;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Website:
            return link.url;
        case $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Other:
            return link.url;
        default:
            return "https://unitysmp.com/404";
    }
}
var $f5b8326354f9b840$exports = {};


$f5b8326354f9b840$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("ijJb6");


const $181cd6f47a9a1c1a$var$defaultAvatar = new URL($f5b8326354f9b840$exports).href;

const $181cd6f47a9a1c1a$var$defaultSkin = new URL($f5b8326354f9b840$exports).href;
var $8d3c533829218f96$exports = {};


$8d3c533829218f96$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("fvSHm");


var $4217ba121c941882$exports = {};


$4217ba121c941882$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("GtT9U");


var $ba746ef03501504c$exports = {};


$ba746ef03501504c$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("k8oxB");


var $69e3b008c69f4aa5$exports = {};


$69e3b008c69f4aa5$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("kZFer");


var $8c80959688198077$exports = {};


$8c80959688198077$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("3oqDK");


var $bee8767a8a7c556f$exports = {};


$bee8767a8a7c556f$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("7Whib");


var $c60e78b6513756c1$exports = {};


$c60e78b6513756c1$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("2kycD");


var $3c49e819a62efbf9$exports = {};


$3c49e819a62efbf9$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("idIOv");


var $54d74b6412d217ba$exports = {};


$54d74b6412d217ba$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("6byxO");


var $f9fa33821baf6e40$exports = {};


$f9fa33821baf6e40$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("dhmgX");


var $3112390a2a62f484$exports = {};


$3112390a2a62f484$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("8BxRi");


var $09223a727117afe2$exports = {};


$09223a727117afe2$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("iFav6");


var $5e1568eaf35784f4$exports = {};


$5e1568eaf35784f4$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("gHOMk");


var $adf9816dee42b39a$exports = {};


$adf9816dee42b39a$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("cDfld");


var $6f44a3861b9ba35e$exports = {};


$6f44a3861b9ba35e$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("cnCro");


var $8ae9c87db7f344f9$exports = {};


$8ae9c87db7f344f9$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("fnOY4");


var $bde9ecca2183ee1e$exports = {};


$bde9ecca2183ee1e$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("7LPGW");


var $218ea1616f3ebb06$exports = {};


$218ea1616f3ebb06$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("2Y4js");


var $648f4313dc5ef7f9$exports = {};


$648f4313dc5ef7f9$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("5QXUl");


var $d74518f3c1abfdd4$exports = {};


$d74518f3c1abfdd4$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("dtCR2");


var $390576f02de6b3a1$exports = {};


$390576f02de6b3a1$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("lH40g");


var $711d927553848a1d$exports = {};


$711d927553848a1d$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("labdt");


var $576e9a460049b552$exports = {};


$576e9a460049b552$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("1NyJc");


var $3077fbc602622e05$exports = {};


$3077fbc602622e05$exports = (parcelRequire("c8qBC")).getBundleURL("580Wd") + (parcelRequire("3NI1h")).resolve("15cu8");


const $181cd6f47a9a1c1a$export$100ad4af8c8d544f = [
    {
        username: "JawbreakerSD",
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($8d3c533829218f96$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Owner,
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@JawbreakerSD",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "jawbreakersd",
                label: "Twitch",
                color: "#6441a5"
            }
        ]
    },
    {
        username: "Flameborne",
        avatar: new URL($4217ba121c941882$exports).href,
        skinTexture: new URL($ba746ef03501504c$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        aliases: [
            "Flame"
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        bio: "Just tryna have fun playing video games. Can sometimes lead to questionable jokes, so enter at your own risk.",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@flameb0rne",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "flameb0rne",
                label: "Twitch",
                color: "#6441a5"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Instagram,
                handle: "flameb0rne",
                label: "Instagram",
                color: "#e1306c"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Discord,
                url: "https://discord.gg/TfPYvWDCEZ",
                label: "Discord Server",
                color: "#7289da"
            }
        ]
    },
    {
        username: "RynoTheRaccy",
        aliases: [
            "Ryno"
        ],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($69e3b008c69f4aa5$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@rynotheraccy",
                label: "YouTube"
            }
        ]
    },
    {
        username: "Foogi",
        aliases: [
            "Foogi6697"
        ],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($8c80959688198077$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@foogi6697",
                label: "YouTube"
            }
        ]
    },
    {
        avatar: "https://insberr.com/assets/insberr_avatar.png",
        skinTexture: new URL($bee8767a8a7c556f$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member,
            $181cd6f47a9a1c1a$export$975b30855231130c.WebsiteManager
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        username: "insberr",
        bio: "I am a programmer and Youtuber. I waste a lot of time and made this website. I am happy to be a part of this new SMP! Hopefully my YouTube channel will grow.",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@insberr.gaming",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "insberr",
                label: "Twitch",
                color: "#6441a5"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Website,
                url: "https://insberr.com/",
                label: "Website",
                color: "#00ff00"
            }
        ]
    },
    {
        username: "Canadian_God",
        aliases: [
            "Canada"
        ],
        avatar: new URL($c60e78b6513756c1$exports).href,
        skinTexture: new URL($3c49e819a62efbf9$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ],
        bio: "A fellow canadian ready to have some fun and adventures",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@Canadian_God",
                label: "YouTube"
            }
        ]
    },
    {
        username: "Shreked",
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($54d74b6412d217ba$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        dateLeft: new Date("May 1, 2024 11:00"),
        seasonsPresent: [
            1
        ],
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@RealShrekTheOgre",
                label: "YouTube"
            }
        ]
    },
    {
        username: "PRINCE HOTROD",
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($f9fa33821baf6e40$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@PRINCEHOTROD",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "RashPlayz",
        aliases: [
            "Rash"
        ],
        avatar: new URL($3112390a2a62f484$exports).href,
        skinTexture: new URL($09223a727117afe2$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@Rash-Playz",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "Attilary",
        aliases: [
            "Attila"
        ],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($5e1568eaf35784f4$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Admin,
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@attilary",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "AlphaFennec",
        aliases: [],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($adf9816dee42b39a$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@AlphaFennec",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "C0D",
        avatar: new URL($6f44a3861b9ba35e$exports).href,
        skinTexture: new URL($8ae9c87db7f344f9$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [],
        dateLeft: new Date("May 1, 2024 11:00"),
        seasonsPresent: [
            1
        ]
    },
    {
        username: "pepo",
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: $181cd6f47a9a1c1a$var$defaultSkin,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@LesTross",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "123Potato",
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($bde9ecca2183ee1e$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "propotatoess",
                label: "Twitch",
                color: "#6441a5"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "SkulkerBox",
        aliases: [
            "Skulker"
        ],
        avatar: new URL($218ea1616f3ebb06$exports).href,
        skinTexture: new URL($648f4313dc5ef7f9$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("July 10, 2023 11:00"),
        bio: "I’m a builder who can be a bit of a devil to my friends, I also don’t really upload and appear in there stuff a lot more",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@SkulkerBoxx",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "skulkerbox",
                label: "Twitch",
                color: "#6441a5"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "PenguinNitr0",
        aliases: [
            "Nitr0"
        ],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($d74518f3c1abfdd4$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("August 13, 2023 11:00"),
        bio: "i try to get along with most people. also poopy.",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "https://www.youtube.com/channel/UC8xdOL5zp-VUxGYJGaUbIpA",
                label: "YouTube"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "FatamusBalamus2",
        aliases: [
            "Fatamus",
            "Ballamus",
            "Fat Balls"
        ],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($390576f02de6b3a1$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("August 27, 2023 11:00"),
        bio: "Yo what up it me Fatamus/Fat Balls. I make content on YouTube, good content in fact (I think). I make video essays, gaming videos, and skits. I also stream every now and then which is cool",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@fatamusballamus6004",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "fatamusballamus",
                label: "Twitch",
                color: "#6441a5"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "mrbutternub02",
        aliases: [
            "Butternub"
        ],
        avatar: new URL($711d927553848a1d$exports).href,
        skinTexture: new URL($576e9a460049b552$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date("August 21, 2023 11:00"),
        bio: "Very loud streamer who is not afraid to scream at his fellow streamers using “funny mic”. Also the best plant main in michigan",
        links: [
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.YouTube,
                handle: "@mrbutternub02",
                label: "YouTube"
            },
            {
                linkSite: $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c.Twitch,
                handle: "MrButternub02",
                label: "Twitch",
                color: "#6441a5"
            }
        ],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    },
    {
        username: "CosmicBlossom",
        aliases: [],
        avatar: $181cd6f47a9a1c1a$var$defaultAvatar,
        skinTexture: new URL($3077fbc602622e05$exports).href,
        roles: [
            $181cd6f47a9a1c1a$export$975b30855231130c.Member
        ],
        dateJoined: new Date(""),
        bio: "A cozy but also chaotic YouTube VTuber with a unhealthy obsession with aesthetics.If you like Minecraft and VTubers why not stop by",
        links: [],
        dateLeft: null,
        seasonsPresent: [
            1,
            2
        ]
    }
];


const $aed673ec07ea61d0$export$36e3a68624d1acaf = 2;
const $aed673ec07ea61d0$export$7ac67e6665ec5711 = [
    {
        season: 1,
        modpack: {
            name: "BounceSMP Public",
            url: "https://www.curseforge.com/minecraft/modpacks/bouncesmp-public"
        }
    },
    {
        season: 2,
        modpack: {
            name: "Valhelsia 5",
            url: "https://www.curseforge.com/minecraft/modpacks/valhelsia-5"
        }
    }
];



var $4fnJY = parcelRequire("4fnJY");

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");
parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $7ED3r = parcelRequire("7ED3r");

var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");
parcelRequire("lTb4y");

var $3Beyx = parcelRequire("3Beyx");

var $4fnJY = parcelRequire("4fnJY");
var $464e28735f796e40$export$2e2bcd8739ae039 = (0, $3Beyx.default)(/*#__PURE__*/ (0, $4fnJY.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $e9ecdf0198ad6a10$export$ffd560f22c0ecf04(slot) {
    return (0, $io057.default)("MuiAvatar", slot);
}
const $e9ecdf0198ad6a10$var$avatarClasses = (0, $6w46Z.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $e9ecdf0198ad6a10$export$2e2bcd8739ae039 = $e9ecdf0198ad6a10$var$avatarClasses;



var $4fnJY = parcelRequire("4fnJY");
const $7e58a5c9c3232bc1$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $7e58a5c9c3232bc1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $e9ecdf0198ad6a10$export$ffd560f22c0ecf04), classes);
};
const $7e58a5c9c3232bc1$var$AvatarRoot = (0, $l7HUa.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $alwoF.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $alwoF.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $7e58a5c9c3232bc1$var$AvatarImg = (0, $l7HUa.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $7e58a5c9c3232bc1$var$AvatarFallback = (0, $l7HUa.default)((0, $464e28735f796e40$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $7e58a5c9c3232bc1$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $9Raem.useState(false);
    $9Raem.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $7e58a5c9c3232bc1$var$Avatar = /*#__PURE__*/ $lTb4y.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $bjnlX.default)(props, $7e58a5c9c3232bc1$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $7e58a5c9c3232bc1$var$useLoaded((0, $alwoF.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $alwoF.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $7e58a5c9c3232bc1$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $4fnJY.jsx)($7e58a5c9c3232bc1$var$AvatarImg, (0, $alwoF.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $4fnJY.jsx)($7e58a5c9c3232bc1$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $4fnJY.jsx)($7e58a5c9c3232bc1$var$AvatarRoot, (0, $alwoF.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $bIObK.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $7e58a5c9c3232bc1$export$2e2bcd8739ae039 = $7e58a5c9c3232bc1$var$Avatar;



var $kLMXp = parcelRequire("kLMXp");
function $fd4301ee5597692a$export$2e2bcd8739ae039(props) {
    const { member: member } = props;
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $7e58a5c9c3232bc1$export$2e2bcd8739ae039), {
        src: member.avatar,
        sx: {
            bgcolor: (0, $kLMXp.default)[300],
            width: props.widthOneHundred ? "100%" : 56,
            height: props.widthOneHundred ? "auto" : 56
        },
        alt: member.username,
        "aria-label": member.username + "-avatar",
        children: member.username[0]
    });
}


var $31f24d5f57600913$exports = {};
"use strict";
var $b887953b307823a3$exports = {};
function $b887953b307823a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$b887953b307823a3$exports = $b887953b307823a3$var$_interopRequireDefault, $b887953b307823a3$exports.__esModule = true, $b887953b307823a3$exports["default"] = $b887953b307823a3$exports;


Object.defineProperty($31f24d5f57600913$exports, "__esModule", {
    value: true
});
$31f24d5f57600913$exports.default = void 0;

var $31f24d5f57600913$var$_createSvgIcon = $b887953b307823a3$exports((parcelRequire("ihlVT")));

var $4fnJY = parcelRequire("4fnJY");
var $31f24d5f57600913$var$_default = (0, $31f24d5f57600913$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4fnJY.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "KeyboardArrowLeft");
$31f24d5f57600913$exports.default = $31f24d5f57600913$var$_default;


var $34a19b5d37e5becf$exports = {};
"use strict";

Object.defineProperty($34a19b5d37e5becf$exports, "__esModule", {
    value: true
});
$34a19b5d37e5becf$exports.default = void 0;

var $34a19b5d37e5becf$var$_createSvgIcon = $b887953b307823a3$exports((parcelRequire("ihlVT")));

var $4fnJY = parcelRequire("4fnJY");
var $34a19b5d37e5becf$var$_default = (0, $34a19b5d37e5becf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4fnJY.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
$34a19b5d37e5becf$exports.default = $34a19b5d37e5becf$var$_default;


parcelRequire("lTb4y");
var $9Raem = parcelRequire("9Raem");
var $lTb4y = parcelRequire("lTb4y");
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $824f5e122dad54af$export$3545e07a80636437 = "142";
const $824f5e122dad54af$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $824f5e122dad54af$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $824f5e122dad54af$export$3237e1f2c1ea1f44 = 0;
const $824f5e122dad54af$export$b9a7b4fc5cb15f9b = 1;
const $824f5e122dad54af$export$b8058bcc7037d3f3 = 2;
const $824f5e122dad54af$export$f24be24dcddeac0d = 3;
const $824f5e122dad54af$export$346307dbae2b7447 = 0;
const $824f5e122dad54af$export$5813f879eee7cd88 = 1;
const $824f5e122dad54af$export$a47c4b43a1be34f0 = 2;
const $824f5e122dad54af$export$896ae1ade6c829c4 = 3;
const $824f5e122dad54af$export$2ede184fc2998901 = 0;
const $824f5e122dad54af$export$d9f0486e75b5ace = 1;
const $824f5e122dad54af$export$3b296b6f144d5b03 = 2;
const $824f5e122dad54af$export$a62047d29c96d8ff = 1;
const $824f5e122dad54af$export$fadb74c06a7f490 = 2;
const $824f5e122dad54af$export$63b8d6b580fc65ba = 0;
const $824f5e122dad54af$export$5b29a26d96ee6af0 = 1;
const $824f5e122dad54af$export$777d8f9551c2216b = 2;
const $824f5e122dad54af$export$cdfa06f868e2e467 = 3;
const $824f5e122dad54af$export$4138e1c684b46a20 = 4;
const $824f5e122dad54af$export$eda4864c68df1fa2 = 5;
const $824f5e122dad54af$export$20183a0484ce21a0 = 100;
const $824f5e122dad54af$export$73e0df5177988548 = 101;
const $824f5e122dad54af$export$28e582859cbec660 = 102;
const $824f5e122dad54af$export$c8c1508da8d0600c = 103;
const $824f5e122dad54af$export$99948c02fb51055f = 104;
const $824f5e122dad54af$export$2110f05edf778d3d = 200;
const $824f5e122dad54af$export$8805bad65e24940e = 201;
const $824f5e122dad54af$export$7fbe15b28d28cf52 = 202;
const $824f5e122dad54af$export$947829af9f2c17f6 = 203;
const $824f5e122dad54af$export$d5773124e86cf28c = 204;
const $824f5e122dad54af$export$11d468cc7f19e971 = 205;
const $824f5e122dad54af$export$a78aed1ca2a87192 = 206;
const $824f5e122dad54af$export$5d0fe17fd8773bac = 207;
const $824f5e122dad54af$export$ef5f2dd8ffac5574 = 208;
const $824f5e122dad54af$export$56b85b2686ab16 = 209;
const $824f5e122dad54af$export$c05e2a1fc8609506 = 210;
const $824f5e122dad54af$export$69025ce147cee220 = 0;
const $824f5e122dad54af$export$7182eb52ea3b3f04 = 1;
const $824f5e122dad54af$export$eedccec66ab7ebe = 2;
const $824f5e122dad54af$export$296f78a0b892f81a = 3;
const $824f5e122dad54af$export$a60d398fc7b7590e = 4;
const $824f5e122dad54af$export$7d7234c1240a1fc4 = 5;
const $824f5e122dad54af$export$c5e2c52991f30937 = 6;
const $824f5e122dad54af$export$2f843afa843d8916 = 7;
const $824f5e122dad54af$export$e50ac29801f1774d = 0;
const $824f5e122dad54af$export$9f9d94f963c85479 = 1;
const $824f5e122dad54af$export$e641dc52bc3494aa = 2;
const $824f5e122dad54af$export$9fcb6b4294603b2 = 0;
const $824f5e122dad54af$export$98f52c2a46c598ca = 1;
const $824f5e122dad54af$export$74b25e54b3bcd548 = 2;
const $824f5e122dad54af$export$932b3dd283d4a366 = 3;
const $824f5e122dad54af$export$a0d98fe6d7e4af64 = 4;
const $824f5e122dad54af$export$2c7b09c1e9abfb5e = 5;
const $824f5e122dad54af$export$1beec6768cbb3d2d = 300;
const $824f5e122dad54af$export$8759762a6477f2c4 = 301;
const $824f5e122dad54af$export$dc59f8aed047f61d = 302;
const $824f5e122dad54af$export$d64030b316d3b087 = 303;
const $824f5e122dad54af$export$ee99d97d46898098 = 304;
const $824f5e122dad54af$export$dbf3e70ff37af79 = 306;
const $824f5e122dad54af$export$533346c8e8dac0f5 = 1000;
const $824f5e122dad54af$export$9d9334239a5a5e06 = 1001;
const $824f5e122dad54af$export$c7e7c00b14f51a4f = 1002;
const $824f5e122dad54af$export$727aa5ec3fe39bf0 = 1003;
const $824f5e122dad54af$export$d129e38cf6feaa8c = 1004;
const $824f5e122dad54af$export$14a4936464a36496 = 1004;
const $824f5e122dad54af$export$d2327c1afe5bfdf2 = 1005;
const $824f5e122dad54af$export$cbc5b7f5647595d8 = 1005;
const $824f5e122dad54af$export$8a72f490b25c56c8 = 1006;
const $824f5e122dad54af$export$19a719f377145a13 = 1007;
const $824f5e122dad54af$export$dbe96bee3fe9dbf0 = 1007;
const $824f5e122dad54af$export$5d8599b6a933fb1b = 1008;
const $824f5e122dad54af$export$90d80f1e3506775f = 1008;
const $824f5e122dad54af$export$2e8ce08d3f6f5e10 = 1009;
const $824f5e122dad54af$export$545fce0311a9796a = 1010;
const $824f5e122dad54af$export$88572337f312435f = 1011;
const $824f5e122dad54af$export$c63dc51868b06a9d = 1012;
const $824f5e122dad54af$export$5c612977753abe2 = 1013;
const $824f5e122dad54af$export$c3c7fc4518ebba96 = 1014;
const $824f5e122dad54af$export$f6d331659b644596 = 1015;
const $824f5e122dad54af$export$2697304443f382bc = 1016;
const $824f5e122dad54af$export$b3969b01faf587f2 = 1017;
const $824f5e122dad54af$export$18886f8ae33e90de = 1018;
const $824f5e122dad54af$export$6c8ea339bfab1301 = 1020;
const $824f5e122dad54af$export$988473390501ed4b = 1021;
const $824f5e122dad54af$export$7c67423a5ee6f5eb = 1022;
const $824f5e122dad54af$export$3f8bb04b555a363c = 1023;
const $824f5e122dad54af$export$cc09ccbf6d1ed449 = 1024;
const $824f5e122dad54af$export$9053a81c4a69c289 = 1025;
const $824f5e122dad54af$export$c1b6b5136be58045 = 1026;
const $824f5e122dad54af$export$1e113ac2d0905829 = 1027;
const $824f5e122dad54af$export$4e041a7967d15c4b = 1028;
const $824f5e122dad54af$export$aa92e870a709d190 = 1029;
const $824f5e122dad54af$export$6cdf0b461c7ce8a0 = 1030;
const $824f5e122dad54af$export$1ba1c45f9f77d4d7 = 1031;
const $824f5e122dad54af$export$c200e7d26f592f21 = 1033;
const $824f5e122dad54af$export$21d1799c6d552fc0 = 33776;
const $824f5e122dad54af$export$afa304c3e981b668 = 33777;
const $824f5e122dad54af$export$d2a1a68024a3e56c = 33778;
const $824f5e122dad54af$export$9a79c424327dacf9 = 33779;
const $824f5e122dad54af$export$19ada9bbb1af3573 = 35840;
const $824f5e122dad54af$export$d0f0355bb3d948e4 = 35841;
const $824f5e122dad54af$export$b82296714358084c = 35842;
const $824f5e122dad54af$export$b71692456c47b6c3 = 35843;
const $824f5e122dad54af$export$6ab91af2d757aee7 = 36196;
const $824f5e122dad54af$export$7800993ef8106a6a = 37492;
const $824f5e122dad54af$export$23ed8300a860e7d8 = 37496;
const $824f5e122dad54af$export$dc5570b4a2b92d48 = 37808;
const $824f5e122dad54af$export$68880cd325f8b2fb = 37809;
const $824f5e122dad54af$export$7d2c0be323373d95 = 37810;
const $824f5e122dad54af$export$22b52da301fc3a3e = 37811;
const $824f5e122dad54af$export$c009e2cb4a66485e = 37812;
const $824f5e122dad54af$export$118fff5afa255b63 = 37813;
const $824f5e122dad54af$export$120713c829ae0667 = 37814;
const $824f5e122dad54af$export$c79eeabbf53313e9 = 37815;
const $824f5e122dad54af$export$443cf6567cdd6424 = 37816;
const $824f5e122dad54af$export$6573984fc9840780 = 37817;
const $824f5e122dad54af$export$e7aee563f30091de = 37818;
const $824f5e122dad54af$export$2eb8634622ddeab7 = 37819;
const $824f5e122dad54af$export$202b1ce7b5d25742 = 37820;
const $824f5e122dad54af$export$18ab77abd087e467 = 37821;
const $824f5e122dad54af$export$ce40b115e188bc81 = 36492;
const $824f5e122dad54af$export$d62fdc9d1b1cccad = 2200;
const $824f5e122dad54af$export$dfaf4422ce096e29 = 2201;
const $824f5e122dad54af$export$f8f6f2041b78e210 = 2202;
const $824f5e122dad54af$export$995b32462a65e855 = 2300;
const $824f5e122dad54af$export$30fac1aace31cf4d = 2301;
const $824f5e122dad54af$export$198b11ff4c72bb30 = 2302;
const $824f5e122dad54af$export$7f795934b84ab523 = 2400;
const $824f5e122dad54af$export$24a4ccb5099273b5 = 2401;
const $824f5e122dad54af$export$8e8c3ecdcd8e1fee = 2402;
const $824f5e122dad54af$export$bcfbbdcf8de7f8cd = 2500;
const $824f5e122dad54af$export$d875e029ef558d3 = 2501;
const $824f5e122dad54af$export$4c28c87c2dc84758 = 0;
const $824f5e122dad54af$export$b23a071aa286eb29 = 1;
const $824f5e122dad54af$export$f0d8293634f88842 = 2;
const $824f5e122dad54af$export$7207336e4151a112 = 3000;
const $824f5e122dad54af$export$f32388edbb32674 = 3001;
const $824f5e122dad54af$export$deeb383078690b50 = 3200;
const $824f5e122dad54af$export$8f910f4c4f73df11 = 3201;
const $824f5e122dad54af$export$2852a58ebdac27b8 = 0;
const $824f5e122dad54af$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $824f5e122dad54af$export$bfcb490c2dd3db51 = "";
const $824f5e122dad54af$export$561f394b24edfcaa = "srgb";
const $824f5e122dad54af$export$42429b3acfb233a4 = "srgb-linear";
const $824f5e122dad54af$export$69433f11f42d5527 = 0;
const $824f5e122dad54af$export$9f542ae4b5baca34 = 7680;
const $824f5e122dad54af$export$8a4f28336ef203d3 = 7681;
const $824f5e122dad54af$export$2928c0231297c036 = 7682;
const $824f5e122dad54af$export$c0e9611c8a15f9a8 = 7683;
const $824f5e122dad54af$export$9c2c08927385dcc4 = 34055;
const $824f5e122dad54af$export$7c74ea00fa1315e6 = 34056;
const $824f5e122dad54af$export$22e2e5726612443 = 5386;
const $824f5e122dad54af$export$1343870698229224 = 512;
const $824f5e122dad54af$export$8e1d8ed281997fa6 = 513;
const $824f5e122dad54af$export$55648a1cde8329a7 = 514;
const $824f5e122dad54af$export$2dff107857e6aca2 = 515;
const $824f5e122dad54af$export$6f93765ab2f451a2 = 516;
const $824f5e122dad54af$export$6f3fb2d2440f2b76 = 517;
const $824f5e122dad54af$export$4119cf7b4c98fd5a = 518;
const $824f5e122dad54af$export$14cf96713ddd97a8 = 519;
const $824f5e122dad54af$export$763e8360f4d7f77d = 35044;
const $824f5e122dad54af$export$8505d14ac8546ca = 35048;
const $824f5e122dad54af$export$721e63549e51d81e = 35040;
const $824f5e122dad54af$export$415731dc4f48e299 = 35045;
const $824f5e122dad54af$export$9e809946455f13bc = 35049;
const $824f5e122dad54af$export$2ed9499a35b5f832 = 35041;
const $824f5e122dad54af$export$32ab2503ea19469a = 35046;
const $824f5e122dad54af$export$ab4022c2c3f86315 = 35050;
const $824f5e122dad54af$export$ba7f1db36a76a970 = 35042;
const $824f5e122dad54af$export$43600cc67fabd9f = "100";
const $824f5e122dad54af$export$f63012db5506e7dd = "300 es";
const $824f5e122dad54af$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $824f5e122dad54af$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $824f5e122dad54af$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $824f5e122dad54af$var$_seed = 1234567;
const $824f5e122dad54af$var$DEG2RAD = Math.PI / 180;
const $824f5e122dad54af$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $824f5e122dad54af$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $824f5e122dad54af$var$_lut[d0 & 0xff] + $824f5e122dad54af$var$_lut[d0 >> 8 & 0xff] + $824f5e122dad54af$var$_lut[d0 >> 16 & 0xff] + $824f5e122dad54af$var$_lut[d0 >> 24 & 0xff] + "-" + $824f5e122dad54af$var$_lut[d1 & 0xff] + $824f5e122dad54af$var$_lut[d1 >> 8 & 0xff] + "-" + $824f5e122dad54af$var$_lut[d1 >> 16 & 0x0f | 0x40] + $824f5e122dad54af$var$_lut[d1 >> 24 & 0xff] + "-" + $824f5e122dad54af$var$_lut[d2 & 0x3f | 0x80] + $824f5e122dad54af$var$_lut[d2 >> 8 & 0xff] + "-" + $824f5e122dad54af$var$_lut[d2 >> 16 & 0xff] + $824f5e122dad54af$var$_lut[d2 >> 24 & 0xff] + $824f5e122dad54af$var$_lut[d3 & 0xff] + $824f5e122dad54af$var$_lut[d3 >> 8 & 0xff] + $824f5e122dad54af$var$_lut[d3 >> 16 & 0xff] + $824f5e122dad54af$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $824f5e122dad54af$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $824f5e122dad54af$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $824f5e122dad54af$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $824f5e122dad54af$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $824f5e122dad54af$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $824f5e122dad54af$var$damp(x, y, lambda, dt) {
    return $824f5e122dad54af$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $824f5e122dad54af$var$pingpong(x, length = 1) {
    return length - Math.abs($824f5e122dad54af$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $824f5e122dad54af$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $824f5e122dad54af$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $824f5e122dad54af$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $824f5e122dad54af$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $824f5e122dad54af$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $824f5e122dad54af$var$seededRandom(s) {
    if (s !== undefined) $824f5e122dad54af$var$_seed = s;
    // Mulberry32 generator
    let t = $824f5e122dad54af$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $824f5e122dad54af$var$degToRad(degrees) {
    return degrees * $824f5e122dad54af$var$DEG2RAD;
}
function $824f5e122dad54af$var$radToDeg(radians) {
    return radians * $824f5e122dad54af$var$RAD2DEG;
}
function $824f5e122dad54af$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $824f5e122dad54af$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $824f5e122dad54af$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $824f5e122dad54af$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $824f5e122dad54af$var$denormalize$1(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $824f5e122dad54af$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
var $824f5e122dad54af$export$6a7ef315a0d1ef07 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $824f5e122dad54af$var$DEG2RAD,
    RAD2DEG: $824f5e122dad54af$var$RAD2DEG,
    generateUUID: $824f5e122dad54af$var$generateUUID,
    clamp: $824f5e122dad54af$var$clamp,
    euclideanModulo: $824f5e122dad54af$var$euclideanModulo,
    mapLinear: $824f5e122dad54af$var$mapLinear,
    inverseLerp: $824f5e122dad54af$var$inverseLerp,
    lerp: $824f5e122dad54af$var$lerp,
    damp: $824f5e122dad54af$var$damp,
    pingpong: $824f5e122dad54af$var$pingpong,
    smoothstep: $824f5e122dad54af$var$smoothstep,
    smootherstep: $824f5e122dad54af$var$smootherstep,
    randInt: $824f5e122dad54af$var$randInt,
    randFloat: $824f5e122dad54af$var$randFloat,
    randFloatSpread: $824f5e122dad54af$var$randFloatSpread,
    seededRandom: $824f5e122dad54af$var$seededRandom,
    degToRad: $824f5e122dad54af$var$degToRad,
    radToDeg: $824f5e122dad54af$var$radToDeg,
    isPowerOfTwo: $824f5e122dad54af$var$isPowerOfTwo,
    ceilPowerOfTwo: $824f5e122dad54af$var$ceilPowerOfTwo,
    floorPowerOfTwo: $824f5e122dad54af$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $824f5e122dad54af$var$setQuaternionFromProperEuler,
    normalize: $824f5e122dad54af$var$normalize,
    denormalize: $824f5e122dad54af$var$denormalize$1
});
class $824f5e122dad54af$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $824f5e122dad54af$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $824f5e122dad54af$export$8ff26dafa08918 {
    constructor(){
        $824f5e122dad54af$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
function $824f5e122dad54af$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] > 65535) return true;
    }
    return false;
}
const $824f5e122dad54af$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $824f5e122dad54af$var$getTypedArray(type, buffer) {
    return new $824f5e122dad54af$var$TYPED_ARRAYS[type](buffer);
}
function $824f5e122dad54af$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function $824f5e122dad54af$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $824f5e122dad54af$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
// JavaScript RGB-to-RGB transforms, defined as
// FN[InputColorSpace][OutputColorSpace] callback functions.
const $824f5e122dad54af$var$FN = {
    [$824f5e122dad54af$export$561f394b24edfcaa]: {
        [$824f5e122dad54af$export$42429b3acfb233a4]: $824f5e122dad54af$var$SRGBToLinear
    },
    [$824f5e122dad54af$export$42429b3acfb233a4]: {
        [$824f5e122dad54af$export$561f394b24edfcaa]: $824f5e122dad54af$var$LinearToSRGB
    }
};
const $824f5e122dad54af$export$5e6fd513f44698c = {
    legacyMode: true,
    get workingColorSpace () {
        return $824f5e122dad54af$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if ($824f5e122dad54af$var$FN[sourceColorSpace] && $824f5e122dad54af$var$FN[sourceColorSpace][targetColorSpace] !== undefined) {
            const fn = $824f5e122dad54af$var$FN[sourceColorSpace][targetColorSpace];
            color.r = fn(color.r);
            color.g = fn(color.g);
            color.b = fn(color.b);
            return color;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
const $824f5e122dad54af$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $824f5e122dad54af$var$_rgb = {
    r: 0,
    g: 0,
    b: 0
};
const $824f5e122dad54af$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $824f5e122dad54af$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $824f5e122dad54af$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $824f5e122dad54af$var$toComponents(source, target) {
    target.r = source.r;
    target.g = source.g;
    target.b = source.b;
    return target;
}
class $824f5e122dad54af$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $824f5e122dad54af$export$42429b3acfb233a4) {
        this.r = r;
        this.g = g;
        this.b = b;
        $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $824f5e122dad54af$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $824f5e122dad54af$var$euclideanModulo(h, 1);
        s = $824f5e122dad54af$var$clamp(s, 0, 1);
        l = $824f5e122dad54af$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $824f5e122dad54af$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $824f5e122dad54af$var$hue2rgb(q, p, h);
            this.b = $824f5e122dad54af$var$hue2rgb(q, p, h - 1 / 3);
        }
        $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace1);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                $824f5e122dad54af$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        // color keywords
        const hex = $824f5e122dad54af$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $824f5e122dad54af$var$SRGBToLinear(color.r);
        this.g = $824f5e122dad54af$var$SRGBToLinear(color.g);
        this.b = $824f5e122dad54af$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $824f5e122dad54af$var$LinearToSRGB(color.r);
        this.g = $824f5e122dad54af$var$LinearToSRGB(color.g);
        this.b = $824f5e122dad54af$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        $824f5e122dad54af$export$5e6fd513f44698c.fromWorkingColorSpace($824f5e122dad54af$var$toComponents(this, $824f5e122dad54af$var$_rgb), colorSpace1);
        return $824f5e122dad54af$var$clamp($824f5e122dad54af$var$_rgb.r * 255, 0, 255) << 16 ^ $824f5e122dad54af$var$clamp($824f5e122dad54af$var$_rgb.g * 255, 0, 255) << 8 ^ $824f5e122dad54af$var$clamp($824f5e122dad54af$var$_rgb.b * 255, 0, 255) << 0;
    }
    getHexString(colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $824f5e122dad54af$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        $824f5e122dad54af$export$5e6fd513f44698c.fromWorkingColorSpace($824f5e122dad54af$var$toComponents(this, $824f5e122dad54af$var$_rgb), colorSpace1);
        const r = $824f5e122dad54af$var$_rgb.r, g = $824f5e122dad54af$var$_rgb.g, b = $824f5e122dad54af$var$_rgb.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $824f5e122dad54af$export$42429b3acfb233a4) {
        $824f5e122dad54af$export$5e6fd513f44698c.fromWorkingColorSpace($824f5e122dad54af$var$toComponents(this, $824f5e122dad54af$var$_rgb), colorSpace1);
        target.r = $824f5e122dad54af$var$_rgb.r;
        target.g = $824f5e122dad54af$var$_rgb.g;
        target.b = $824f5e122dad54af$var$_rgb.b;
        return target;
    }
    getStyle(colorSpace1 = $824f5e122dad54af$export$561f394b24edfcaa) {
        $824f5e122dad54af$export$5e6fd513f44698c.fromWorkingColorSpace($824f5e122dad54af$var$toComponents(this, $824f5e122dad54af$var$_rgb), colorSpace1);
        if (colorSpace1 !== $824f5e122dad54af$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${$824f5e122dad54af$var$_rgb.r} ${$824f5e122dad54af$var$_rgb.g} ${$824f5e122dad54af$var$_rgb.b})`;
        return `rgb(${$824f5e122dad54af$var$_rgb.r * 255 | 0},${$824f5e122dad54af$var$_rgb.g * 255 | 0},${$824f5e122dad54af$var$_rgb.b * 255 | 0})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($824f5e122dad54af$var$_hslA);
        $824f5e122dad54af$var$_hslA.h += h;
        $824f5e122dad54af$var$_hslA.s += s;
        $824f5e122dad54af$var$_hslA.l += l;
        this.setHSL($824f5e122dad54af$var$_hslA.h, $824f5e122dad54af$var$_hslA.s, $824f5e122dad54af$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($824f5e122dad54af$var$_hslA);
        color.getHSL($824f5e122dad54af$var$_hslB);
        const h = $824f5e122dad54af$var$lerp($824f5e122dad54af$var$_hslA.h, $824f5e122dad54af$var$_hslB.h, alpha);
        const s = $824f5e122dad54af$var$lerp($824f5e122dad54af$var$_hslA.s, $824f5e122dad54af$var$_hslB.s, alpha);
        const l = $824f5e122dad54af$var$lerp($824f5e122dad54af$var$_hslA.l, $824f5e122dad54af$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
$824f5e122dad54af$export$892596cec99bc70e.NAMES = $824f5e122dad54af$var$_colorKeywords;
let $824f5e122dad54af$var$_canvas;
class $824f5e122dad54af$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($824f5e122dad54af$var$_canvas === undefined) $824f5e122dad54af$var$_canvas = $824f5e122dad54af$var$createElementNS("canvas");
            $824f5e122dad54af$var$_canvas.width = image.width;
            $824f5e122dad54af$var$_canvas.height = image.height;
            const context = $824f5e122dad54af$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $824f5e122dad54af$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $824f5e122dad54af$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $824f5e122dad54af$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($824f5e122dad54af$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $824f5e122dad54af$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
class $824f5e122dad54af$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($824f5e122dad54af$var$serializeImage(data[i].image));
                else url.push($824f5e122dad54af$var$serializeImage(data[i]));
            } else // texture
            url = $824f5e122dad54af$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $824f5e122dad54af$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $824f5e122dad54af$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $824f5e122dad54af$var$textureId = 0;
class $824f5e122dad54af$export$5431306cf43de24a extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(image = $824f5e122dad54af$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $824f5e122dad54af$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $824f5e122dad54af$export$9d9334239a5a5e06, wrapT = $824f5e122dad54af$export$9d9334239a5a5e06, magFilter = $824f5e122dad54af$export$8a72f490b25c56c8, minFilter = $824f5e122dad54af$export$5d8599b6a933fb1b, format = $824f5e122dad54af$export$3f8bb04b555a363c, type = $824f5e122dad54af$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $824f5e122dad54af$export$7207336e4151a112){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $824f5e122dad54af$var$textureId++
        });
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.name = "";
        this.source = new $824f5e122dad54af$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $824f5e122dad54af$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.center = new $824f5e122dad54af$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $824f5e122dad54af$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (JSON.stringify(this.userData) !== "{}") output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $824f5e122dad54af$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $824f5e122dad54af$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $824f5e122dad54af$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $824f5e122dad54af$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $824f5e122dad54af$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $824f5e122dad54af$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $824f5e122dad54af$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
}
$824f5e122dad54af$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$824f5e122dad54af$export$5431306cf43de24a.DEFAULT_MAPPING = $824f5e122dad54af$export$1beec6768cbb3d2d;
class $824f5e122dad54af$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $824f5e122dad54af$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $824f5e122dad54af$export$3c052beb2e51e23f extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture = new $824f5e122dad54af$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $824f5e122dad54af$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $824f5e122dad54af$export$dfac6c8e811406a3 extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.minFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.wrapR = $824f5e122dad54af$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $824f5e122dad54af$export$c77a02c11ed180c7 extends $824f5e122dad54af$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $824f5e122dad54af$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $824f5e122dad54af$export$d7a3086320f856db extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.minFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.wrapR = $824f5e122dad54af$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $824f5e122dad54af$export$7ee06591009639df extends $824f5e122dad54af$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $824f5e122dad54af$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $824f5e122dad54af$export$bd934554fb721730 extends $824f5e122dad54af$export$3c052beb2e51e23f {
    constructor(width, height, count, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $824f5e122dad54af$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
        return qm.slerpQuaternions(qa, qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($824f5e122dad54af$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $824f5e122dad54af$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $824f5e122dad54af$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
        return this.applyQuaternion($824f5e122dad54af$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($824f5e122dad54af$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $824f5e122dad54af$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($824f5e122dad54af$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($824f5e122dad54af$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($824f5e122dad54af$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $824f5e122dad54af$var$_vector$c = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_quaternion$4 = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
class $824f5e122dad54af$export$6f7d5a9418ab2aa3 {
    constructor(min = new $824f5e122dad54af$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $824f5e122dad54af$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $824f5e122dad54af$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count; i < l; i++){
                    $824f5e122dad54af$var$_vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                    this.expandByPoint($824f5e122dad54af$var$_vector$b);
                }
            } else {
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                $824f5e122dad54af$var$_box$3.copy(geometry.boundingBox);
                $824f5e122dad54af$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($824f5e122dad54af$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $824f5e122dad54af$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $824f5e122dad54af$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($824f5e122dad54af$var$_center);
        $824f5e122dad54af$var$_extents.subVectors(this.max, $824f5e122dad54af$var$_center);
        // translate triangle to aabb origin
        $824f5e122dad54af$var$_v0$2.subVectors(triangle.a, $824f5e122dad54af$var$_center);
        $824f5e122dad54af$var$_v1$7.subVectors(triangle.b, $824f5e122dad54af$var$_center);
        $824f5e122dad54af$var$_v2$3.subVectors(triangle.c, $824f5e122dad54af$var$_center);
        // compute edge vectors for triangle
        $824f5e122dad54af$var$_f0.subVectors($824f5e122dad54af$var$_v1$7, $824f5e122dad54af$var$_v0$2);
        $824f5e122dad54af$var$_f1.subVectors($824f5e122dad54af$var$_v2$3, $824f5e122dad54af$var$_v1$7);
        $824f5e122dad54af$var$_f2.subVectors($824f5e122dad54af$var$_v0$2, $824f5e122dad54af$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$824f5e122dad54af$var$_f0.z,
            $824f5e122dad54af$var$_f0.y,
            0,
            -$824f5e122dad54af$var$_f1.z,
            $824f5e122dad54af$var$_f1.y,
            0,
            -$824f5e122dad54af$var$_f2.z,
            $824f5e122dad54af$var$_f2.y,
            $824f5e122dad54af$var$_f0.z,
            0,
            -$824f5e122dad54af$var$_f0.x,
            $824f5e122dad54af$var$_f1.z,
            0,
            -$824f5e122dad54af$var$_f1.x,
            $824f5e122dad54af$var$_f2.z,
            0,
            -$824f5e122dad54af$var$_f2.x,
            -$824f5e122dad54af$var$_f0.y,
            $824f5e122dad54af$var$_f0.x,
            0,
            -$824f5e122dad54af$var$_f1.y,
            $824f5e122dad54af$var$_f1.x,
            0,
            -$824f5e122dad54af$var$_f2.y,
            $824f5e122dad54af$var$_f2.x,
            0
        ];
        if (!$824f5e122dad54af$var$satForAxes(axes, $824f5e122dad54af$var$_v0$2, $824f5e122dad54af$var$_v1$7, $824f5e122dad54af$var$_v2$3, $824f5e122dad54af$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$824f5e122dad54af$var$satForAxes(axes, $824f5e122dad54af$var$_v0$2, $824f5e122dad54af$var$_v1$7, $824f5e122dad54af$var$_v2$3, $824f5e122dad54af$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $824f5e122dad54af$var$_triangleNormal.crossVectors($824f5e122dad54af$var$_f0, $824f5e122dad54af$var$_f1);
        axes = [
            $824f5e122dad54af$var$_triangleNormal.x,
            $824f5e122dad54af$var$_triangleNormal.y,
            $824f5e122dad54af$var$_triangleNormal.z
        ];
        return $824f5e122dad54af$var$satForAxes(axes, $824f5e122dad54af$var$_v0$2, $824f5e122dad54af$var$_v1$7, $824f5e122dad54af$var$_v2$3, $824f5e122dad54af$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $824f5e122dad54af$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($824f5e122dad54af$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $824f5e122dad54af$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $824f5e122dad54af$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $824f5e122dad54af$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $824f5e122dad54af$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $824f5e122dad54af$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $824f5e122dad54af$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $824f5e122dad54af$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $824f5e122dad54af$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($824f5e122dad54af$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $824f5e122dad54af$var$_points = [
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699()
];
const $824f5e122dad54af$var$_vector$b = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_box$3 = /*@__PURE__*/ new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $824f5e122dad54af$var$_v0$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v1$7 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v2$3 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
// triangle edge vectors
const $824f5e122dad54af$var$_f0 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_f1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_f2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_center = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_extents = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_triangleNormal = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_testAxis = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
function $824f5e122dad54af$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $824f5e122dad54af$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($824f5e122dad54af$var$_testAxis.x) + extents.y * Math.abs($824f5e122dad54af$var$_testAxis.y) + extents.z * Math.abs($824f5e122dad54af$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($824f5e122dad54af$var$_testAxis);
        const p1 = v1.dot($824f5e122dad54af$var$_testAxis);
        const p2 = v2.dot($824f5e122dad54af$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $824f5e122dad54af$var$_box$2 = /*@__PURE__*/ new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
const $824f5e122dad54af$var$_v1$6 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_toFarthestPoint = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_toPoint = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$805e8b72413ccaba {
    constructor(center = new $824f5e122dad54af$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $824f5e122dad54af$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $824f5e122dad54af$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $824f5e122dad54af$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($824f5e122dad54af$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $824f5e122dad54af$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $824f5e122dad54af$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($824f5e122dad54af$var$_v1$6.copy(sphere.center).add($824f5e122dad54af$var$_toFarthestPoint));
        this.expandByPoint($824f5e122dad54af$var$_v1$6.copy(sphere.center).sub($824f5e122dad54af$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $824f5e122dad54af$var$_vector$a = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_segCenter = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_segDir = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_diff = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_edge1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_edge2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_normal$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$a186db52eed6d40e {
    constructor(origin = new $824f5e122dad54af$export$64b5c384219d3699(), direction = new $824f5e122dad54af$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $824f5e122dad54af$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $824f5e122dad54af$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $824f5e122dad54af$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $824f5e122dad54af$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $824f5e122dad54af$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $824f5e122dad54af$var$_segDir.copy(v1).sub(v0).normalize();
        $824f5e122dad54af$var$_diff.copy(this.origin).sub($824f5e122dad54af$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($824f5e122dad54af$var$_segDir);
        const b0 = $824f5e122dad54af$var$_diff.dot(this.direction);
        const b1 = -$824f5e122dad54af$var$_diff.dot($824f5e122dad54af$var$_segDir);
        const c = $824f5e122dad54af$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($824f5e122dad54af$var$_segDir).multiplyScalar(s1).add($824f5e122dad54af$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $824f5e122dad54af$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $824f5e122dad54af$var$_vector$a.dot(this.direction);
        const d2 = $824f5e122dad54af$var$_vector$a.dot($824f5e122dad54af$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $824f5e122dad54af$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $824f5e122dad54af$var$_edge1.subVectors(b, a);
        $824f5e122dad54af$var$_edge2.subVectors(c, a);
        $824f5e122dad54af$var$_normal$1.crossVectors($824f5e122dad54af$var$_edge1, $824f5e122dad54af$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($824f5e122dad54af$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $824f5e122dad54af$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($824f5e122dad54af$var$_edge2.crossVectors($824f5e122dad54af$var$_diff, $824f5e122dad54af$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($824f5e122dad54af$var$_edge1.cross($824f5e122dad54af$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $824f5e122dad54af$var$_diff.dot($824f5e122dad54af$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $824f5e122dad54af$export$2ae72fc923e5eb5 {
    constructor(){
        $824f5e122dad54af$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $824f5e122dad54af$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $824f5e122dad54af$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $824f5e122dad54af$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $824f5e122dad54af$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($824f5e122dad54af$var$_zero, q, $824f5e122dad54af$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $824f5e122dad54af$var$_z.subVectors(eye, target);
        if ($824f5e122dad54af$var$_z.lengthSq() === 0) // eye and target are in the same position
        $824f5e122dad54af$var$_z.z = 1;
        $824f5e122dad54af$var$_z.normalize();
        $824f5e122dad54af$var$_x.crossVectors(up, $824f5e122dad54af$var$_z);
        if ($824f5e122dad54af$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $824f5e122dad54af$var$_z.x += 0.0001;
            else $824f5e122dad54af$var$_z.z += 0.0001;
            $824f5e122dad54af$var$_z.normalize();
            $824f5e122dad54af$var$_x.crossVectors(up, $824f5e122dad54af$var$_z);
        }
        $824f5e122dad54af$var$_x.normalize();
        $824f5e122dad54af$var$_y.crossVectors($824f5e122dad54af$var$_z, $824f5e122dad54af$var$_x);
        te[0] = $824f5e122dad54af$var$_x.x;
        te[4] = $824f5e122dad54af$var$_y.x;
        te[8] = $824f5e122dad54af$var$_z.x;
        te[1] = $824f5e122dad54af$var$_x.y;
        te[5] = $824f5e122dad54af$var$_y.y;
        te[9] = $824f5e122dad54af$var$_z.y;
        te[2] = $824f5e122dad54af$var$_x.z;
        te[6] = $824f5e122dad54af$var$_y.z;
        te[10] = $824f5e122dad54af$var$_z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $824f5e122dad54af$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $824f5e122dad54af$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $824f5e122dad54af$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $824f5e122dad54af$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $824f5e122dad54af$var$_m1$2.elements[0] *= invSX;
        $824f5e122dad54af$var$_m1$2.elements[1] *= invSX;
        $824f5e122dad54af$var$_m1$2.elements[2] *= invSX;
        $824f5e122dad54af$var$_m1$2.elements[4] *= invSY;
        $824f5e122dad54af$var$_m1$2.elements[5] *= invSY;
        $824f5e122dad54af$var$_m1$2.elements[6] *= invSY;
        $824f5e122dad54af$var$_m1$2.elements[8] *= invSZ;
        $824f5e122dad54af$var$_m1$2.elements[9] *= invSZ;
        $824f5e122dad54af$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($824f5e122dad54af$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $824f5e122dad54af$var$_v1$5 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_m1$2 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_zero = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 0);
const $824f5e122dad54af$var$_one = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(1, 1, 1);
const $824f5e122dad54af$var$_x = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_y = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_z = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_matrix$1 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_quaternion$3 = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
class $824f5e122dad54af$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $824f5e122dad54af$export$d93cc409a0768c5f.DefaultOrder){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($824f5e122dad54af$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$824f5e122dad54af$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($824f5e122dad54af$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$824f5e122dad54af$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($824f5e122dad54af$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$824f5e122dad54af$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $824f5e122dad54af$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($824f5e122dad54af$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $824f5e122dad54af$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($824f5e122dad54af$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    // @deprecated since r138, 02cf0df1cb4575d5842fef9c85bb5a89fe020d53
    toVector3() {
        console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
    }
}
$824f5e122dad54af$export$d93cc409a0768c5f.DefaultOrder = "XYZ";
$824f5e122dad54af$export$d93cc409a0768c5f.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
class $824f5e122dad54af$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $824f5e122dad54af$var$_object3DId = 0;
const $824f5e122dad54af$var$_v1$4 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_q1 = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
const $824f5e122dad54af$var$_m1$1 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_target = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_position$3 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_scale$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_quaternion$2 = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
const $824f5e122dad54af$var$_xAxis = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(1, 0, 0);
const $824f5e122dad54af$var$_yAxis = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0);
const $824f5e122dad54af$var$_zAxis = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 1);
const $824f5e122dad54af$var$_addedEvent = {
    type: "added"
};
const $824f5e122dad54af$var$_removedEvent = {
    type: "removed"
};
class $824f5e122dad54af$export$e4dd07dff30cc924 extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $824f5e122dad54af$var$_object3DId++
        });
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $824f5e122dad54af$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $824f5e122dad54af$export$64b5c384219d3699();
        const rotation = new $824f5e122dad54af$export$d93cc409a0768c5f();
        const quaternion = new $824f5e122dad54af$export$23d6a54f0bbc85a3();
        const scale = new $824f5e122dad54af$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $824f5e122dad54af$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $824f5e122dad54af$export$8ff26dafa08918()
            }
        });
        this.matrix = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.matrixWorld = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $824f5e122dad54af$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $824f5e122dad54af$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $824f5e122dad54af$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($824f5e122dad54af$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $824f5e122dad54af$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($824f5e122dad54af$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($824f5e122dad54af$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($824f5e122dad54af$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($824f5e122dad54af$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $824f5e122dad54af$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($824f5e122dad54af$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($824f5e122dad54af$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($824f5e122dad54af$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($824f5e122dad54af$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($824f5e122dad54af$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $824f5e122dad54af$var$_target.copy(x);
        else $824f5e122dad54af$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $824f5e122dad54af$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $824f5e122dad54af$var$_m1$1.lookAt($824f5e122dad54af$var$_position$3, $824f5e122dad54af$var$_target, this.up);
        else $824f5e122dad54af$var$_m1$1.lookAt($824f5e122dad54af$var$_target, $824f5e122dad54af$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($824f5e122dad54af$var$_m1$1);
        if (parent) {
            $824f5e122dad54af$var$_m1$1.extractRotation(parent.matrixWorld);
            $824f5e122dad54af$var$_q1.setFromRotationMatrix($824f5e122dad54af$var$_m1$1);
            this.quaternion.premultiply($824f5e122dad54af$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($824f5e122dad54af$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($824f5e122dad54af$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($824f5e122dad54af$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $824f5e122dad54af$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $824f5e122dad54af$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($824f5e122dad54af$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($824f5e122dad54af$var$_position$3, target, $824f5e122dad54af$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($824f5e122dad54af$var$_position$3, $824f5e122dad54af$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== "{}") object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$824f5e122dad54af$export$e4dd07dff30cc924.DefaultUp = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0);
$824f5e122dad54af$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
const $824f5e122dad54af$var$_v0$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v1$3 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v2$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v3$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vab = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vac = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vbc = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vap = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vbp = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vcp = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$5a465592bfe74b48 {
    constructor(a = new $824f5e122dad54af$export$64b5c384219d3699(), b = new $824f5e122dad54af$export$64b5c384219d3699(), c = new $824f5e122dad54af$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $824f5e122dad54af$var$_v0$1.subVectors(a, b);
        target.cross($824f5e122dad54af$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $824f5e122dad54af$var$_v0$1.subVectors(c, a);
        $824f5e122dad54af$var$_v1$3.subVectors(b, a);
        $824f5e122dad54af$var$_v2$2.subVectors(point, a);
        const dot00 = $824f5e122dad54af$var$_v0$1.dot($824f5e122dad54af$var$_v0$1);
        const dot01 = $824f5e122dad54af$var$_v0$1.dot($824f5e122dad54af$var$_v1$3);
        const dot02 = $824f5e122dad54af$var$_v0$1.dot($824f5e122dad54af$var$_v2$2);
        const dot11 = $824f5e122dad54af$var$_v1$3.dot($824f5e122dad54af$var$_v1$3);
        const dot12 = $824f5e122dad54af$var$_v1$3.dot($824f5e122dad54af$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $824f5e122dad54af$var$_v3$1);
        return $824f5e122dad54af$var$_v3$1.x >= 0 && $824f5e122dad54af$var$_v3$1.y >= 0 && $824f5e122dad54af$var$_v3$1.x + $824f5e122dad54af$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $824f5e122dad54af$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $824f5e122dad54af$var$_v3$1.x);
        target.addScaledVector(uv2, $824f5e122dad54af$var$_v3$1.y);
        target.addScaledVector(uv3, $824f5e122dad54af$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $824f5e122dad54af$var$_v0$1.subVectors(c, b);
        $824f5e122dad54af$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $824f5e122dad54af$var$_v0$1.cross($824f5e122dad54af$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $824f5e122dad54af$var$_v0$1.subVectors(this.c, this.b);
        $824f5e122dad54af$var$_v1$3.subVectors(this.a, this.b);
        return $824f5e122dad54af$var$_v0$1.cross($824f5e122dad54af$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $824f5e122dad54af$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $824f5e122dad54af$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $824f5e122dad54af$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $824f5e122dad54af$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $824f5e122dad54af$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $824f5e122dad54af$var$_vab.subVectors(b, a);
        $824f5e122dad54af$var$_vac.subVectors(c, a);
        $824f5e122dad54af$var$_vap.subVectors(p, a);
        const d1 = $824f5e122dad54af$var$_vab.dot($824f5e122dad54af$var$_vap);
        const d2 = $824f5e122dad54af$var$_vac.dot($824f5e122dad54af$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $824f5e122dad54af$var$_vbp.subVectors(p, b);
        const d3 = $824f5e122dad54af$var$_vab.dot($824f5e122dad54af$var$_vbp);
        const d4 = $824f5e122dad54af$var$_vac.dot($824f5e122dad54af$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($824f5e122dad54af$var$_vab, v);
        }
        $824f5e122dad54af$var$_vcp.subVectors(p, c);
        const d5 = $824f5e122dad54af$var$_vab.dot($824f5e122dad54af$var$_vcp);
        const d6 = $824f5e122dad54af$var$_vac.dot($824f5e122dad54af$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($824f5e122dad54af$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $824f5e122dad54af$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($824f5e122dad54af$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($824f5e122dad54af$var$_vab, v).addScaledVector($824f5e122dad54af$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $824f5e122dad54af$var$materialId = 0;
class $824f5e122dad54af$export$a2d8b23205c25948 extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $824f5e122dad54af$var$materialId++
        });
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $824f5e122dad54af$export$5b29a26d96ee6af0;
        this.side = $824f5e122dad54af$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $824f5e122dad54af$export$d5773124e86cf28c;
        this.blendDst = $824f5e122dad54af$export$11d468cc7f19e971;
        this.blendEquation = $824f5e122dad54af$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $824f5e122dad54af$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $824f5e122dad54af$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $824f5e122dad54af$export$9f542ae4b5baca34;
        this.stencilZFail = $824f5e122dad54af$export$9f542ae4b5baca34;
        this.stencilZPass = $824f5e122dad54af$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn("THREE.Material: '" + key + "' parameter is undefined.");
                continue;
            }
            // for backward compatibility if shading is set in the constructor
            if (key === "shading") {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
                this.flatShading = newValue === $824f5e122dad54af$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $824f5e122dad54af$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $824f5e122dad54af$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (JSON.stringify(this.userData) !== "{}") data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
class $824f5e122dad54af$export$55cbcc9b622fe1f5 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $824f5e122dad54af$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
const $824f5e122dad54af$var$_vector$9 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vector2$1 = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
class $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $824f5e122dad54af$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i);
                color = new $824f5e122dad54af$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i);
                vector = new $824f5e122dad54af$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i);
                vector = new $824f5e122dad54af$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i);
                vector = new $824f5e122dad54af$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector2$1.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $824f5e122dad54af$var$_vector2$1.x, $824f5e122dad54af$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$9.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$9.x, $824f5e122dad54af$var$_vector$9.y, $824f5e122dad54af$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$9.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$9.x, $824f5e122dad54af$var$_vector$9.y, $824f5e122dad54af$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$9.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$9.x, $824f5e122dad54af$var$_vector$9.y, $824f5e122dad54af$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$9.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$9.x, $824f5e122dad54af$var$_vector$9.y, $824f5e122dad54af$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $824f5e122dad54af$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $824f5e122dad54af$export$f9ff2d6a20248cbf extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$cacc90cf35d11cdd extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$baaa85a1a812c157 extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$2b755a102ccdcefe extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$640a853f68025f2e extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$46b369aed2968a0a extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$7eb8c9fa25cd5bd6 extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$dbd3698c64958d69 extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
}
class $824f5e122dad54af$export$cbe7a62641830ebd extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $824f5e122dad54af$export$9e0ade74842adbb8 extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $824f5e122dad54af$var$_id$1 = 0;
const $824f5e122dad54af$var$_m1 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_obj = /*@__PURE__*/ new $824f5e122dad54af$export$e4dd07dff30cc924();
const $824f5e122dad54af$var$_offset = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_box$1 = /*@__PURE__*/ new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
const $824f5e122dad54af$var$_boxMorphTargets = /*@__PURE__*/ new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
const $824f5e122dad54af$var$_vector$8 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$b7be63a67df8959 extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $824f5e122dad54af$var$_id$1++
        });
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($824f5e122dad54af$var$arrayNeedsUint32(index) ? $824f5e122dad54af$export$7eb8c9fa25cd5bd6 : $824f5e122dad54af$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $824f5e122dad54af$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $824f5e122dad54af$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $824f5e122dad54af$var$_m1.makeRotationX(angle);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $824f5e122dad54af$var$_m1.makeRotationY(angle);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $824f5e122dad54af$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $824f5e122dad54af$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $824f5e122dad54af$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($824f5e122dad54af$var$_m1);
        return this;
    }
    lookAt(vector) {
        $824f5e122dad54af$var$_obj.lookAt(vector);
        $824f5e122dad54af$var$_obj.updateMatrix();
        this.applyMatrix4($824f5e122dad54af$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($824f5e122dad54af$var$_offset).negate();
        this.translate($824f5e122dad54af$var$_offset.x, $824f5e122dad54af$var$_offset.y, $824f5e122dad54af$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $824f5e122dad54af$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $824f5e122dad54af$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $824f5e122dad54af$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $824f5e122dad54af$var$_vector$8.addVectors(this.boundingBox.min, $824f5e122dad54af$var$_box$1.min);
                    this.boundingBox.expandByPoint($824f5e122dad54af$var$_vector$8);
                    $824f5e122dad54af$var$_vector$8.addVectors(this.boundingBox.max, $824f5e122dad54af$var$_box$1.max);
                    this.boundingBox.expandByPoint($824f5e122dad54af$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($824f5e122dad54af$var$_box$1.min);
                    this.boundingBox.expandByPoint($824f5e122dad54af$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $824f5e122dad54af$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $824f5e122dad54af$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $824f5e122dad54af$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $824f5e122dad54af$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $824f5e122dad54af$var$_vector$8.addVectors($824f5e122dad54af$var$_box$1.min, $824f5e122dad54af$var$_boxMorphTargets.min);
                    $824f5e122dad54af$var$_box$1.expandByPoint($824f5e122dad54af$var$_vector$8);
                    $824f5e122dad54af$var$_vector$8.addVectors($824f5e122dad54af$var$_box$1.max, $824f5e122dad54af$var$_boxMorphTargets.max);
                    $824f5e122dad54af$var$_box$1.expandByPoint($824f5e122dad54af$var$_vector$8);
                } else {
                    $824f5e122dad54af$var$_box$1.expandByPoint($824f5e122dad54af$var$_boxMorphTargets.min);
                    $824f5e122dad54af$var$_box$1.expandByPoint($824f5e122dad54af$var$_boxMorphTargets.max);
                }
            }
            $824f5e122dad54af$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $824f5e122dad54af$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($824f5e122dad54af$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $824f5e122dad54af$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $824f5e122dad54af$var$_offset.fromBufferAttribute(position, j);
                        $824f5e122dad54af$var$_vector$8.add($824f5e122dad54af$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($824f5e122dad54af$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $824f5e122dad54af$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $824f5e122dad54af$export$64b5c384219d3699();
            tan2[i] = new $824f5e122dad54af$export$64b5c384219d3699();
        }
        const vA = new $824f5e122dad54af$export$64b5c384219d3699(), vB = new $824f5e122dad54af$export$64b5c384219d3699(), vC = new $824f5e122dad54af$export$64b5c384219d3699(), uvA = new $824f5e122dad54af$export$c977b3e384af9ae1(), uvB = new $824f5e122dad54af$export$c977b3e384af9ae1(), uvC = new $824f5e122dad54af$export$c977b3e384af9ae1(), sdir = new $824f5e122dad54af$export$64b5c384219d3699(), tdir = new $824f5e122dad54af$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $824f5e122dad54af$export$64b5c384219d3699(), tmp2 = new $824f5e122dad54af$export$64b5c384219d3699();
        const n = new $824f5e122dad54af$export$64b5c384219d3699(), n2 = new $824f5e122dad54af$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $824f5e122dad54af$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $824f5e122dad54af$export$64b5c384219d3699(), pB = new $824f5e122dad54af$export$64b5c384219d3699(), pC = new $824f5e122dad54af$export$64b5c384219d3699();
            const nA = new $824f5e122dad54af$export$64b5c384219d3699(), nB = new $824f5e122dad54af$export$64b5c384219d3699(), nC = new $824f5e122dad54af$export$64b5c384219d3699();
            const cb = new $824f5e122dad54af$export$64b5c384219d3699(), ab = new $824f5e122dad54af$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $824f5e122dad54af$var$_vector$8.fromBufferAttribute(normals, i);
            $824f5e122dad54af$var$_vector$8.normalize();
            normals.setXYZ(i, $824f5e122dad54af$var$_vector$8.x, $824f5e122dad54af$var$_vector$8.y, $824f5e122dad54af$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $824f5e122dad54af$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $824f5e122dad54af$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        // geometry generator parameters
        if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $824f5e122dad54af$var$_inverseMatrix$2 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_ray$2 = /*@__PURE__*/ new $824f5e122dad54af$export$a186db52eed6d40e();
const $824f5e122dad54af$var$_sphere$3 = /*@__PURE__*/ new $824f5e122dad54af$export$805e8b72413ccaba();
const $824f5e122dad54af$var$_vA$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vB$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vC$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_tempA = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_tempB = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_tempC = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_morphA = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_morphB = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_morphC = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_uvA$1 = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_uvB$1 = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_uvC$1 = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_intersectionPoint = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_intersectionPointWorld = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$e176487c05830cc5 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(geometry = new $824f5e122dad54af$export$b7be63a67df8959(), material = new $824f5e122dad54af$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $824f5e122dad54af$var$_sphere$3.copy(geometry.boundingSphere);
        $824f5e122dad54af$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($824f5e122dad54af$var$_sphere$3) === false) return;
        //
        $824f5e122dad54af$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $824f5e122dad54af$var$_ray$2.copy(raycaster.ray).applyMatrix4($824f5e122dad54af$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($824f5e122dad54af$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        const uv = geometry.attributes.uv;
        const uv2 = geometry.attributes.uv2;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $824f5e122dad54af$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $824f5e122dad54af$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $824f5e122dad54af$var$checkBufferGeometryIntersection(this, material, raycaster, $824f5e122dad54af$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $824f5e122dad54af$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $824f5e122dad54af$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $824f5e122dad54af$var$checkBufferGeometryIntersection(this, material, raycaster, $824f5e122dad54af$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $824f5e122dad54af$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $824f5e122dad54af$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $824f5e122dad54af$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $824f5e122dad54af$var$_intersectionPointWorld.copy(point);
    $824f5e122dad54af$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($824f5e122dad54af$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $824f5e122dad54af$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $824f5e122dad54af$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $824f5e122dad54af$var$_vA$1.fromBufferAttribute(position, a);
    $824f5e122dad54af$var$_vB$1.fromBufferAttribute(position, b);
    $824f5e122dad54af$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
        $824f5e122dad54af$var$_morphA.set(0, 0, 0);
        $824f5e122dad54af$var$_morphB.set(0, 0, 0);
        $824f5e122dad54af$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $824f5e122dad54af$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $824f5e122dad54af$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $824f5e122dad54af$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $824f5e122dad54af$var$_morphA.addScaledVector($824f5e122dad54af$var$_tempA, influence);
                $824f5e122dad54af$var$_morphB.addScaledVector($824f5e122dad54af$var$_tempB, influence);
                $824f5e122dad54af$var$_morphC.addScaledVector($824f5e122dad54af$var$_tempC, influence);
            } else {
                $824f5e122dad54af$var$_morphA.addScaledVector($824f5e122dad54af$var$_tempA.sub($824f5e122dad54af$var$_vA$1), influence);
                $824f5e122dad54af$var$_morphB.addScaledVector($824f5e122dad54af$var$_tempB.sub($824f5e122dad54af$var$_vB$1), influence);
                $824f5e122dad54af$var$_morphC.addScaledVector($824f5e122dad54af$var$_tempC.sub($824f5e122dad54af$var$_vC$1), influence);
            }
        }
        $824f5e122dad54af$var$_vA$1.add($824f5e122dad54af$var$_morphA);
        $824f5e122dad54af$var$_vB$1.add($824f5e122dad54af$var$_morphB);
        $824f5e122dad54af$var$_vC$1.add($824f5e122dad54af$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $824f5e122dad54af$var$_vA$1);
        object.boneTransform(b, $824f5e122dad54af$var$_vB$1);
        object.boneTransform(c, $824f5e122dad54af$var$_vC$1);
    }
    const intersection = $824f5e122dad54af$var$checkIntersection(object, material, raycaster, ray, $824f5e122dad54af$var$_vA$1, $824f5e122dad54af$var$_vB$1, $824f5e122dad54af$var$_vC$1, $824f5e122dad54af$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $824f5e122dad54af$var$_uvA$1.fromBufferAttribute(uv, a);
            $824f5e122dad54af$var$_uvB$1.fromBufferAttribute(uv, b);
            $824f5e122dad54af$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $824f5e122dad54af$export$5a465592bfe74b48.getUV($824f5e122dad54af$var$_intersectionPoint, $824f5e122dad54af$var$_vA$1, $824f5e122dad54af$var$_vB$1, $824f5e122dad54af$var$_vC$1, $824f5e122dad54af$var$_uvA$1, $824f5e122dad54af$var$_uvB$1, $824f5e122dad54af$var$_uvC$1, new $824f5e122dad54af$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $824f5e122dad54af$var$_uvA$1.fromBufferAttribute(uv2, a);
            $824f5e122dad54af$var$_uvB$1.fromBufferAttribute(uv2, b);
            $824f5e122dad54af$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $824f5e122dad54af$export$5a465592bfe74b48.getUV($824f5e122dad54af$var$_intersectionPoint, $824f5e122dad54af$var$_vA$1, $824f5e122dad54af$var$_vB$1, $824f5e122dad54af$var$_vC$1, $824f5e122dad54af$var$_uvA$1, $824f5e122dad54af$var$_uvB$1, $824f5e122dad54af$var$_uvC$1, new $824f5e122dad54af$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $824f5e122dad54af$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $824f5e122dad54af$export$5a465592bfe74b48.getNormal($824f5e122dad54af$var$_vA$1, $824f5e122dad54af$var$_vB$1, $824f5e122dad54af$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $824f5e122dad54af$export$ab3456a079aa7d80 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $824f5e122dad54af$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$ab3456a079aa7d80(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $824f5e122dad54af$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $824f5e122dad54af$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $824f5e122dad54af$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const $824f5e122dad54af$export$d8ecdf8615bfea69 = {
    clone: $824f5e122dad54af$var$cloneUniforms,
    merge: $824f5e122dad54af$var$mergeUniforms
};
var $824f5e122dad54af$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $824f5e122dad54af$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $824f5e122dad54af$export$83c7d75d550a8b0d extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.vertexShader = $824f5e122dad54af$var$default_vertex;
        this.fragmentShader = $824f5e122dad54af$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv2": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
            this.setValues(parameters);
        }
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $824f5e122dad54af$var$cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $824f5e122dad54af$export$79f141de891a5fed extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $824f5e122dad54af$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $824f5e122dad54af$export$74e4ae24825f68d7 extends $824f5e122dad54af$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $824f5e122dad54af$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($824f5e122dad54af$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $824f5e122dad54af$var$RAD2DEG * 2 * Math.atan(Math.tan($824f5e122dad54af$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($824f5e122dad54af$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $824f5e122dad54af$var$fov = 90, $824f5e122dad54af$var$aspect = 1;
class $824f5e122dad54af$export$d0cdd0bd804995de extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $824f5e122dad54af$export$74e4ae24825f68d7($824f5e122dad54af$var$fov, $824f5e122dad54af$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $824f5e122dad54af$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $824f5e122dad54af$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $824f5e122dad54af$export$ee2e5a18258a4049 extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $824f5e122dad54af$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $824f5e122dad54af$export$ac386671d651941e extends $824f5e122dad54af$export$3c052beb2e51e23f {
    constructor(size, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $824f5e122dad54af$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $824f5e122dad54af$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $824f5e122dad54af$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $824f5e122dad54af$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $824f5e122dad54af$export$d9f0486e75b5ace,
            blending: $824f5e122dad54af$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $824f5e122dad54af$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $824f5e122dad54af$export$5d8599b6a933fb1b) texture.minFilter = $824f5e122dad54af$export$8a72f490b25c56c8;
        const camera = new $824f5e122dad54af$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $824f5e122dad54af$var$_vector1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vector2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_normalMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918();
class $824f5e122dad54af$export$7ff5ac152ef991b0 {
    constructor(normal = new $824f5e122dad54af$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $824f5e122dad54af$var$_vector1.subVectors(c, b).cross($824f5e122dad54af$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($824f5e122dad54af$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $824f5e122dad54af$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($824f5e122dad54af$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $824f5e122dad54af$var$_sphere$2 = /*@__PURE__*/ new $824f5e122dad54af$export$805e8b72413ccaba();
const $824f5e122dad54af$var$_vector$7 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$35efe6f4c85463d2 {
    constructor(p0 = new $824f5e122dad54af$export$7ff5ac152ef991b0(), p1 = new $824f5e122dad54af$export$7ff5ac152ef991b0(), p2 = new $824f5e122dad54af$export$7ff5ac152ef991b0(), p3 = new $824f5e122dad54af$export$7ff5ac152ef991b0(), p4 = new $824f5e122dad54af$export$7ff5ac152ef991b0(), p5 = new $824f5e122dad54af$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $824f5e122dad54af$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($824f5e122dad54af$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $824f5e122dad54af$var$_sphere$2.center.set(0, 0, 0);
        $824f5e122dad54af$var$_sphere$2.radius = 0.7071067811865476;
        $824f5e122dad54af$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($824f5e122dad54af$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $824f5e122dad54af$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $824f5e122dad54af$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $824f5e122dad54af$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($824f5e122dad54af$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $824f5e122dad54af$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $824f5e122dad54af$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $824f5e122dad54af$export$e789a11a194ca4e0 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$e789a11a194ca4e0(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $824f5e122dad54af$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $824f5e122dad54af$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $824f5e122dad54af$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $824f5e122dad54af$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $824f5e122dad54af$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $824f5e122dad54af$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $824f5e122dad54af$var$begin_vertex = "vec3 transformed = vec3( position );";
var $824f5e122dad54af$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $824f5e122dad54af$var$bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\n#ifdef USE_IRIDESCENCE\nvec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = mix(F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence);\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\n#endif\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif";
var $824f5e122dad54af$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\nconst mat3 XYZ_TO_REC709 = mat3(\n    3.2404542, -0.9692660,  0.0556434,\n   -1.5371385,  1.8760108, -0.2040259,\n   -0.4985314,  0.0415560,  1.0572252\n);\nvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n   vec3 sqrtF0 = sqrt( fresnel0 );\n   return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n}\nvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n   return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n}\nfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n   return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n}\nvec3 evalSensitivity( float OPD, vec3 shift ) {\n   float phase = 2.0 * PI * OPD * 1.0e-9;\n   vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n   vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n   vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n   vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( -pow2( phase ) * var );\n   xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[0] ) * exp( -4.5282e+09 * pow2( phase ) );\n   xyz /= 1.0685e-7;\n   vec3 srgb = XYZ_TO_REC709 * xyz;\n   return srgb;\n}\nvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n   vec3 I;\n   float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n   float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n   float cosTheta2Sq = 1.0 - sinTheta2Sq;\n   if ( cosTheta2Sq < 0.0 ) {\n       return vec3( 1.0 );\n   }\n   float cosTheta2 = sqrt( cosTheta2Sq );\n   float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n   float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n   float R21 = R12;\n   float T121 = 1.0 - R12;\n   float phi12 = 0.0;\n   if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n   float phi21 = PI - phi12;\n   vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );   vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n   vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n   vec3 phi23 = vec3( 0.0 );\n   if ( baseIOR[0] < iridescenceIOR ) phi23[0] = PI;\n   if ( baseIOR[1] < iridescenceIOR ) phi23[1] = PI;\n   if ( baseIOR[2] < iridescenceIOR ) phi23[2] = PI;\n   float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n   vec3 phi = vec3( phi21 ) + phi23;\n   vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n   vec3 r123 = sqrt( R123 );\n   vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n   vec3 C0 = R12 + Rs;\n   I = C0;\n   vec3 Cm = Rs - T121;\n   for ( int m = 1; m <= 2; ++m ) {\n       Cm *= r123;\n       vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n       I += Cm * Sm;\n   }\n   return max( I, vec3( 0.0 ) );\n}\n#endif";
var $824f5e122dad54af$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $824f5e122dad54af$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $824f5e122dad54af$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $824f5e122dad54af$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $824f5e122dad54af$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $824f5e122dad54af$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $824f5e122dad54af$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $824f5e122dad54af$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $824f5e122dad54af$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $824f5e122dad54af$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var $824f5e122dad54af$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $824f5e122dad54af$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $824f5e122dad54af$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $824f5e122dad54af$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $824f5e122dad54af$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $824f5e122dad54af$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $824f5e122dad54af$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $824f5e122dad54af$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $824f5e122dad54af$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $824f5e122dad54af$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $824f5e122dad54af$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $824f5e122dad54af$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $824f5e122dad54af$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $824f5e122dad54af$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $824f5e122dad54af$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $824f5e122dad54af$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $824f5e122dad54af$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $824f5e122dad54af$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var $824f5e122dad54af$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $824f5e122dad54af$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $824f5e122dad54af$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointLightInfo( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotLightInfo( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var $824f5e122dad54af$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#else\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $824f5e122dad54af$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var $824f5e122dad54af$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $824f5e122dad54af$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var $824f5e122dad54af$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $824f5e122dad54af$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var $824f5e122dad54af$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	#ifdef SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULARINTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n		#endif\n		#ifdef USE_SPECULARCOLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEENCOLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEENROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n	#endif\n#endif";
var $824f5e122dad54af$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	#ifdef USE_IRIDESCENCE\n		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );\n	#else\n		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $824f5e122dad54af$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\nfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\nif ( material.iridescenceThickness == 0.0 ) {\n	material.iridescence = 0.0;\n} else {\n	material.iridescence = saturate( material.iridescence );\n}\nif ( material.iridescence > 0.0 ) {\n	material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n	material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $824f5e122dad54af$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $824f5e122dad54af$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $824f5e122dad54af$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $824f5e122dad54af$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $824f5e122dad54af$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $824f5e122dad54af$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $824f5e122dad54af$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $824f5e122dad54af$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $824f5e122dad54af$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $824f5e122dad54af$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $824f5e122dad54af$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $824f5e122dad54af$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $824f5e122dad54af$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $824f5e122dad54af$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $824f5e122dad54af$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $824f5e122dad54af$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $824f5e122dad54af$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $824f5e122dad54af$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $824f5e122dad54af$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $824f5e122dad54af$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $824f5e122dad54af$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $824f5e122dad54af$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var $824f5e122dad54af$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $824f5e122dad54af$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var $824f5e122dad54af$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var $824f5e122dad54af$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $824f5e122dad54af$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $824f5e122dad54af$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $824f5e122dad54af$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $824f5e122dad54af$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $824f5e122dad54af$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $824f5e122dad54af$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $824f5e122dad54af$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $824f5e122dad54af$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $824f5e122dad54af$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $824f5e122dad54af$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $824f5e122dad54af$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var $824f5e122dad54af$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $824f5e122dad54af$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $824f5e122dad54af$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $824f5e122dad54af$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $824f5e122dad54af$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $824f5e122dad54af$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $824f5e122dad54af$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $824f5e122dad54af$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $824f5e122dad54af$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $824f5e122dad54af$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionAlpha = 1.0;\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n	transmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var $824f5e122dad54af$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		#ifdef texture2DLodEXT\n			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#else\n			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#endif\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( attenuationDistance == 0.0 ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var $824f5e122dad54af$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var $824f5e122dad54af$var$uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var $824f5e122dad54af$var$uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $824f5e122dad54af$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var $824f5e122dad54af$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var $824f5e122dad54af$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $824f5e122dad54af$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $824f5e122dad54af$var$vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $824f5e122dad54af$var$fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	gl_FragColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		gl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n	#endif\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $824f5e122dad54af$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $824f5e122dad54af$var$fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $824f5e122dad54af$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $824f5e122dad54af$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $824f5e122dad54af$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $824f5e122dad54af$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $824f5e122dad54af$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $824f5e122dad54af$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $824f5e122dad54af$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $824f5e122dad54af$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $824f5e122dad54af$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $824f5e122dad54af$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $824f5e122dad54af$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $824f5e122dad54af$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULARINTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n	#ifdef USE_SPECULARCOLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEENCOLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEENROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $824f5e122dad54af$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $824f5e122dad54af$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $824f5e122dad54af$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $824f5e122dad54af$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $824f5e122dad54af$export$955f9f2e84c43c8b = {
    alphamap_fragment: $824f5e122dad54af$var$alphamap_fragment,
    alphamap_pars_fragment: $824f5e122dad54af$var$alphamap_pars_fragment,
    alphatest_fragment: $824f5e122dad54af$var$alphatest_fragment,
    alphatest_pars_fragment: $824f5e122dad54af$var$alphatest_pars_fragment,
    aomap_fragment: $824f5e122dad54af$var$aomap_fragment,
    aomap_pars_fragment: $824f5e122dad54af$var$aomap_pars_fragment,
    begin_vertex: $824f5e122dad54af$var$begin_vertex,
    beginnormal_vertex: $824f5e122dad54af$var$beginnormal_vertex,
    bsdfs: $824f5e122dad54af$var$bsdfs,
    iridescence_fragment: $824f5e122dad54af$var$iridescence_fragment,
    bumpmap_pars_fragment: $824f5e122dad54af$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $824f5e122dad54af$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $824f5e122dad54af$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $824f5e122dad54af$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $824f5e122dad54af$var$clipping_planes_vertex,
    color_fragment: $824f5e122dad54af$var$color_fragment,
    color_pars_fragment: $824f5e122dad54af$var$color_pars_fragment,
    color_pars_vertex: $824f5e122dad54af$var$color_pars_vertex,
    color_vertex: $824f5e122dad54af$var$color_vertex,
    common: $824f5e122dad54af$var$common,
    cube_uv_reflection_fragment: $824f5e122dad54af$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $824f5e122dad54af$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $824f5e122dad54af$var$displacementmap_pars_vertex,
    displacementmap_vertex: $824f5e122dad54af$var$displacementmap_vertex,
    emissivemap_fragment: $824f5e122dad54af$var$emissivemap_fragment,
    emissivemap_pars_fragment: $824f5e122dad54af$var$emissivemap_pars_fragment,
    encodings_fragment: $824f5e122dad54af$var$encodings_fragment,
    encodings_pars_fragment: $824f5e122dad54af$var$encodings_pars_fragment,
    envmap_fragment: $824f5e122dad54af$var$envmap_fragment,
    envmap_common_pars_fragment: $824f5e122dad54af$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $824f5e122dad54af$var$envmap_pars_fragment,
    envmap_pars_vertex: $824f5e122dad54af$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $824f5e122dad54af$var$envmap_physical_pars_fragment,
    envmap_vertex: $824f5e122dad54af$var$envmap_vertex,
    fog_vertex: $824f5e122dad54af$var$fog_vertex,
    fog_pars_vertex: $824f5e122dad54af$var$fog_pars_vertex,
    fog_fragment: $824f5e122dad54af$var$fog_fragment,
    fog_pars_fragment: $824f5e122dad54af$var$fog_pars_fragment,
    gradientmap_pars_fragment: $824f5e122dad54af$var$gradientmap_pars_fragment,
    lightmap_fragment: $824f5e122dad54af$var$lightmap_fragment,
    lightmap_pars_fragment: $824f5e122dad54af$var$lightmap_pars_fragment,
    lights_lambert_vertex: $824f5e122dad54af$var$lights_lambert_vertex,
    lights_pars_begin: $824f5e122dad54af$var$lights_pars_begin,
    lights_toon_fragment: $824f5e122dad54af$var$lights_toon_fragment,
    lights_toon_pars_fragment: $824f5e122dad54af$var$lights_toon_pars_fragment,
    lights_phong_fragment: $824f5e122dad54af$var$lights_phong_fragment,
    lights_phong_pars_fragment: $824f5e122dad54af$var$lights_phong_pars_fragment,
    lights_physical_fragment: $824f5e122dad54af$var$lights_physical_fragment,
    lights_physical_pars_fragment: $824f5e122dad54af$var$lights_physical_pars_fragment,
    lights_fragment_begin: $824f5e122dad54af$var$lights_fragment_begin,
    lights_fragment_maps: $824f5e122dad54af$var$lights_fragment_maps,
    lights_fragment_end: $824f5e122dad54af$var$lights_fragment_end,
    logdepthbuf_fragment: $824f5e122dad54af$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $824f5e122dad54af$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $824f5e122dad54af$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $824f5e122dad54af$var$logdepthbuf_vertex,
    map_fragment: $824f5e122dad54af$var$map_fragment,
    map_pars_fragment: $824f5e122dad54af$var$map_pars_fragment,
    map_particle_fragment: $824f5e122dad54af$var$map_particle_fragment,
    map_particle_pars_fragment: $824f5e122dad54af$var$map_particle_pars_fragment,
    metalnessmap_fragment: $824f5e122dad54af$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $824f5e122dad54af$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $824f5e122dad54af$var$morphcolor_vertex,
    morphnormal_vertex: $824f5e122dad54af$var$morphnormal_vertex,
    morphtarget_pars_vertex: $824f5e122dad54af$var$morphtarget_pars_vertex,
    morphtarget_vertex: $824f5e122dad54af$var$morphtarget_vertex,
    normal_fragment_begin: $824f5e122dad54af$var$normal_fragment_begin,
    normal_fragment_maps: $824f5e122dad54af$var$normal_fragment_maps,
    normal_pars_fragment: $824f5e122dad54af$var$normal_pars_fragment,
    normal_pars_vertex: $824f5e122dad54af$var$normal_pars_vertex,
    normal_vertex: $824f5e122dad54af$var$normal_vertex,
    normalmap_pars_fragment: $824f5e122dad54af$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $824f5e122dad54af$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $824f5e122dad54af$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $824f5e122dad54af$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $824f5e122dad54af$var$iridescence_pars_fragment,
    output_fragment: $824f5e122dad54af$var$output_fragment,
    packing: $824f5e122dad54af$var$packing,
    premultiplied_alpha_fragment: $824f5e122dad54af$var$premultiplied_alpha_fragment,
    project_vertex: $824f5e122dad54af$var$project_vertex,
    dithering_fragment: $824f5e122dad54af$var$dithering_fragment,
    dithering_pars_fragment: $824f5e122dad54af$var$dithering_pars_fragment,
    roughnessmap_fragment: $824f5e122dad54af$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $824f5e122dad54af$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $824f5e122dad54af$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $824f5e122dad54af$var$shadowmap_pars_vertex,
    shadowmap_vertex: $824f5e122dad54af$var$shadowmap_vertex,
    shadowmask_pars_fragment: $824f5e122dad54af$var$shadowmask_pars_fragment,
    skinbase_vertex: $824f5e122dad54af$var$skinbase_vertex,
    skinning_pars_vertex: $824f5e122dad54af$var$skinning_pars_vertex,
    skinning_vertex: $824f5e122dad54af$var$skinning_vertex,
    skinnormal_vertex: $824f5e122dad54af$var$skinnormal_vertex,
    specularmap_fragment: $824f5e122dad54af$var$specularmap_fragment,
    specularmap_pars_fragment: $824f5e122dad54af$var$specularmap_pars_fragment,
    tonemapping_fragment: $824f5e122dad54af$var$tonemapping_fragment,
    tonemapping_pars_fragment: $824f5e122dad54af$var$tonemapping_pars_fragment,
    transmission_fragment: $824f5e122dad54af$var$transmission_fragment,
    transmission_pars_fragment: $824f5e122dad54af$var$transmission_pars_fragment,
    uv_pars_fragment: $824f5e122dad54af$var$uv_pars_fragment,
    uv_pars_vertex: $824f5e122dad54af$var$uv_pars_vertex,
    uv_vertex: $824f5e122dad54af$var$uv_vertex,
    uv2_pars_fragment: $824f5e122dad54af$var$uv2_pars_fragment,
    uv2_pars_vertex: $824f5e122dad54af$var$uv2_pars_vertex,
    uv2_vertex: $824f5e122dad54af$var$uv2_vertex,
    worldpos_vertex: $824f5e122dad54af$var$worldpos_vertex,
    background_vert: $824f5e122dad54af$var$vertex$g,
    background_frag: $824f5e122dad54af$var$fragment$g,
    cube_vert: $824f5e122dad54af$var$vertex$f,
    cube_frag: $824f5e122dad54af$var$fragment$f,
    depth_vert: $824f5e122dad54af$var$vertex$e,
    depth_frag: $824f5e122dad54af$var$fragment$e,
    distanceRGBA_vert: $824f5e122dad54af$var$vertex$d,
    distanceRGBA_frag: $824f5e122dad54af$var$fragment$d,
    equirect_vert: $824f5e122dad54af$var$vertex$c,
    equirect_frag: $824f5e122dad54af$var$fragment$c,
    linedashed_vert: $824f5e122dad54af$var$vertex$b,
    linedashed_frag: $824f5e122dad54af$var$fragment$b,
    meshbasic_vert: $824f5e122dad54af$var$vertex$a,
    meshbasic_frag: $824f5e122dad54af$var$fragment$a,
    meshlambert_vert: $824f5e122dad54af$var$vertex$9,
    meshlambert_frag: $824f5e122dad54af$var$fragment$9,
    meshmatcap_vert: $824f5e122dad54af$var$vertex$8,
    meshmatcap_frag: $824f5e122dad54af$var$fragment$8,
    meshnormal_vert: $824f5e122dad54af$var$vertex$7,
    meshnormal_frag: $824f5e122dad54af$var$fragment$7,
    meshphong_vert: $824f5e122dad54af$var$vertex$6,
    meshphong_frag: $824f5e122dad54af$var$fragment$6,
    meshphysical_vert: $824f5e122dad54af$var$vertex$5,
    meshphysical_frag: $824f5e122dad54af$var$fragment$5,
    meshtoon_vert: $824f5e122dad54af$var$vertex$4,
    meshtoon_frag: $824f5e122dad54af$var$fragment$4,
    points_vert: $824f5e122dad54af$var$vertex$3,
    points_frag: $824f5e122dad54af$var$fragment$3,
    shadow_vert: $824f5e122dad54af$var$vertex$2,
    shadow_frag: $824f5e122dad54af$var$fragment$2,
    sprite_vert: $824f5e122dad54af$var$vertex$1,
    sprite_frag: $824f5e122dad54af$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $824f5e122dad54af$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        } // basic, lambert, phong
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918()
        }
    }
};
const $824f5e122dad54af$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.specularmap,
            $824f5e122dad54af$export$6643083551874bf5.envmap,
            $824f5e122dad54af$export$6643083551874bf5.aomap,
            $824f5e122dad54af$export$6643083551874bf5.lightmap,
            $824f5e122dad54af$export$6643083551874bf5.fog
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.specularmap,
            $824f5e122dad54af$export$6643083551874bf5.envmap,
            $824f5e122dad54af$export$6643083551874bf5.aomap,
            $824f5e122dad54af$export$6643083551874bf5.lightmap,
            $824f5e122dad54af$export$6643083551874bf5.emissivemap,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            $824f5e122dad54af$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.specularmap,
            $824f5e122dad54af$export$6643083551874bf5.envmap,
            $824f5e122dad54af$export$6643083551874bf5.aomap,
            $824f5e122dad54af$export$6643083551874bf5.lightmap,
            $824f5e122dad54af$export$6643083551874bf5.emissivemap,
            $824f5e122dad54af$export$6643083551874bf5.bumpmap,
            $824f5e122dad54af$export$6643083551874bf5.normalmap,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            $824f5e122dad54af$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.envmap,
            $824f5e122dad54af$export$6643083551874bf5.aomap,
            $824f5e122dad54af$export$6643083551874bf5.lightmap,
            $824f5e122dad54af$export$6643083551874bf5.emissivemap,
            $824f5e122dad54af$export$6643083551874bf5.bumpmap,
            $824f5e122dad54af$export$6643083551874bf5.normalmap,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            $824f5e122dad54af$export$6643083551874bf5.roughnessmap,
            $824f5e122dad54af$export$6643083551874bf5.metalnessmap,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            $824f5e122dad54af$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.aomap,
            $824f5e122dad54af$export$6643083551874bf5.lightmap,
            $824f5e122dad54af$export$6643083551874bf5.emissivemap,
            $824f5e122dad54af$export$6643083551874bf5.bumpmap,
            $824f5e122dad54af$export$6643083551874bf5.normalmap,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            $824f5e122dad54af$export$6643083551874bf5.gradientmap,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            $824f5e122dad54af$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.bumpmap,
            $824f5e122dad54af$export$6643083551874bf5.normalmap,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.points,
            $824f5e122dad54af$export$6643083551874bf5.fog
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.bumpmap,
            $824f5e122dad54af$export$6643083551874bf5.normalmap,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.sprite,
            $824f5e122dad54af$export$6643083551874bf5.fog
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.background_frag
    },
    cube: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.common,
            $824f5e122dad54af$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
            $824f5e122dad54af$export$6643083551874bf5.lights,
            $824f5e122dad54af$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.shadow_frag
    }
};
$824f5e122dad54af$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $824f5e122dad54af$var$mergeUniforms([
        $824f5e122dad54af$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(0x000000)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $824f5e122dad54af$export$955f9f2e84c43c8b.meshphysical_frag
};
function $824f5e122dad54af$var$WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === "additive") background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $824f5e122dad54af$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $824f5e122dad54af$export$e176487c05830cc5(new $824f5e122dad54af$export$ab3456a079aa7d80(1, 1, 1), new $824f5e122dad54af$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $824f5e122dad54af$var$cloneUniforms($824f5e122dad54af$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $824f5e122dad54af$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $824f5e122dad54af$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $824f5e122dad54af$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $824f5e122dad54af$export$e176487c05830cc5(new $824f5e122dad54af$export$e789a11a194ca4e0(2, 2), new $824f5e122dad54af$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $824f5e122dad54af$var$cloneUniforms($824f5e122dad54af$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $824f5e122dad54af$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $824f5e122dad54af$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $824f5e122dad54af$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $824f5e122dad54af$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $824f5e122dad54af$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $824f5e122dad54af$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $824f5e122dad54af$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $824f5e122dad54af$export$7ff5ac152ef991b0(), viewNormalMatrix = new $824f5e122dad54af$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $824f5e122dad54af$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $824f5e122dad54af$export$d64030b316d3b087) texture.mapping = $824f5e122dad54af$export$8759762a6477f2c4;
        else if (mapping === $824f5e122dad54af$export$ee99d97d46898098) texture.mapping = $824f5e122dad54af$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $824f5e122dad54af$export$d64030b316d3b087 || mapping === $824f5e122dad54af$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $824f5e122dad54af$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $824f5e122dad54af$export$9ebf355ee4ed261b extends $824f5e122dad54af$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $824f5e122dad54af$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $824f5e122dad54af$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $824f5e122dad54af$var$MAX_SAMPLES = 20;
const $824f5e122dad54af$var$_flatCamera = /*@__PURE__*/ new $824f5e122dad54af$export$9ebf355ee4ed261b();
const $824f5e122dad54af$var$_clearColor = /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e();
let $824f5e122dad54af$var$_oldTarget = null;
// Golden Ratio
const $824f5e122dad54af$var$PHI = (1 + Math.sqrt(5)) / 2;
const $824f5e122dad54af$var$INV_PHI = 1 / $824f5e122dad54af$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $824f5e122dad54af$var$_axisDirections = [
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, $824f5e122dad54af$var$PHI, $824f5e122dad54af$var$INV_PHI),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(0, $824f5e122dad54af$var$PHI, -$824f5e122dad54af$var$INV_PHI),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699($824f5e122dad54af$var$INV_PHI, 0, $824f5e122dad54af$var$PHI),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(-$824f5e122dad54af$var$INV_PHI, 0, $824f5e122dad54af$var$PHI),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699($824f5e122dad54af$var$PHI, $824f5e122dad54af$var$INV_PHI, 0),
    /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699(-$824f5e122dad54af$var$PHI, $824f5e122dad54af$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $824f5e122dad54af$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $824f5e122dad54af$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $824f5e122dad54af$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $824f5e122dad54af$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($824f5e122dad54af$var$_oldTarget);
        outputTarget.scissorTest = false;
        $824f5e122dad54af$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $824f5e122dad54af$export$8759762a6477f2c4 || texture.mapping === $824f5e122dad54af$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $824f5e122dad54af$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $824f5e122dad54af$export$8a72f490b25c56c8,
            minFilter: $824f5e122dad54af$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $824f5e122dad54af$export$2697304443f382bc,
            format: $824f5e122dad54af$export$3f8bb04b555a363c,
            encoding: $824f5e122dad54af$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $824f5e122dad54af$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $824f5e122dad54af$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $824f5e122dad54af$var$_createPlanes(_lodMax));
            this._blurMaterial = $824f5e122dad54af$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $824f5e122dad54af$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $824f5e122dad54af$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $824f5e122dad54af$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($824f5e122dad54af$var$_clearColor);
        renderer.toneMapping = $824f5e122dad54af$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $824f5e122dad54af$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $824f5e122dad54af$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $824f5e122dad54af$export$e176487c05830cc5(new $824f5e122dad54af$export$ab3456a079aa7d80(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($824f5e122dad54af$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $824f5e122dad54af$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $824f5e122dad54af$export$8759762a6477f2c4 || texture.mapping === $824f5e122dad54af$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $824f5e122dad54af$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $824f5e122dad54af$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $824f5e122dad54af$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $824f5e122dad54af$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $824f5e122dad54af$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $824f5e122dad54af$var$_axisDirections[(i - 1) % $824f5e122dad54af$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $824f5e122dad54af$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $824f5e122dad54af$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $824f5e122dad54af$var$MAX_SAMPLES;
        if (samples > $824f5e122dad54af$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$824f5e122dad54af$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $824f5e122dad54af$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $824f5e122dad54af$var$LOD_MIN ? lodOut - _lodMax + $824f5e122dad54af$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $824f5e122dad54af$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $824f5e122dad54af$var$_flatCamera);
    }
}
function $824f5e122dad54af$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $824f5e122dad54af$var$LOD_MIN + 1 + $824f5e122dad54af$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $824f5e122dad54af$var$LOD_MIN) sigma = $824f5e122dad54af$var$EXTRA_LOD_SIGMA[i - lodMax + $824f5e122dad54af$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $824f5e122dad54af$export$b7be63a67df8959();
        planes.setAttribute("position", new $824f5e122dad54af$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $824f5e122dad54af$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $824f5e122dad54af$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $824f5e122dad54af$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $824f5e122dad54af$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $824f5e122dad54af$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $824f5e122dad54af$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $824f5e122dad54af$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $824f5e122dad54af$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($824f5e122dad54af$var$MAX_SAMPLES);
    const poleAxis = new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $824f5e122dad54af$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $824f5e122dad54af$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $824f5e122dad54af$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $824f5e122dad54af$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $824f5e122dad54af$var$_getEquirectMaterial() {
    return new $824f5e122dad54af$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $824f5e122dad54af$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $824f5e122dad54af$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $824f5e122dad54af$var$_getCubemapMaterial() {
    return new $824f5e122dad54af$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $824f5e122dad54af$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $824f5e122dad54af$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $824f5e122dad54af$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $824f5e122dad54af$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $824f5e122dad54af$export$d64030b316d3b087 || mapping === $824f5e122dad54af$export$ee99d97d46898098;
            const isCubeMap = mapping === $824f5e122dad54af$export$8759762a6477f2c4 || mapping === $824f5e122dad54af$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $824f5e122dad54af$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $824f5e122dad54af$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $824f5e122dad54af$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $824f5e122dad54af$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($824f5e122dad54af$var$arrayNeedsUint32(indices) ? $824f5e122dad54af$export$7eb8c9fa25cd5bd6 : $824f5e122dad54af$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $824f5e122dad54af$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $824f5e122dad54af$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $824f5e122dad54af$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $824f5e122dad54af$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $824f5e122dad54af$var$denormalize(morph, attribute) {
    let denominator = 1;
    const array = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
    if (array instanceof Int8Array) denominator = 127;
    else if (array instanceof Uint8Array) denominator = 255;
    else if (array instanceof Uint16Array) denominator = 65535;
    else if (array instanceof Int16Array) denominator = 32767;
    else if (array instanceof Int32Array) denominator = 2147483647;
    else console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", array);
    morph.divideScalar(denominator);
}
function $824f5e122dad54af$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $824f5e122dad54af$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $824f5e122dad54af$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $824f5e122dad54af$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            if (morphTarget.normalized === true) $824f5e122dad54af$var$denormalize(morph, morphTarget);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            if (morphNormal.normalized === true) $824f5e122dad54af$var$denormalize(morph, morphNormal);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            if (morphColor.normalized === true) $824f5e122dad54af$var$denormalize(morph, morphColor);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $824f5e122dad54af$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($824f5e122dad54af$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($824f5e122dad54af$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $824f5e122dad54af$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $824f5e122dad54af$var$emptyTexture = /*@__PURE__*/ new $824f5e122dad54af$export$5431306cf43de24a();
const $824f5e122dad54af$var$emptyArrayTexture = /*@__PURE__*/ new $824f5e122dad54af$export$dfac6c8e811406a3();
const $824f5e122dad54af$var$empty3dTexture = /*@__PURE__*/ new $824f5e122dad54af$export$d7a3086320f856db();
const $824f5e122dad54af$var$emptyCubeTexture = /*@__PURE__*/ new $824f5e122dad54af$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $824f5e122dad54af$var$arrayCacheF32 = [];
const $824f5e122dad54af$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $824f5e122dad54af$var$mat4array = new Float32Array(16);
const $824f5e122dad54af$var$mat3array = new Float32Array(9);
const $824f5e122dad54af$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $824f5e122dad54af$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $824f5e122dad54af$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $824f5e122dad54af$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $824f5e122dad54af$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $824f5e122dad54af$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $824f5e122dad54af$var$allocTexUnits(textures, n) {
    let r = $824f5e122dad54af$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $824f5e122dad54af$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $824f5e122dad54af$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $824f5e122dad54af$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    }
}
function $824f5e122dad54af$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    }
}
function $824f5e122dad54af$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $824f5e122dad54af$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, elements)) return;
        $824f5e122dad54af$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $824f5e122dad54af$var$mat2array);
        $824f5e122dad54af$var$copyArray(cache, elements);
    }
}
function $824f5e122dad54af$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, elements)) return;
        $824f5e122dad54af$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $824f5e122dad54af$var$mat3array);
        $824f5e122dad54af$var$copyArray(cache, elements);
    }
}
function $824f5e122dad54af$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $824f5e122dad54af$var$copyArray(cache, v);
    } else {
        if ($824f5e122dad54af$var$arraysEqual(cache, elements)) return;
        $824f5e122dad54af$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $824f5e122dad54af$var$mat4array);
        $824f5e122dad54af$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $824f5e122dad54af$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $824f5e122dad54af$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
function $824f5e122dad54af$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
function $824f5e122dad54af$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
// Single unsigned integer
function $824f5e122dad54af$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $824f5e122dad54af$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
function $824f5e122dad54af$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
function $824f5e122dad54af$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($824f5e122dad54af$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $824f5e122dad54af$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $824f5e122dad54af$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $824f5e122dad54af$var$emptyTexture, unit);
}
function $824f5e122dad54af$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $824f5e122dad54af$var$empty3dTexture, unit);
}
function $824f5e122dad54af$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $824f5e122dad54af$var$emptyCubeTexture, unit);
}
function $824f5e122dad54af$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $824f5e122dad54af$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $824f5e122dad54af$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $824f5e122dad54af$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $824f5e122dad54af$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $824f5e122dad54af$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $824f5e122dad54af$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $824f5e122dad54af$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $824f5e122dad54af$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $824f5e122dad54af$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $824f5e122dad54af$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $824f5e122dad54af$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $824f5e122dad54af$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $824f5e122dad54af$var$setValueV4i; // _VEC4
        case 0x1405:
            return $824f5e122dad54af$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $824f5e122dad54af$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $824f5e122dad54af$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $824f5e122dad54af$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $824f5e122dad54af$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $824f5e122dad54af$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $824f5e122dad54af$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $824f5e122dad54af$var$setValueT2DArray1;
    }
}
// Array of scalars
function $824f5e122dad54af$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $824f5e122dad54af$var$setValueV2fArray(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $824f5e122dad54af$var$setValueV3fArray(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $824f5e122dad54af$var$setValueV4fArray(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $824f5e122dad54af$var$setValueM2Array(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $824f5e122dad54af$var$setValueM3Array(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $824f5e122dad54af$var$setValueM4Array(gl, v) {
    const data = $824f5e122dad54af$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $824f5e122dad54af$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $824f5e122dad54af$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $824f5e122dad54af$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $824f5e122dad54af$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $824f5e122dad54af$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $824f5e122dad54af$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $824f5e122dad54af$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $824f5e122dad54af$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $824f5e122dad54af$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $824f5e122dad54af$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $824f5e122dad54af$var$emptyTexture, units[i]);
}
function $824f5e122dad54af$var$setValueT3DArray(gl, v, textures) {
    const n = v.length;
    const units = $824f5e122dad54af$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $824f5e122dad54af$var$empty3dTexture, units[i]);
}
function $824f5e122dad54af$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $824f5e122dad54af$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $824f5e122dad54af$var$emptyCubeTexture, units[i]);
}
function $824f5e122dad54af$var$setValueT2DArrayArray(gl, v, textures) {
    const n = v.length;
    const units = $824f5e122dad54af$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $824f5e122dad54af$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $824f5e122dad54af$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $824f5e122dad54af$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $824f5e122dad54af$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $824f5e122dad54af$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $824f5e122dad54af$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $824f5e122dad54af$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $824f5e122dad54af$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $824f5e122dad54af$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $824f5e122dad54af$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $824f5e122dad54af$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $824f5e122dad54af$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $824f5e122dad54af$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $824f5e122dad54af$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $824f5e122dad54af$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $824f5e122dad54af$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $824f5e122dad54af$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $824f5e122dad54af$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $824f5e122dad54af$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $824f5e122dad54af$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $824f5e122dad54af$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $824f5e122dad54af$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $824f5e122dad54af$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $824f5e122dad54af$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $824f5e122dad54af$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $824f5e122dad54af$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $824f5e122dad54af$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $824f5e122dad54af$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $824f5e122dad54af$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $824f5e122dad54af$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $824f5e122dad54af$var$RePathPart.exec(path), matchEnd = $824f5e122dad54af$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $824f5e122dad54af$var$addUniform(container, subscript === undefined ? new $824f5e122dad54af$var$SingleUniform(id, activeInfo, addr) : new $824f5e122dad54af$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $824f5e122dad54af$var$StructuredUniform(id);
                $824f5e122dad54af$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $824f5e122dad54af$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, 35718);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $824f5e122dad54af$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $824f5e122dad54af$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $824f5e122dad54af$var$programIdCount = 0;
function $824f5e122dad54af$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $824f5e122dad54af$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $824f5e122dad54af$export$7207336e4151a112:
            return [
                "Linear",
                "( value )"
            ];
        case $824f5e122dad54af$export$f32388edbb32674:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $824f5e122dad54af$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $824f5e122dad54af$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $824f5e122dad54af$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $824f5e122dad54af$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $824f5e122dad54af$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $824f5e122dad54af$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $824f5e122dad54af$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $824f5e122dad54af$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $824f5e122dad54af$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $824f5e122dad54af$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $824f5e122dad54af$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($824f5e122dad54af$var$filterEmptyLine).join("\n");
}
function $824f5e122dad54af$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $824f5e122dad54af$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $824f5e122dad54af$var$filterEmptyLine(string) {
    return string !== "";
}
function $824f5e122dad54af$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $824f5e122dad54af$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $824f5e122dad54af$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $824f5e122dad54af$var$resolveIncludes(string) {
    return string.replace($824f5e122dad54af$var$includePattern, $824f5e122dad54af$var$includeReplacer);
}
function $824f5e122dad54af$var$includeReplacer(match, include) {
    const string = $824f5e122dad54af$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $824f5e122dad54af$var$resolveIncludes(string);
}
// Unroll Loops
const $824f5e122dad54af$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $824f5e122dad54af$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $824f5e122dad54af$var$unrollLoops(string) {
    return string.replace($824f5e122dad54af$var$unrollLoopPattern, $824f5e122dad54af$var$loopReplacer).replace($824f5e122dad54af$var$deprecatedUnrollLoopPattern, $824f5e122dad54af$var$deprecatedLoopReplacer);
}
function $824f5e122dad54af$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
    return $824f5e122dad54af$var$loopReplacer(match, start, end, snippet);
}
function $824f5e122dad54af$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $824f5e122dad54af$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $824f5e122dad54af$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $824f5e122dad54af$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $824f5e122dad54af$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $824f5e122dad54af$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $824f5e122dad54af$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $824f5e122dad54af$export$8759762a6477f2c4:
        case $824f5e122dad54af$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $824f5e122dad54af$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $824f5e122dad54af$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $824f5e122dad54af$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $824f5e122dad54af$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $824f5e122dad54af$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $824f5e122dad54af$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $824f5e122dad54af$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $824f5e122dad54af$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $824f5e122dad54af$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $824f5e122dad54af$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $824f5e122dad54af$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $824f5e122dad54af$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $824f5e122dad54af$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $824f5e122dad54af$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $824f5e122dad54af$var$generateExtensions(parameters);
    const customDefines = $824f5e122dad54af$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($824f5e122dad54af$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($824f5e122dad54af$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $824f5e122dad54af$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($824f5e122dad54af$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $824f5e122dad54af$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $824f5e122dad54af$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $824f5e122dad54af$export$9fcb6b4294603b2 ? $824f5e122dad54af$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $824f5e122dad54af$export$9fcb6b4294603b2 ? $824f5e122dad54af$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $824f5e122dad54af$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $824f5e122dad54af$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($824f5e122dad54af$var$filterEmptyLine).join("\n");
    }
    vertexShader = $824f5e122dad54af$var$resolveIncludes(vertexShader);
    vertexShader = $824f5e122dad54af$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $824f5e122dad54af$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $824f5e122dad54af$var$resolveIncludes(fragmentShader);
    fragmentShader = $824f5e122dad54af$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $824f5e122dad54af$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $824f5e122dad54af$var$unrollLoops(vertexShader);
    fragmentShader = $824f5e122dad54af$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $824f5e122dad54af$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $824f5e122dad54af$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $824f5e122dad54af$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $824f5e122dad54af$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $824f5e122dad54af$var$getShaderErrors(gl, glVertexShader, "vertex");
            const fragmentErrors = $824f5e122dad54af$var$getShaderErrors(gl, glFragmentShader, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $824f5e122dad54af$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $824f5e122dad54af$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $824f5e122dad54af$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $824f5e122dad54af$var$_id = 0;
class $824f5e122dad54af$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        if (cache.has(material) === false) cache.set(material, new Set());
        return cache.get(material);
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        if (cache.has(code) === false) {
            const stage = new $824f5e122dad54af$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return cache.get(code);
    }
}
class $824f5e122dad54af$var$WebGLShaderStage {
    constructor(code){
        this.id = $824f5e122dad54af$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $824f5e122dad54af$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $824f5e122dad54af$export$89312ce47c0ca777();
    const _customShaders = new $824f5e122dad54af$var$WebGLShaderCache();
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $824f5e122dad54af$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $824f5e122dad54af$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const useAlphaTest = material.alphaTest > 0;
        const useClearcoat = material.clearcoat > 0;
        const useIridescence = material.iridescence > 0;
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $824f5e122dad54af$export$7207336e4151a112,
            map: !!material.map,
            matcap: !!material.matcap,
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            lightMap: !!material.lightMap,
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $824f5e122dad54af$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $824f5e122dad54af$export$2852a58ebdac27b8,
            decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === $824f5e122dad54af$export$f32388edbb32674,
            clearcoat: useClearcoat,
            clearcoatMap: useClearcoat && !!material.clearcoatMap,
            clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
            iridescence: useIridescence,
            iridescenceMap: useIridescence && !!material.iridescenceMap,
            iridescenceThicknessMap: useIridescence && !!material.iridescenceThicknessMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            specularIntensityMap: !!material.specularIntensityMap,
            specularColorMap: !!material.specularColorMap,
            opaque: material.transparent === false && material.blending === $824f5e122dad54af$export$5b29a26d96ee6af0,
            alphaMap: !!material.alphaMap,
            alphaTest: useAlphaTest,
            gradientMap: !!material.gradientMap,
            sheen: material.sheen > 0,
            sheenColorMap: !!material.sheenColorMap,
            sheenRoughnessMap: !!material.sheenRoughnessMap,
            transmission: material.transmission > 0,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: !!material.normalMap && !!geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $824f5e122dad54af$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $824f5e122dad54af$export$3b296b6f144d5b03,
            flipSided: material.side === $824f5e122dad54af$export$d9f0486e75b5ace,
            useDepthPacking: !!material.depthPacking,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.combine);
        array.push(parameters.vertexUvs);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.map) _programLayers.enable(4);
        if (parameters.matcap) _programLayers.enable(5);
        if (parameters.envMap) _programLayers.enable(6);
        if (parameters.lightMap) _programLayers.enable(7);
        if (parameters.aoMap) _programLayers.enable(8);
        if (parameters.emissiveMap) _programLayers.enable(9);
        if (parameters.bumpMap) _programLayers.enable(10);
        if (parameters.normalMap) _programLayers.enable(11);
        if (parameters.objectSpaceNormalMap) _programLayers.enable(12);
        if (parameters.tangentSpaceNormalMap) _programLayers.enable(13);
        if (parameters.clearcoat) _programLayers.enable(14);
        if (parameters.clearcoatMap) _programLayers.enable(15);
        if (parameters.clearcoatRoughnessMap) _programLayers.enable(16);
        if (parameters.clearcoatNormalMap) _programLayers.enable(17);
        if (parameters.iridescence) _programLayers.enable(18);
        if (parameters.iridescenceMap) _programLayers.enable(19);
        if (parameters.iridescenceThicknessMap) _programLayers.enable(20);
        if (parameters.displacementMap) _programLayers.enable(21);
        if (parameters.specularMap) _programLayers.enable(22);
        if (parameters.roughnessMap) _programLayers.enable(23);
        if (parameters.metalnessMap) _programLayers.enable(24);
        if (parameters.gradientMap) _programLayers.enable(25);
        if (parameters.alphaMap) _programLayers.enable(26);
        if (parameters.alphaTest) _programLayers.enable(27);
        if (parameters.vertexColors) _programLayers.enable(28);
        if (parameters.vertexAlphas) _programLayers.enable(29);
        if (parameters.vertexUvs) _programLayers.enable(30);
        if (parameters.vertexTangents) _programLayers.enable(31);
        if (parameters.uvsVertexOnly) _programLayers.enable(32);
        if (parameters.fog) _programLayers.enable(33);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.useFog) _programLayers.enable(0);
        if (parameters.flatShading) _programLayers.enable(1);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(2);
        if (parameters.skinning) _programLayers.enable(3);
        if (parameters.morphTargets) _programLayers.enable(4);
        if (parameters.morphNormals) _programLayers.enable(5);
        if (parameters.morphColors) _programLayers.enable(6);
        if (parameters.premultipliedAlpha) _programLayers.enable(7);
        if (parameters.shadowMapEnabled) _programLayers.enable(8);
        if (parameters.physicallyCorrectLights) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.useDepthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.specularIntensityMap) _programLayers.enable(14);
        if (parameters.specularColorMap) _programLayers.enable(15);
        if (parameters.transmission) _programLayers.enable(16);
        if (parameters.transmissionMap) _programLayers.enable(17);
        if (parameters.thicknessMap) _programLayers.enable(18);
        if (parameters.sheen) _programLayers.enable(19);
        if (parameters.sheenColorMap) _programLayers.enable(20);
        if (parameters.sheenRoughnessMap) _programLayers.enable(21);
        if (parameters.decodeVideoTexture) _programLayers.enable(22);
        if (parameters.opaque) _programLayers.enable(23);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $824f5e122dad54af$export$bee4a7d47f8f5014[shaderID];
            uniforms = $824f5e122dad54af$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $824f5e122dad54af$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $824f5e122dad54af$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $824f5e122dad54af$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $824f5e122dad54af$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $824f5e122dad54af$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $824f5e122dad54af$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $824f5e122dad54af$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $824f5e122dad54af$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $824f5e122dad54af$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $824f5e122dad54af$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $824f5e122dad54af$var$WebGLRenderList();
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $824f5e122dad54af$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $824f5e122dad54af$export$64b5c384219d3699(),
                        color: new $824f5e122dad54af$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $824f5e122dad54af$export$64b5c384219d3699(),
                        direction: new $824f5e122dad54af$export$64b5c384219d3699(),
                        color: new $824f5e122dad54af$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $824f5e122dad54af$export$64b5c384219d3699(),
                        color: new $824f5e122dad54af$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $824f5e122dad54af$export$64b5c384219d3699(),
                        skyColor: new $824f5e122dad54af$export$892596cec99bc70e(),
                        groundColor: new $824f5e122dad54af$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $824f5e122dad54af$export$892596cec99bc70e(),
                        position: new $824f5e122dad54af$export$64b5c384219d3699(),
                        halfWidth: new $824f5e122dad54af$export$64b5c384219d3699(),
                        halfHeight: new $824f5e122dad54af$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $824f5e122dad54af$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $824f5e122dad54af$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $824f5e122dad54af$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $824f5e122dad54af$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $824f5e122dad54af$var$nextVersion = 0;
function $824f5e122dad54af$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $824f5e122dad54af$var$WebGLLights(extensions, capabilities) {
    const cache = new $824f5e122dad54af$var$UniformsCache();
    const shadowCache = $824f5e122dad54af$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $824f5e122dad54af$export$64b5c384219d3699());
    const vector3 = new $824f5e122dad54af$export$64b5c384219d3699();
    const matrix4 = new $824f5e122dad54af$export$2ae72fc923e5eb5();
    const matrix42 = new $824f5e122dad54af$export$2ae72fc923e5eb5();
    function setup(lights, physicallyCorrectLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($824f5e122dad54af$var$shadowCastingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $824f5e122dad54af$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $824f5e122dad54af$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $824f5e122dad54af$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $824f5e122dad54af$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $824f5e122dad54af$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $824f5e122dad54af$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $824f5e122dad54af$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $824f5e122dad54af$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $824f5e122dad54af$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(physicallyCorrectLights) {
        lights.setup(lightsArray, physicallyCorrectLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $824f5e122dad54af$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $824f5e122dad54af$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $824f5e122dad54af$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $824f5e122dad54af$export$2698c22ec13825db extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $824f5e122dad54af$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $824f5e122dad54af$export$33e187ed002f2a19 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.referencePosition = new $824f5e122dad54af$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $824f5e122dad54af$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $824f5e122dad54af$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $824f5e122dad54af$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $824f5e122dad54af$export$35efe6f4c85463d2();
    const _shadowMapSize = new $824f5e122dad54af$export$c977b3e384af9ae1(), _viewportSize = new $824f5e122dad54af$export$c977b3e384af9ae1(), _viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3(), _depthMaterial = new $824f5e122dad54af$export$2698c22ec13825db({
        depthPacking: $824f5e122dad54af$export$8f910f4c4f73df11
    }), _distanceMaterial = new $824f5e122dad54af$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $824f5e122dad54af$export$d9f0486e75b5ace,
        1: $824f5e122dad54af$export$2ede184fc2998901,
        2: $824f5e122dad54af$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $824f5e122dad54af$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $824f5e122dad54af$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $824f5e122dad54af$var$vertex,
        fragmentShader: $824f5e122dad54af$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $824f5e122dad54af$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $824f5e122dad54af$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $824f5e122dad54af$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $824f5e122dad54af$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($824f5e122dad54af$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null) {
                const pars = this.type !== $824f5e122dad54af$export$896ae1ade6c829c4 ? {
                    minFilter: $824f5e122dad54af$export$727aa5ec3fe39bf0,
                    magFilter: $824f5e122dad54af$export$727aa5ec3fe39bf0
                } : {};
                shadow.map = new $824f5e122dad54af$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $824f5e122dad54af$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $824f5e122dad54af$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $824f5e122dad54af$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $824f5e122dad54af$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $824f5e122dad54af$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $824f5e122dad54af$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $824f5e122dad54af$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $824f5e122dad54af$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $824f5e122dad54af$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $824f5e122dad54af$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $824f5e122dad54af$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $824f5e122dad54af$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $824f5e122dad54af$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $824f5e122dad54af$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $824f5e122dad54af$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $824f5e122dad54af$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($824f5e122dad54af$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($824f5e122dad54af$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($824f5e122dad54af$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$824f5e122dad54af$export$20183a0484ce21a0]: 32774,
        [$824f5e122dad54af$export$73e0df5177988548]: 32778,
        [$824f5e122dad54af$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$824f5e122dad54af$export$c8c1508da8d0600c] = 32775;
        equationToGL[$824f5e122dad54af$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$824f5e122dad54af$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$824f5e122dad54af$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$824f5e122dad54af$export$2110f05edf778d3d]: 0,
        [$824f5e122dad54af$export$8805bad65e24940e]: 1,
        [$824f5e122dad54af$export$7fbe15b28d28cf52]: 768,
        [$824f5e122dad54af$export$d5773124e86cf28c]: 770,
        [$824f5e122dad54af$export$c05e2a1fc8609506]: 776,
        [$824f5e122dad54af$export$ef5f2dd8ffac5574]: 774,
        [$824f5e122dad54af$export$a78aed1ca2a87192]: 772,
        [$824f5e122dad54af$export$947829af9f2c17f6]: 769,
        [$824f5e122dad54af$export$11d468cc7f19e971]: 771,
        [$824f5e122dad54af$export$56b85b2686ab16]: 775,
        [$824f5e122dad54af$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $824f5e122dad54af$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $824f5e122dad54af$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $824f5e122dad54af$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $824f5e122dad54af$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $824f5e122dad54af$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $824f5e122dad54af$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $824f5e122dad54af$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $824f5e122dad54af$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $824f5e122dad54af$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $824f5e122dad54af$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $824f5e122dad54af$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $824f5e122dad54af$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $824f5e122dad54af$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $824f5e122dad54af$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $824f5e122dad54af$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $824f5e122dad54af$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $824f5e122dad54af$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($824f5e122dad54af$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $824f5e122dad54af$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $824f5e122dad54af$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $824f5e122dad54af$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $824f5e122dad54af$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $824f5e122dad54af$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $824f5e122dad54af$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $824f5e122dad54af$var$isPowerOfTwo(image.width) && $824f5e122dad54af$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $824f5e122dad54af$export$9d9334239a5a5e06 || texture.wrapT !== $824f5e122dad54af$export$9d9334239a5a5e06 || texture.minFilter !== $824f5e122dad54af$export$727aa5ec3fe39bf0 && texture.minFilter !== $824f5e122dad54af$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $824f5e122dad54af$export$727aa5ec3fe39bf0 && texture.minFilter !== $824f5e122dad54af$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $824f5e122dad54af$export$f32388edbb32674 && isVideoTexture === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $824f5e122dad54af$export$727aa5ec3fe39bf0 && texture.minFilter !== $824f5e122dad54af$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $824f5e122dad54af$export$727aa5ec3fe39bf0 || f === $824f5e122dad54af$export$d129e38cf6feaa8c || f === $824f5e122dad54af$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.encoding);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$824f5e122dad54af$export$533346c8e8dac0f5]: 10497,
        [$824f5e122dad54af$export$9d9334239a5a5e06]: 33071,
        [$824f5e122dad54af$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$824f5e122dad54af$export$727aa5ec3fe39bf0]: 9728,
        [$824f5e122dad54af$export$d129e38cf6feaa8c]: 9984,
        [$824f5e122dad54af$export$d2327c1afe5bfdf2]: 9986,
        [$824f5e122dad54af$export$8a72f490b25c56c8]: 9729,
        [$824f5e122dad54af$export$19a719f377145a13]: 9985,
        [$824f5e122dad54af$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $824f5e122dad54af$export$9d9334239a5a5e06 || texture.wrapT !== $824f5e122dad54af$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $824f5e122dad54af$export$727aa5ec3fe39bf0 && texture.minFilter !== $824f5e122dad54af$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.type === $824f5e122dad54af$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $824f5e122dad54af$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataArrayTexture) textureType = 35866;
        if (texture.isData3DTexture) textureType = 32879;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = 6402;
                if (isWebGL2) {
                    if (texture.type === $824f5e122dad54af$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (texture.type === $824f5e122dad54af$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                    else if (texture.type === $824f5e122dad54af$export$6c8ea339bfab1301) glInternalFormat = 35056;
                    else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $824f5e122dad54af$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $824f5e122dad54af$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $824f5e122dad54af$export$c63dc51868b06a9d && texture.type !== $824f5e122dad54af$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $824f5e122dad54af$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $824f5e122dad54af$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = 34041;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $824f5e122dad54af$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $824f5e122dad54af$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (texture.format !== $824f5e122dad54af$export$3f8bb04b555a363c) {
                        if (glFormat !== null) {
                            if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                            else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                    } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(3553, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(34067, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $824f5e122dad54af$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(34067);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $824f5e122dad54af$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $824f5e122dad54af$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.encoding);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $824f5e122dad54af$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $824f5e122dad54af$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(36161, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(36160, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = 16384;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
            }
            state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(36064 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(36008, invalidationArray);
            }
            state.bindFramebuffer(36008, null);
            state.bindFramebuffer(36009, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, webglTexture, 0);
            }
            state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $824f5e122dad54af$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $824f5e122dad54af$export$7207336e4151a112) {
            // sRGB
            if (encoding === $824f5e122dad54af$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $824f5e122dad54af$export$3f8bb04b555a363c) {
                        texture.format = $824f5e122dad54af$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $824f5e122dad54af$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $824f5e122dad54af$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $824f5e122dad54af$export$3f8bb04b555a363c || type !== $824f5e122dad54af$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture encoding:", encoding);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $824f5e122dad54af$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $824f5e122dad54af$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $824f5e122dad54af$export$b3969b01faf587f2) return 32819;
        if (p === $824f5e122dad54af$export$18886f8ae33e90de) return 32820;
        if (p === $824f5e122dad54af$export$545fce0311a9796a) return 5120;
        if (p === $824f5e122dad54af$export$88572337f312435f) return 5122;
        if (p === $824f5e122dad54af$export$c63dc51868b06a9d) return 5123;
        if (p === $824f5e122dad54af$export$5c612977753abe2) return 5124;
        if (p === $824f5e122dad54af$export$c3c7fc4518ebba96) return 5125;
        if (p === $824f5e122dad54af$export$f6d331659b644596) return 5126;
        if (p === $824f5e122dad54af$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $824f5e122dad54af$export$988473390501ed4b) return 6406;
        if (p === $824f5e122dad54af$export$3f8bb04b555a363c) return 6408;
        if (p === $824f5e122dad54af$export$cc09ccbf6d1ed449) return 6409;
        if (p === $824f5e122dad54af$export$9053a81c4a69c289) return 6410;
        if (p === $824f5e122dad54af$export$c1b6b5136be58045) return 6402;
        if (p === $824f5e122dad54af$export$1e113ac2d0905829) return 34041;
        if (p === $824f5e122dad54af$export$4e041a7967d15c4b) return 6403;
        if (p === $824f5e122dad54af$export$7c67423a5ee6f5eb) {
            console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228");
            return 6408;
        }
        // WebGL 1 sRGB fallback
        if (p === $824f5e122dad54af$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $824f5e122dad54af$export$aa92e870a709d190) return 36244;
        if (p === $824f5e122dad54af$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $824f5e122dad54af$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $824f5e122dad54af$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $824f5e122dad54af$export$21d1799c6d552fc0 || p === $824f5e122dad54af$export$afa304c3e981b668 || p === $824f5e122dad54af$export$d2a1a68024a3e56c || p === $824f5e122dad54af$export$9a79c424327dacf9) {
            if (encoding === $824f5e122dad54af$export$f32388edbb32674) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $824f5e122dad54af$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $824f5e122dad54af$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $824f5e122dad54af$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $824f5e122dad54af$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $824f5e122dad54af$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $824f5e122dad54af$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $824f5e122dad54af$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $824f5e122dad54af$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $824f5e122dad54af$export$19ada9bbb1af3573 || p === $824f5e122dad54af$export$d0f0355bb3d948e4 || p === $824f5e122dad54af$export$b82296714358084c || p === $824f5e122dad54af$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $824f5e122dad54af$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $824f5e122dad54af$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $824f5e122dad54af$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $824f5e122dad54af$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $824f5e122dad54af$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $824f5e122dad54af$export$7800993ef8106a6a || p === $824f5e122dad54af$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $824f5e122dad54af$export$7800993ef8106a6a) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $824f5e122dad54af$export$23ed8300a860e7d8) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $824f5e122dad54af$export$dc5570b4a2b92d48 || p === $824f5e122dad54af$export$68880cd325f8b2fb || p === $824f5e122dad54af$export$7d2c0be323373d95 || p === $824f5e122dad54af$export$22b52da301fc3a3e || p === $824f5e122dad54af$export$c009e2cb4a66485e || p === $824f5e122dad54af$export$118fff5afa255b63 || p === $824f5e122dad54af$export$120713c829ae0667 || p === $824f5e122dad54af$export$c79eeabbf53313e9 || p === $824f5e122dad54af$export$443cf6567cdd6424 || p === $824f5e122dad54af$export$6573984fc9840780 || p === $824f5e122dad54af$export$e7aee563f30091de || p === $824f5e122dad54af$export$2eb8634622ddeab7 || p === $824f5e122dad54af$export$202b1ce7b5d25742 || p === $824f5e122dad54af$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $824f5e122dad54af$export$dc5570b4a2b92d48) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $824f5e122dad54af$export$68880cd325f8b2fb) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $824f5e122dad54af$export$7d2c0be323373d95) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $824f5e122dad54af$export$22b52da301fc3a3e) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $824f5e122dad54af$export$c009e2cb4a66485e) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $824f5e122dad54af$export$118fff5afa255b63) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $824f5e122dad54af$export$120713c829ae0667) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $824f5e122dad54af$export$c79eeabbf53313e9) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $824f5e122dad54af$export$443cf6567cdd6424) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $824f5e122dad54af$export$6573984fc9840780) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $824f5e122dad54af$export$e7aee563f30091de) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $824f5e122dad54af$export$2eb8634622ddeab7) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $824f5e122dad54af$export$202b1ce7b5d25742) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $824f5e122dad54af$export$18ab77abd087e467) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $824f5e122dad54af$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $824f5e122dad54af$export$ce40b115e188bc81) return encoding === $824f5e122dad54af$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        //
        if (p === $824f5e122dad54af$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $824f5e122dad54af$export$56b937d9e5581166 extends $824f5e122dad54af$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $824f5e122dad54af$export$eb2fcfdbd7ba97d4 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $824f5e122dad54af$var$_moveEvent = {
    type: "move"
};
class $824f5e122dad54af$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $824f5e122dad54af$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $824f5e122dad54af$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $824f5e122dad54af$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $824f5e122dad54af$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $824f5e122dad54af$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $824f5e122dad54af$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $824f5e122dad54af$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $824f5e122dad54af$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($824f5e122dad54af$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $824f5e122dad54af$export$fc830aa069cc8c2f extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $824f5e122dad54af$export$c1b6b5136be58045;
        if (format !== $824f5e122dad54af$export$c1b6b5136be58045 && format !== $824f5e122dad54af$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $824f5e122dad54af$export$c1b6b5136be58045) type = $824f5e122dad54af$export$c3c7fc4518ebba96;
        if (type === undefined && format === $824f5e122dad54af$export$1e113ac2d0905829) type = $824f5e122dad54af$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
class $824f5e122dad54af$var$WebXRManager extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $824f5e122dad54af$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3();
        const cameraR = new $824f5e122dad54af$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $824f5e122dad54af$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $824f5e122dad54af$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $824f5e122dad54af$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $824f5e122dad54af$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $824f5e122dad54af$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $824f5e122dad54af$export$3f8bb04b555a363c,
                        type: $824f5e122dad54af$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $824f5e122dad54af$export$1e113ac2d0905829 : $824f5e122dad54af$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $824f5e122dad54af$export$6c8ea339bfab1301 : $824f5e122dad54af$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $824f5e122dad54af$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $824f5e122dad54af$export$3f8bb04b555a363c,
                        type: $824f5e122dad54af$export$2e8ce08d3f6f5e10,
                        depthTexture: new $824f5e122dad54af$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        encoding: renderer.outputEncoding,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.
                this.setFoveation(1.0);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].dispatchEvent({
                        type: "disconnected",
                        data: inputSource
                    });
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.dispatchEvent({
                    type: "connected",
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $824f5e122dad54af$export$64b5c384219d3699();
        const cameraRPos = new $824f5e122dad54af$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer !== null) return glProjLayer.fixedFoveation;
            if (glBaseLayer !== null) return glBaseLayer.fixedFoveation;
            return undefined;
        };
        this.setFoveation = function(foveation) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            if (glProjLayer !== null) glProjLayer.fixedFoveation = foveation;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = foveation;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $824f5e122dad54af$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            xrFrame = null;
        }
        const animation = new $824f5e122dad54af$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $824f5e122dad54af$var$WebGLMaterials(renderer, properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $824f5e122dad54af$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $824f5e122dad54af$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        // 13. iridescence map
        // 14. iridescence thickness map
        // 15. specular intensity map
        // 16. specular tint map
        // 17. transmission map
        // 18. thickness map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        else if (material.iridescenceMap) uvScaleMap = material.iridescenceMap;
        else if (material.iridescenceThicknessMap) uvScaleMap = material.iridescenceThicknessMap;
        else if (material.specularIntensityMap) uvScaleMap = material.specularIntensityMap;
        else if (material.specularColorMap) uvScaleMap = material.specularColorMap;
        else if (material.transmissionMap) uvScaleMap = material.transmissionMap;
        else if (material.thicknessMap) uvScaleMap = material.thicknessMap;
        else if (material.sheenColorMap) uvScaleMap = material.sheenColorMap;
        else if (material.sheenRoughnessMap) uvScaleMap = material.sheenRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) uniforms.sheenColorMap.value = material.sheenColorMap;
            if (material.sheenRoughnessMap) uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
            if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                if (material.side === $824f5e122dad54af$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) uniforms.iridescenceMap.value = material.iridescenceMap;
            if (material.iridescenceThicknessMap) uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularIntensityMap) uniforms.specularIntensityMap.value = material.specularIntensityMap;
        if (material.specularColorMap) uniforms.specularColorMap.value = material.specularColorMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $824f5e122dad54af$var$createCanvasElement() {
    const canvas = $824f5e122dad54af$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
function $824f5e122dad54af$export$f6cc00ef28d7cf97(parameters = {}) {
    this.isWebGLRenderer = true;
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $824f5e122dad54af$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let _alpha;
    if (_context !== null) _alpha = _context.getContextAttributes().alpha;
    else _alpha = parameters.alpha !== undefined ? parameters.alpha : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.outputEncoding = $824f5e122dad54af$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $824f5e122dad54af$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    //
    Object.defineProperties(this, {
        // @deprecated since r136, 0e21088102b4de7e0a0a33140620b7a3424b9e6d
        gammaFactor: {
            get: function() {
                console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
                return 2;
            },
            set: function() {
                console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
            }
        }
    });
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $824f5e122dad54af$export$fa7daccca11cdbe3();
    const _currentScissor = new $824f5e122dad54af$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new $824f5e122dad54af$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $824f5e122dad54af$export$2ae72fc923e5eb5();
    const _vector2 = new $824f5e122dad54af$export$c977b3e384af9ae1();
    const _vector3 = new $824f5e122dad54af$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: true,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // OffscreenCanvas does not have setAttribute, see #22811
        if ("setAttribute" in _canvas) _canvas.setAttribute("data-engine", `three.js r${$824f5e122dad54af$export$3545e07a80636437}`);
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener("webglcontextlost", onContextLost, false);
        _canvas.addEventListener("webglcontextrestored", onContextRestore, false);
        _canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
        if (_gl === null) {
            const contextNames = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                else throw new Error("Error creating WebGL context.");
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                "rangeMin": 1,
                "rangeMax": 1,
                "precision": 1
            };
        };
    } catch (error) {
        console.error("THREE.WebGLRenderer: " + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new $824f5e122dad54af$var$WebGLExtensions(_gl);
        capabilities = new $824f5e122dad54af$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $824f5e122dad54af$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $824f5e122dad54af$var$WebGLState(_gl, extensions, capabilities);
        info = new $824f5e122dad54af$var$WebGLInfo();
        properties = new $824f5e122dad54af$var$WebGLProperties();
        textures = new $824f5e122dad54af$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $824f5e122dad54af$var$WebGLCubeMaps(_this);
        cubeuvmaps = new $824f5e122dad54af$var$WebGLCubeUVMaps(_this);
        attributes = new $824f5e122dad54af$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $824f5e122dad54af$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $824f5e122dad54af$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $824f5e122dad54af$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $824f5e122dad54af$var$WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new $824f5e122dad54af$var$WebGLClipping(properties);
        programCache = new $824f5e122dad54af$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new $824f5e122dad54af$var$WebGLMaterials(_this, properties);
        renderLists = new $824f5e122dad54af$var$WebGLRenderLists();
        renderStates = new $824f5e122dad54af$var$WebGLRenderStates(extensions, capabilities);
        background = new $824f5e122dad54af$var$WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
        shadowMap = new $824f5e122dad54af$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $824f5e122dad54af$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $824f5e122dad54af$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $824f5e122dad54af$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + "px";
            _canvas.style.height = height + "px";
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color = true, depth = true, stencil = true) {
        let bits = 0;
        if (color) bits |= 16384;
        if (depth) bits |= 256;
        if (stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener("webglcontextlost", onContextLost, false);
        _canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
        _canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        programCache.dispose();
        xr.dispose();
        xr.removeEventListener("sessionstart", onXRSessionStart);
        xr.removeEventListener("sessionend", onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log("THREE.WebGLRenderer: Context Lost.");
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log("THREE.WebGLRenderer: Context Restored.");
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onContextCreationError(event) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) {
            programs.forEach(function(program) {
                programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) programCache.releaseShaderCache(material);
        }
    }
    // Buffer rendering
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
        renderStateStack.pop();
        currentRenderState = null;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $824f5e122dad54af$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof self !== "undefined") animation.setContext(self);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            for(let i = 0, l = cameras.length; i < l; i++){
                const camera2 = cameras[i];
                renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
        } else renderScene(currentRenderList, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderScene(currentRenderList, scene, camera, viewport) {
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        currentRenderState.setupLightsView(camera);
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
    }
    function renderTransmissionPass(opaqueObjects, scene, camera) {
        const isWebGL2 = capabilities.isWebGL2;
        if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $824f5e122dad54af$export$3c052beb2e51e23f(1, 1, {
            generateMipmaps: true,
            type: extensions.has("EXT_color_buffer_half_float") ? $824f5e122dad54af$export$2697304443f382bc : $824f5e122dad54af$export$2e8ce08d3f6f5e10,
            minFilter: $824f5e122dad54af$export$5d8599b6a933fb1b,
            samples: isWebGL2 && _antialias === true ? 4 : 0
        });
        _this.getDrawingBufferSize(_vector2);
        if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
        else _transmissionRenderTarget.setSize($824f5e122dad54af$var$floorPowerOfTwo(_vector2.x), $824f5e122dad54af$var$floorPowerOfTwo(_vector2.y));
        //
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $824f5e122dad54af$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === $824f5e122dad54af$export$3b296b6f144d5b03) {
            material.side = $824f5e122dad54af$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $824f5e122dad54af$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $824f5e122dad54af$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener("dispose", onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(object, parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $824f5e122dad54af$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.morphTargets = parameters.morphTargets;
        materialProperties.morphNormals = parameters.morphNormals;
        materialProperties.morphColors = parameters.morphColors;
        materialProperties.morphTargetsCount = parameters.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
        materialProperties.vertexTangents = parameters.vertexTangents;
        materialProperties.toneMapping = parameters.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $824f5e122dad54af$export$7207336e4151a112;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphColors = !!geometry.morphAttributes.color;
        const toneMapping = material.toneMapped ? _this.toneMapping : $824f5e122dad54af$export$9fcb6b4294603b2;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
            else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
            else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
            else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
            else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
            else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
            else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        }
        // skinning and morph target uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone and morph texture must go before other textures
        // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, "bindMatrix");
            p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
            }
        }
        const morphAttributes = geometry.morphAttributes;
        if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, material, program);
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $824f5e122dad54af$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $824f5e122dad54af$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
        // common matrices
        p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
        p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
        p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__hasExternalTextures = true;
        if (renderTargetProperties.__hasExternalTextures) {
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                    console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                // We need to make sure to rebind the framebuffer.
                state.bindFramebuffer(36160, null);
                useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
            else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        }
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isData3DTexture || texture.isDataArrayTexture) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
        _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $824f5e122dad54af$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                const halfFloatSupportedByExt = textureType === $824f5e122dad54af$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                if (textureType !== $824f5e122dad54af$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $824f5e122dad54af$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isData3DTexture) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataArrayTexture) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
        else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
        else if (texture.isDataArrayTexture) textures.setTexture2DArray(texture, 0);
        else textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
class $824f5e122dad54af$export$a2f65229194348f9 extends $824f5e122dad54af$export$f6cc00ef28d7cf97 {
}
$824f5e122dad54af$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $824f5e122dad54af$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $824f5e122dad54af$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $824f5e122dad54af$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $824f5e122dad54af$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $824f5e122dad54af$export$38af1803e3442a7f extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
class $824f5e122dad54af$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $824f5e122dad54af$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $824f5e122dad54af$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $824f5e122dad54af$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $824f5e122dad54af$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $824f5e122dad54af$var$_vector$6 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $824f5e122dad54af$var$_vector$6.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$6.x, $824f5e122dad54af$var$_vector$6.y, $824f5e122dad54af$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$6.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$6.x, $824f5e122dad54af$var$_vector$6.y, $824f5e122dad54af$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $824f5e122dad54af$var$_vector$6.fromBufferAttribute(this, i);
            $824f5e122dad54af$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $824f5e122dad54af$var$_vector$6.x, $824f5e122dad54af$var$_vector$6.y, $824f5e122dad54af$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $824f5e122dad54af$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $824f5e122dad54af$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $824f5e122dad54af$export$5ec7dd1c6994bf8e extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $824f5e122dad54af$var$_geometry;
const $824f5e122dad54af$var$_intersectPoint = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_worldScale = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_mvPosition = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_alignedPosition = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_rotatedPosition = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_viewWorldMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_vA = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vB = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_vC = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_uvA = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_uvB = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
const $824f5e122dad54af$var$_uvC = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
class $824f5e122dad54af$export$3075603db8e6204c extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($824f5e122dad54af$var$_geometry === undefined) {
            $824f5e122dad54af$var$_geometry = new $824f5e122dad54af$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $824f5e122dad54af$export$3d5cd879f108f53f(float32Array, 5);
            $824f5e122dad54af$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $824f5e122dad54af$var$_geometry.setAttribute("position", new $824f5e122dad54af$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $824f5e122dad54af$var$_geometry.setAttribute("uv", new $824f5e122dad54af$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $824f5e122dad54af$var$_geometry;
        this.material = material !== undefined ? material : new $824f5e122dad54af$export$5ec7dd1c6994bf8e();
        this.center = new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $824f5e122dad54af$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $824f5e122dad54af$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $824f5e122dad54af$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $824f5e122dad54af$var$_worldScale.multiplyScalar(-$824f5e122dad54af$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $824f5e122dad54af$var$transformVertex($824f5e122dad54af$var$_vA.set(-0.5, -0.5, 0), $824f5e122dad54af$var$_mvPosition, center, $824f5e122dad54af$var$_worldScale, sin, cos);
        $824f5e122dad54af$var$transformVertex($824f5e122dad54af$var$_vB.set(0.5, -0.5, 0), $824f5e122dad54af$var$_mvPosition, center, $824f5e122dad54af$var$_worldScale, sin, cos);
        $824f5e122dad54af$var$transformVertex($824f5e122dad54af$var$_vC.set(0.5, 0.5, 0), $824f5e122dad54af$var$_mvPosition, center, $824f5e122dad54af$var$_worldScale, sin, cos);
        $824f5e122dad54af$var$_uvA.set(0, 0);
        $824f5e122dad54af$var$_uvB.set(1, 0);
        $824f5e122dad54af$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($824f5e122dad54af$var$_vA, $824f5e122dad54af$var$_vB, $824f5e122dad54af$var$_vC, false, $824f5e122dad54af$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $824f5e122dad54af$var$transformVertex($824f5e122dad54af$var$_vB.set(-0.5, 0.5, 0), $824f5e122dad54af$var$_mvPosition, center, $824f5e122dad54af$var$_worldScale, sin, cos);
            $824f5e122dad54af$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($824f5e122dad54af$var$_vA, $824f5e122dad54af$var$_vC, $824f5e122dad54af$var$_vB, false, $824f5e122dad54af$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($824f5e122dad54af$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $824f5e122dad54af$var$_intersectPoint.clone(),
            uv: $824f5e122dad54af$export$5a465592bfe74b48.getUV($824f5e122dad54af$var$_intersectPoint, $824f5e122dad54af$var$_vA, $824f5e122dad54af$var$_vB, $824f5e122dad54af$var$_vC, $824f5e122dad54af$var$_uvA, $824f5e122dad54af$var$_uvB, $824f5e122dad54af$var$_uvC, new $824f5e122dad54af$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $824f5e122dad54af$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $824f5e122dad54af$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $824f5e122dad54af$var$_rotatedPosition.x = cos * $824f5e122dad54af$var$_alignedPosition.x - sin * $824f5e122dad54af$var$_alignedPosition.y;
        $824f5e122dad54af$var$_rotatedPosition.y = sin * $824f5e122dad54af$var$_alignedPosition.x + cos * $824f5e122dad54af$var$_alignedPosition.y;
    } else $824f5e122dad54af$var$_rotatedPosition.copy($824f5e122dad54af$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $824f5e122dad54af$var$_rotatedPosition.x;
    vertexPosition.y += $824f5e122dad54af$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($824f5e122dad54af$var$_viewWorldMatrix);
}
const $824f5e122dad54af$var$_v1$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v2$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$112e7237be0c5f30 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $824f5e122dad54af$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($824f5e122dad54af$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $824f5e122dad54af$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $824f5e122dad54af$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $824f5e122dad54af$var$_v1$2.distanceTo($824f5e122dad54af$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $824f5e122dad54af$var$_basePosition = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_skinIndex = /*@__PURE__*/ new $824f5e122dad54af$export$fa7daccca11cdbe3();
const $824f5e122dad54af$var$_skinWeight = /*@__PURE__*/ new $824f5e122dad54af$export$fa7daccca11cdbe3();
const $824f5e122dad54af$var$_vector$5 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_matrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
class $824f5e122dad54af$export$b303577035157ecf extends $824f5e122dad54af$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $824f5e122dad54af$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $824f5e122dad54af$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $824f5e122dad54af$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $824f5e122dad54af$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $824f5e122dad54af$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $824f5e122dad54af$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $824f5e122dad54af$var$_skinIndex.getComponent(i);
                $824f5e122dad54af$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($824f5e122dad54af$var$_vector$5.copy($824f5e122dad54af$var$_basePosition).applyMatrix4($824f5e122dad54af$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
class $824f5e122dad54af$export$b127726e56765aa4 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $824f5e122dad54af$export$b691f601014eabe1 extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0, minFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $824f5e122dad54af$var$_offsetMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_identityMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
class $824f5e122dad54af$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $824f5e122dad54af$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $824f5e122dad54af$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $824f5e122dad54af$var$_identityMatrix;
            $824f5e122dad54af$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $824f5e122dad54af$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $824f5e122dad54af$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $824f5e122dad54af$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $824f5e122dad54af$export$b691f601014eabe1(boneMatrices, size, size, $824f5e122dad54af$export$3f8bb04b555a363c, $824f5e122dad54af$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $824f5e122dad54af$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $824f5e122dad54af$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $824f5e122dad54af$export$32ea87a8b54d744a extends $824f5e122dad54af$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        if (typeof normalized === "number") {
            meshPerAttribute = normalized;
            normalized = false;
            console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
        }
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $824f5e122dad54af$var$_instanceLocalMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_instanceWorldMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_instanceIntersects = [];
const $824f5e122dad54af$var$_mesh = /*@__PURE__*/ new $824f5e122dad54af$export$e176487c05830cc5();
class $824f5e122dad54af$export$f3c979c331175ad7 extends $824f5e122dad54af$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $824f5e122dad54af$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $824f5e122dad54af$var$_mesh.geometry = this.geometry;
        $824f5e122dad54af$var$_mesh.material = this.material;
        if ($824f5e122dad54af$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $824f5e122dad54af$var$_instanceLocalMatrix);
            $824f5e122dad54af$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $824f5e122dad54af$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $824f5e122dad54af$var$_mesh.matrixWorld = $824f5e122dad54af$var$_instanceWorldMatrix;
            $824f5e122dad54af$var$_mesh.raycast(raycaster, $824f5e122dad54af$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $824f5e122dad54af$var$_instanceIntersects.length; i < l; i++){
                const intersect = $824f5e122dad54af$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $824f5e122dad54af$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $824f5e122dad54af$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $824f5e122dad54af$export$fbaaa33907730a0c extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $824f5e122dad54af$var$_start$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_end$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_inverseMatrix$1 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_ray$1 = /*@__PURE__*/ new $824f5e122dad54af$export$a186db52eed6d40e();
const $824f5e122dad54af$var$_sphere$1 = /*@__PURE__*/ new $824f5e122dad54af$export$805e8b72413ccaba();
class $824f5e122dad54af$export$17d680238e50603e extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(geometry = new $824f5e122dad54af$export$b7be63a67df8959(), material = new $824f5e122dad54af$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $824f5e122dad54af$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $824f5e122dad54af$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $824f5e122dad54af$var$_start$1.distanceTo($824f5e122dad54af$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $824f5e122dad54af$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $824f5e122dad54af$var$_sphere$1.copy(geometry.boundingSphere);
        $824f5e122dad54af$var$_sphere$1.applyMatrix4(matrixWorld);
        $824f5e122dad54af$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($824f5e122dad54af$var$_sphere$1) === false) return;
        //
        $824f5e122dad54af$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $824f5e122dad54af$var$_ray$1.copy(raycaster.ray).applyMatrix4($824f5e122dad54af$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $824f5e122dad54af$export$64b5c384219d3699();
        const vEnd = new $824f5e122dad54af$export$64b5c384219d3699();
        const interSegment = new $824f5e122dad54af$export$64b5c384219d3699();
        const interRay = new $824f5e122dad54af$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $824f5e122dad54af$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $824f5e122dad54af$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $824f5e122dad54af$var$_start = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_end = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$ff1ed10fedfdd604 extends $824f5e122dad54af$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $824f5e122dad54af$var$_start.fromBufferAttribute(positionAttribute, i);
                $824f5e122dad54af$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $824f5e122dad54af$var$_start.distanceTo($824f5e122dad54af$var$_end);
            }
            geometry.setAttribute("lineDistance", new $824f5e122dad54af$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $824f5e122dad54af$export$f85a24d745e4f17d extends $824f5e122dad54af$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $824f5e122dad54af$export$a178c45366ce5d6b extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $824f5e122dad54af$var$_inverseMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_ray = /*@__PURE__*/ new $824f5e122dad54af$export$a186db52eed6d40e();
const $824f5e122dad54af$var$_sphere = /*@__PURE__*/ new $824f5e122dad54af$export$805e8b72413ccaba();
const $824f5e122dad54af$var$_position$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$1c787534cb11aa3e extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(geometry = new $824f5e122dad54af$export$b7be63a67df8959(), material = new $824f5e122dad54af$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $824f5e122dad54af$var$_sphere.copy(geometry.boundingSphere);
        $824f5e122dad54af$var$_sphere.applyMatrix4(matrixWorld);
        $824f5e122dad54af$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($824f5e122dad54af$var$_sphere) === false) return;
        //
        $824f5e122dad54af$var$_inverseMatrix.copy(matrixWorld).invert();
        $824f5e122dad54af$var$_ray.copy(raycaster.ray).applyMatrix4($824f5e122dad54af$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $824f5e122dad54af$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $824f5e122dad54af$var$testPoint($824f5e122dad54af$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $824f5e122dad54af$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $824f5e122dad54af$var$testPoint($824f5e122dad54af$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $824f5e122dad54af$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $824f5e122dad54af$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $824f5e122dad54af$export$64b5c384219d3699();
        $824f5e122dad54af$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $824f5e122dad54af$export$6e09d1edf8d5a25c extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $824f5e122dad54af$export$9270d786f73ce6fe extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.format = format;
        this.magFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.minFilter = $824f5e122dad54af$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $824f5e122dad54af$export$3466bac9141a5cc4 extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $824f5e122dad54af$export$f7189e49152d1c13 extends $824f5e122dad54af$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $824f5e122dad54af$export$c977b3e384af9ae1() : new $824f5e122dad54af$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $824f5e122dad54af$export$64b5c384219d3699();
        const mat = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $824f5e122dad54af$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $824f5e122dad54af$export$64b5c384219d3699();
        binormals[0] = new $824f5e122dad54af$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($824f5e122dad54af$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($824f5e122dad54af$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $824f5e122dad54af$export$3f87a931616cde04 extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $824f5e122dad54af$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $824f5e122dad54af$export$b1eedc9aab6300e8 extends $824f5e122dad54af$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $824f5e122dad54af$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $824f5e122dad54af$var$tmp = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$px = /*@__PURE__*/ new $824f5e122dad54af$var$CubicPoly();
const $824f5e122dad54af$var$py = /*@__PURE__*/ new $824f5e122dad54af$var$CubicPoly();
const $824f5e122dad54af$var$pz = /*@__PURE__*/ new $824f5e122dad54af$var$CubicPoly();
class $824f5e122dad54af$export$b9146b27c24b744c extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $824f5e122dad54af$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $824f5e122dad54af$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $824f5e122dad54af$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $824f5e122dad54af$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $824f5e122dad54af$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $824f5e122dad54af$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $824f5e122dad54af$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $824f5e122dad54af$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $824f5e122dad54af$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $824f5e122dad54af$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($824f5e122dad54af$var$px.calc(weight), $824f5e122dad54af$var$py.calc(weight), $824f5e122dad54af$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $824f5e122dad54af$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $824f5e122dad54af$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $824f5e122dad54af$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $824f5e122dad54af$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $824f5e122dad54af$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $824f5e122dad54af$var$QuadraticBezier(t, p0, p1, p2) {
    return $824f5e122dad54af$var$QuadraticBezierP0(t, p0) + $824f5e122dad54af$var$QuadraticBezierP1(t, p1) + $824f5e122dad54af$var$QuadraticBezierP2(t, p2);
}
//
function $824f5e122dad54af$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $824f5e122dad54af$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $824f5e122dad54af$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $824f5e122dad54af$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $824f5e122dad54af$var$CubicBezier(t, p0, p1, p2, p3) {
    return $824f5e122dad54af$var$CubicBezierP0(t, p0) + $824f5e122dad54af$var$CubicBezierP1(t, p1) + $824f5e122dad54af$var$CubicBezierP2(t, p2) + $824f5e122dad54af$var$CubicBezierP3(t, p3);
}
class $824f5e122dad54af$export$e36650d36468bb39 extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v1 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v2 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v3 = new $824f5e122dad54af$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($824f5e122dad54af$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $824f5e122dad54af$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $824f5e122dad54af$export$13d5f1c9525f246c extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $824f5e122dad54af$export$64b5c384219d3699(), v1 = new $824f5e122dad54af$export$64b5c384219d3699(), v2 = new $824f5e122dad54af$export$64b5c384219d3699(), v3 = new $824f5e122dad54af$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($824f5e122dad54af$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $824f5e122dad54af$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $824f5e122dad54af$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $824f5e122dad54af$export$ab2e07e76531a47e extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v2 = new $824f5e122dad54af$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $824f5e122dad54af$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $824f5e122dad54af$export$1fdfd9d9cf487600 extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $824f5e122dad54af$export$64b5c384219d3699(), v2 = new $824f5e122dad54af$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $824f5e122dad54af$export$5938c4ee491a43ad extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v1 = new $824f5e122dad54af$export$c977b3e384af9ae1(), v2 = new $824f5e122dad54af$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($824f5e122dad54af$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $824f5e122dad54af$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $824f5e122dad54af$export$bf3f4c7e459f90fc extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $824f5e122dad54af$export$64b5c384219d3699(), v1 = new $824f5e122dad54af$export$64b5c384219d3699(), v2 = new $824f5e122dad54af$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($824f5e122dad54af$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $824f5e122dad54af$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $824f5e122dad54af$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $824f5e122dad54af$export$d3bdd77da77afc1b extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $824f5e122dad54af$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($824f5e122dad54af$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $824f5e122dad54af$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $824f5e122dad54af$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $824f5e122dad54af$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $824f5e122dad54af$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $824f5e122dad54af$export$b9146b27c24b744c,
    CubicBezierCurve: $824f5e122dad54af$export$e36650d36468bb39,
    CubicBezierCurve3: $824f5e122dad54af$export$13d5f1c9525f246c,
    EllipseCurve: $824f5e122dad54af$export$3f87a931616cde04,
    LineCurve: $824f5e122dad54af$export$ab2e07e76531a47e,
    LineCurve3: $824f5e122dad54af$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $824f5e122dad54af$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $824f5e122dad54af$export$bf3f4c7e459f90fc,
    SplineCurve: $824f5e122dad54af$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $824f5e122dad54af$export$4aaf9b66af1bbf2c extends $824f5e122dad54af$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $824f5e122dad54af$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $824f5e122dad54af$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $824f5e122dad54af$export$4b2950bdac9b6ee9 extends $824f5e122dad54af$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $824f5e122dad54af$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $824f5e122dad54af$export$ab2e07e76531a47e(this.currentPoint.clone(), new $824f5e122dad54af$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $824f5e122dad54af$export$5938c4ee491a43ad(this.currentPoint.clone(), new $824f5e122dad54af$export$c977b3e384af9ae1(aCPx, aCPy), new $824f5e122dad54af$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $824f5e122dad54af$export$e36650d36468bb39(this.currentPoint.clone(), new $824f5e122dad54af$export$c977b3e384af9ae1(aCP1x, aCP1y), new $824f5e122dad54af$export$c977b3e384af9ae1(aCP2x, aCP2y), new $824f5e122dad54af$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $824f5e122dad54af$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $824f5e122dad54af$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $824f5e122dad54af$export$dc3e1273c1dd9240 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(points = [
        new $824f5e122dad54af$export$c977b3e384af9ae1(0, 0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, 0),
        new $824f5e122dad54af$export$c977b3e384af9ae1(0, -0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $824f5e122dad54af$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const uv = new $824f5e122dad54af$export$c977b3e384af9ae1();
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        const curNormal = new $824f5e122dad54af$export$64b5c384219d3699();
        const prevNormal = new $824f5e122dad54af$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$dc3e1273c1dd9240(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $824f5e122dad54af$export$f036d76f832848a extends $824f5e122dad54af$export$dc3e1273c1dd9240 {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $824f5e122dad54af$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$f036d76f832848a(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $824f5e122dad54af$export$3f74fe60decf7462 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const uv = new $824f5e122dad54af$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$3f74fe60decf7462(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $824f5e122dad54af$export$d4345c83207d7c68 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $824f5e122dad54af$export$64b5c384219d3699();
            const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $824f5e122dad54af$export$c977b3e384af9ae1();
            const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$d4345c83207d7c68(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $824f5e122dad54af$export$59d971120dc8b6e7 extends $824f5e122dad54af$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$59d971120dc8b6e7(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $824f5e122dad54af$export$38789b531813345c extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $824f5e122dad54af$export$64b5c384219d3699();
            const b = new $824f5e122dad54af$export$64b5c384219d3699();
            const c = new $824f5e122dad54af$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $824f5e122dad54af$export$64b5c384219d3699();
            const b = new $824f5e122dad54af$export$64b5c384219d3699();
            const c = new $824f5e122dad54af$export$64b5c384219d3699();
            const centroid = new $824f5e122dad54af$export$64b5c384219d3699();
            const uvA = new $824f5e122dad54af$export$c977b3e384af9ae1();
            const uvB = new $824f5e122dad54af$export$c977b3e384af9ae1();
            const uvC = new $824f5e122dad54af$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$38789b531813345c(data.vertices, data.indices, data.radius, data.details);
    }
}
class $824f5e122dad54af$export$37cd4e52cce48c4c extends $824f5e122dad54af$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$37cd4e52cce48c4c(data.radius, data.detail);
    }
}
const $824f5e122dad54af$var$_v0 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v1$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_normal = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_triangle = /*@__PURE__*/ new $824f5e122dad54af$export$5a465592bfe74b48();
class $824f5e122dad54af$export$4730b1542707547f extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($824f5e122dad54af$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $824f5e122dad54af$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $824f5e122dad54af$var$_triangle.getNormal($824f5e122dad54af$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $824f5e122dad54af$var$_triangle[vertKeys[j]];
                    const v1 = $824f5e122dad54af$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($824f5e122dad54af$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $824f5e122dad54af$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $824f5e122dad54af$var$_v0.fromBufferAttribute(positionAttr, index0);
                $824f5e122dad54af$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($824f5e122dad54af$var$_v0.x, $824f5e122dad54af$var$_v0.y, $824f5e122dad54af$var$_v0.z);
                vertices.push($824f5e122dad54af$var$_v1$1.x, $824f5e122dad54af$var$_v1$1.y, $824f5e122dad54af$var$_v1$1.z);
            }
            this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
class $824f5e122dad54af$export$6428a7f2611ef1fa extends $824f5e122dad54af$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $824f5e122dad54af$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $824f5e122dad54af$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $824f5e122dad54af$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $824f5e122dad54af$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $824f5e122dad54af$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $824f5e122dad54af$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $824f5e122dad54af$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $824f5e122dad54af$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $824f5e122dad54af$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $824f5e122dad54af$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $824f5e122dad54af$var$equals(last, last.next)) {
        $824f5e122dad54af$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $824f5e122dad54af$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($824f5e122dad54af$var$equals(p, p.next) || $824f5e122dad54af$var$area(p.prev, p, p.next) === 0)) {
            $824f5e122dad54af$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $824f5e122dad54af$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $824f5e122dad54af$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $824f5e122dad54af$var$isEarHashed(ear, minX, minY, invSize) : $824f5e122dad54af$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $824f5e122dad54af$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $824f5e122dad54af$var$earcutLinked($824f5e122dad54af$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $824f5e122dad54af$var$cureLocalIntersections($824f5e122dad54af$var$filterPoints(ear), triangles, dim);
                $824f5e122dad54af$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $824f5e122dad54af$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $824f5e122dad54af$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($824f5e122dad54af$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($824f5e122dad54af$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $824f5e122dad54af$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $824f5e122dad54af$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($824f5e122dad54af$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $824f5e122dad54af$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $824f5e122dad54af$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $824f5e122dad54af$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $824f5e122dad54af$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $824f5e122dad54af$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $824f5e122dad54af$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $824f5e122dad54af$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $824f5e122dad54af$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $824f5e122dad54af$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $824f5e122dad54af$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $824f5e122dad54af$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$824f5e122dad54af$var$equals(a, b) && $824f5e122dad54af$var$intersects(a, p, p.next, b) && $824f5e122dad54af$var$locallyInside(a, b) && $824f5e122dad54af$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $824f5e122dad54af$var$removeNode(p);
            $824f5e122dad54af$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $824f5e122dad54af$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $824f5e122dad54af$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $824f5e122dad54af$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $824f5e122dad54af$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $824f5e122dad54af$var$filterPoints(a, a.next);
                c = $824f5e122dad54af$var$filterPoints(c, c.next);
                // run earcut on each half
                $824f5e122dad54af$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $824f5e122dad54af$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $824f5e122dad54af$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $824f5e122dad54af$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($824f5e122dad54af$var$getLeftmost(list));
    }
    queue.sort($824f5e122dad54af$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $824f5e122dad54af$var$eliminateHole(queue[i], outerNode);
        outerNode = $824f5e122dad54af$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $824f5e122dad54af$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $824f5e122dad54af$var$eliminateHole(hole, outerNode) {
    outerNode = $824f5e122dad54af$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $824f5e122dad54af$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $824f5e122dad54af$var$filterPoints(outerNode, outerNode.next);
        $824f5e122dad54af$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $824f5e122dad54af$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $824f5e122dad54af$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($824f5e122dad54af$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $824f5e122dad54af$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $824f5e122dad54af$var$sectorContainsSector(m, p) {
    return $824f5e122dad54af$var$area(m.prev, m, p.prev) < 0 && $824f5e122dad54af$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $824f5e122dad54af$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $824f5e122dad54af$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $824f5e122dad54af$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $824f5e122dad54af$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $824f5e122dad54af$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $824f5e122dad54af$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $824f5e122dad54af$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $824f5e122dad54af$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$824f5e122dad54af$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($824f5e122dad54af$var$locallyInside(a, b) && $824f5e122dad54af$var$locallyInside(b, a) && $824f5e122dad54af$var$middleInside(a, b) && // locally visible
    ($824f5e122dad54af$var$area(a.prev, a, b.prev) || $824f5e122dad54af$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $824f5e122dad54af$var$equals(a, b) && $824f5e122dad54af$var$area(a.prev, a, a.next) > 0 && $824f5e122dad54af$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $824f5e122dad54af$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $824f5e122dad54af$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $824f5e122dad54af$var$intersects(p1, q1, p2, q2) {
    const o1 = $824f5e122dad54af$var$sign($824f5e122dad54af$var$area(p1, q1, p2));
    const o2 = $824f5e122dad54af$var$sign($824f5e122dad54af$var$area(p1, q1, q2));
    const o3 = $824f5e122dad54af$var$sign($824f5e122dad54af$var$area(p2, q2, p1));
    const o4 = $824f5e122dad54af$var$sign($824f5e122dad54af$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $824f5e122dad54af$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $824f5e122dad54af$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $824f5e122dad54af$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $824f5e122dad54af$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $824f5e122dad54af$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $824f5e122dad54af$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $824f5e122dad54af$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $824f5e122dad54af$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $824f5e122dad54af$var$locallyInside(a, b) {
    return $824f5e122dad54af$var$area(a.prev, a, a.next) < 0 ? $824f5e122dad54af$var$area(a, b, a.next) >= 0 && $824f5e122dad54af$var$area(a, a.prev, b) >= 0 : $824f5e122dad54af$var$area(a, b, a.prev) < 0 || $824f5e122dad54af$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $824f5e122dad54af$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $824f5e122dad54af$var$splitPolygon(a, b) {
    const a2 = new $824f5e122dad54af$var$Node(a.i, a.x, a.y), b2 = new $824f5e122dad54af$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $824f5e122dad54af$var$insertNode(i, x, y, last) {
    const p = new $824f5e122dad54af$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $824f5e122dad54af$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $824f5e122dad54af$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $824f5e122dad54af$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $824f5e122dad54af$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $824f5e122dad54af$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $824f5e122dad54af$var$removeDupEndPts(contour);
        $824f5e122dad54af$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($824f5e122dad54af$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $824f5e122dad54af$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $824f5e122dad54af$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $824f5e122dad54af$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $824f5e122dad54af$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $824f5e122dad54af$export$91836d01b9f75a58 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(shapes = new $824f5e122dad54af$export$6428a7f2611ef1fa([
        new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, 0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(-0.5, 0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(-0.5, -0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $824f5e122dad54af$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $824f5e122dad54af$export$64b5c384219d3699();
                normal = new $824f5e122dad54af$export$64b5c384219d3699();
                position2 = new $824f5e122dad54af$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$824f5e122dad54af$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($824f5e122dad54af$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $824f5e122dad54af$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $824f5e122dad54af$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $824f5e122dad54af$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $824f5e122dad54af$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $824f5e122dad54af$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $824f5e122dad54af$export$91836d01b9f75a58(geometryShapes, data.options);
    }
}
const $824f5e122dad54af$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $824f5e122dad54af$export$c977b3e384af9ae1(a_x, a_y),
            new $824f5e122dad54af$export$c977b3e384af9ae1(b_x, b_y),
            new $824f5e122dad54af$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $824f5e122dad54af$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $824f5e122dad54af$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $824f5e122dad54af$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $824f5e122dad54af$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $824f5e122dad54af$export$731fd4feef063ea2 extends $824f5e122dad54af$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$731fd4feef063ea2(data.radius, data.detail);
    }
}
class $824f5e122dad54af$export$8e05fc91596f4752 extends $824f5e122dad54af$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$8e05fc91596f4752(data.radius, data.detail);
    }
}
class $824f5e122dad54af$export$ee8b85b34b7d9cad extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const uv = new $824f5e122dad54af$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$ee8b85b34b7d9cad(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $824f5e122dad54af$export$233afc324766bed8 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(shapes = new $824f5e122dad54af$export$6428a7f2611ef1fa([
        new $824f5e122dad54af$export$c977b3e384af9ae1(0, 0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(-0.5, -0.5),
        new $824f5e122dad54af$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($824f5e122dad54af$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($824f5e122dad54af$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $824f5e122dad54af$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $824f5e122dad54af$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $824f5e122dad54af$export$233afc324766bed8(geometryShapes, data.curveSegments);
    }
}
function $824f5e122dad54af$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $824f5e122dad54af$export$d5d06a966fec4192 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$d5d06a966fec4192(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $824f5e122dad54af$export$369e08f62a796c65 extends $824f5e122dad54af$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$369e08f62a796c65(data.radius, data.detail);
    }
}
class $824f5e122dad54af$export$19d55f905fa4f2cb extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $824f5e122dad54af$export$64b5c384219d3699();
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$19d55f905fa4f2cb(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $824f5e122dad54af$export$2b32466f4274fe5c extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        const P1 = new $824f5e122dad54af$export$64b5c384219d3699();
        const P2 = new $824f5e122dad54af$export$64b5c384219d3699();
        const B = new $824f5e122dad54af$export$64b5c384219d3699();
        const T = new $824f5e122dad54af$export$64b5c384219d3699();
        const N = new $824f5e122dad54af$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $824f5e122dad54af$export$2b32466f4274fe5c(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $824f5e122dad54af$export$d97a193ce44e691b extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(path = new $824f5e122dad54af$export$bf3f4c7e459f90fc(new $824f5e122dad54af$export$64b5c384219d3699(-1, -1, 0), new $824f5e122dad54af$export$64b5c384219d3699(-1, 1, 0), new $824f5e122dad54af$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $824f5e122dad54af$export$64b5c384219d3699();
        const normal = new $824f5e122dad54af$export$64b5c384219d3699();
        const uv = new $824f5e122dad54af$export$c977b3e384af9ae1();
        let P = new $824f5e122dad54af$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $824f5e122dad54af$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $824f5e122dad54af$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $824f5e122dad54af$export$d97a193ce44e691b(new $824f5e122dad54af$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $824f5e122dad54af$export$4b739da06d24892b extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $824f5e122dad54af$export$64b5c384219d3699();
            const end = new $824f5e122dad54af$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($824f5e122dad54af$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($824f5e122dad54af$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $824f5e122dad54af$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $824f5e122dad54af$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $824f5e122dad54af$export$ab3456a079aa7d80,
    BoxBufferGeometry: $824f5e122dad54af$export$ab3456a079aa7d80,
    CapsuleGeometry: $824f5e122dad54af$export$f036d76f832848a,
    CapsuleBufferGeometry: $824f5e122dad54af$export$f036d76f832848a,
    CircleGeometry: $824f5e122dad54af$export$3f74fe60decf7462,
    CircleBufferGeometry: $824f5e122dad54af$export$3f74fe60decf7462,
    ConeGeometry: $824f5e122dad54af$export$59d971120dc8b6e7,
    ConeBufferGeometry: $824f5e122dad54af$export$59d971120dc8b6e7,
    CylinderGeometry: $824f5e122dad54af$export$d4345c83207d7c68,
    CylinderBufferGeometry: $824f5e122dad54af$export$d4345c83207d7c68,
    DodecahedronGeometry: $824f5e122dad54af$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $824f5e122dad54af$export$37cd4e52cce48c4c,
    EdgesGeometry: $824f5e122dad54af$export$4730b1542707547f,
    ExtrudeGeometry: $824f5e122dad54af$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $824f5e122dad54af$export$91836d01b9f75a58,
    IcosahedronGeometry: $824f5e122dad54af$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $824f5e122dad54af$export$731fd4feef063ea2,
    LatheGeometry: $824f5e122dad54af$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $824f5e122dad54af$export$dc3e1273c1dd9240,
    OctahedronGeometry: $824f5e122dad54af$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $824f5e122dad54af$export$8e05fc91596f4752,
    PlaneGeometry: $824f5e122dad54af$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $824f5e122dad54af$export$e789a11a194ca4e0,
    PolyhedronGeometry: $824f5e122dad54af$export$38789b531813345c,
    PolyhedronBufferGeometry: $824f5e122dad54af$export$38789b531813345c,
    RingGeometry: $824f5e122dad54af$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $824f5e122dad54af$export$ee8b85b34b7d9cad,
    ShapeGeometry: $824f5e122dad54af$export$233afc324766bed8,
    ShapeBufferGeometry: $824f5e122dad54af$export$233afc324766bed8,
    SphereGeometry: $824f5e122dad54af$export$d5d06a966fec4192,
    SphereBufferGeometry: $824f5e122dad54af$export$d5d06a966fec4192,
    TetrahedronGeometry: $824f5e122dad54af$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $824f5e122dad54af$export$369e08f62a796c65,
    TorusGeometry: $824f5e122dad54af$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $824f5e122dad54af$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $824f5e122dad54af$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $824f5e122dad54af$export$2b32466f4274fe5c,
    TubeGeometry: $824f5e122dad54af$export$d97a193ce44e691b,
    TubeBufferGeometry: $824f5e122dad54af$export$d97a193ce44e691b,
    WireframeGeometry: $824f5e122dad54af$export$4b739da06d24892b
});
class $824f5e122dad54af$export$e8564da406055a3 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$21c421a2e1df9d22 extends $824f5e122dad54af$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $824f5e122dad54af$export$f2980790215acccd extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $824f5e122dad54af$export$2852a58ebdac27b8;
        this.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$28d04986c4269c9f extends $824f5e122dad54af$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $824f5e122dad54af$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $824f5e122dad54af$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $824f5e122dad54af$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $824f5e122dad54af$export$24c72f71cbaf0678 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $824f5e122dad54af$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $824f5e122dad54af$export$2852a58ebdac27b8;
        this.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $824f5e122dad54af$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$df893cf97e765622 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $824f5e122dad54af$export$2852a58ebdac27b8;
        this.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$bfe8c0a091f41ae7 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $824f5e122dad54af$export$2852a58ebdac27b8;
        this.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $824f5e122dad54af$export$5023a9a8114806b8 extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $824f5e122dad54af$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $824f5e122dad54af$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$6f5fef6235ec12ee extends $824f5e122dad54af$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $824f5e122dad54af$export$2852a58ebdac27b8;
        this.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $824f5e122dad54af$export$327886a3efaeaebe extends $824f5e122dad54af$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
const $824f5e122dad54af$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if ($824f5e122dad54af$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === "quaternion") {
                const referenceQuat = new $824f5e122dad54af$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
                $824f5e122dad54af$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = $824f5e122dad54af$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $824f5e122dad54af$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $824f5e122dad54af$export$3646682e7a3959 extends $824f5e122dad54af$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $824f5e122dad54af$export$7f795934b84ab523,
            endingEnd: $824f5e122dad54af$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $824f5e122dad54af$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $824f5e122dad54af$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $824f5e122dad54af$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $824f5e122dad54af$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $824f5e122dad54af$export$a8e6009059f51e1a extends $824f5e122dad54af$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $824f5e122dad54af$export$fb9758ef7ef8d5cc extends $824f5e122dad54af$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $824f5e122dad54af$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                "values": $824f5e122dad54af$export$7ee8caa573e71ad1.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $824f5e122dad54af$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $824f5e122dad54af$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $824f5e122dad54af$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $824f5e122dad54af$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $824f5e122dad54af$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $824f5e122dad54af$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $824f5e122dad54af$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $824f5e122dad54af$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $824f5e122dad54af$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(times, from, to);
            this.values = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($824f5e122dad54af$export$7ee8caa573e71ad1.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(this.times), values = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $824f5e122dad54af$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
            this.values = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
        const values = $824f5e122dad54af$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$824f5e122dad54af$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$824f5e122dad54af$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$824f5e122dad54af$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $824f5e122dad54af$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $824f5e122dad54af$export$d3a344b98cf0b775 extends $824f5e122dad54af$export$b0e479f45b7006d6 {
}
$824f5e122dad54af$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$824f5e122dad54af$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$824f5e122dad54af$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $824f5e122dad54af$export$995b32462a65e855;
$824f5e122dad54af$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$824f5e122dad54af$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $824f5e122dad54af$export$83444c5d885347d8 extends $824f5e122dad54af$export$b0e479f45b7006d6 {
}
$824f5e122dad54af$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $824f5e122dad54af$export$d45f0d1a4d9a9314 extends $824f5e122dad54af$export$b0e479f45b7006d6 {
}
$824f5e122dad54af$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $824f5e122dad54af$export$2db1cfb7923d931e extends $824f5e122dad54af$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$824f5e122dad54af$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $824f5e122dad54af$export$b8043f12b5aafbd7 extends $824f5e122dad54af$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $824f5e122dad54af$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$824f5e122dad54af$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$824f5e122dad54af$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $824f5e122dad54af$export$30fac1aace31cf4d;
$824f5e122dad54af$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $824f5e122dad54af$export$6ce41d4f3a8df9cd extends $824f5e122dad54af$export$b0e479f45b7006d6 {
}
$824f5e122dad54af$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$824f5e122dad54af$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$824f5e122dad54af$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $824f5e122dad54af$export$995b32462a65e855;
$824f5e122dad54af$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$824f5e122dad54af$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $824f5e122dad54af$export$5ce2dcb4cc9f2bff extends $824f5e122dad54af$export$b0e479f45b7006d6 {
}
$824f5e122dad54af$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $824f5e122dad54af$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $824f5e122dad54af$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $824f5e122dad54af$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($824f5e122dad54af$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($824f5e122dad54af$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $824f5e122dad54af$export$7ee8caa573e71ad1.getKeyframeOrder(times);
            times = $824f5e122dad54af$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
            values = $824f5e122dad54af$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $824f5e122dad54af$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $824f5e122dad54af$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $824f5e122dad54af$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($824f5e122dad54af$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($824f5e122dad54af$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($824f5e122dad54af$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $824f5e122dad54af$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $824f5e122dad54af$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $824f5e122dad54af$export$5ce2dcb4cc9f2bff;
        case "color":
            return $824f5e122dad54af$export$83444c5d885347d8;
        case "quaternion":
            return $824f5e122dad54af$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $824f5e122dad54af$export$d3a344b98cf0b775;
        case "string":
            return $824f5e122dad54af$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $824f5e122dad54af$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $824f5e122dad54af$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $824f5e122dad54af$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $824f5e122dad54af$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $824f5e122dad54af$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $824f5e122dad54af$export$b033c3f9a95c6a16 = new $824f5e122dad54af$export$99cc795e99919eed();
class $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $824f5e122dad54af$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $824f5e122dad54af$var$loading = {};
class $824f5e122dad54af$export$98435a25b5cf7b2b extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $824f5e122dad54af$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($824f5e122dad54af$var$loading[url] !== undefined) {
            $824f5e122dad54af$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $824f5e122dad54af$var$loading[url] = [];
        $824f5e122dad54af$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $824f5e122dad54af$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get("Content-Length");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw Error(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $824f5e122dad54af$export$94affb487e701bf2.add(url, data);
            const callbacks = $824f5e122dad54af$var$loading[url];
            delete $824f5e122dad54af$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $824f5e122dad54af$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $824f5e122dad54af$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $824f5e122dad54af$export$29711c7e14f61db extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $824f5e122dad54af$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $824f5e122dad54af$export$bd73ce947a280350 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $824f5e122dad54af$export$3466bac9141a5cc4();
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $824f5e122dad54af$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $824f5e122dad54af$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $824f5e122dad54af$export$8905ce1c7a2464a1 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $824f5e122dad54af$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $824f5e122dad54af$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $824f5e122dad54af$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $824f5e122dad54af$export$2ec114afc2cf6308 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $824f5e122dad54af$export$ee2e5a18258a4049();
        const loader = new $824f5e122dad54af$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $824f5e122dad54af$export$792d8a18f2c55855 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $824f5e122dad54af$export$b691f601014eabe1();
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $824f5e122dad54af$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $824f5e122dad54af$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $824f5e122dad54af$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $824f5e122dad54af$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $824f5e122dad54af$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $824f5e122dad54af$export$fd1bfc71f64c538c extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $824f5e122dad54af$export$5431306cf43de24a();
        const loader = new $824f5e122dad54af$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $824f5e122dad54af$export$6ecadb6ed240d696 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $824f5e122dad54af$export$8d474f55edbb9624 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($824f5e122dad54af$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $824f5e122dad54af$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $824f5e122dad54af$var$_projScreenMatrix$1 = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_lightPositionWorld$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_lookTarget$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $824f5e122dad54af$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $824f5e122dad54af$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $824f5e122dad54af$export$35efe6f4c85463d2();
        this._frameExtents = new $824f5e122dad54af$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $824f5e122dad54af$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($824f5e122dad54af$var$_lightPositionWorld$1);
        $824f5e122dad54af$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($824f5e122dad54af$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $824f5e122dad54af$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($824f5e122dad54af$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $824f5e122dad54af$var$SpotLightShadow extends $824f5e122dad54af$var$LightShadow {
    constructor(){
        super(new $824f5e122dad54af$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $824f5e122dad54af$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $824f5e122dad54af$export$81495cbb73897362 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($824f5e122dad54af$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $824f5e122dad54af$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $824f5e122dad54af$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $824f5e122dad54af$var$_projScreenMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_lightPositionWorld = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_lookTarget = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$var$PointLightShadow extends $824f5e122dad54af$var$LightShadow {
    constructor(){
        super(new $824f5e122dad54af$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $824f5e122dad54af$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $824f5e122dad54af$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $824f5e122dad54af$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $824f5e122dad54af$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $824f5e122dad54af$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $824f5e122dad54af$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $824f5e122dad54af$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $824f5e122dad54af$export$64b5c384219d3699(1, 0, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(-1, 0, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 1),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 0, -1),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 1, 0),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 1),
            new $824f5e122dad54af$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $824f5e122dad54af$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($824f5e122dad54af$var$_lightPositionWorld);
        $824f5e122dad54af$var$_lookTarget.copy(camera.position);
        $824f5e122dad54af$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($824f5e122dad54af$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$824f5e122dad54af$var$_lightPositionWorld.x, -$824f5e122dad54af$var$_lightPositionWorld.y, -$824f5e122dad54af$var$_lightPositionWorld.z);
        $824f5e122dad54af$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($824f5e122dad54af$var$_projScreenMatrix);
    }
}
class $824f5e122dad54af$export$4c9c1cb3f0b6f455 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $824f5e122dad54af$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $824f5e122dad54af$var$DirectionalLightShadow extends $824f5e122dad54af$var$LightShadow {
    constructor(){
        super(new $824f5e122dad54af$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $824f5e122dad54af$export$3fea33cc9972c868 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($824f5e122dad54af$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $824f5e122dad54af$export$e4dd07dff30cc924();
        this.shadow = new $824f5e122dad54af$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $824f5e122dad54af$export$af279bfef9ec2c96 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $824f5e122dad54af$export$61db2d908bbd2429 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $824f5e122dad54af$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $824f5e122dad54af$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $824f5e122dad54af$export$e7ef036e309b38d2 extends $824f5e122dad54af$export$6ecadb6ed240d696 {
    constructor(sh = new $824f5e122dad54af$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $824f5e122dad54af$export$3bd6d323353dcf96 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $824f5e122dad54af$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $824f5e122dad54af$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $824f5e122dad54af$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $824f5e122dad54af$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $824f5e122dad54af$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $824f5e122dad54af$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $824f5e122dad54af$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $824f5e122dad54af$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $824f5e122dad54af$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $824f5e122dad54af$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $824f5e122dad54af$export$e8564da406055a3,
            SpriteMaterial: $824f5e122dad54af$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $824f5e122dad54af$export$21c421a2e1df9d22,
            ShaderMaterial: $824f5e122dad54af$export$83c7d75d550a8b0d,
            PointsMaterial: $824f5e122dad54af$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $824f5e122dad54af$export$28d04986c4269c9f,
            MeshStandardMaterial: $824f5e122dad54af$export$f2980790215acccd,
            MeshPhongMaterial: $824f5e122dad54af$export$24c72f71cbaf0678,
            MeshToonMaterial: $824f5e122dad54af$export$df893cf97e765622,
            MeshNormalMaterial: $824f5e122dad54af$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $824f5e122dad54af$export$5023a9a8114806b8,
            MeshDepthMaterial: $824f5e122dad54af$export$2698c22ec13825db,
            MeshDistanceMaterial: $824f5e122dad54af$export$33e187ed002f2a19,
            MeshBasicMaterial: $824f5e122dad54af$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $824f5e122dad54af$export$6f5fef6235ec12ee,
            LineDashedMaterial: $824f5e122dad54af$export$327886a3efaeaebe,
            LineBasicMaterial: $824f5e122dad54af$export$fbaaa33907730a0c,
            Material: $824f5e122dad54af$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $824f5e122dad54af$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $824f5e122dad54af$export$231f009cbe414146 extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $824f5e122dad54af$export$dc275bb96327833a extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $824f5e122dad54af$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $824f5e122dad54af$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $824f5e122dad54af$export$231f009cbe414146() : new $824f5e122dad54af$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $824f5e122dad54af$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $824f5e122dad54af$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $824f5e122dad54af$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $824f5e122dad54af$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $824f5e122dad54af$export$32ea87a8b54d744a : $824f5e122dad54af$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $824f5e122dad54af$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $824f5e122dad54af$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $824f5e122dad54af$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $824f5e122dad54af$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $824f5e122dad54af$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $824f5e122dad54af$export$40110c8505c5ad19 extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $824f5e122dad54af$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $824f5e122dad54af$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $824f5e122dad54af$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $824f5e122dad54af$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $824f5e122dad54af$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case "Geometry":
                        console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
                        break;
                    default:
                        if (data.type in $824f5e122dad54af$var$Geometries) geometry = $824f5e122dad54af$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $824f5e122dad54af$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === "MultiMaterial") {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $824f5e122dad54af$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $824f5e122dad54af$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $824f5e122dad54af$export$99cc795e99919eed(onLoad);
            loader = new $824f5e122dad54af$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $824f5e122dad54af$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $824f5e122dad54af$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $824f5e122dad54af$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $824f5e122dad54af$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $824f5e122dad54af$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $824f5e122dad54af$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $824f5e122dad54af$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $824f5e122dad54af$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $824f5e122dad54af$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $824f5e122dad54af$export$b691f601014eabe1();
                else texture = new $824f5e122dad54af$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $824f5e122dad54af$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $824f5e122dad54af$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $824f5e122dad54af$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $824f5e122dad54af$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $824f5e122dad54af$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $824f5e122dad54af$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $824f5e122dad54af$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $824f5e122dad54af$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $824f5e122dad54af$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case "PerspectiveCamera":
                object = new $824f5e122dad54af$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $824f5e122dad54af$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $824f5e122dad54af$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $824f5e122dad54af$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $824f5e122dad54af$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $824f5e122dad54af$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $824f5e122dad54af$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $824f5e122dad54af$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $824f5e122dad54af$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $824f5e122dad54af$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $824f5e122dad54af$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $824f5e122dad54af$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $824f5e122dad54af$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $824f5e122dad54af$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $824f5e122dad54af$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $824f5e122dad54af$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $824f5e122dad54af$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $824f5e122dad54af$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $824f5e122dad54af$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $824f5e122dad54af$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $824f5e122dad54af$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $824f5e122dad54af$export$b127726e56765aa4();
                break;
            default:
                object = new $824f5e122dad54af$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().");
        return this.setResourcePath(value);
    }
}
const $824f5e122dad54af$var$TEXTURE_MAPPING = {
    UVMapping: $824f5e122dad54af$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $824f5e122dad54af$export$8759762a6477f2c4,
    CubeRefractionMapping: $824f5e122dad54af$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $824f5e122dad54af$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $824f5e122dad54af$export$ee99d97d46898098,
    CubeUVReflectionMapping: $824f5e122dad54af$export$dbf3e70ff37af79
};
const $824f5e122dad54af$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $824f5e122dad54af$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $824f5e122dad54af$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $824f5e122dad54af$export$c7e7c00b14f51a4f
};
const $824f5e122dad54af$var$TEXTURE_FILTER = {
    NearestFilter: $824f5e122dad54af$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $824f5e122dad54af$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $824f5e122dad54af$export$d2327c1afe5bfdf2,
    LinearFilter: $824f5e122dad54af$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $824f5e122dad54af$export$19a719f377145a13,
    LinearMipmapLinearFilter: $824f5e122dad54af$export$5d8599b6a933fb1b
};
class $824f5e122dad54af$export$52286b55c4a9b51f extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $824f5e122dad54af$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $824f5e122dad54af$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $824f5e122dad54af$var$_context;
const $824f5e122dad54af$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($824f5e122dad54af$var$_context === undefined) $824f5e122dad54af$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $824f5e122dad54af$var$_context;
    },
    setContext: function(value) {
        $824f5e122dad54af$var$_context = value;
    }
};
class $824f5e122dad54af$export$d8d5fccfbf47714e extends $824f5e122dad54af$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $824f5e122dad54af$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $824f5e122dad54af$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $824f5e122dad54af$export$2f22dadc8bc42820 extends $824f5e122dad54af$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $824f5e122dad54af$export$892596cec99bc70e().set(skyColor);
        const color2 = new $824f5e122dad54af$export$892596cec99bc70e().set(groundColor);
        const sky = new $824f5e122dad54af$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $824f5e122dad54af$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $824f5e122dad54af$export$afe310a21c86023d extends $824f5e122dad54af$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $824f5e122dad54af$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $824f5e122dad54af$var$_eyeRight = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_eyeLeft = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_projectionMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
class $824f5e122dad54af$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $824f5e122dad54af$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $824f5e122dad54af$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $824f5e122dad54af$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($824f5e122dad54af$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $824f5e122dad54af$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $824f5e122dad54af$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $824f5e122dad54af$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $824f5e122dad54af$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($824f5e122dad54af$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $824f5e122dad54af$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $824f5e122dad54af$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($824f5e122dad54af$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($824f5e122dad54af$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($824f5e122dad54af$var$_eyeRight);
    }
}
class $824f5e122dad54af$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $824f5e122dad54af$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $824f5e122dad54af$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $824f5e122dad54af$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $824f5e122dad54af$var$_position$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_quaternion$1 = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
const $824f5e122dad54af$var$_scale$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_orientation$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$8a1b810c6fde8951 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $824f5e122dad54af$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $824f5e122dad54af$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($824f5e122dad54af$var$_position$1, $824f5e122dad54af$var$_quaternion$1, $824f5e122dad54af$var$_scale$1);
        $824f5e122dad54af$var$_orientation$1.set(0, 0, -1).applyQuaternion($824f5e122dad54af$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($824f5e122dad54af$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($824f5e122dad54af$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($824f5e122dad54af$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($824f5e122dad54af$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($824f5e122dad54af$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($824f5e122dad54af$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($824f5e122dad54af$var$_position$1.x, $824f5e122dad54af$var$_position$1.y, $824f5e122dad54af$var$_position$1.z);
            listener.setOrientation($824f5e122dad54af$var$_orientation$1.x, $824f5e122dad54af$var$_orientation$1.y, $824f5e122dad54af$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $824f5e122dad54af$export$153755f98d9861de extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $824f5e122dad54af$var$_position = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_quaternion = /*@__PURE__*/ new $824f5e122dad54af$export$23d6a54f0bbc85a3();
const $824f5e122dad54af$var$_scale = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_orientation = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$4b3e397ef1832507 extends $824f5e122dad54af$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($824f5e122dad54af$var$_position, $824f5e122dad54af$var$_quaternion, $824f5e122dad54af$var$_scale);
        $824f5e122dad54af$var$_orientation.set(0, 0, 1).applyQuaternion($824f5e122dad54af$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($824f5e122dad54af$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($824f5e122dad54af$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($824f5e122dad54af$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($824f5e122dad54af$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($824f5e122dad54af$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($824f5e122dad54af$var$_orientation.z, endTime);
        } else {
            panner.setPosition($824f5e122dad54af$var$_position.x, $824f5e122dad54af$var$_position.y, $824f5e122dad54af$var$_position.z);
            panner.setOrientation($824f5e122dad54af$var$_orientation.x, $824f5e122dad54af$var$_orientation.y, $824f5e122dad54af$var$_orientation.z);
        }
    }
}
class $824f5e122dad54af$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $824f5e122dad54af$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $824f5e122dad54af$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $824f5e122dad54af$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $824f5e122dad54af$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $824f5e122dad54af$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $824f5e122dad54af$var$_reservedRe = new RegExp("[" + $824f5e122dad54af$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $824f5e122dad54af$var$_wordChar = "[^" + $824f5e122dad54af$var$_RESERVED_CHARS_RE + "]";
const $824f5e122dad54af$var$_wordCharOrDot = "[^" + $824f5e122dad54af$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $824f5e122dad54af$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $824f5e122dad54af$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $824f5e122dad54af$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $824f5e122dad54af$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $824f5e122dad54af$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $824f5e122dad54af$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $824f5e122dad54af$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $824f5e122dad54af$var$_wordChar);
const $824f5e122dad54af$var$_trackRe = new RegExp("^" + $824f5e122dad54af$var$_directoryRe + $824f5e122dad54af$var$_nodeRe + $824f5e122dad54af$var$_objectRe + $824f5e122dad54af$var$_propertyRe + "$");
const $824f5e122dad54af$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones"
];
class $824f5e122dad54af$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $824f5e122dad54af$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $824f5e122dad54af$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $824f5e122dad54af$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $824f5e122dad54af$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $824f5e122dad54af$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $824f5e122dad54af$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($824f5e122dad54af$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $824f5e122dad54af$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($824f5e122dad54af$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $824f5e122dad54af$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$824f5e122dad54af$export$7bf70fcf9f891893.Composite = $824f5e122dad54af$var$Composite;
$824f5e122dad54af$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$824f5e122dad54af$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$824f5e122dad54af$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $824f5e122dad54af$export$7bf70fcf9f891893.prototype._getValue_direct,
    $824f5e122dad54af$export$7bf70fcf9f891893.prototype._getValue_array,
    $824f5e122dad54af$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $824f5e122dad54af$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$824f5e122dad54af$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_direct,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_array,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $824f5e122dad54af$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $824f5e122dad54af$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $824f5e122dad54af$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $824f5e122dad54af$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $824f5e122dad54af$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $824f5e122dad54af$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $824f5e122dad54af$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $824f5e122dad54af$export$7f795934b84ab523,
            endingEnd: $824f5e122dad54af$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $824f5e122dad54af$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $824f5e122dad54af$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $824f5e122dad54af$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $824f5e122dad54af$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $824f5e122dad54af$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $824f5e122dad54af$export$24a4ccb5099273b5;
            settings.endingEnd = $824f5e122dad54af$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $824f5e122dad54af$export$24a4ccb5099273b5 : $824f5e122dad54af$export$7f795934b84ab523;
            else settings.endingStart = $824f5e122dad54af$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $824f5e122dad54af$export$24a4ccb5099273b5 : $824f5e122dad54af$export$7f795934b84ab523;
            else settings.endingEnd = $824f5e122dad54af$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $824f5e122dad54af$var$_controlInterpolantsResultBuffer = /*@__PURE__*/ new Float32Array(1);
class $824f5e122dad54af$export$fbd77e5aefaa0102 extends $824f5e122dad54af$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $824f5e122dad54af$export$dfe0af1ca1acb78a($824f5e122dad54af$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $824f5e122dad54af$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $824f5e122dad54af$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $824f5e122dad54af$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $824f5e122dad54af$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $824f5e122dad54af$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $824f5e122dad54af$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $824f5e122dad54af$export$2947cebfe91c02f8 {
    constructor(value){
        if (typeof value === "string") {
            console.warn("THREE.Uniform: Type parameter is no longer needed.");
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new $824f5e122dad54af$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
class $824f5e122dad54af$export$25ec0e1af1389358 extends $824f5e122dad54af$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $824f5e122dad54af$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $824f5e122dad54af$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $824f5e122dad54af$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $824f5e122dad54af$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $824f5e122dad54af$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($824f5e122dad54af$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$824f5e122dad54af$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($824f5e122dad54af$var$ascSort);
        return intersects;
    }
}
function $824f5e122dad54af$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $824f5e122dad54af$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$824f5e122dad54af$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $824f5e122dad54af$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($824f5e122dad54af$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $824f5e122dad54af$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $824f5e122dad54af$var$_vector$4 = /*@__PURE__*/ new $824f5e122dad54af$export$c977b3e384af9ae1();
class $824f5e122dad54af$export$60f553fa130f08b0 {
    constructor(min = new $824f5e122dad54af$export$c977b3e384af9ae1(Infinity, Infinity), max = new $824f5e122dad54af$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $824f5e122dad54af$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $824f5e122dad54af$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $824f5e122dad54af$var$_startP = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_startEnd = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$e0ba6359f1954fd3 {
    constructor(start = new $824f5e122dad54af$export$64b5c384219d3699(), end = new $824f5e122dad54af$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $824f5e122dad54af$var$_startP.subVectors(point, this.start);
        $824f5e122dad54af$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $824f5e122dad54af$var$_startEnd.dot($824f5e122dad54af$var$_startEnd);
        const startEnd_startP = $824f5e122dad54af$var$_startEnd.dot($824f5e122dad54af$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $824f5e122dad54af$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $824f5e122dad54af$var$_vector$3 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$4b14638ffdd81e68 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(positions, 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $824f5e122dad54af$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $824f5e122dad54af$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($824f5e122dad54af$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $824f5e122dad54af$var$_vector$2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_boneMatrix = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
const $824f5e122dad54af$var$_matrixWorldInv = /*@__PURE__*/ new $824f5e122dad54af$export$2ae72fc923e5eb5();
class $824f5e122dad54af$export$5277df3c9e732259 extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $824f5e122dad54af$var$getBoneList(object);
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $824f5e122dad54af$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $824f5e122dad54af$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $824f5e122dad54af$export$cbe7a62641830ebd(colors, 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $824f5e122dad54af$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $824f5e122dad54af$var$_boneMatrix.multiplyMatrices($824f5e122dad54af$var$_matrixWorldInv, bone.matrixWorld);
                $824f5e122dad54af$var$_vector$2.setFromMatrixPosition($824f5e122dad54af$var$_boneMatrix);
                position.setXYZ(j, $824f5e122dad54af$var$_vector$2.x, $824f5e122dad54af$var$_vector$2.y, $824f5e122dad54af$var$_vector$2.z);
                $824f5e122dad54af$var$_boneMatrix.multiplyMatrices($824f5e122dad54af$var$_matrixWorldInv, bone.parent.matrixWorld);
                $824f5e122dad54af$var$_vector$2.setFromMatrixPosition($824f5e122dad54af$var$_boneMatrix);
                position.setXYZ(j + 1, $824f5e122dad54af$var$_vector$2.x, $824f5e122dad54af$var$_vector$2.y, $824f5e122dad54af$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $824f5e122dad54af$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $824f5e122dad54af$var$getBoneList(object.children[i]));
    return boneList;
}
class $824f5e122dad54af$export$9a9291685b9e4023 extends $824f5e122dad54af$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $824f5e122dad54af$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $824f5e122dad54af$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $824f5e122dad54af$var$_vector$1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_color1 = /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e();
const $824f5e122dad54af$var$_color2 = /*@__PURE__*/ new $824f5e122dad54af$export$892596cec99bc70e();
class $824f5e122dad54af$export$8dca15f13f4f8172 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $824f5e122dad54af$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $824f5e122dad54af$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $824f5e122dad54af$export$8dea267bd6bde117(colors, 3));
        this.add(new $824f5e122dad54af$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $824f5e122dad54af$var$_color1.copy(this.light.color);
            $824f5e122dad54af$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $824f5e122dad54af$var$_color1 : $824f5e122dad54af$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($824f5e122dad54af$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $824f5e122dad54af$export$3875d39926561055 extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $824f5e122dad54af$export$892596cec99bc70e(color1);
        color2 = new $824f5e122dad54af$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $824f5e122dad54af$export$cbe7a62641830ebd(colors, 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
}
class $824f5e122dad54af$export$361430a10f533cd3 extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $824f5e122dad54af$export$892596cec99bc70e(color1);
        color2 = new $824f5e122dad54af$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $824f5e122dad54af$export$cbe7a62641830ebd(colors, 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
}
const $824f5e122dad54af$var$_v1 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v2 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_v3 = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
class $824f5e122dad54af$export$f8e434dc14203e7d extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $824f5e122dad54af$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $824f5e122dad54af$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $824f5e122dad54af$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $824f5e122dad54af$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $824f5e122dad54af$var$_v3.subVectors($824f5e122dad54af$var$_v2, $824f5e122dad54af$var$_v1);
        this.lightPlane.lookAt($824f5e122dad54af$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($824f5e122dad54af$var$_v2);
        this.targetLine.scale.z = $824f5e122dad54af$var$_v3.length();
    }
}
const $824f5e122dad54af$var$_vector = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
const $824f5e122dad54af$var$_camera = /*@__PURE__*/ new $824f5e122dad54af$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $824f5e122dad54af$export$ed8e93f853cd795 extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $824f5e122dad54af$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $824f5e122dad54af$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $824f5e122dad54af$export$892596cec99bc70e(0xff0000);
        const colorUp = new $824f5e122dad54af$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $824f5e122dad54af$export$892596cec99bc70e(0xffffff);
        const colorCross = new $824f5e122dad54af$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $824f5e122dad54af$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $824f5e122dad54af$var$setPoint("c", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, 0, -1);
        $824f5e122dad54af$var$setPoint("t", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, 0, 1);
        // near
        $824f5e122dad54af$var$setPoint("n1", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, -h, -1);
        $824f5e122dad54af$var$setPoint("n2", pointMap, geometry, $824f5e122dad54af$var$_camera, w, -h, -1);
        $824f5e122dad54af$var$setPoint("n3", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, h, -1);
        $824f5e122dad54af$var$setPoint("n4", pointMap, geometry, $824f5e122dad54af$var$_camera, w, h, -1);
        // far
        $824f5e122dad54af$var$setPoint("f1", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, -h, 1);
        $824f5e122dad54af$var$setPoint("f2", pointMap, geometry, $824f5e122dad54af$var$_camera, w, -h, 1);
        $824f5e122dad54af$var$setPoint("f3", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, h, 1);
        $824f5e122dad54af$var$setPoint("f4", pointMap, geometry, $824f5e122dad54af$var$_camera, w, h, 1);
        // up
        $824f5e122dad54af$var$setPoint("u1", pointMap, geometry, $824f5e122dad54af$var$_camera, w * 0.7, h * 1.1, -1);
        $824f5e122dad54af$var$setPoint("u2", pointMap, geometry, $824f5e122dad54af$var$_camera, -w * 0.7, h * 1.1, -1);
        $824f5e122dad54af$var$setPoint("u3", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, h * 2, -1);
        // cross
        $824f5e122dad54af$var$setPoint("cf1", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, 0, 1);
        $824f5e122dad54af$var$setPoint("cf2", pointMap, geometry, $824f5e122dad54af$var$_camera, w, 0, 1);
        $824f5e122dad54af$var$setPoint("cf3", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, -h, 1);
        $824f5e122dad54af$var$setPoint("cf4", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, h, 1);
        $824f5e122dad54af$var$setPoint("cn1", pointMap, geometry, $824f5e122dad54af$var$_camera, -w, 0, -1);
        $824f5e122dad54af$var$setPoint("cn2", pointMap, geometry, $824f5e122dad54af$var$_camera, w, 0, -1);
        $824f5e122dad54af$var$setPoint("cn3", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, -h, -1);
        $824f5e122dad54af$var$setPoint("cn4", pointMap, geometry, $824f5e122dad54af$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $824f5e122dad54af$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $824f5e122dad54af$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $824f5e122dad54af$var$_vector.x, $824f5e122dad54af$var$_vector.y, $824f5e122dad54af$var$_vector.z);
    }
}
const $824f5e122dad54af$var$_box = /*@__PURE__*/ new $824f5e122dad54af$export$6f7d5a9418ab2aa3();
class $824f5e122dad54af$export$38a664cc862a6a9d extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setIndex(new $824f5e122dad54af$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $824f5e122dad54af$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $824f5e122dad54af$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $824f5e122dad54af$var$_box.setFromObject(this.object);
        if ($824f5e122dad54af$var$_box.isEmpty()) return;
        const min = $824f5e122dad54af$var$_box.min;
        const max = $824f5e122dad54af$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
}
class $824f5e122dad54af$export$ce39f4bb96c9a290 extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setIndex(new $824f5e122dad54af$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $824f5e122dad54af$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $824f5e122dad54af$export$a34fe8156c66e5d7 extends $824f5e122dad54af$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $824f5e122dad54af$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $824f5e122dad54af$export$e176487c05830cc5(geometry2, new $824f5e122dad54af$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? $824f5e122dad54af$export$d9f0486e75b5ace : $824f5e122dad54af$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const $824f5e122dad54af$var$_axis = /*@__PURE__*/ new $824f5e122dad54af$export$64b5c384219d3699();
let $824f5e122dad54af$var$_lineGeometry, $824f5e122dad54af$var$_coneGeometry;
class $824f5e122dad54af$export$a3008e7bd8d2cbe7 extends $824f5e122dad54af$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 1), origin = new $824f5e122dad54af$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($824f5e122dad54af$var$_lineGeometry === undefined) {
            $824f5e122dad54af$var$_lineGeometry = new $824f5e122dad54af$export$b7be63a67df8959();
            $824f5e122dad54af$var$_lineGeometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $824f5e122dad54af$var$_coneGeometry = new $824f5e122dad54af$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $824f5e122dad54af$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $824f5e122dad54af$export$17d680238e50603e($824f5e122dad54af$var$_lineGeometry, new $824f5e122dad54af$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $824f5e122dad54af$export$e176487c05830cc5($824f5e122dad54af$var$_coneGeometry, new $824f5e122dad54af$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $824f5e122dad54af$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($824f5e122dad54af$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $824f5e122dad54af$export$6c8303f35b8578fd extends $824f5e122dad54af$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $824f5e122dad54af$export$b7be63a67df8959();
        geometry.setAttribute("position", new $824f5e122dad54af$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $824f5e122dad54af$export$cbe7a62641830ebd(colors, 3));
        const material = new $824f5e122dad54af$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $824f5e122dad54af$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $824f5e122dad54af$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $824f5e122dad54af$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $824f5e122dad54af$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $824f5e122dad54af$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $824f5e122dad54af$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $824f5e122dad54af$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $824f5e122dad54af$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const { floatView: $824f5e122dad54af$var$_floatView, uint32View: $824f5e122dad54af$var$_uint32View, baseTable: $824f5e122dad54af$var$_baseTable, shiftTable: $824f5e122dad54af$var$_shiftTable, mantissaTable: $824f5e122dad54af$var$_mantissaTable, exponentTable: $824f5e122dad54af$var$_exponentTable, offsetTable: $824f5e122dad54af$var$_offsetTable } = /*@__PURE__*/ $824f5e122dad54af$var$_generateTables();
function $824f5e122dad54af$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $824f5e122dad54af$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $824f5e122dad54af$var$clamp(val, -65504, 65504);
    $824f5e122dad54af$var$_floatView[0] = val;
    const f = $824f5e122dad54af$var$_uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $824f5e122dad54af$var$_baseTable[e] + ((f & 0x007fffff) >> $824f5e122dad54af$var$_shiftTable[e]);
}
// float16 to float32
function $824f5e122dad54af$var$fromHalfFloat(val) {
    const m = val >> 10;
    $824f5e122dad54af$var$_uint32View[0] = $824f5e122dad54af$var$_mantissaTable[$824f5e122dad54af$var$_offsetTable[m] + (val & 0x3ff)] + $824f5e122dad54af$var$_exponentTable[m];
    return $824f5e122dad54af$var$_floatView[0];
}
var $824f5e122dad54af$export$11ce8b759162cc80 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toHalfFloat: $824f5e122dad54af$var$toHalfFloat,
    fromHalfFloat: $824f5e122dad54af$var$fromHalfFloat
});
// r133, c5bb5434555a3c3ddd784944a0a124f996fc721b
class $824f5e122dad54af$export$8f6f2b4b16d33f extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(){
        console.error("THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js");
        super();
    }
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
class $824f5e122dad54af$export$684b774b4473ba5f extends $824f5e122dad54af$export$b7be63a67df8959 {
    constructor(){
        console.error("THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js");
        super();
    }
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
function $824f5e122dad54af$export$812303d6cad736b3() {
    console.error("THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js");
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
function $824f5e122dad54af$export$89abf52a030e56ee() {
    console.error("THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js");
}
// r134, d65e0af06644fe5a84a6fc0e372f4318f95a04c0
function $824f5e122dad54af$export$960665a8431ecff6() {
    console.error("THREE.ImmediateRenderObject has been removed.");
}
// r138, 48b05d3500acc084df50be9b4c90781ad9b8cb17
class $824f5e122dad54af$export$cb2022643d3c928d extends $824f5e122dad54af$export$3c052beb2e51e23f {
    constructor(width, height, options){
        console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
        super(width, height, options);
        this.samples = 4;
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $824f5e122dad54af$export$e38bf4541665bbbd extends $824f5e122dad54af$export$dfac6c8e811406a3 {
    constructor(data, width, height, depth){
        console.warn("THREE.DataTexture2DArray has been renamed to DataArrayTexture.");
        super(data, width, height, depth);
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $824f5e122dad54af$export$ef03cdc98340bab4 extends $824f5e122dad54af$export$d7a3086320f856db {
    constructor(data, width, height, depth){
        console.warn("THREE.DataTexture3D has been renamed to Data3DTexture.");
        super(data, width, height, depth);
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $824f5e122dad54af$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $824f5e122dad54af$export$3545e07a80636437;
}


function $43ff881bd78cd4f7$var$setUVs(box, u, v, width, height, depth, textureWidth, textureHeight) {
    const toFaceVertices = (x1, y1, x2, y2)=>[
            new (0, $824f5e122dad54af$export$c977b3e384af9ae1)(x1 / textureWidth, 1.0 - y2 / textureHeight),
            new (0, $824f5e122dad54af$export$c977b3e384af9ae1)(x2 / textureWidth, 1.0 - y2 / textureHeight),
            new (0, $824f5e122dad54af$export$c977b3e384af9ae1)(x2 / textureWidth, 1.0 - y1 / textureHeight),
            new (0, $824f5e122dad54af$export$c977b3e384af9ae1)(x1 / textureWidth, 1.0 - y1 / textureHeight)
        ];
    const top = toFaceVertices(u + depth, v, u + width + depth, v + depth);
    const bottom = toFaceVertices(u + width + depth, v, u + width * 2 + depth, v + depth);
    const left = toFaceVertices(u, v + depth, u + depth, v + depth + height);
    const front = toFaceVertices(u + depth, v + depth, u + width + depth, v + depth + height);
    const right = toFaceVertices(u + width + depth, v + depth, u + width + depth * 2, v + height + depth);
    const back = toFaceVertices(u + width + depth * 2, v + depth, u + width * 2 + depth * 2, v + height + depth);
    const uvAttr = box.attributes.uv;
    uvAttr.copyVector2sArray([
        right[3],
        right[2],
        right[0],
        right[1],
        left[3],
        left[2],
        left[0],
        left[1],
        top[3],
        top[2],
        top[0],
        top[1],
        bottom[0],
        bottom[1],
        bottom[3],
        bottom[2],
        front[3],
        front[2],
        front[0],
        front[1],
        back[3],
        back[2],
        back[0],
        back[1]
    ]);
    uvAttr.needsUpdate = true;
}
function $43ff881bd78cd4f7$var$setSkinUVs(box, u, v, width, height, depth) {
    $43ff881bd78cd4f7$var$setUVs(box, u, v, width, height, depth, 64, 64);
}
function $43ff881bd78cd4f7$var$setCapeUVs(box, u, v, width, height, depth) {
    $43ff881bd78cd4f7$var$setUVs(box, u, v, width, height, depth, 64, 32);
}
class $43ff881bd78cd4f7$export$f8730a012e88d71c extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(innerLayer, outerLayer){
        super();
        this.innerLayer = innerLayer;
        this.outerLayer = outerLayer;
        innerLayer.name = "inner";
        outerLayer.name = "outer";
    }
}
class $43ff881bd78cd4f7$export$a8a60345eadc09fd extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(){
        super();
        this.modelListeners = []; // called when model(slim property) is changed
        this.slim = false;
        this._map = null;
        this.layer1Material = new (0, $824f5e122dad54af$export$f2980790215acccd)({
            side: (0, $824f5e122dad54af$export$2ede184fc2998901)
        });
        this.layer2Material = new (0, $824f5e122dad54af$export$f2980790215acccd)({
            side: (0, $824f5e122dad54af$export$3b296b6f144d5b03),
            transparent: true,
            alphaTest: 1e-5
        });
        this.layer1MaterialBiased = this.layer1Material.clone();
        this.layer1MaterialBiased.polygonOffset = true;
        this.layer1MaterialBiased.polygonOffsetFactor = 1.0;
        this.layer1MaterialBiased.polygonOffsetUnits = 1.0;
        this.layer2MaterialBiased = this.layer2Material.clone();
        this.layer2MaterialBiased.polygonOffset = true;
        this.layer2MaterialBiased.polygonOffsetFactor = 1.0;
        this.layer2MaterialBiased.polygonOffsetUnits = 1.0;
        // Head
        const headBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(8, 8, 8);
        $43ff881bd78cd4f7$var$setSkinUVs(headBox, 0, 0, 8, 8, 8);
        const headMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(headBox, this.layer1Material);
        const head2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(9, 9, 9);
        $43ff881bd78cd4f7$var$setSkinUVs(head2Box, 32, 0, 8, 8, 8);
        const head2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(head2Box, this.layer2Material);
        this.head = new $43ff881bd78cd4f7$export$f8730a012e88d71c(headMesh, head2Mesh);
        this.head.name = "head";
        this.head.add(headMesh, head2Mesh);
        headMesh.position.y = 4;
        head2Mesh.position.y = 4;
        this.add(this.head);
        // Body
        const bodyBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(8, 12, 4);
        $43ff881bd78cd4f7$var$setSkinUVs(bodyBox, 16, 16, 8, 12, 4);
        const bodyMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(bodyBox, this.layer1Material);
        const body2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(8.5, 12.5, 4.5);
        $43ff881bd78cd4f7$var$setSkinUVs(body2Box, 16, 32, 8, 12, 4);
        const body2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(body2Box, this.layer2Material);
        this.body = new $43ff881bd78cd4f7$export$f8730a012e88d71c(bodyMesh, body2Mesh);
        this.body.name = "body";
        this.body.add(bodyMesh, body2Mesh);
        this.body.position.y = -6;
        this.add(this.body);
        // Right Arm
        const rightArmBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)();
        const rightArmMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(rightArmBox, this.layer1MaterialBiased);
        this.modelListeners.push(()=>{
            rightArmMesh.scale.x = this.slim ? 3 : 4;
            rightArmMesh.scale.y = 12;
            rightArmMesh.scale.z = 4;
            $43ff881bd78cd4f7$var$setSkinUVs(rightArmBox, 40, 16, this.slim ? 3 : 4, 12, 4);
        });
        const rightArm2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)();
        const rightArm2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(rightArm2Box, this.layer2MaterialBiased);
        this.modelListeners.push(()=>{
            rightArm2Mesh.scale.x = this.slim ? 3.5 : 4.5;
            rightArm2Mesh.scale.y = 12.5;
            rightArm2Mesh.scale.z = 4.5;
            $43ff881bd78cd4f7$var$setSkinUVs(rightArm2Box, 40, 32, this.slim ? 3 : 4, 12, 4);
        });
        const rightArmPivot = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        rightArmPivot.add(rightArmMesh, rightArm2Mesh);
        this.modelListeners.push(()=>{
            rightArmPivot.position.x = this.slim ? -0.5 : -1;
        });
        rightArmPivot.position.y = -4;
        this.rightArm = new $43ff881bd78cd4f7$export$f8730a012e88d71c(rightArmMesh, rightArm2Mesh);
        this.rightArm.name = "rightArm";
        this.rightArm.add(rightArmPivot);
        this.rightArm.position.x = -5;
        this.rightArm.position.y = -2;
        this.add(this.rightArm);
        // Left Arm
        const leftArmBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)();
        const leftArmMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(leftArmBox, this.layer1MaterialBiased);
        this.modelListeners.push(()=>{
            leftArmMesh.scale.x = this.slim ? 3 : 4;
            leftArmMesh.scale.y = 12;
            leftArmMesh.scale.z = 4;
            $43ff881bd78cd4f7$var$setSkinUVs(leftArmBox, 32, 48, this.slim ? 3 : 4, 12, 4);
        });
        const leftArm2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)();
        const leftArm2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(leftArm2Box, this.layer2MaterialBiased);
        this.modelListeners.push(()=>{
            leftArm2Mesh.scale.x = this.slim ? 3.5 : 4.5;
            leftArm2Mesh.scale.y = 12.5;
            leftArm2Mesh.scale.z = 4.5;
            $43ff881bd78cd4f7$var$setSkinUVs(leftArm2Box, 48, 48, this.slim ? 3 : 4, 12, 4);
        });
        const leftArmPivot = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        leftArmPivot.add(leftArmMesh, leftArm2Mesh);
        this.modelListeners.push(()=>{
            leftArmPivot.position.x = this.slim ? 0.5 : 1;
        });
        leftArmPivot.position.y = -4;
        this.leftArm = new $43ff881bd78cd4f7$export$f8730a012e88d71c(leftArmMesh, leftArm2Mesh);
        this.leftArm.name = "leftArm";
        this.leftArm.add(leftArmPivot);
        this.leftArm.position.x = 5;
        this.leftArm.position.y = -2;
        this.add(this.leftArm);
        // Right Leg
        const rightLegBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(4, 12, 4);
        $43ff881bd78cd4f7$var$setSkinUVs(rightLegBox, 0, 16, 4, 12, 4);
        const rightLegMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(rightLegBox, this.layer1MaterialBiased);
        const rightLeg2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(4.5, 12.5, 4.5);
        $43ff881bd78cd4f7$var$setSkinUVs(rightLeg2Box, 0, 32, 4, 12, 4);
        const rightLeg2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(rightLeg2Box, this.layer2MaterialBiased);
        const rightLegPivot = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        rightLegPivot.add(rightLegMesh, rightLeg2Mesh);
        rightLegPivot.position.y = -6;
        this.rightLeg = new $43ff881bd78cd4f7$export$f8730a012e88d71c(rightLegMesh, rightLeg2Mesh);
        this.rightLeg.name = "rightLeg";
        this.rightLeg.add(rightLegPivot);
        this.rightLeg.position.x = -1.9;
        this.rightLeg.position.y = -12;
        this.rightLeg.position.z = -0.1;
        this.add(this.rightLeg);
        // Left Leg
        const leftLegBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(4, 12, 4);
        $43ff881bd78cd4f7$var$setSkinUVs(leftLegBox, 16, 48, 4, 12, 4);
        const leftLegMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(leftLegBox, this.layer1MaterialBiased);
        const leftLeg2Box = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(4.5, 12.5, 4.5);
        $43ff881bd78cd4f7$var$setSkinUVs(leftLeg2Box, 0, 48, 4, 12, 4);
        const leftLeg2Mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(leftLeg2Box, this.layer2MaterialBiased);
        const leftLegPivot = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        leftLegPivot.add(leftLegMesh, leftLeg2Mesh);
        leftLegPivot.position.y = -6;
        this.leftLeg = new $43ff881bd78cd4f7$export$f8730a012e88d71c(leftLegMesh, leftLeg2Mesh);
        this.leftLeg.name = "leftLeg";
        this.leftLeg.add(leftLegPivot);
        this.leftLeg.position.x = 1.9;
        this.leftLeg.position.y = -12;
        this.leftLeg.position.z = -0.1;
        this.add(this.leftLeg);
        this.modelType = "default";
    }
    get map() {
        return this._map;
    }
    set map(newMap) {
        this._map = newMap;
        this.layer1Material.map = newMap;
        this.layer1Material.needsUpdate = true;
        this.layer1MaterialBiased.map = newMap;
        this.layer1MaterialBiased.needsUpdate = true;
        this.layer2Material.map = newMap;
        this.layer2Material.needsUpdate = true;
        this.layer2MaterialBiased.map = newMap;
        this.layer2MaterialBiased.needsUpdate = true;
    }
    get modelType() {
        return this.slim ? "slim" : "default";
    }
    set modelType(value) {
        this.slim = value === "slim";
        this.modelListeners.forEach((listener)=>listener());
    }
    getBodyParts() {
        return this.children.filter((it)=>it instanceof $43ff881bd78cd4f7$export$f8730a012e88d71c);
    }
    setInnerLayerVisible(value) {
        this.getBodyParts().forEach((part)=>part.innerLayer.visible = value);
    }
    setOuterLayerVisible(value) {
        this.getBodyParts().forEach((part)=>part.outerLayer.visible = value);
    }
    resetJoints() {
        this.head.rotation.set(0, 0, 0);
        this.leftArm.rotation.set(0, 0, 0);
        this.rightArm.rotation.set(0, 0, 0);
        this.leftLeg.rotation.set(0, 0, 0);
        this.rightLeg.rotation.set(0, 0, 0);
    }
}
class $43ff881bd78cd4f7$export$502aecf59b19ccfb extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(){
        super();
        this.material = new (0, $824f5e122dad54af$export$f2980790215acccd)({
            side: (0, $824f5e122dad54af$export$3b296b6f144d5b03),
            transparent: true,
            alphaTest: 1e-5
        });
        // +z (front) - inside of cape
        // -z (back) - outside of cape
        const capeBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(10, 16, 1);
        $43ff881bd78cd4f7$var$setCapeUVs(capeBox, 0, 0, 10, 16, 1);
        this.cape = new (0, $824f5e122dad54af$export$e176487c05830cc5)(capeBox, this.material);
        this.cape.position.y = -8;
        this.cape.position.z = .5;
        this.add(this.cape);
    }
    get map() {
        return this.material.map;
    }
    set map(newMap) {
        this.material.map = newMap;
        this.material.needsUpdate = true;
    }
}
class $43ff881bd78cd4f7$export$863e7b2e03ffbed9 extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(){
        super();
        this.material = new (0, $824f5e122dad54af$export$f2980790215acccd)({
            side: (0, $824f5e122dad54af$export$3b296b6f144d5b03),
            transparent: true,
            alphaTest: 1e-5
        });
        const leftWingBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(12, 22, 4);
        $43ff881bd78cd4f7$var$setCapeUVs(leftWingBox, 22, 0, 10, 20, 2);
        const leftWingMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(leftWingBox, this.material);
        leftWingMesh.position.x = -5;
        leftWingMesh.position.y = -10;
        leftWingMesh.position.z = -1;
        this.leftWing = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        this.leftWing.add(leftWingMesh);
        this.add(this.leftWing);
        const rightWingBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(12, 22, 4);
        $43ff881bd78cd4f7$var$setCapeUVs(rightWingBox, 22, 0, 10, 20, 2);
        const rightWingMesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)(rightWingBox, this.material);
        rightWingMesh.scale.x = -1;
        rightWingMesh.position.x = 5;
        rightWingMesh.position.y = -10;
        rightWingMesh.position.z = -1;
        this.rightWing = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        this.rightWing.add(rightWingMesh);
        this.add(this.rightWing);
        this.leftWing.position.x = 5;
        this.leftWing.rotation.x = .2617994;
        this.resetJoints();
    }
    resetJoints() {
        this.leftWing.rotation.y = .01; // to avoid z-fighting
        this.leftWing.rotation.z = .2617994;
        this.updateRightWing();
    }
    /**
     * Mirrors the position & rotation of left wing,
     * and apply them to the right wing.
     */ updateRightWing() {
        this.rightWing.position.x = -this.leftWing.position.x;
        this.rightWing.position.y = this.leftWing.position.y;
        this.rightWing.rotation.x = this.leftWing.rotation.x;
        this.rightWing.rotation.y = -this.leftWing.rotation.y;
        this.rightWing.rotation.z = -this.leftWing.rotation.z;
    }
    get map() {
        return this.material.map;
    }
    set map(newMap) {
        this.material.map = newMap;
        this.material.needsUpdate = true;
    }
}
class $43ff881bd78cd4f7$export$d4b24823ff19595a extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(){
        super();
        this.material = new (0, $824f5e122dad54af$export$f2980790215acccd)({
            side: (0, $824f5e122dad54af$export$2ede184fc2998901)
        });
        const earBox = new (0, $824f5e122dad54af$export$ab3456a079aa7d80)(8, 8, 4 / 3);
        $43ff881bd78cd4f7$var$setUVs(earBox, 0, 0, 6, 6, 1, 14, 7);
        this.rightEar = new (0, $824f5e122dad54af$export$e176487c05830cc5)(earBox, this.material);
        this.rightEar.name = "rightEar";
        this.rightEar.position.x = -6;
        this.add(this.rightEar);
        this.leftEar = new (0, $824f5e122dad54af$export$e176487c05830cc5)(earBox, this.material);
        this.leftEar.name = "leftEar";
        this.leftEar.position.x = 6;
        this.add(this.leftEar);
    }
    get map() {
        return this.material.map;
    }
    set map(newMap) {
        this.material.map = newMap;
        this.material.needsUpdate = true;
    }
}
const $43ff881bd78cd4f7$var$CapeDefaultAngle = 10.8 * Math.PI / 180;
class $43ff881bd78cd4f7$export$3392198d5a2a5d25 extends (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4) {
    constructor(){
        super();
        this.skin = new $43ff881bd78cd4f7$export$a8a60345eadc09fd();
        this.skin.name = "skin";
        this.skin.position.y = 8;
        this.add(this.skin);
        this.cape = new $43ff881bd78cd4f7$export$502aecf59b19ccfb();
        this.cape.name = "cape";
        this.cape.position.y = 8;
        this.cape.position.z = -2;
        this.cape.rotation.x = $43ff881bd78cd4f7$var$CapeDefaultAngle;
        this.cape.rotation.y = Math.PI;
        this.add(this.cape);
        this.elytra = new $43ff881bd78cd4f7$export$863e7b2e03ffbed9();
        this.elytra.name = "elytra";
        this.elytra.position.y = 8;
        this.elytra.position.z = -2;
        this.elytra.visible = false;
        this.add(this.elytra);
        this.ears = new $43ff881bd78cd4f7$export$d4b24823ff19595a();
        this.ears.name = "ears";
        this.ears.position.y = 10;
        this.ears.position.z = 2 / 3;
        this.ears.visible = false;
        this.skin.head.add(this.ears);
    }
    get backEquipment() {
        if (this.cape.visible) return "cape";
        else if (this.elytra.visible) return "elytra";
        else return null;
    }
    set backEquipment(value) {
        this.cape.visible = value === "cape";
        this.elytra.visible = value === "elytra";
    }
    resetJoints() {
        this.skin.resetJoints();
        this.cape.rotation.x = $43ff881bd78cd4f7$var$CapeDefaultAngle;
        this.elytra.resetJoints();
    }
}


function $babb75b92e7c00bd$export$e670a942b4642d21(value) {
    return value instanceof HTMLImageElement || value instanceof HTMLVideoElement || value instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && value instanceof ImageBitmap || typeof OffscreenCanvas !== "undefined" && value instanceof OffscreenCanvas;
}


function $c5e9d68c13022cdf$var$copyImage(context, sX, sY, w, h, dX, dY, flipHorizontal) {
    const imgData = context.getImageData(sX, sY, w, h);
    if (flipHorizontal) {
        for(let y = 0; y < h; y++)for(let x = 0; x < w / 2; x++){
            const index = (x + y * w) * 4;
            const index2 = (w - x - 1 + y * w) * 4;
            const pA1 = imgData.data[index];
            const pA2 = imgData.data[index + 1];
            const pA3 = imgData.data[index + 2];
            const pA4 = imgData.data[index + 3];
            const pB1 = imgData.data[index2];
            const pB2 = imgData.data[index2 + 1];
            const pB3 = imgData.data[index2 + 2];
            const pB4 = imgData.data[index2 + 3];
            imgData.data[index] = pB1;
            imgData.data[index + 1] = pB2;
            imgData.data[index + 2] = pB3;
            imgData.data[index + 3] = pB4;
            imgData.data[index2] = pA1;
            imgData.data[index2 + 1] = pA2;
            imgData.data[index2 + 2] = pA3;
            imgData.data[index2 + 3] = pA4;
        }
    }
    context.putImageData(imgData, dX, dY);
}
function $c5e9d68c13022cdf$var$hasTransparency(context, x0, y0, w, h) {
    const imgData = context.getImageData(x0, y0, w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const offset = (x + y * w) * 4;
        if (imgData.data[offset + 3] !== 0xff) return true;
    }
    return false;
}
function $c5e9d68c13022cdf$var$computeSkinScale(width) {
    return width / 64.0;
}
function $c5e9d68c13022cdf$var$fixOpaqueSkin(context, width, format1_8) {
    // see https://github.com/bs-community/skinview3d/issues/15
    // see https://github.com/bs-community/skinview3d/issues/93
    // check whether the skin has opaque background
    if (format1_8) {
        if ($c5e9d68c13022cdf$var$hasTransparency(context, 0, 0, width, width)) return;
    } else {
        if ($c5e9d68c13022cdf$var$hasTransparency(context, 0, 0, width, width / 2)) return;
    }
    const scale = $c5e9d68c13022cdf$var$computeSkinScale(width);
    const clearArea = (x, y, w, h)=>context.clearRect(x * scale, y * scale, w * scale, h * scale);
    clearArea(40, 0, 8, 8); // Helm Top
    clearArea(48, 0, 8, 8); // Helm Bottom
    clearArea(32, 8, 8, 8); // Helm Right
    clearArea(40, 8, 8, 8); // Helm Front
    clearArea(48, 8, 8, 8); // Helm Left
    clearArea(56, 8, 8, 8); // Helm Back
    if (format1_8) {
        clearArea(4, 32, 4, 4); // Right Leg Layer 2 Top
        clearArea(8, 32, 4, 4); // Right Leg Layer 2 Bottom
        clearArea(0, 36, 4, 12); // Right Leg Layer 2 Right
        clearArea(4, 36, 4, 12); // Right Leg Layer 2 Front
        clearArea(8, 36, 4, 12); // Right Leg Layer 2 Left
        clearArea(12, 36, 4, 12); // Right Leg Layer 2 Back
        clearArea(20, 32, 8, 4); // Torso Layer 2 Top
        clearArea(28, 32, 8, 4); // Torso Layer 2 Bottom
        clearArea(16, 36, 4, 12); // Torso Layer 2 Right
        clearArea(20, 36, 8, 12); // Torso Layer 2 Front
        clearArea(28, 36, 4, 12); // Torso Layer 2 Left
        clearArea(32, 36, 8, 12); // Torso Layer 2 Back
        clearArea(44, 32, 4, 4); // Right Arm Layer 2 Top
        clearArea(48, 32, 4, 4); // Right Arm Layer 2 Bottom
        clearArea(40, 36, 4, 12); // Right Arm Layer 2 Right
        clearArea(44, 36, 4, 12); // Right Arm Layer 2 Front
        clearArea(48, 36, 4, 12); // Right Arm Layer 2 Left
        clearArea(52, 36, 12, 12); // Right Arm Layer 2 Back
        clearArea(4, 48, 4, 4); // Left Leg Layer 2 Top
        clearArea(8, 48, 4, 4); // Left Leg Layer 2 Bottom
        clearArea(0, 52, 4, 12); // Left Leg Layer 2 Right
        clearArea(4, 52, 4, 12); // Left Leg Layer 2 Front
        clearArea(8, 52, 4, 12); // Left Leg Layer 2 Left
        clearArea(12, 52, 4, 12); // Left Leg Layer 2 Back
        clearArea(52, 48, 4, 4); // Left Arm Layer 2 Top
        clearArea(56, 48, 4, 4); // Left Arm Layer 2 Bottom
        clearArea(48, 52, 4, 12); // Left Arm Layer 2 Right
        clearArea(52, 52, 4, 12); // Left Arm Layer 2 Front
        clearArea(56, 52, 4, 12); // Left Arm Layer 2 Left
        clearArea(60, 52, 4, 12); // Left Arm Layer 2 Back
    }
}
function $c5e9d68c13022cdf$var$convertSkinTo1_8(context, width) {
    const scale = $c5e9d68c13022cdf$var$computeSkinScale(width);
    const copySkin = (sX, sY, w, h, dX, dY, flipHorizontal)=>$c5e9d68c13022cdf$var$copyImage(context, sX * scale, sY * scale, w * scale, h * scale, dX * scale, dY * scale, flipHorizontal);
    copySkin(4, 16, 4, 4, 20, 48, true); // Top Leg
    copySkin(8, 16, 4, 4, 24, 48, true); // Bottom Leg
    copySkin(0, 20, 4, 12, 24, 52, true); // Outer Leg
    copySkin(4, 20, 4, 12, 20, 52, true); // Front Leg
    copySkin(8, 20, 4, 12, 16, 52, true); // Inner Leg
    copySkin(12, 20, 4, 12, 28, 52, true); // Back Leg
    copySkin(44, 16, 4, 4, 36, 48, true); // Top Arm
    copySkin(48, 16, 4, 4, 40, 48, true); // Bottom Arm
    copySkin(40, 20, 4, 12, 40, 52, true); // Outer Arm
    copySkin(44, 20, 4, 12, 36, 52, true); // Front Arm
    copySkin(48, 20, 4, 12, 32, 52, true); // Inner Arm
    copySkin(52, 20, 4, 12, 44, 52, true); // Back Arm
}
function $c5e9d68c13022cdf$export$e97ed89594729991(canvas, image) {
    let isOldFormat = false;
    if (image.width !== image.height) {
        if (image.width === 2 * image.height) isOldFormat = true;
        else throw new Error(`Bad skin size: ${image.width}x${image.height}`);
    }
    const context = canvas.getContext("2d");
    if (isOldFormat) {
        const sideLength = image.width;
        canvas.width = sideLength;
        canvas.height = sideLength;
        context.clearRect(0, 0, sideLength, sideLength);
        context.drawImage(image, 0, 0, sideLength, sideLength / 2.0);
        $c5e9d68c13022cdf$var$convertSkinTo1_8(context, sideLength);
        $c5e9d68c13022cdf$var$fixOpaqueSkin(context, canvas.width, false);
    } else {
        canvas.width = image.width;
        canvas.height = image.height;
        context.clearRect(0, 0, image.width, image.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        $c5e9d68c13022cdf$var$fixOpaqueSkin(context, canvas.width, true);
    }
}
function $c5e9d68c13022cdf$var$computeCapeScale(image) {
    if (image.width === 2 * image.height) // 64x32
    return image.width / 64;
    else if (image.width * 17 === image.height * 22) // 22x17
    return image.width / 22;
    else if (image.width * 11 === image.height * 23) // 46x22
    return image.width / 46;
    else throw new Error(`Bad cape size: ${image.width}x${image.height}`);
}
function $c5e9d68c13022cdf$export$a6f8afd863bdc5c8(canvas, image) {
    const scale = $c5e9d68c13022cdf$var$computeCapeScale(image);
    canvas.width = 64 * scale;
    canvas.height = 32 * scale;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, image.width, image.height);
}
function $c5e9d68c13022cdf$var$isAreaBlack(context, x0, y0, w, h) {
    const imgData = context.getImageData(x0, y0, w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const offset = (x + y * w) * 4;
        if (!(imgData.data[offset + 0] === 0 && imgData.data[offset + 1] === 0 && imgData.data[offset + 2] === 0 && imgData.data[offset + 3] === 0xff)) return false;
    }
    return true;
}
function $c5e9d68c13022cdf$var$isAreaWhite(context, x0, y0, w, h) {
    const imgData = context.getImageData(x0, y0, w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const offset = (x + y * w) * 4;
        if (!(imgData.data[offset + 0] === 0xff && imgData.data[offset + 1] === 0xff && imgData.data[offset + 2] === 0xff && imgData.data[offset + 3] === 0xff)) return false;
    }
    return true;
}
function $c5e9d68c13022cdf$export$6e7370d31b7d7026(canvas) {
    // The right arm area of *default* skins:
    // (44,16)->*-------*-------*
    // (40,20)  |top    |bottom |
    // \|/      |4x4    |4x4    |
    //  *-------*-------*-------*-------*
    //  |right  |front  |left   |back   |
    //  |4x12   |4x12   |4x12   |4x12   |
    //  *-------*-------*-------*-------*
    // The right arm area of *slim* skins:
    // (44,16)->*------*------*-*
    // (40,20)  |top   |bottom| |<----[x0=50,y0=16,w=2,h=4]
    // \|/      |3x4   |3x4   | |
    //  *-------*------*------***-----*-*
    //  |right  |front |left   |back  | |<----[x0=54,y0=20,w=2,h=12]
    //  |4x12   |3x12  |4x12   |3x12  | |
    //  *-------*------*-------*------*-*
    // Compared with default right arms, slim right arms have 2 unused areas.
    //
    // The same is true for left arm:
    // The left arm area of *default* skins:
    // (36,48)->*-------*-------*
    // (32,52)  |top    |bottom |
    // \|/      |4x4    |4x4    |
    //  *-------*-------*-------*-------*
    //  |right  |front  |left   |back   |
    //  |4x12   |4x12   |4x12   |4x12   |
    //  *-------*-------*-------*-------*
    // The left arm area of *slim* skins:
    // (36,48)->*------*------*-*
    // (32,52)  |top   |bottom| |<----[x0=42,y0=48,w=2,h=4]
    // \|/      |3x4   |3x4   | |
    //  *-------*------*------***-----*-*
    //  |right  |front |left   |back  | |<----[x0=46,y0=52,w=2,h=12]
    //  |4x12   |3x12  |4x12   |3x12  | |
    //  *-------*------*-------*------*-*
    //
    // If there is a transparent pixel in any of the 4 unused areas, the skin must be slim,
    // as transparent pixels are not allowed in the first layer.
    // If the 4 areas are all black or all white, the skin is also considered as slim.
    const scale = $c5e9d68c13022cdf$var$computeSkinScale(canvas.width);
    const context = canvas.getContext("2d");
    const checkTransparency = (x, y, w, h)=>$c5e9d68c13022cdf$var$hasTransparency(context, x * scale, y * scale, w * scale, h * scale);
    const checkBlack = (x, y, w, h)=>$c5e9d68c13022cdf$var$isAreaBlack(context, x * scale, y * scale, w * scale, h * scale);
    const checkWhite = (x, y, w, h)=>$c5e9d68c13022cdf$var$isAreaWhite(context, x * scale, y * scale, w * scale, h * scale);
    const isSlim = checkTransparency(50, 16, 2, 4) || checkTransparency(54, 20, 2, 12) || checkTransparency(42, 48, 2, 4) || checkTransparency(46, 52, 2, 12) || checkBlack(50, 16, 2, 4) && checkBlack(54, 20, 2, 12) && checkBlack(42, 48, 2, 4) && checkBlack(46, 52, 2, 12) || checkWhite(50, 16, 2, 4) && checkWhite(54, 20, 2, 12) && checkWhite(42, 48, 2, 4) && checkWhite(46, 52, 2, 12);
    return isSlim ? "slim" : "default";
}
function $c5e9d68c13022cdf$var$computeEarsScale(image) {
    if (image.width === image.height * 2 && image.height % 7 === 0) return image.height / 7;
    else throw new Error(`Bad ears size: ${image.width}x${image.height}`);
}
function $c5e9d68c13022cdf$export$16b3dc87096ae892(canvas, image) {
    const scale = $c5e9d68c13022cdf$var$computeEarsScale(image);
    canvas.width = 14 * scale;
    canvas.height = 7 * scale;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, image.width, image.height);
}
function $c5e9d68c13022cdf$export$5e33df73376b7be8(canvas, image) {
    if (image.width !== image.height && image.width !== 2 * image.height) throw new Error(`Bad skin size: ${image.width}x${image.height}`);
    const scale = $c5e9d68c13022cdf$var$computeSkinScale(image.width);
    const w = 14 * scale;
    const h = 7 * scale;
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, w, h);
    context.drawImage(image, 24 * scale, 0, w, h, 0, 0, w, h);
}


async function $d13a011c37e5f769$export$fe58198efe02b173(source) {
    const image = document.createElement("img");
    return new Promise((resolve, reject)=>{
        image.onload = ()=>resolve(image);
        image.onerror = reject;
        image.crossOrigin = "anonymous";
        if (typeof source === "string") image.src = source;
        else {
            if (source.crossOrigin !== undefined) image.crossOrigin = source.crossOrigin;
            if (source.referrerPolicy !== undefined) image.referrerPolicy = source.referrerPolicy;
            image.src = source.src;
        }
    });
}






// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $8fa0446d97946485$var$_changeEvent = {
    type: "change"
};
const $8fa0446d97946485$var$_startEvent = {
    type: "start"
};
const $8fa0446d97946485$var$_endEvent = {
    type: "end"
};
class $8fa0446d97946485$export$8ff7788029dfdf52 extends (0, $824f5e122dad54af$export$ec8b666c5fe2c75a) {
    constructor(object, domElement){
        super();
        if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
        this.object = object;
        this.domElement = domElement;
        this.domElement.style.touchAction = "none"; // disable touch scroll
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $824f5e122dad54af$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $824f5e122dad54af$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $824f5e122dad54af$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $824f5e122dad54af$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $824f5e122dad54af$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        //
        // public methods
        //
        this.getPolarAngle = function() {
            return spherical.phi;
        };
        this.getAzimuthalAngle = function() {
            return spherical.theta;
        };
        this.getDistance = function() {
            return this.object.position.distanceTo(this.target);
        };
        this.listenToKeyEvents = function(domElement) {
            domElement.addEventListener("keydown", onKeyDown);
            this._domElementKeyEvents = domElement;
        };
        this.saveState = function() {
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;
        };
        this.reset = function() {
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent($8fa0446d97946485$var$_changeEvent);
            scope.update();
            state = STATE.NONE;
        };
        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function() {
            const offset = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
            // so camera.up is the orbit axis
            const quat = new (0, $824f5e122dad54af$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $824f5e122dad54af$export$64b5c384219d3699)(0, 1, 0));
            const quatInverse = quat.clone().invert();
            const lastPosition = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
            const lastQuaternion = new (0, $824f5e122dad54af$export$23d6a54f0bbc85a3)();
            const twoPI = 2 * Math.PI;
            return function update() {
                const position = scope.object.position;
                offset.copy(position).sub(scope.target);
                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);
                // angle from z-axis around y-axis
                spherical.setFromVector3(offset);
                if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                }
                // restrict theta to be between desired limits
                let min = scope.minAzimuthAngle;
                let max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                    else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
                }
                // restrict phi to be between desired limits
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
                spherical.makeSafe();
                spherical.radius *= scale;
                // restrict radius to be between desired limits
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
                // move target to panned location
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offset.setFromSpherical(spherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                scope.object.lookAt(scope.target);
                if (scope.enableDamping === true) {
                    sphericalDelta.theta *= 1 - scope.dampingFactor;
                    sphericalDelta.phi *= 1 - scope.dampingFactor;
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                } else {
                    sphericalDelta.set(0, 0, 0);
                    panOffset.set(0, 0, 0);
                }
                scale = 1;
                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8
                if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    scope.dispatchEvent($8fa0446d97946485$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        }();
        this.dispose = function() {
            scope.domElement.removeEventListener("contextmenu", onContextMenu);
            scope.domElement.removeEventListener("pointerdown", onPointerDown);
            scope.domElement.removeEventListener("pointercancel", onPointerCancel);
            scope.domElement.removeEventListener("wheel", onMouseWheel);
            scope.domElement.removeEventListener("pointermove", onPointerMove);
            scope.domElement.removeEventListener("pointerup", onPointerUp);
            if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
        //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };
        //
        // internals
        //
        const scope = this;
        const STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        let state = STATE.NONE;
        const EPS = 0.000001;
        // current position in spherical coordinates
        const spherical = new (0, $824f5e122dad54af$export$d712cd887b4a00f7)();
        const sphericalDelta = new (0, $824f5e122dad54af$export$d712cd887b4a00f7)();
        let scale = 1;
        const panOffset = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
        let zoomChanged = false;
        const rotateStart = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const rotateEnd = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const rotateDelta = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const panStart = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const panEnd = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const panDelta = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const dollyStart = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const dollyEnd = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const dollyDelta = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
        const pointers = [];
        const pointerPositions = {};
        function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        }
        function getZoomScale() {
            return Math.pow(0.95, scope.zoomSpeed);
        }
        function rotateLeft(angle) {
            sphericalDelta.theta -= angle;
        }
        function rotateUp(angle) {
            sphericalDelta.phi -= angle;
        }
        const panLeft = function() {
            const v = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
            return function panLeft(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        }();
        const panUp = function() {
            const v = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
            return function panUp(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        }();
        // deltaX and deltaY are in pixels; right and down are positive
        const pan = function() {
            const offset = new (0, $824f5e122dad54af$export$64b5c384219d3699)();
            return function pan(deltaX, deltaY) {
                const element = scope.domElement;
                if (scope.object.isPerspectiveCamera) {
                    // perspective
                    const position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();
                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
                    // we use only clientHeight here so aspect ratio does not distort speed
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
                } else if (scope.object.isOrthographicCamera) {
                    // orthographic
                    panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
                } else {
                    // camera neither orthographic nor perspective
                    console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
                    scope.enablePan = false;
                }
            };
        }();
        function dollyOut(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale /= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        function dollyIn(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale *= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        //
        // event callbacks - update the object state
        //
        function handleMouseDownRotate(event) {
            rotateStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        }
        function handleMouseMoveRotate(event) {
            rotateEnd.set(event.clientX, event.clientY);
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
            scope.update();
        }
        function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        }
        function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        }
        function handleMouseWheel(event) {
            if (event.deltaY < 0) dollyIn(getZoomScale());
            else if (event.deltaY > 0) dollyOut(getZoomScale());
            scope.update();
        }
        function handleKeyDown(event) {
            let needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                // prevent the browser from scrolling on cursor keys
                event.preventDefault();
                scope.update();
            }
        }
        function handleTouchStartRotate() {
            if (pointers.length === 1) rotateStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                rotateStart.set(x, y);
            }
        }
        function handleTouchStartPan() {
            if (pointers.length === 1) panStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                panStart.set(x, y);
            }
        }
        function handleTouchStartDolly() {
            const dx = pointers[0].pageX - pointers[1].pageX;
            const dy = pointers[0].pageY - pointers[1].pageY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        }
        function handleTouchStartDollyPan() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enablePan) handleTouchStartPan();
        }
        function handleTouchStartDollyRotate() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enableRotate) handleTouchStartRotate();
        }
        function handleTouchMoveRotate(event) {
            if (pointers.length == 1) rotateEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                rotateEnd.set(x, y);
            }
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
        }
        function handleTouchMovePan(event) {
            if (pointers.length === 1) panEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        }
        function handleTouchMoveDolly(event) {
            const position = getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            dollyOut(dollyDelta.y);
            dollyStart.copy(dollyEnd);
        }
        function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        }
        function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        }
        //
        // event handlers - FSM: listen for events and reset state
        //
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            if (pointers.length === 0) {
                scope.domElement.setPointerCapture(event.pointerId);
                scope.domElement.addEventListener("pointermove", onPointerMove);
                scope.domElement.addEventListener("pointerup", onPointerUp);
            }
            //
            addPointer(event);
            if (event.pointerType === "touch") onTouchStart(event);
            else onMouseDown(event);
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === "touch") onTouchMove(event);
            else onMouseMove(event);
        }
        function onPointerUp(event) {
            removePointer(event);
            if (pointers.length === 0) {
                scope.domElement.releasePointerCapture(event.pointerId);
                scope.domElement.removeEventListener("pointermove", onPointerMove);
                scope.domElement.removeEventListener("pointerup", onPointerUp);
            }
            scope.dispatchEvent($8fa0446d97946485$var$_endEvent);
            state = STATE.NONE;
        }
        function onPointerCancel(event) {
            removePointer(event);
        }
        function onMouseDown(event) {
            let mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $824f5e122dad54af$export$7177b3e430c2d7ca).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    state = STATE.DOLLY;
                    break;
                case (0, $824f5e122dad54af$export$7177b3e430c2d7ca).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    }
                    break;
                case (0, $824f5e122dad54af$export$7177b3e430c2d7ca).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($8fa0446d97946485$var$_startEvent);
        }
        function onMouseMove(event) {
            if (scope.enabled === false) return;
            switch(state){
                case STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        }
        function onMouseWheel(event) {
            if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;
            event.preventDefault();
            scope.dispatchEvent($8fa0446d97946485$var$_startEvent);
            handleMouseWheel(event);
            scope.dispatchEvent($8fa0446d97946485$var$_endEvent);
        }
        function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        }
        function onTouchStart(event) {
            trackPointer(event);
            switch(pointers.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $824f5e122dad54af$export$d46bd3ead7cc759b).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate();
                            state = STATE.TOUCH_ROTATE;
                            break;
                        case (0, $824f5e122dad54af$export$d46bd3ead7cc759b).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan();
                            state = STATE.TOUCH_PAN;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $824f5e122dad54af$export$d46bd3ead7cc759b).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan();
                            state = STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $824f5e122dad54af$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate();
                            state = STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($8fa0446d97946485$var$_startEvent);
        }
        function onTouchMove(event) {
            trackPointer(event);
            switch(state){
                case STATE.TOUCH_ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    state = STATE.NONE;
            }
        }
        function onContextMenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        }
        function addPointer(event) {
            pointers.push(event);
        }
        function removePointer(event) {
            delete pointerPositions[event.pointerId];
            for(let i = 0; i < pointers.length; i++)if (pointers[i].pointerId == event.pointerId) {
                pointers.splice(i, 1);
                return;
            }
        }
        function trackPointer(event) {
            let position = pointerPositions[event.pointerId];
            if (position === undefined) {
                position = new (0, $824f5e122dad54af$export$c977b3e384af9ae1)();
                pointerPositions[event.pointerId] = position;
            }
            position.set(event.pageX, event.pageY);
        }
        function getSecondPointerPosition(event) {
            const pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
            return pointerPositions[pointer.pointerId];
        }
        //
        scope.domElement.addEventListener("contextmenu", onContextMenu);
        scope.domElement.addEventListener("pointerdown", onPointerDown);
        scope.domElement.addEventListener("pointercancel", onPointerCancel);
        scope.domElement.addEventListener("wheel", onMouseWheel, {
            passive: false
        });
        // force an update at start
        this.update();
    }
}
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
class $8fa0446d97946485$export$7628ccdac312035f extends $8fa0446d97946485$export$8ff7788029dfdf52 {
    constructor(object, domElement){
        super(object, domElement);
        this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up
        this.mouseButtons.LEFT = (0, $824f5e122dad54af$export$7177b3e430c2d7ca).PAN;
        this.mouseButtons.RIGHT = (0, $824f5e122dad54af$export$7177b3e430c2d7ca).ROTATE;
        this.touches.ONE = (0, $824f5e122dad54af$export$d46bd3ead7cc759b).PAN;
        this.touches.TWO = (0, $824f5e122dad54af$export$d46bd3ead7cc759b).DOLLY_ROTATE;
    }
}



/**
 * Full-screen textured quad shader
 */ const $7ab214301d0e7423$export$57f84a24a9a6130d = {
    uniforms: {
        "tDiffuse": {
            value: null
        },
        "opacity": {
            value: 1.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			gl_FragColor = texture2D( tDiffuse, vUv );
			gl_FragColor.a *= opacity;


		}`
};




class $164a6e4eae474e87$export$802bc10488da99c7 {
    constructor(){
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
}
// Helper for passes that need to fill the viewport with a single quad.
const $164a6e4eae474e87$var$_camera = new (0, $824f5e122dad54af$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
const $164a6e4eae474e87$var$_geometry = new (0, $824f5e122dad54af$export$b7be63a67df8959)();
$164a6e4eae474e87$var$_geometry.setAttribute("position", new (0, $824f5e122dad54af$export$cbe7a62641830ebd)([
    -1,
    3,
    0,
    -1,
    -1,
    0,
    3,
    -1,
    0
], 3));
$164a6e4eae474e87$var$_geometry.setAttribute("uv", new (0, $824f5e122dad54af$export$cbe7a62641830ebd)([
    0,
    2,
    0,
    0,
    2,
    0
], 2));
class $164a6e4eae474e87$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)($164a6e4eae474e87$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $164a6e4eae474e87$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}


class $0cc9bb0d64fa3588$export$c55093fd4f9e42f0 extends (0, $164a6e4eae474e87$export$802bc10488da99c7) {
    constructor(shader, textureID){
        super();
        this.textureID = textureID !== undefined ? textureID : "tDiffuse";
        if (shader instanceof (0, $824f5e122dad54af$export$83c7d75d550a8b0d)) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        } else if (shader) {
            this.uniforms = (0, $824f5e122dad54af$export$d8ecdf8615bfea69).clone(shader.uniforms);
            this.material = new (0, $824f5e122dad54af$export$83c7d75d550a8b0d)({
                defines: Object.assign({}, shader.defines),
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        this.fsQuad = new (0, $164a6e4eae474e87$export$3983474c8e6e978b)(this.material);
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
        this.fsQuad.material = this.material;
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this.fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(writeBuffer);
            // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
            if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
            this.fsQuad.render(renderer);
        }
    }
}



class $a3b8822c13b76abc$export$bb424a4005d6dde0 extends (0, $164a6e4eae474e87$export$802bc10488da99c7) {
    constructor(scene, camera){
        super();
        this.scene = scene;
        this.camera = camera;
        this.clear = true;
        this.needsSwap = false;
        this.inverse = false;
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const context = renderer.getContext();
        const state = renderer.state;
        // don't update color or depth
        state.buffers.color.setMask(false);
        state.buffers.depth.setMask(false);
        // lock buffers
        state.buffers.color.setLocked(true);
        state.buffers.depth.setLocked(true);
        // set up stencil
        let writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        } else {
            writeValue = 1;
            clearValue = 0;
        }
        state.buffers.stencil.setTest(true);
        state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
        state.buffers.stencil.setClear(clearValue);
        state.buffers.stencil.setLocked(true);
        // draw into the stencil buffer
        renderer.setRenderTarget(readBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        // unlock color and depth buffer for subsequent rendering
        state.buffers.color.setLocked(false);
        state.buffers.depth.setLocked(false);
        // only render where stencil is set to 1
        state.buffers.stencil.setLocked(false);
        state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        state.buffers.stencil.setLocked(true);
    }
}
class $a3b8822c13b76abc$export$8d8650aed29c6251 extends (0, $164a6e4eae474e87$export$802bc10488da99c7) {
    constructor(){
        super();
        this.needsSwap = false;
    }
    render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
        renderer.state.buffers.stencil.setLocked(false);
        renderer.state.buffers.stencil.setTest(false);
    }
}


class $3025dafbefabd73d$export$7fe01e6ab8aa748c {
    constructor(renderer, renderTarget){
        this.renderer = renderer;
        if (renderTarget === undefined) {
            const size = renderer.getSize(new (0, $824f5e122dad54af$export$c977b3e384af9ae1)());
            this._pixelRatio = renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $824f5e122dad54af$export$3c052beb2e51e23f)(this._width * this._pixelRatio, this._height * this._pixelRatio);
            renderTarget.texture.name = "EffectComposer.rt1";
        } else {
            this._pixelRatio = 1;
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = "EffectComposer.rt2";
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
        this.renderToScreen = true;
        this.passes = [];
        // dependencies
        if ((0, $7ab214301d0e7423$export$57f84a24a9a6130d) === undefined) console.error("THREE.EffectComposer relies on CopyShader");
        if ((0, $0cc9bb0d64fa3588$export$c55093fd4f9e42f0) === undefined) console.error("THREE.EffectComposer relies on ShaderPass");
        this.copyPass = new (0, $0cc9bb0d64fa3588$export$c55093fd4f9e42f0)((0, $7ab214301d0e7423$export$57f84a24a9a6130d));
        this.clock = new (0, $824f5e122dad54af$export$9735c82c4bae3302)();
    }
    swapBuffers() {
        const tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    }
    addPass(pass) {
        this.passes.push(pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    insertPass(pass, index) {
        this.passes.splice(index, 0, pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    removePass(pass) {
        const index = this.passes.indexOf(pass);
        if (index !== -1) this.passes.splice(index, 1);
    }
    isLastEnabledPass(passIndex) {
        for(let i = passIndex + 1; i < this.passes.length; i++){
            if (this.passes[i].enabled) return false;
        }
        return true;
    }
    render(deltaTime) {
        // deltaTime value is in seconds
        if (deltaTime === undefined) deltaTime = this.clock.getDelta();
        const currentRenderTarget = this.renderer.getRenderTarget();
        let maskActive = false;
        for(let i = 0, il = this.passes.length; i < il; i++){
            const pass = this.passes[i];
            if (pass.enabled === false) continue;
            pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    const context = this.renderer.getContext();
                    const stencil = this.renderer.state.buffers.stencil;
                    //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                    //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if ((0, $a3b8822c13b76abc$export$bb424a4005d6dde0) !== undefined) {
                if (pass instanceof (0, $a3b8822c13b76abc$export$bb424a4005d6dde0)) maskActive = true;
                else if (pass instanceof (0, $a3b8822c13b76abc$export$8d8650aed29c6251)) maskActive = false;
            }
        }
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    reset(renderTarget) {
        if (renderTarget === undefined) {
            const size = this.renderer.getSize(new (0, $824f5e122dad54af$export$c977b3e384af9ae1)());
            this._pixelRatio = this.renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = this.renderTarget1.clone();
            renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
        }
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
        this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
        for(let i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
    }
    setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
}
class $3025dafbefabd73d$export$802bc10488da99c7 {
    constructor(){
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
}
// Helper for passes that need to fill the viewport with a single quad.
const $3025dafbefabd73d$var$_camera = new (0, $824f5e122dad54af$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
const $3025dafbefabd73d$var$_geometry = new (0, $824f5e122dad54af$export$b7be63a67df8959)();
$3025dafbefabd73d$var$_geometry.setAttribute("position", new (0, $824f5e122dad54af$export$cbe7a62641830ebd)([
    -1,
    3,
    0,
    -1,
    -1,
    0,
    3,
    -1,
    0
], 3));
$3025dafbefabd73d$var$_geometry.setAttribute("uv", new (0, $824f5e122dad54af$export$cbe7a62641830ebd)([
    0,
    2,
    0,
    0,
    2,
    0
], 2));
class $3025dafbefabd73d$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $824f5e122dad54af$export$e176487c05830cc5)($3025dafbefabd73d$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $3025dafbefabd73d$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}




class $a642a177c98a7e3a$export$f63ea822f020b5b0 extends (0, $164a6e4eae474e87$export$802bc10488da99c7) {
    constructor(scene, camera, overrideMaterial, clearColor, clearAlpha){
        super();
        this.scene = scene;
        this.camera = camera;
        this.overrideMaterial = overrideMaterial;
        this.clearColor = clearColor;
        this.clearAlpha = clearAlpha !== undefined ? clearAlpha : 0;
        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;
        this._oldClearColor = new (0, $824f5e122dad54af$export$892596cec99bc70e)();
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        let oldClearAlpha, oldOverrideMaterial;
        if (this.overrideMaterial !== undefined) {
            oldOverrideMaterial = this.scene.overrideMaterial;
            this.scene.overrideMaterial = this.overrideMaterial;
        }
        if (this.clearColor) {
            renderer.getClearColor(this._oldClearColor);
            oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearColor(this.clearColor, this.clearAlpha);
        }
        if (this.clearDepth) renderer.clearDepth();
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
        if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        renderer.render(this.scene, this.camera);
        if (this.clearColor) renderer.setClearColor(this._oldClearColor, oldClearAlpha);
        if (this.overrideMaterial !== undefined) this.scene.overrideMaterial = oldOverrideMaterial;
        renderer.autoClear = oldAutoClear;
    }
}




/**
 * NVIDIA FXAA by Timothy Lottes
 * https://developer.download.nvidia.com/assets/gamedev/files/sdk/11/FXAA_WhitePaper.pdf
 * - WebGL port by @supereggbert
 * http://www.glge.org/demos/fxaa/
 * Further improved by Daniel Sturk
 */ const $00c7eb9ee8117d1e$export$f01fbdb03ef71c1d = {
    uniforms: {
        "tDiffuse": {
            value: null
        },
        "resolution": {
            value: new (0, $824f5e122dad54af$export$c977b3e384af9ae1)(1 / 1024, 1 / 512)
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: `
	precision highp float;

	uniform sampler2D tDiffuse;

	uniform vec2 resolution;

	varying vec2 vUv;

	// FXAA 3.11 implementation by NVIDIA, ported to WebGL by Agost Biro (biro@archilogic.com)

	//----------------------------------------------------------------------------------
	// File:        es3-kepler\FXAA\assets\shaders/FXAA_DefaultES.frag
	// SDK Version: v3.00
	// Email:       gameworks@nvidia.com
	// Site:        http://developer.nvidia.com/
	//
	// Copyright (c) 2014-2015, NVIDIA CORPORATION. All rights reserved.
	//
	// Redistribution and use in source and binary forms, with or without
	// modification, are permitted provided that the following conditions
	// are met:
	//  * Redistributions of source code must retain the above copyright
	//    notice, this list of conditions and the following disclaimer.
	//  * Redistributions in binary form must reproduce the above copyright
	//    notice, this list of conditions and the following disclaimer in the
	//    documentation and/or other materials provided with the distribution.
	//  * Neither the name of NVIDIA CORPORATION nor the names of its
	//    contributors may be used to endorse or promote products derived
	//    from this software without specific prior written permission.
	//
	// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS ''AS IS'' AND ANY
	// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
	// PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	//
	//----------------------------------------------------------------------------------

	#ifndef FXAA_DISCARD
			//
			// Only valid for PC OpenGL currently.
			// Probably will not work when FXAA_GREEN_AS_LUMA = 1.
			//
			// 1 = Use discard on pixels which don't need AA.
			//     For APIs which enable concurrent TEX+ROP from same surface.
			// 0 = Return unchanged color on pixels which don't need AA.
			//
			#define FXAA_DISCARD 0
	#endif

	/*--------------------------------------------------------------------------*/
	#define FxaaTexTop(t, p) texture2D(t, p, -100.0)
	#define FxaaTexOff(t, p, o, r) texture2D(t, p + (o * r), -100.0)
	/*--------------------------------------------------------------------------*/

	#define NUM_SAMPLES 5

	// assumes colors have premultipliedAlpha, so that the calculated color contrast is scaled by alpha
	float contrast( vec4 a, vec4 b ) {
			vec4 diff = abs( a - b );
			return max( max( max( diff.r, diff.g ), diff.b ), diff.a );
	}

	/*============================================================================

									FXAA3 QUALITY - PC

	============================================================================*/

	/*--------------------------------------------------------------------------*/
	vec4 FxaaPixelShader(
			vec2 posM,
			sampler2D tex,
			vec2 fxaaQualityRcpFrame,
			float fxaaQualityEdgeThreshold,
			float fxaaQualityinvEdgeThreshold
	) {
			vec4 rgbaM = FxaaTexTop(tex, posM);
			vec4 rgbaS = FxaaTexOff(tex, posM, vec2( 0.0, 1.0), fxaaQualityRcpFrame.xy);
			vec4 rgbaE = FxaaTexOff(tex, posM, vec2( 1.0, 0.0), fxaaQualityRcpFrame.xy);
			vec4 rgbaN = FxaaTexOff(tex, posM, vec2( 0.0,-1.0), fxaaQualityRcpFrame.xy);
			vec4 rgbaW = FxaaTexOff(tex, posM, vec2(-1.0, 0.0), fxaaQualityRcpFrame.xy);
			// . S .
			// W M E
			// . N .

			bool earlyExit = max( max( max(
					contrast( rgbaM, rgbaN ),
					contrast( rgbaM, rgbaS ) ),
					contrast( rgbaM, rgbaE ) ),
					contrast( rgbaM, rgbaW ) )
					< fxaaQualityEdgeThreshold;
			// . 0 .
			// 0 0 0
			// . 0 .

			#if (FXAA_DISCARD == 1)
					if(earlyExit) FxaaDiscard;
			#else
					if(earlyExit) return rgbaM;
			#endif

			float contrastN = contrast( rgbaM, rgbaN );
			float contrastS = contrast( rgbaM, rgbaS );
			float contrastE = contrast( rgbaM, rgbaE );
			float contrastW = contrast( rgbaM, rgbaW );

			float relativeVContrast = ( contrastN + contrastS ) - ( contrastE + contrastW );
			relativeVContrast *= fxaaQualityinvEdgeThreshold;

			bool horzSpan = relativeVContrast > 0.;
			// . 1 .
			// 0 0 0
			// . 1 .

			// 45 deg edge detection and corners of objects, aka V/H contrast is too similar
			if( abs( relativeVContrast ) < .3 ) {
					// locate the edge
					vec2 dirToEdge;
					dirToEdge.x = contrastE > contrastW ? 1. : -1.;
					dirToEdge.y = contrastS > contrastN ? 1. : -1.;
					// . 2 .      . 1 .
					// 1 0 2  ~=  0 0 1
					// . 1 .      . 0 .

					// tap 2 pixels and see which ones are "outside" the edge, to
					// determine if the edge is vertical or horizontal

					vec4 rgbaAlongH = FxaaTexOff(tex, posM, vec2( dirToEdge.x, -dirToEdge.y ), fxaaQualityRcpFrame.xy);
					float matchAlongH = contrast( rgbaM, rgbaAlongH );
					// . 1 .
					// 0 0 1
					// . 0 H

					vec4 rgbaAlongV = FxaaTexOff(tex, posM, vec2( -dirToEdge.x, dirToEdge.y ), fxaaQualityRcpFrame.xy);
					float matchAlongV = contrast( rgbaM, rgbaAlongV );
					// V 1 .
					// 0 0 1
					// . 0 .

					relativeVContrast = matchAlongV - matchAlongH;
					relativeVContrast *= fxaaQualityinvEdgeThreshold;

					if( abs( relativeVContrast ) < .3 ) { // 45 deg edge
							// 1 1 .
							// 0 0 1
							// . 0 1

							// do a simple blur
							return mix(
									rgbaM,
									(rgbaN + rgbaS + rgbaE + rgbaW) * .25,
									.4
							);
					}

					horzSpan = relativeVContrast > 0.;
			}

			if(!horzSpan) rgbaN = rgbaW;
			if(!horzSpan) rgbaS = rgbaE;
			// . 0 .      1
			// 1 0 1  ->  0
			// . 0 .      1

			bool pairN = contrast( rgbaM, rgbaN ) > contrast( rgbaM, rgbaS );
			if(!pairN) rgbaN = rgbaS;

			vec2 offNP;
			offNP.x = (!horzSpan) ? 0.0 : fxaaQualityRcpFrame.x;
			offNP.y = ( horzSpan) ? 0.0 : fxaaQualityRcpFrame.y;

			bool doneN = false;
			bool doneP = false;

			float nDist = 0.;
			float pDist = 0.;

			vec2 posN = posM;
			vec2 posP = posM;

			int iterationsUsed = 0;
			int iterationsUsedN = 0;
			int iterationsUsedP = 0;
			for( int i = 0; i < NUM_SAMPLES; i++ ) {
					iterationsUsed = i;

					float increment = float(i + 1);

					if(!doneN) {
							nDist += increment;
							posN = posM + offNP * nDist;
							vec4 rgbaEndN = FxaaTexTop(tex, posN.xy);
							doneN = contrast( rgbaEndN, rgbaM ) > contrast( rgbaEndN, rgbaN );
							iterationsUsedN = i;
					}

					if(!doneP) {
							pDist += increment;
							posP = posM - offNP * pDist;
							vec4 rgbaEndP = FxaaTexTop(tex, posP.xy);
							doneP = contrast( rgbaEndP, rgbaM ) > contrast( rgbaEndP, rgbaN );
							iterationsUsedP = i;
					}

					if(doneN || doneP) break;
			}


			if ( !doneP && !doneN ) return rgbaM; // failed to find end of edge

			float dist = min(
					doneN ? float( iterationsUsedN ) / float( NUM_SAMPLES - 1 ) : 1.,
					doneP ? float( iterationsUsedP ) / float( NUM_SAMPLES - 1 ) : 1.
			);

			// hacky way of reduces blurriness of mostly diagonal edges
			// but reduces AA quality
			dist = pow(dist, .5);

			dist = 1. - dist;

			return mix(
					rgbaM,
					rgbaN,
					dist * .5
			);
	}

	void main() {
			const float edgeDetectionQuality = .2;
			const float invEdgeDetectionQuality = 1. / edgeDetectionQuality;

			gl_FragColor = FxaaPixelShader(
					vUv,
					tDiffuse,
					resolution,
					edgeDetectionQuality, // [0,1] contrast needed, otherwise early discard
					invEdgeDetectionQuality
			);

	}
	`
};




class $65ce48d0349a1577$export$f50d9fcafba808a0 extends (0, $824f5e122dad54af$export$3075603db8e6204c) {
    constructor(text = "", options = {}){
        const material = new (0, $824f5e122dad54af$export$5ec7dd1c6994bf8e)({
            transparent: true,
            alphaTest: 1e-5
        });
        super(material);
        this.textMaterial = material;
        this.text = text;
        this.font = options.font === undefined ? "48px Minecraft" : options.font;
        this.margin = options.margin === undefined ? [
            5,
            10,
            5,
            10
        ] : options.margin;
        this.textStyle = options.textStyle === undefined ? "white" : options.textStyle;
        this.backgroundStyle = options.backgroundStyle === undefined ? "rgba(0,0,0,.25)" : options.backgroundStyle;
        this.height = options.height === undefined ? 4.0 : options.height;
        const repaintAfterLoaded = options.repaintAfterLoaded === undefined ? true : options.repaintAfterLoaded;
        if (repaintAfterLoaded && !document.fonts.check(this.font, this.text)) {
            this.paint();
            this.painted = this.loadAndPaint();
        } else {
            this.paint();
            this.painted = Promise.resolve();
        }
    }
    async loadAndPaint() {
        await document.fonts.load(this.font, this.text);
        this.paint();
    }
    paint() {
        const canvas = document.createElement("canvas");
        // Measure the text size
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let ctx = canvas.getContext("2d");
        ctx.font = this.font;
        const metrics = ctx.measureText(this.text);
        // Compute canvas size
        canvas.width = this.margin[3] + metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight + this.margin[1];
        canvas.height = this.margin[0] + metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent + this.margin[2];
        // After change canvas size, the context needs to be re-created
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ctx = canvas.getContext("2d");
        ctx.font = this.font;
        // Fill background
        ctx.fillStyle = this.backgroundStyle;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Draw text
        ctx.fillStyle = this.textStyle;
        ctx.fillText(this.text, this.margin[3] + metrics.actualBoundingBoxLeft, this.margin[0] + metrics.actualBoundingBoxAscent);
        // Apply texture
        const texture = new (0, $824f5e122dad54af$export$f7189e49152d1c13)(canvas);
        texture.magFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        texture.minFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.textMaterial.map = texture;
        this.textMaterial.needsUpdate = true;
        // Update size
        this.scale.x = canvas.width / canvas.height * this.height;
        this.scale.y = this.height;
    }
}


class $3855f28999f6d3bc$export$64c9a871c8ae0fe4 {
    constructor(options = {}){
        this.globalLight = new (0, $824f5e122dad54af$export$af279bfef9ec2c96)(0xffffff, 0.4);
        this.cameraLight = new (0, $824f5e122dad54af$export$4c9c1cb3f0b6f455)(0xffffff, 0.6);
        this.skinTexture = null;
        this.capeTexture = null;
        this.earsTexture = null;
        this.backgroundTexture = null;
        this._disposed = false;
        this._renderPaused = false;
        /**
         * Whether to rotate the player along the y axis.
         *
         * @defaultValue `false`
         */ this.autoRotate = false;
        /**
         * The angular velocity of the player, in rad/s.
         *
         * @defaultValue `1.0`
         * @see {@link autoRotate}
         */ this.autoRotateSpeed = 1.0;
        this._nameTag = null;
        this.canvas = options.canvas === undefined ? document.createElement("canvas") : options.canvas;
        this.skinCanvas = document.createElement("canvas");
        this.capeCanvas = document.createElement("canvas");
        this.earsCanvas = document.createElement("canvas");
        this.scene = new (0, $824f5e122dad54af$export$38af1803e3442a7f)();
        this.camera = new (0, $824f5e122dad54af$export$74e4ae24825f68d7)();
        this.camera.add(this.cameraLight);
        this.scene.add(this.camera);
        this.scene.add(this.globalLight);
        this.renderer = new (0, $824f5e122dad54af$export$f6cc00ef28d7cf97)({
            canvas: this.canvas,
            preserveDrawingBuffer: options.preserveDrawingBuffer === true // default: false
        });
        this.onDevicePixelRatioChange = ()=>{
            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.updateComposerSize();
            if (this._pixelRatio === "match-device") {
                this.devicePixelRatioQuery = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
                this.devicePixelRatioQuery.addEventListener("change", this.onDevicePixelRatioChange, {
                    once: true
                });
            }
        };
        if (options.pixelRatio === undefined || options.pixelRatio === "match-device") {
            this._pixelRatio = "match-device";
            this.devicePixelRatioQuery = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            this.devicePixelRatioQuery.addEventListener("change", this.onDevicePixelRatioChange, {
                once: true
            });
            this.renderer.setPixelRatio(window.devicePixelRatio);
        } else {
            this._pixelRatio = options.pixelRatio;
            this.devicePixelRatioQuery = null;
            this.renderer.setPixelRatio(options.pixelRatio);
        }
        this.renderer.setClearColor(0, 0);
        let renderTarget;
        if (this.renderer.capabilities.isWebGL2) // Use float precision depth if possible
        // see https://github.com/bs-community/skinview3d/issues/111
        renderTarget = new (0, $824f5e122dad54af$export$3c052beb2e51e23f)(0, 0, {
            depthTexture: new (0, $824f5e122dad54af$export$fc830aa069cc8c2f)(0, 0, (0, $824f5e122dad54af$export$f6d331659b644596))
        });
        this.composer = new (0, $3025dafbefabd73d$export$7fe01e6ab8aa748c)(this.renderer, renderTarget);
        this.renderPass = new (0, $a642a177c98a7e3a$export$f63ea822f020b5b0)(this.scene, this.camera);
        this.fxaaPass = new (0, $0cc9bb0d64fa3588$export$c55093fd4f9e42f0)((0, $00c7eb9ee8117d1e$export$f01fbdb03ef71c1d));
        this.composer.addPass(this.renderPass);
        this.composer.addPass(this.fxaaPass);
        this.playerObject = new (0, $43ff881bd78cd4f7$export$3392198d5a2a5d25)();
        this.playerObject.name = "player";
        this.playerObject.skin.visible = false;
        this.playerObject.cape.visible = false;
        this.playerWrapper = new (0, $824f5e122dad54af$export$eb2fcfdbd7ba97d4)();
        this.playerWrapper.add(this.playerObject);
        this.scene.add(this.playerWrapper);
        this.controls = new (0, $8fa0446d97946485$export$8ff7788029dfdf52)(this.camera, this.canvas);
        this.controls.enablePan = false; // disable pan by default
        this.controls.minDistance = 10;
        this.controls.maxDistance = 256;
        if (options.enableControls === false) this.controls.enabled = false;
        if (options.skin !== undefined) this.loadSkin(options.skin, {
            model: options.model,
            ears: options.ears === "current-skin"
        });
        if (options.cape !== undefined) this.loadCape(options.cape);
        if (options.ears !== undefined && options.ears !== "current-skin") this.loadEars(options.ears.source, {
            textureType: options.ears.textureType
        });
        if (options.width !== undefined) this.width = options.width;
        if (options.height !== undefined) this.height = options.height;
        if (options.background !== undefined) this.background = options.background;
        if (options.panorama !== undefined) this.loadPanorama(options.panorama);
        if (options.nameTag !== undefined) this.nameTag = options.nameTag;
        this.camera.position.z = 1;
        this._zoom = options.zoom === undefined ? 0.9 : options.zoom;
        this.fov = options.fov === undefined ? 50 : options.fov;
        this._animation = options.animation === undefined ? null : options.animation;
        this.clock = new (0, $824f5e122dad54af$export$9735c82c4bae3302)();
        if (options.renderPaused === true) {
            this._renderPaused = true;
            this.animationID = null;
        } else this.animationID = window.requestAnimationFrame(()=>this.draw());
        this.onContextLost = (event)=>{
            event.preventDefault();
            if (this.animationID !== null) {
                window.cancelAnimationFrame(this.animationID);
                this.animationID = null;
            }
        };
        this.onContextRestored = ()=>{
            this.renderer.setClearColor(0, 0); // Clear color might be lost
            if (!this._renderPaused && !this._disposed && this.animationID === null) this.animationID = window.requestAnimationFrame(()=>this.draw());
        };
        this.canvas.addEventListener("webglcontextlost", this.onContextLost, false);
        this.canvas.addEventListener("webglcontextrestored", this.onContextRestored, false);
    }
    updateComposerSize() {
        this.composer.setSize(this.width, this.height);
        const pixelRatio = this.renderer.getPixelRatio();
        this.composer.setPixelRatio(pixelRatio);
        this.fxaaPass.material.uniforms["resolution"].value.x = 1 / (this.width * pixelRatio);
        this.fxaaPass.material.uniforms["resolution"].value.y = 1 / (this.height * pixelRatio);
    }
    recreateSkinTexture() {
        if (this.skinTexture !== null) this.skinTexture.dispose();
        this.skinTexture = new (0, $824f5e122dad54af$export$f7189e49152d1c13)(this.skinCanvas);
        this.skinTexture.magFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.skinTexture.minFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.playerObject.skin.map = this.skinTexture;
    }
    recreateCapeTexture() {
        if (this.capeTexture !== null) this.capeTexture.dispose();
        this.capeTexture = new (0, $824f5e122dad54af$export$f7189e49152d1c13)(this.capeCanvas);
        this.capeTexture.magFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.capeTexture.minFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.playerObject.cape.map = this.capeTexture;
        this.playerObject.elytra.map = this.capeTexture;
    }
    recreateEarsTexture() {
        if (this.earsTexture !== null) this.earsTexture.dispose();
        this.earsTexture = new (0, $824f5e122dad54af$export$f7189e49152d1c13)(this.earsCanvas);
        this.earsTexture.magFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.earsTexture.minFilter = (0, $824f5e122dad54af$export$727aa5ec3fe39bf0);
        this.playerObject.ears.map = this.earsTexture;
    }
    loadSkin(source, options = {}) {
        if (source === null) this.resetSkin();
        else if ((0, $babb75b92e7c00bd$export$e670a942b4642d21)(source)) {
            (0, $c5e9d68c13022cdf$export$e97ed89594729991)(this.skinCanvas, source);
            this.recreateSkinTexture();
            if (options.model === undefined || options.model === "auto-detect") this.playerObject.skin.modelType = (0, $c5e9d68c13022cdf$export$6e7370d31b7d7026)(this.skinCanvas);
            else this.playerObject.skin.modelType = options.model;
            if (options.makeVisible !== false) this.playerObject.skin.visible = true;
            if (options.ears === true || options.ears == "load-only") {
                (0, $c5e9d68c13022cdf$export$5e33df73376b7be8)(this.earsCanvas, source);
                this.recreateEarsTexture();
                if (options.ears === true) this.playerObject.ears.visible = true;
            }
        } else return (0, $d13a011c37e5f769$export$fe58198efe02b173)(source).then((image)=>this.loadSkin(image, options));
    }
    resetSkin() {
        this.playerObject.skin.visible = false;
        this.playerObject.skin.map = null;
        if (this.skinTexture !== null) {
            this.skinTexture.dispose();
            this.skinTexture = null;
        }
    }
    loadCape(source, options = {}) {
        if (source === null) this.resetCape();
        else if ((0, $babb75b92e7c00bd$export$e670a942b4642d21)(source)) {
            (0, $c5e9d68c13022cdf$export$a6f8afd863bdc5c8)(this.capeCanvas, source);
            this.recreateCapeTexture();
            if (options.makeVisible !== false) this.playerObject.backEquipment = options.backEquipment === undefined ? "cape" : options.backEquipment;
        } else return (0, $d13a011c37e5f769$export$fe58198efe02b173)(source).then((image)=>this.loadCape(image, options));
    }
    resetCape() {
        this.playerObject.backEquipment = null;
        this.playerObject.cape.map = null;
        this.playerObject.elytra.map = null;
        if (this.capeTexture !== null) {
            this.capeTexture.dispose();
            this.capeTexture = null;
        }
    }
    loadEars(source, options = {}) {
        if (source === null) this.resetEars();
        else if ((0, $babb75b92e7c00bd$export$e670a942b4642d21)(source)) {
            if (options.textureType === "skin") (0, $c5e9d68c13022cdf$export$5e33df73376b7be8)(this.earsCanvas, source);
            else (0, $c5e9d68c13022cdf$export$16b3dc87096ae892)(this.earsCanvas, source);
            this.recreateEarsTexture();
            if (options.makeVisible !== false) this.playerObject.ears.visible = true;
        } else return (0, $d13a011c37e5f769$export$fe58198efe02b173)(source).then((image)=>this.loadEars(image, options));
    }
    resetEars() {
        this.playerObject.ears.visible = false;
        this.playerObject.ears.map = null;
        if (this.earsTexture !== null) {
            this.earsTexture.dispose();
            this.earsTexture = null;
        }
    }
    loadPanorama(source) {
        return this.loadBackground(source, (0, $824f5e122dad54af$export$d64030b316d3b087));
    }
    loadBackground(source, mapping) {
        if ((0, $babb75b92e7c00bd$export$e670a942b4642d21)(source)) {
            if (this.backgroundTexture !== null) this.backgroundTexture.dispose();
            this.backgroundTexture = new (0, $824f5e122dad54af$export$5431306cf43de24a)();
            this.backgroundTexture.image = source;
            if (mapping !== undefined) this.backgroundTexture.mapping = mapping;
            this.backgroundTexture.needsUpdate = true;
            this.scene.background = this.backgroundTexture;
        } else return (0, $d13a011c37e5f769$export$fe58198efe02b173)(source).then((image)=>this.loadBackground(image, mapping));
    }
    draw() {
        const dt = this.clock.getDelta();
        if (this._animation !== null) this._animation.update(this.playerObject, dt);
        if (this.autoRotate) this.playerWrapper.rotation.y += dt * this.autoRotateSpeed;
        this.controls.update();
        this.render();
        this.animationID = window.requestAnimationFrame(()=>this.draw());
    }
    /**
    * Renders the scene to the canvas.
    * This method does not change the animation progress.
    */ render() {
        this.composer.render();
    }
    setSize(width, height) {
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(width, height);
        this.updateComposerSize();
    }
    dispose() {
        this._disposed = true;
        this.canvas.removeEventListener("webglcontextlost", this.onContextLost, false);
        this.canvas.removeEventListener("webglcontextrestored", this.onContextRestored, false);
        if (this.devicePixelRatioQuery !== null) {
            this.devicePixelRatioQuery.removeEventListener("change", this.onDevicePixelRatioChange);
            this.devicePixelRatioQuery = null;
        }
        if (this.animationID !== null) {
            window.cancelAnimationFrame(this.animationID);
            this.animationID = null;
        }
        this.controls.dispose();
        this.renderer.dispose();
        this.resetSkin();
        this.resetCape();
        this.resetEars();
        this.background = null;
        this.fxaaPass.fsQuad.dispose();
    }
    get disposed() {
        return this._disposed;
    }
    /**
     * Whether rendering and animations are paused.
     * Setting this property to true will stop both rendering and animation loops.
     * Setting it back to false will resume them.
     */ get renderPaused() {
        return this._renderPaused;
    }
    set renderPaused(value) {
        this._renderPaused = value;
        if (this._renderPaused && this.animationID !== null) {
            window.cancelAnimationFrame(this.animationID);
            this.animationID = null;
            this.clock.stop();
            this.clock.autoStart = true;
        } else if (!this._renderPaused && !this._disposed && !this.renderer.getContext().isContextLost() && this.animationID == null) this.animationID = window.requestAnimationFrame(()=>this.draw());
    }
    get width() {
        return this.renderer.getSize(new (0, $824f5e122dad54af$export$c977b3e384af9ae1)()).width;
    }
    set width(newWidth) {
        this.setSize(newWidth, this.height);
    }
    get height() {
        return this.renderer.getSize(new (0, $824f5e122dad54af$export$c977b3e384af9ae1)()).height;
    }
    set height(newHeight) {
        this.setSize(this.width, newHeight);
    }
    get background() {
        return this.scene.background;
    }
    set background(value) {
        if (value === null || value instanceof (0, $824f5e122dad54af$export$892596cec99bc70e) || value instanceof (0, $824f5e122dad54af$export$5431306cf43de24a)) this.scene.background = value;
        else this.scene.background = new (0, $824f5e122dad54af$export$892596cec99bc70e)(value);
        if (this.backgroundTexture !== null && value !== this.backgroundTexture) {
            this.backgroundTexture.dispose();
            this.backgroundTexture = null;
        }
    }
    adjustCameraDistance() {
        let distance = 4.5 + 16.5 / Math.tan(this.fov / 180 * Math.PI / 2) / this.zoom;
        // limit distance between 10 ~ 256 (default min / max distance of OrbitControls)
        if (distance < 10) distance = 10;
        else if (distance > 256) distance = 256;
        this.camera.position.multiplyScalar(distance / this.camera.position.length());
        this.camera.updateProjectionMatrix();
    }
    resetCameraPose() {
        this.camera.position.set(0, 0, 1);
        this.camera.rotation.set(0, 0, 0);
        this.adjustCameraDistance();
    }
    get fov() {
        return this.camera.fov;
    }
    set fov(value) {
        this.camera.fov = value;
        this.adjustCameraDistance();
    }
    get zoom() {
        return this._zoom;
    }
    set zoom(value) {
        this._zoom = value;
        this.adjustCameraDistance();
    }
    get pixelRatio() {
        return this._pixelRatio;
    }
    set pixelRatio(newValue) {
        if (newValue === "match-device") {
            if (this._pixelRatio !== "match-device") {
                this._pixelRatio = newValue;
                this.onDevicePixelRatioChange();
            }
        } else {
            if (this._pixelRatio === "match-device" && this.devicePixelRatioQuery !== null) {
                this.devicePixelRatioQuery.removeEventListener("change", this.onDevicePixelRatioChange);
                this.devicePixelRatioQuery = null;
            }
            this._pixelRatio = newValue;
            this.renderer.setPixelRatio(newValue);
            this.updateComposerSize();
        }
    }
    /**
     * The animation that is current playing, or `null` if no animation is playing.
     *
     * Setting this property to a different value will change the current animation.
     * The player's pose and the progress of the new animation will be reset before playing.
     *
     * Setting this property to `null` will stop the current animation and reset the player's pose.
     */ get animation() {
        return this._animation;
    }
    set animation(animation) {
        if (this._animation !== animation) {
            this.playerObject.resetJoints();
            this.playerObject.position.set(0, 0, 0);
            this.playerObject.rotation.set(0, 0, 0);
            this.clock.stop();
            this.clock.autoStart = true;
        }
        if (animation !== null) animation.progress = 0;
        this._animation = animation;
    }
    /**
     * The name tag to display above the player, or `null` if there is none.
     *
     * When setting this property to a `string` value, a {@link NameTagObject}
     * will be automatically created with default options.
     *
     * @example
     * ```
     * skinViewer.nameTag = "hello";
     * skinViewer.nameTag = new NameTagObject("hello", { textStyle: "yellow" });
     * skinViewer.nameTag = null;
     * ```
     */ get nameTag() {
        return this._nameTag;
    }
    set nameTag(newVal) {
        if (this._nameTag !== null) // Remove the old name tag from the scene
        this.playerWrapper.remove(this._nameTag);
        if (newVal !== null) {
            if (!(newVal instanceof (0, $824f5e122dad54af$export$e4dd07dff30cc924))) newVal = new (0, $65ce48d0349a1577$export$f50d9fcafba808a0)(newVal);
            // Add the new name tag to the scene
            this.playerWrapper.add(newVal);
            // Set y position
            newVal.position.y = 20;
        }
        this._nameTag = newVal;
    }
}


/**
 * An animation which can be played on a {@link PlayerObject}.
 *
 * This is an abstract class. Subclasses of this class would implement
 * particular animations.
 */ class $32b404a308029b97$export$d8641debd6290116 {
    constructor(){
        /**
         * The speed of the animation.
         *
         * @defaultValue `1.0`
         */ this.speed = 1.0;
        /**
         * Whether the animation is paused.
         *
         * @defaultValue `false`
         */ this.paused = false;
        /**
         * The current progress of the animation.
         */ this.progress = 0;
    }
    /**
     * Plays the animation, and update the progress.
     *
     * The elapsed time `deltaTime` will be scaled by {@link speed}.
     * If {@link paused} is `true`, this method will do nothing.
     *
     * @param player - the player object
     * @param deltaTime - time elapsed since last call
     */ update(player, deltaTime) {
        if (this.paused) return;
        const delta = deltaTime * this.speed;
        this.animate(player, delta);
        this.progress += delta;
    }
}
class $32b404a308029b97$export$2f5a3c1802b555d5 extends $32b404a308029b97$export$d8641debd6290116 {
    constructor(fn){
        super();
        this.fn = fn;
    }
    animate(player, delta) {
        this.fn(player, this.progress, delta);
    }
}
class $32b404a308029b97$export$411b824e9aec2643 extends $32b404a308029b97$export$d8641debd6290116 {
    animate(player) {
        // Multiply by animation's natural speed
        const t = this.progress * 2;
        // Arm swing
        const basicArmRotationZ = Math.PI * 0.02;
        player.skin.leftArm.rotation.z = Math.cos(t) * 0.03 + basicArmRotationZ;
        player.skin.rightArm.rotation.z = Math.cos(t + Math.PI) * 0.03 - basicArmRotationZ;
        // Always add an angle for cape around the x axis
        const basicCapeRotationX = Math.PI * 0.06;
        player.cape.rotation.x = Math.sin(t) * 0.01 + basicCapeRotationX;
    }
}
class $32b404a308029b97$export$443e38207a741c8f extends $32b404a308029b97$export$d8641debd6290116 {
    constructor(){
        super(...arguments);
        /**
         * Whether to shake head when walking.
         *
         * @defaultValue `true`
         */ this.headBobbing = true;
    }
    animate(player) {
        // Multiply by animation's natural speed
        const t = this.progress * 8;
        // Leg swing
        player.skin.leftLeg.rotation.x = Math.sin(t) * 0.5;
        player.skin.rightLeg.rotation.x = Math.sin(t + Math.PI) * 0.5;
        // Arm swing
        player.skin.leftArm.rotation.x = Math.sin(t + Math.PI) * 0.5;
        player.skin.rightArm.rotation.x = Math.sin(t) * 0.5;
        const basicArmRotationZ = Math.PI * 0.02;
        player.skin.leftArm.rotation.z = Math.cos(t) * 0.03 + basicArmRotationZ;
        player.skin.rightArm.rotation.z = Math.cos(t + Math.PI) * 0.03 - basicArmRotationZ;
        if (this.headBobbing) {
            // Head shaking with different frequency & amplitude
            player.skin.head.rotation.y = Math.sin(t / 4) * 0.2;
            player.skin.head.rotation.x = Math.sin(t / 5) * 0.1;
        } else {
            player.skin.head.rotation.y = 0;
            player.skin.head.rotation.x = 0;
        }
        // Always add an angle for cape around the x axis
        const basicCapeRotationX = Math.PI * 0.06;
        player.cape.rotation.x = Math.sin(t / 1.5) * 0.06 + basicCapeRotationX;
    }
}
class $32b404a308029b97$export$5778c27ae75d631e extends $32b404a308029b97$export$d8641debd6290116 {
    animate(player) {
        // Multiply by animation's natural speed
        const t = this.progress * 15 + Math.PI * 0.5;
        // Leg swing with larger amplitude
        player.skin.leftLeg.rotation.x = Math.cos(t + Math.PI) * 1.3;
        player.skin.rightLeg.rotation.x = Math.cos(t) * 1.3;
        // Arm swing
        player.skin.leftArm.rotation.x = Math.cos(t) * 1.5;
        player.skin.rightArm.rotation.x = Math.cos(t + Math.PI) * 1.5;
        const basicArmRotationZ = Math.PI * 0.1;
        player.skin.leftArm.rotation.z = Math.cos(t) * 0.1 + basicArmRotationZ;
        player.skin.rightArm.rotation.z = Math.cos(t + Math.PI) * 0.1 - basicArmRotationZ;
        // Jumping
        player.position.y = Math.cos(t * 2);
        // Dodging when running
        player.position.x = Math.cos(t) * 0.15;
        // Slightly tilting when running
        player.rotation.z = Math.cos(t + Math.PI) * 0.01;
        // Apply higher swing frequency, lower amplitude,
        // and greater basic rotation around x axis,
        // to cape when running.
        const basicCapeRotationX = Math.PI * 0.3;
        player.cape.rotation.x = Math.sin(t * 2) * 0.1 + basicCapeRotationX;
    // What about head shaking?
    // You shouldn't glance right and left when running dude :P
    }
}
function $32b404a308029b97$var$clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
}
class $32b404a308029b97$export$589383aedcd45bdd extends $32b404a308029b97$export$d8641debd6290116 {
    animate(player) {
        // Body rotation finishes in 0.5s
        // Elytra expansion finishes in 3.3s
        const t = this.progress > 0 ? this.progress * 20 : 0;
        const startProgress = $32b404a308029b97$var$clamp(t * t / 100, 0, 1);
        player.rotation.x = startProgress * Math.PI / 2;
        player.skin.head.rotation.x = startProgress > .5 ? Math.PI / 4 - player.rotation.x : 0;
        const basicArmRotationZ = Math.PI * .25 * startProgress;
        player.skin.leftArm.rotation.z = basicArmRotationZ;
        player.skin.rightArm.rotation.z = -basicArmRotationZ;
        const elytraRotationX = .34906584;
        const elytraRotationZ = Math.PI / 2;
        const interpolation = Math.pow(.9, t);
        player.elytra.leftWing.rotation.x = elytraRotationX + interpolation * (.2617994 - elytraRotationX);
        player.elytra.leftWing.rotation.z = elytraRotationZ + interpolation * (.2617994 - elytraRotationZ);
        player.elytra.updateRightWing();
    }
}





const $e2321692a1470f38$export$2e2bcd8739ae039 = ({ className: n, width: c, height: s, skinUrl: i, capeUrl: o, onReady: u, options: m })=>{
    const l = (0, $9Raem.useRef)(), d = (0, $9Raem.useRef)();
    return (0, $9Raem.useEffect)(()=>{
        const e = new (0, $3855f28999f6d3bc$export$64c9a871c8ae0fe4)(Object.assign({
            canvas: l.current,
            width: Number(c),
            height: Number(s)
        }, m));
        i && e.loadSkin(i), o && e.loadCape(o), d.current = e, u && u({
            viewer: d.current,
            canvasRef: l.current
        });
    }, []), (0, $9Raem.useEffect)(()=>{
        i && d.current.loadSkin(i);
    }, [
        i
    ]), (0, $9Raem.useEffect)(()=>{
        o && d.current.loadCape(o);
    }, [
        o
    ]), (0, $9Raem.useEffect)(()=>{
        d.current.setSize(Number(c), Number(s));
    }, [
        c,
        s
    ]), (0, $lTb4y.default).createElement("canvas", {
        className: n,
        ref: l
    });
};




var $4fnJY = parcelRequire("4fnJY");


var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");

var $3P2ac = parcelRequire("3P2ac");
var $7ED3r = parcelRequire("7ED3r");
var $io057 = parcelRequire("io057");


var $iQwnU = parcelRequire("iQwnU");


var $aiTSV = parcelRequire("aiTSV");

var $4C9sh = parcelRequire("4C9sh");

var $6y3Kg = parcelRequire("6y3Kg");

var $4fnJY = parcelRequire("4fnJY");
const $b71a35246e03901f$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $b71a35246e03901f$var$defaultTheme = (0, $aiTSV.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $b71a35246e03901f$var$defaultCreateStyledComponent = (0, $746fe359b0f0950f$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $b71a35246e03901f$var$useThemePropsDefault(props) {
    return (0, $iQwnU.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $b71a35246e03901f$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $b71a35246e03901f$var$joinChildren(children, separator) {
    const childrenArray = $lTb4y.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $lTb4y.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $b71a35246e03901f$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $b71a35246e03901f$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $alwoF.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $4C9sh.handleBreakpoints)({
        theme: theme
    }, (0, $4C9sh.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $6y3Kg.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $4C9sh.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $4C9sh.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $6y3Kg.getValue)(transformer, propValue)
            };
            return {
                "& > :not(style) ~ :not(style)": {
                    margin: 0,
                    [`margin${$b71a35246e03901f$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $6y3Kg.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3P2ac.default)(styles, (0, $4C9sh.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $4C9sh.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $b71a35246e03901f$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $b71a35246e03901f$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $b71a35246e03901f$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $7ED3r.default)(slots, (slot)=>(0, $io057.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($b71a35246e03901f$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $lTb4y.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $3e1fa5e5288a4cf1$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $bjnlX.default)(props, $b71a35246e03901f$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $4fnJY.jsx)(StackRoot, (0, $alwoF.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $bIObK.default)(classes.root, className)
        }, other, {
            children: divider ? $b71a35246e03901f$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $l7HUa = parcelRequire("l7HUa");

var $lEU9Q = parcelRequire("lEU9Q");
const $0369076aa74253d2$var$Stack = (0, $b71a35246e03901f$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $l7HUa.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $lEU9Q.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $0369076aa74253d2$export$2e2bcd8739ae039 = $0369076aa74253d2$var$Stack;





var $ep79K = parcelRequire("ep79K");

var $9Raem = parcelRequire("9Raem");
function $e01afc4a71485466$var$i() {
    throw new Error("Cycle detected");
}
function $e01afc4a71485466$var$t() {
    if (!($e01afc4a71485466$var$h > 1)) {
        var i, t = !1;
        while(void 0 !== $e01afc4a71485466$var$n){
            var o = $e01afc4a71485466$var$n;
            $e01afc4a71485466$var$n = void 0;
            $e01afc4a71485466$var$s++;
            while(void 0 !== o){
                var r = o.o;
                o.o = void 0;
                o.f &= -3;
                if (!(8 & o.f) && $e01afc4a71485466$var$c(o)) try {
                    o.c();
                } catch (o) {
                    if (!t) {
                        i = o;
                        t = !0;
                    }
                }
                o = r;
            }
        }
        $e01afc4a71485466$var$s = 0;
        $e01afc4a71485466$var$h--;
        if (t) throw i;
    } else $e01afc4a71485466$var$h--;
}
function $e01afc4a71485466$export$712ea50be43a7858(i) {
    if ($e01afc4a71485466$var$h > 0) return i();
    $e01afc4a71485466$var$h++;
    try {
        return i();
    } finally{
        $e01afc4a71485466$var$t();
    }
}
var $e01afc4a71485466$var$r = void 0, $e01afc4a71485466$var$n = void 0, $e01afc4a71485466$var$h = 0, $e01afc4a71485466$var$s = 0, $e01afc4a71485466$var$f = 0;
function $e01afc4a71485466$var$v(i) {
    if (void 0 !== $e01afc4a71485466$var$r) {
        var t = i.n;
        if (void 0 === t || t.t !== $e01afc4a71485466$var$r) {
            t = {
                i: 0,
                S: i,
                p: $e01afc4a71485466$var$r.s,
                n: void 0,
                t: $e01afc4a71485466$var$r,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $e01afc4a71485466$var$r.s) $e01afc4a71485466$var$r.s.n = t;
            $e01afc4a71485466$var$r.s = t;
            i.n = t;
            if (32 & $e01afc4a71485466$var$r.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $e01afc4a71485466$var$r.s;
                t.n = void 0;
                $e01afc4a71485466$var$r.s.n = t;
                $e01afc4a71485466$var$r.s = t;
            }
            return t;
        }
    }
}
function $e01afc4a71485466$export$8210dfe1863c478(i) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
}
$e01afc4a71485466$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.S = function(i) {
    if (this.t !== i && void 0 === i.e) {
        i.x = this.t;
        if (void 0 !== this.t) this.t.e = i;
        this.t = i;
    }
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.U = function(i) {
    if (void 0 !== this.t) {
        var t = i.e, o = i.x;
        if (void 0 !== t) {
            t.x = o;
            i.e = void 0;
        }
        if (void 0 !== o) {
            o.e = t;
            i.x = void 0;
        }
        if (i === this.t) this.t = o;
    }
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $e01afc4a71485466$export$dc573d8a6576cdb3(function() {
        var o = t.value, r = 32 & this.f;
        this.f &= -33;
        try {
            i(o);
        } finally{
            this.f |= r;
        }
    });
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$e01afc4a71485466$export$8210dfe1863c478.prototype.peek = function() {
    return this.v;
};
Object.defineProperty($e01afc4a71485466$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $e01afc4a71485466$var$v(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(o) {
        if ($e01afc4a71485466$var$r instanceof $e01afc4a71485466$var$l) !function() {
            throw new Error("Computed cannot have side-effects");
        }();
        if (o !== this.v) {
            if ($e01afc4a71485466$var$s > 100) $e01afc4a71485466$var$i();
            this.v = o;
            this.i++;
            $e01afc4a71485466$var$f++;
            $e01afc4a71485466$var$h++;
            try {
                for(var n = this.t; void 0 !== n; n = n.x)n.t.N();
            } finally{
                $e01afc4a71485466$var$t();
            }
        }
    }
});
function $e01afc4a71485466$export$e2ef10f86a8d60e8(i) {
    return new $e01afc4a71485466$export$8210dfe1863c478(i);
}
function $e01afc4a71485466$var$c(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $e01afc4a71485466$var$d(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var o = t.S.n;
        if (void 0 !== o) t.r = o;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $e01afc4a71485466$var$a(i) {
    var t = i.s, o = void 0;
    while(void 0 !== t){
        var r = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== r) r.n = t.n;
            if (void 0 !== t.n) t.n.p = r;
        } else o = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = r;
    }
    i.s = o;
}
function $e01afc4a71485466$var$l(i) {
    $e01afc4a71485466$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $e01afc4a71485466$var$f - 1;
    this.f = 4;
}
($e01afc4a71485466$var$l.prototype = new $e01afc4a71485466$export$8210dfe1863c478).h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $e01afc4a71485466$var$f) return !0;
    this.g = $e01afc4a71485466$var$f;
    this.f |= 1;
    if (this.i > 0 && !$e01afc4a71485466$var$c(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $e01afc4a71485466$var$r;
    try {
        $e01afc4a71485466$var$d(this);
        $e01afc4a71485466$var$r = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $e01afc4a71485466$var$r = i;
    $e01afc4a71485466$var$a(this);
    this.f &= -2;
    return !0;
};
$e01afc4a71485466$var$l.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $e01afc4a71485466$export$8210dfe1863c478.prototype.S.call(this, i);
};
$e01afc4a71485466$var$l.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $e01afc4a71485466$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$e01afc4a71485466$var$l.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
$e01afc4a71485466$var$l.prototype.peek = function() {
    if (!this.h()) $e01afc4a71485466$var$i();
    if (16 & this.f) throw this.v;
    return this.v;
};
Object.defineProperty($e01afc4a71485466$var$l.prototype, "value", {
    get: function() {
        if (1 & this.f) $e01afc4a71485466$var$i();
        var t = $e01afc4a71485466$var$v(this);
        this.h();
        if (void 0 !== t) t.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $e01afc4a71485466$export$2983e091f1a1e8e2(i) {
    return new $e01afc4a71485466$var$l(i);
}
function $e01afc4a71485466$var$y(i) {
    var o = i.u;
    i.u = void 0;
    if ("function" == typeof o) {
        $e01afc4a71485466$var$h++;
        var n = $e01afc4a71485466$var$r;
        $e01afc4a71485466$var$r = void 0;
        try {
            o();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $e01afc4a71485466$var$_(i);
            throw t;
        } finally{
            $e01afc4a71485466$var$r = n;
            $e01afc4a71485466$var$t();
        }
    }
}
function $e01afc4a71485466$var$_(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $e01afc4a71485466$var$y(i);
}
function $e01afc4a71485466$var$p(i) {
    if ($e01afc4a71485466$var$r !== this) throw new Error("Out-of-order effect");
    $e01afc4a71485466$var$a(this);
    $e01afc4a71485466$var$r = i;
    this.f &= -2;
    if (8 & this.f) $e01afc4a71485466$var$_(this);
    $e01afc4a71485466$var$t();
}
function $e01afc4a71485466$var$g(i) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
}
$e01afc4a71485466$var$g.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$e01afc4a71485466$var$g.prototype.S = function() {
    if (1 & this.f) $e01afc4a71485466$var$i();
    this.f |= 1;
    this.f &= -9;
    $e01afc4a71485466$var$y(this);
    $e01afc4a71485466$var$d(this);
    $e01afc4a71485466$var$h++;
    var t = $e01afc4a71485466$var$r;
    $e01afc4a71485466$var$r = this;
    return $e01afc4a71485466$var$p.bind(this, t);
};
$e01afc4a71485466$var$g.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $e01afc4a71485466$var$n;
        $e01afc4a71485466$var$n = this;
    }
};
$e01afc4a71485466$var$g.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $e01afc4a71485466$var$_(this);
};
function $e01afc4a71485466$export$dc573d8a6576cdb3(i) {
    var t = new $e01afc4a71485466$var$g(i);
    try {
        t.c();
    } catch (i) {
        t.d();
        throw i;
    }
    return t.d.bind(t);
}


var $c2291b9d35369b90$var$c, $c2291b9d35369b90$var$v;
function $c2291b9d35369b90$var$s(n, i) {
    (0, $ep79K.options)[n] = i.bind(null, (0, $ep79K.options)[n] || function() {});
}
function $c2291b9d35369b90$var$l(n) {
    if ($c2291b9d35369b90$var$v) $c2291b9d35369b90$var$v();
    $c2291b9d35369b90$var$v = n && n.S();
}
function $c2291b9d35369b90$var$d(n) {
    var r = this, t = n.data, f = $c2291b9d35369b90$export$65d8bf213f6a4478(t);
    f.value = t;
    var o = (0, $9Raem.useMemo)(function() {
        var n = r.__v;
        while(n = n.__)if (n.__c) {
            n.__c.__$f |= 4;
            break;
        }
        r.__$u.c = function() {
            r.base.data = o.peek();
        };
        return (0, $e01afc4a71485466$export$2983e091f1a1e8e2)(function() {
            var n = f.value.value;
            return 0 === n ? 0 : !0 === n ? "" : n || "";
        });
    }, []);
    return o.value;
}
$c2291b9d35369b90$var$d.displayName = "_st";
Object.defineProperties((0, $e01afc4a71485466$export$8210dfe1863c478).prototype, {
    constructor: {
        configurable: !0,
        value: void 0
    },
    type: {
        configurable: !0,
        value: $c2291b9d35369b90$var$d
    },
    props: {
        configurable: !0,
        get: function() {
            return {
                data: this
            };
        }
    },
    __b: {
        configurable: !0,
        value: 1
    }
});
$c2291b9d35369b90$var$s("__b", function(n, r) {
    if ("string" == typeof r.type) {
        var i, t = r.props;
        for(var f in t)if ("children" !== f) {
            var e = t[f];
            if (e instanceof (0, $e01afc4a71485466$export$8210dfe1863c478)) {
                if (!i) r.__np = i = {};
                i[f] = e;
                t[f] = e.peek();
            }
        }
    }
    n(r);
});
$c2291b9d35369b90$var$s("__r", function(n, r) {
    $c2291b9d35369b90$var$l();
    var i, t = r.__c;
    if (t) {
        t.__$f &= -2;
        if (void 0 === (i = t.__$u)) t.__$u = i = function(n) {
            var r;
            (0, $e01afc4a71485466$export$dc573d8a6576cdb3)(function() {
                r = this;
            });
            r.c = function() {
                t.__$f |= 1;
                t.setState({});
            };
            return r;
        }();
    }
    $c2291b9d35369b90$var$c = t;
    $c2291b9d35369b90$var$l(i);
    n(r);
});
$c2291b9d35369b90$var$s("__e", function(n, r, i, t) {
    $c2291b9d35369b90$var$l();
    $c2291b9d35369b90$var$c = void 0;
    n(r, i, t);
});
$c2291b9d35369b90$var$s("diffed", function(n, r) {
    $c2291b9d35369b90$var$l();
    $c2291b9d35369b90$var$c = void 0;
    var i;
    if ("string" == typeof r.type && (i = r.__e)) {
        var t = r.__np, f = r.props;
        if (t) {
            var o = i.U;
            if (o) for(var e in o){
                var u = o[e];
                if (void 0 !== u && !(e in t)) {
                    u.d();
                    o[e] = void 0;
                }
            }
            else i.U = o = {};
            for(var a in t){
                var v = o[a], s = t[a];
                if (void 0 === v) {
                    v = $c2291b9d35369b90$var$p(i, a, s, f);
                    o[a] = v;
                } else v.o(s, f);
            }
        }
    }
    n(r);
});
function $c2291b9d35369b90$var$p(n, r, i, t) {
    var f = r in n && void 0 === n.ownerSVGElement, o = (0, $e01afc4a71485466$export$e2ef10f86a8d60e8)(i);
    return {
        o: function(n, r) {
            o.value = n;
            t = r;
        },
        d: (0, $e01afc4a71485466$export$dc573d8a6576cdb3)(function() {
            var i = o.value.value;
            if (t[r] !== i) {
                t[r] = i;
                if (f) n[r] = i;
                else if (i) n.setAttribute(r, i);
                else n.removeAttribute(r);
            }
        })
    };
}
$c2291b9d35369b90$var$s("unmount", function(n, r) {
    if ("string" == typeof r.type) {
        var i = r.__e;
        if (i) {
            var t = i.U;
            if (t) {
                i.U = void 0;
                for(var f in t){
                    var o = t[f];
                    if (o) o.d();
                }
            }
        }
    } else {
        var e = r.__c;
        if (e) {
            var u = e.__$u;
            if (u) {
                e.__$u = void 0;
                u.d();
            }
        }
    }
    n(r);
});
$c2291b9d35369b90$var$s("__h", function(n, r, i, t) {
    if (t < 3) r.__$f |= 2;
    n(r, i, t);
});
(0, $ep79K.Component).prototype.shouldComponentUpdate = function(n, r) {
    var i = this.__$u;
    if (!(i && void 0 !== i.s || 4 & this.__$f)) return !0;
    if (3 & this.__$f) return !0;
    for(var t in r)return !0;
    for(var f in n)if ("__source" !== f && n[f] !== this.props[f]) return !0;
    for(var o in this.props)if (!(o in n)) return !0;
    return !1;
};
function $c2291b9d35369b90$export$65d8bf213f6a4478(n) {
    return (0, $9Raem.useMemo)(function() {
        return (0, $e01afc4a71485466$export$e2ef10f86a8d60e8)(n);
    }, []);
}
function $c2291b9d35369b90$export$e3d20747ab930783(n) {
    var r = (0, $9Raem.useRef)(n);
    r.current = n;
    $c2291b9d35369b90$var$c.__$f |= 4;
    return (0, $9Raem.useMemo)(function() {
        return (0, $e01afc4a71485466$export$2983e091f1a1e8e2)(function() {
            return r.current();
        });
    }, []);
}
function $c2291b9d35369b90$export$ed99038c4a6f842a(n) {
    var r = (0, $9Raem.useRef)(n);
    r.current = n;
    (0, $9Raem.useEffect)(function() {
        return (0, $e01afc4a71485466$export$dc573d8a6576cdb3)(function() {
            return r.current();
        });
    }, []);
}


const $366b2064aac8ffc1$export$2188713a338b8c2f = (0, $e01afc4a71485466$export$e2ef10f86a8d60e8)(null);



var $4fnJY = parcelRequire("4fnJY");
var $ep79K = parcelRequire("ep79K");

var $bjnlX = parcelRequire("bjnlX");

var $alwoF = parcelRequire("alwoF");

var $lTb4y = parcelRequire("lTb4y");


var $bIObK = parcelRequire("bIObK");


var $7ED3r = parcelRequire("7ED3r");

var $lEU9Q = parcelRequire("lEU9Q");

var $l7HUa = parcelRequire("l7HUa");

var $6w46Z = parcelRequire("6w46Z");

var $io057 = parcelRequire("io057");
function $fc35172bbddb868e$export$5f5333fe417019a7(slot) {
    return (0, $io057.default)("MuiCardMedia", slot);
}
const $fc35172bbddb868e$var$cardMediaClasses = (0, $6w46Z.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $fc35172bbddb868e$export$2e2bcd8739ae039 = $fc35172bbddb868e$var$cardMediaClasses;



var $4fnJY = parcelRequire("4fnJY");
const $c1d05ebc3fc46532$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $c1d05ebc3fc46532$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $7ED3r.default)(slots, (0, $fc35172bbddb868e$export$5f5333fe417019a7), classes);
};
const $c1d05ebc3fc46532$var$CardMediaRoot = (0, $l7HUa.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $alwoF.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $c1d05ebc3fc46532$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $c1d05ebc3fc46532$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $c1d05ebc3fc46532$var$CardMedia = /*#__PURE__*/ $lTb4y.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $lEU9Q.default)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $bjnlX.default)(props, $c1d05ebc3fc46532$var$_excluded);
    const isMediaComponent = $c1d05ebc3fc46532$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $alwoF.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $alwoF.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $c1d05ebc3fc46532$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $c1d05ebc3fc46532$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4fnJY.jsx)($c1d05ebc3fc46532$var$CardMediaRoot, (0, $alwoF.default)({
        className: (0, $bIObK.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $c1d05ebc3fc46532$export$2e2bcd8739ae039 = $c1d05ebc3fc46532$var$CardMedia;






const $61253c30dac4238e$export$ca1b3af8dd9e180f = (0, $e01afc4a71485466$export$e2ef10f86a8d60e8)(null);
fetch("/memberTwitch" + (0, $181cd6f47a9a1c1a$export$100ad4af8c8d544f).map((member)=>{
    const memberTwitchLink = member.links.find((link)=>link.linkSite === (0, $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c).Twitch);
    if (memberTwitchLink !== undefined) return "/" + memberTwitchLink.handle;
    return "";
}).join("")).then((response)=>{
    response.json().then((data)=>{
        $61253c30dac4238e$export$ca1b3af8dd9e180f.value = data.data;
    }).catch((err)=>{
        console.log(err);
    });
}).catch((err)=>{
    console.log(err);
    $61253c30dac4238e$export$ca1b3af8dd9e180f.value = null;
});


function $6a6c1840ede5a1b1$var$BaseStatusCard(props) {
    return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
            sx: props.sx,
            children: [
                props.disableHeader ? null : /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                    title: "Twitch Status"
                }),
                props.children
            ]
        })
    });
}
function $6a6c1840ede5a1b1$export$2e2bcd8739ae039() {
    const member = (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value;
    const twitchStatuses = (0, $61253c30dac4238e$export$ca1b3af8dd9e180f).value;
    if (member === null) return /*#__PURE__*/ (0, $4fnJY.jsx)("div", {
        children: "Member Does Not Exist"
    });
    const doesCurrentMemberHaveTwitch = member.links?.find((link)=>link.linkSite === (0, $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c).Twitch) || undefined;
    const currentMemberTwitchStatus = doesCurrentMemberHaveTwitch !== undefined ? twitchStatuses?.find((twitchStatus)=>twitchStatus.user_login === doesCurrentMemberHaveTwitch.handle) || null : null;
    if (doesCurrentMemberHaveTwitch === undefined) return /*#__PURE__*/ (0, $4fnJY.jsx)((0, $ep79K.Fragment), {});
    if (currentMemberTwitchStatus === null) return /*#__PURE__*/ (0, $4fnJY.jsx)($6a6c1840ede5a1b1$var$BaseStatusCard, {
        children: currentMemberTwitchStatus !== null ? "Currently Live on Twitch!" : "Not Currently Live on Twitch"
    });
    return /*#__PURE__*/ (0, $4fnJY.jsxs)($6a6c1840ede5a1b1$var$BaseStatusCard, {
        children: [
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $c1d05ebc3fc46532$export$2e2bcd8739ae039), {
                component: "img",
                sx: {
                    height: 152
                },
                src: currentMemberTwitchStatus.thumbnail_url.replace("{width}", "1280").replace("{height}", "720"),
                alt: currentMemberTwitchStatus.title
            }),
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        gutterBottom: true,
                        children: currentMemberTwitchStatus.title
                    })
                })
            })
        ]
    });
}


function $58d737306d033bd6$export$2e2bcd8739ae039(props) {
    const member = props.member;
    if (member === null) return /*#__PURE__*/ (0, $4fnJY.jsx)("div", {
        children: "Member Does Not Exist"
    });
    return /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value = null;
                },
                children: "Back"
            }),
            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
                sx: {
                    minWidth: 100
                },
                className: "member-card",
                elevation: 2,
                children: [
                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                        avatar: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $fd4301ee5597692a$export$2e2bcd8739ae039), {
                            member: member
                        }),
                        title: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                            variant: "h6",
                            children: member.username
                        }),
                        subheader: "Joined " + member.dateJoined.toLocaleString(),
                        sx: {
                            mb: -2
                        }
                    }),
                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                            container: true,
                            direction: {
                                xs: "column",
                                md: "row"
                            },
                            columns: {
                                xs: 1,
                                md: 4
                            },
                            spacing: {
                                xs: 2
                            },
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0, $4fnJY.jsx)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                                    xs: 1,
                                    md: 2,
                                    children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
                                        sx: {
                                            minWidth: 270
                                        },
                                        className: "member-card",
                                        elevation: 4,
                                        children: [
                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                                                title: "About"
                                            }),
                                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                        color: "text.secondary",
                                                        gutterBottom: true,
                                                        children: member.roles.map((role, index)=>/*#__PURE__*/ (0, $4fnJY.jsxs)("span", {
                                                                children: [
                                                                    index > 0 ? ", " : "",
                                                                    (0, $181cd6f47a9a1c1a$export$975b30855231130c)[role]
                                                                ]
                                                            }))
                                                    }),
                                                    member.aliases && member.aliases.length > 0 ? /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                        variant: "subtitle2",
                                                        color: "text.secondary",
                                                        gutterBottom: true,
                                                        children: [
                                                            "Aliases:",
                                                            " ",
                                                            member.aliases.map((alias, index)=>/*#__PURE__*/ (0, $4fnJY.jsxs)("span", {
                                                                    children: [
                                                                        index > 0 ? ", " : "",
                                                                        alias
                                                                    ]
                                                                }))
                                                        ]
                                                    }) : "",
                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            mb: -2
                                                        },
                                                        children: member.bio
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $370174308974e07b$export$2e2bcd8739ae039), {
                                                sx: {
                                                    justifyContent: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $0369076aa74253d2$export$2e2bcd8739ae039), {
                                                    direction: {
                                                        xs: "column",
                                                        md: "row"
                                                    },
                                                    spacing: {
                                                        xs: 1,
                                                        md: 2
                                                    },
                                                    justifyContent: {
                                                        xs: "center",
                                                        md: "space-between"
                                                    },
                                                    alignItems: {
                                                        xs: "stretch",
                                                        md: "center"
                                                    },
                                                    useFlexGap: true,
                                                    flexWrap: "wrap",
                                                    children: member.links.map((link)=>/*#__PURE__*/ (0, $4fnJY.jsx)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                                                            href: (0, $181cd6f47a9a1c1a$export$6ac9c143745f8feb)(link),
                                                            size: "medium",
                                                            variant: "text",
                                                            style: {
                                                                color: link.color
                                                            },
                                                            children: link.label || (0, $181cd6f47a9a1c1a$export$a0e36ca1c1f6124c)[link.linkSite]
                                                        }))
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4fnJY.jsx)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                                    xs: 1,
                                    md: 2,
                                    children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
                                        sx: {
                                            minWidth: 270
                                        },
                                        className: "member-card",
                                        elevation: 4,
                                        children: [
                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                                                title: "Recent Content"
                                            }),
                                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                        color: "text.secondary",
                                                        gutterBottom: true,
                                                        children: "More details will be displayed here soon!"
                                                    }),
                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $6a6c1840ede5a1b1$export$2e2bcd8739ae039), {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




// @ts-ignore
const $b5a918c6a7896dec$var$_aboutMessageMDX = (0, $lTb4y.lazy)(()=>(parcelRequire("kpNCR")));
const $b5a918c6a7896dec$var$AboutMessageMDX = ()=>/*#__PURE__*/ (0, $4fnJY.jsx)((0, $lTb4y.Suspense), {
        fallback: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
            sx: {
                mt: 2
            },
            children: [
                /*#__PURE__*/ (0, $4fnJY.jsx)((0, $df06f0ead90319e2$export$2e2bcd8739ae039), {
                    variant: "rounded"
                }),
                /*#__PURE__*/ (0, $4fnJY.jsx)((0, $df06f0ead90319e2$export$2e2bcd8739ae039), {})
            ]
        }),
        children: /*#__PURE__*/ (0, $4fnJY.jsx)($b5a918c6a7896dec$var$_aboutMessageMDX, {})
    });
function $b5a918c6a7896dec$export$2e2bcd8739ae039() {
    const [showAllMembers, setShowAllMembers] = (0, $9Raem.useState)(false);
    const currentSeasonData = (0, $aed673ec07ea61d0$export$7ac67e6665ec5711).find((season)=>season.season === (0, $aed673ec07ea61d0$export$36e3a68624d1acaf));
    if (!currentSeasonData) throw new Error("Current season data not found");
    const currentSeasonMembers = showAllMembers ? (0, $181cd6f47a9a1c1a$export$100ad4af8c8d544f) : (0, $181cd6f47a9a1c1a$export$100ad4af8c8d544f).filter((member)=>member.seasonsPresent.includes((0, $aed673ec07ea61d0$export$36e3a68624d1acaf)));
    if (currentSeasonMembers.length === 0) throw new Error("No members found for current season");
    const theme = (0, $c9a3950c5281cf13$export$2e2bcd8739ae039)();
    const [activeStep, setActiveStep] = (0, $9Raem.useState)(0);
    const maxSteps = currentSeasonMembers.length;
    function handleNext() {
        if (activeStep + 1 === maxSteps) {
            setActiveStep(0);
            return;
        }
        setActiveStep((prevActiveStep)=>prevActiveStep + 1);
    }
    function handleBack() {
        if (activeStep === 0) {
            setActiveStep(maxSteps - 1);
            return;
        }
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
    }
    // This is so that we only render the skin currently being displayed,
    //   and the ones before and after so theres no visual glitching when the user goes between each member
    // For some reason things start to break if too many skins are being rendered at once so thats why this is here
    function decideToRenderSkin(memberIndex) {
        if (activeStep === memberIndex) return true;
        if (activeStep + 1 === memberIndex) return true;
        if (activeStep - 1 === memberIndex) return true;
        return false;
    }
    return /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $ep79K.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
                sx: {
                    display: (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value !== null ? "" : "none"
                },
                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $58d737306d033bd6$export$2e2bcd8739ae039), {
                    member: (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value
                })
            }),
            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                        xs: 10,
                        children: [
                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                variant: "h3",
                                sx: {
                                    mt: 2
                                },
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: /*#__PURE__*/ (0, $4fnJY.jsx)($b5a918c6a7896dec$var$AboutMessageMDX, {})
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: [
                                    "Current Season: ",
                                    (0, $aed673ec07ea61d0$export$36e3a68624d1acaf),
                                    /*#__PURE__*/ (0, $4fnJY.jsx)("br", {}),
                                    "MineCraft Version: ",
                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $897e691b868dc2cd$export$2e2bcd8739ae039), {
                                        href: currentSeasonData.modpack.url,
                                        children: currentSeasonData.modpack.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                sx: {
                                    mt: 4
                                },
                                variant: "h3",
                                justifySelf: "center",
                                children: "Members"
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: [
                                    "There are currently ",
                                    currentSeasonMembers.length,
                                    " members in the server this season."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setShowAllMembers(!showAllMembers);
                                },
                                children: "Show Members From Past Seasons"
                            }),
                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
                                sx: {
                                    maxWidth: 1000,
                                    flexGrow: 1,
                                    mt: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $08071c572e0b8d94$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        steps: maxSteps,
                                        position: "static",
                                        activeStep: activeStep,
                                        sx: {
                                            flexGrow: 1,
                                            bgcolor: theme.palette.background.paper
                                        },
                                        classes: {
                                            root: "member-mobile-stepper"
                                        },
                                        nextButton: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: handleNext,
                                            disabled: activeStep === maxSteps,
                                            children: [
                                                "Next",
                                                theme.direction === "rtl" ? /*#__PURE__*/ (0, $4fnJY.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($31f24d5f57600913$exports))), {}) : /*#__PURE__*/ (0, $4fnJY.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34a19b5d37e5becf$exports))), {})
                                            ]
                                        }),
                                        backButton: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: handleBack,
                                            children: [
                                                theme.direction === "rtl" ? /*#__PURE__*/ (0, $4fnJY.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34a19b5d37e5becf$exports))), {}) : /*#__PURE__*/ (0, $4fnJY.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($31f24d5f57600913$exports))), {}),
                                                "Back"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($30681c66bd9b43df$exports))), {
                                        axis: "x",
                                        index: activeStep,
                                        onChangeIndex: setActiveStep,
                                        enableMouseEvents: true,
                                        children: currentSeasonMembers.map((member, memberIndex)=>/*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
                                                sx: {
                                                    minWidth: 100
                                                },
                                                className: "member-card",
                                                elevation: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                                                        title: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                            variant: "h6",
                                                            children: member.username
                                                        }),
                                                        subheader: "Joined " + member.dateJoined.toLocaleString(),
                                                        sx: {
                                                            mb: -2
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        direction: {
                                                            xs: "column",
                                                            md: "row"
                                                        },
                                                        columns: {
                                                            xs: 1,
                                                            md: 4
                                                        },
                                                        spacing: {
                                                            xs: 2
                                                        },
                                                        justifyContent: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                                                                xs: 1,
                                                                md: 2,
                                                                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $84458b2b8e5ee862$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            height: 400,
                                                                            display: "flex",
                                                                            maxWidth: 800,
                                                                            overflow: "hidden",
                                                                            width: "100%",
                                                                            justifyContent: "center"
                                                                        },
                                                                        children: member.skinTexture && decideToRenderSkin(memberIndex) ? /*#__PURE__*/ (0, $4fnJY.jsx)((0, $e2321692a1470f38$export$2e2bcd8739ae039), {
                                                                            skinUrl: member.skinTexture,
                                                                            height: "400",
                                                                            width: "200",
                                                                            onReady: ({ viewer: viewer })=>{
                                                                                viewer.controls.enableRotate = false;
                                                                                viewer.controls.enableZoom = false;
                                                                                viewer.controls.enablePan = false;
                                                                                viewer.animation = new (0, $32b404a308029b97$export$411b824e9aec2643)();
                                                                                viewer.camera.position.setX(-12.043279210662355);
                                                                                viewer.camera.position.setY(11.890029699207485);
                                                                                viewer.camera.position.setZ(38);
                                                                                // Disable auto rotate
                                                                                viewer.autoRotate = false;
                                                                            }
                                                                        }) : /*#__PURE__*/ (0, $4fnJY.jsx)((0, $fd4301ee5597692a$export$2e2bcd8739ae039), {
                                                                            widthOneHundred: true,
                                                                            member: member
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $16326809e0b0b92a$export$2e2bcd8739ae039), {
                                                                xs: 1,
                                                                md: 2,
                                                                children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $1741921cbd2cd28b$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            minWidth: 250
                                                                        },
                                                                        className: "member-card",
                                                                        elevation: 4,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $e49dec6e8930a45c$export$2e2bcd8739ae039), {
                                                                                onClick: ()=>{
                                                                                    (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value = member;
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $4fnJY.jsx)((0, $51e4c83e24778ef8$export$2e2bcd8739ae039), {
                                                                                        title: "About",
                                                                                        subheader: member.roles.map((role, index)=>/*#__PURE__*/ (0, $4fnJY.jsxs)("span", {
                                                                                                children: [
                                                                                                    index > 0 ? ", " : "",
                                                                                                    (0, $181cd6f47a9a1c1a$export$975b30855231130c)[role]
                                                                                                ]
                                                                                            })),
                                                                                        sx: {
                                                                                            mb: -2
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $c7d802f19fc1c5c9$export$2e2bcd8739ae039), {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                                                                variant: "subtitle2",
                                                                                                color: "text.secondary",
                                                                                                children: [
                                                                                                    "Seasons Present: ",
                                                                                                    member.seasonsPresent.toString()
                                                                                                ]
                                                                                            }),
                                                                                            member.aliases && member.aliases.length > 0 ? /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                                                                variant: "subtitle2",
                                                                                                color: "text.secondary",
                                                                                                gutterBottom: true,
                                                                                                children: [
                                                                                                    "Aliases:",
                                                                                                    " ",
                                                                                                    member.aliases.map((alias, index)=>/*#__PURE__*/ (0, $4fnJY.jsxs)("span", {
                                                                                                            children: [
                                                                                                                index > 0 ? ", " : "",
                                                                                                                alias
                                                                                                            ]
                                                                                                        }))
                                                                                                ]
                                                                                            }) : "",
                                                                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $347a21fd4cb79caa$export$2e2bcd8739ae039), {
                                                                                                sx: {
                                                                                                    mt: 1
                                                                                                },
                                                                                                variant: "body1",
                                                                                                color: "text.secondary",
                                                                                                children: member.bio
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $4fnJY.jsx)((0, $370174308974e07b$export$2e2bcd8739ae039), {
                                                                                children: /*#__PURE__*/ (0, $4fnJY.jsxs)((0, $2641fe421c31af2c$export$2e2bcd8739ae039), {
                                                                                    onClick: ()=>{
                                                                                        (0, $366b2064aac8ffc1$export$2188713a338b8c2f).value = member;
                                                                                    },
                                                                                    size: "medium",
                                                                                    variant: "text",
                                                                                    sx: {
                                                                                        mt: 1,
                                                                                        width: "100%"
                                                                                    },
                                                                                    children: [
                                                                                        "Visit ",
                                                                                        member.username,
                                                                                        "'s Page"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, member.username))
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


const $6ffa3491f225abbf$var$mainRender = /*#__PURE__*/ (0, $4fnJY.jsx)((0, $8acf7da070400ff3$export$2e2bcd8739ae039), {
    children: /*#__PURE__*/ (0, $4fnJY.jsx)((0, $b5a918c6a7896dec$export$2e2bcd8739ae039), {})
});
const $6ffa3491f225abbf$var$documentApp = document.getElementById("app");
if (!$6ffa3491f225abbf$var$documentApp) {
    console.error("What the fuck? theres no app element? wtf?");
    throw new Error("God is dead and we have killed him");
}
(0, $ep79K.render)($6ffa3491f225abbf$var$mainRender, $6ffa3491f225abbf$var$documentApp);

})();
//# sourceMappingURL=index.0000c24b.js.map
